(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eiilo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $a680f9e293819191$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a680f9e293819191$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a680f9e293819191$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a680f9e293819191$var$_typeof(obj);
}
var $a680f9e293819191$var$V3_URL = 'https://js.stripe.com/v3';
var $a680f9e293819191$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $a680f9e293819191$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $a680f9e293819191$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($a680f9e293819191$var$V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$a680f9e293819191$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $a680f9e293819191$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($a680f9e293819191$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $a680f9e293819191$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "4.6.0",
        startTime: startTime
    });
};
var $a680f9e293819191$var$stripePromise = null;
var $a680f9e293819191$var$onErrorListener = null;
var $a680f9e293819191$var$onLoadListener = null;
var $a680f9e293819191$var$onError = function onError(reject) {
    return function() {
        reject(new Error('Failed to load Stripe.js'));
    };
};
var $a680f9e293819191$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $a680f9e293819191$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($a680f9e293819191$var$stripePromise !== null) return $a680f9e293819191$var$stripePromise;
    $a680f9e293819191$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($a680f9e293819191$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $a680f9e293819191$var$findScript();
            if (script && params) console.warn($a680f9e293819191$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $a680f9e293819191$var$injectScript(params);
            else if (script && $a680f9e293819191$var$onLoadListener !== null && $a680f9e293819191$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $a680f9e293819191$var$onLoadListener);
                script.removeEventListener('error', $a680f9e293819191$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $a680f9e293819191$var$injectScript(params);
            }
            $a680f9e293819191$var$onLoadListener = $a680f9e293819191$var$onLoad(resolve, reject);
            $a680f9e293819191$var$onErrorListener = $a680f9e293819191$var$onError(reject);
            script.addEventListener('load', $a680f9e293819191$var$onLoadListener);
            script.addEventListener('error', $a680f9e293819191$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $a680f9e293819191$var$stripePromise["catch"](function(error) {
        $a680f9e293819191$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $a680f9e293819191$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $a680f9e293819191$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $a680f9e293819191$var$validateLoadParams = function validateLoadParams(params) {
    var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");
    if (params === null || $a680f9e293819191$var$_typeof(params) !== 'object') throw new Error(errorMessage);
    if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === 'boolean') return params;
    throw new Error(errorMessage);
};
var $a680f9e293819191$var$loadParams;
var $a680f9e293819191$var$loadStripeCalled = false;
var $a680f9e293819191$var$loadStripe = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $a680f9e293819191$var$loadStripeCalled = true;
    var startTime = Date.now();
    return $a680f9e293819191$var$loadScript($a680f9e293819191$var$loadParams).then(function(maybeStripe) {
        return $a680f9e293819191$var$initStripe(maybeStripe, args, startTime);
    });
};
$a680f9e293819191$var$loadStripe.setLoadParameters = function(params) {
    // we won't throw an error if setLoadParameters is called with the same values as before
    if ($a680f9e293819191$var$loadStripeCalled && $a680f9e293819191$var$loadParams) {
        var validatedParams = $a680f9e293819191$var$validateLoadParams(params);
        var parameterKeys = Object.keys(validatedParams);
        var sameParameters = parameterKeys.reduce(function(previousValue, currentValue) {
            var _loadParams;
            return previousValue && params[currentValue] === ((_loadParams = $a680f9e293819191$var$loadParams) === null || _loadParams === void 0 ? void 0 : _loadParams[currentValue]);
        }, true);
        if (sameParameters) return;
    }
    if ($a680f9e293819191$var$loadStripeCalled) throw new Error('You cannot change load parameters after calling loadStripe');
    $a680f9e293819191$var$loadParams = $a680f9e293819191$var$validateLoadParams(params);
};
module.exports.loadStripe = $a680f9e293819191$var$loadStripe;

});

/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ function $cd0bb46fcf33db2e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $cd0bb46fcf33db2e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $cd0bb46fcf33db2e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $cd0bb46fcf33db2e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $9c9f503bd82065f0$export$71511d61b312f219(o) {
    $9c9f503bd82065f0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9c9f503bd82065f0$export$71511d61b312f219(o);
}


function $3722a5ccbf29c80e$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($3722a5ccbf29c80e$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $9b101634070cfba3$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $0cd339a6e98df7f5$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $b909ea23cfad744d$export$71511d61b312f219(self, call) {
    if (call && ((0, $0cd339a6e98df7f5$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $9b101634070cfba3$export$71511d61b312f219)(self);
}


function $244694db38c6e8cb$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $9c9f503bd82065f0$export$71511d61b312f219)(derived);
    return (0, $b909ea23cfad744d$export$71511d61b312f219)(_this, (0, $3722a5ccbf29c80e$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $9c9f503bd82065f0$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $4eedc8287d3685e8$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $625388bbfb3cd523$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $625388bbfb3cd523$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $625388bbfb3cd523$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $625388bbfb3cd523$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $a6437d79afda84c4$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $ae6a5f02b01abd08$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $9c9f503bd82065f0$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $b12a51be9d81d1bc$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $b12a51be9d81d1bc$export$71511d61b312f219 = Reflect.get;
    else $b12a51be9d81d1bc$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $ae6a5f02b01abd08$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $b12a51be9d81d1bc$export$71511d61b312f219(target, property, receiver || target);
}



function $318f103d6c039280$export$71511d61b312f219(o, p) {
    $318f103d6c039280$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $318f103d6c039280$export$71511d61b312f219(o, p);
}


function $28f6179e2b599279$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $318f103d6c039280$export$71511d61b312f219)(subClass, superClass);
}


function $a5f6cdc932bbffa3$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $961a7dd09e0f91db$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $c634cf1d97a12780$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a47104e1707b411c$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $36be118b55e0b615$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $a47104e1707b411c$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $a47104e1707b411c$export$71511d61b312f219)(o, minLen);
}


function $1733e6e3a24db77c$export$71511d61b312f219(arr, i) {
    return (0, $a5f6cdc932bbffa3$export$71511d61b312f219)(arr) || (0, $961a7dd09e0f91db$export$71511d61b312f219)(arr, i) || (0, $36be118b55e0b615$export$71511d61b312f219)(arr, i) || (0, $c634cf1d97a12780$export$71511d61b312f219)();
}



function $3faf97f7474da518$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $a47104e1707b411c$export$71511d61b312f219)(arr);
}


function $222be757f0b96279$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $da79643899409985$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $f655aa2a9acfd1eb$export$71511d61b312f219(arr) {
    return (0, $3faf97f7474da518$export$71511d61b312f219)(arr) || (0, $222be757f0b96279$export$71511d61b312f219)(arr) || (0, $36be118b55e0b615$export$71511d61b312f219)(arr) || (0, $da79643899409985$export$71511d61b312f219)();
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $248fc3c53839d9ba$var$extendStatics = function extendStatics1(d, b) {
    $248fc3c53839d9ba$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $248fc3c53839d9ba$var$extendStatics(d, b);
};
function $248fc3c53839d9ba$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $248fc3c53839d9ba$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $248fc3c53839d9ba$export$18ce0697a983be9b = function __assign1() {
    $248fc3c53839d9ba$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $248fc3c53839d9ba$export$18ce0697a983be9b.apply(this, arguments);
};
function $248fc3c53839d9ba$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $248fc3c53839d9ba$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $248fc3c53839d9ba$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $248fc3c53839d9ba$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $248fc3c53839d9ba$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $248fc3c53839d9ba$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $248fc3c53839d9ba$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $248fc3c53839d9ba$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $248fc3c53839d9ba$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $248fc3c53839d9ba$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $248fc3c53839d9ba$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $248fc3c53839d9ba$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $248fc3c53839d9ba$export$45d3717a4c69092e(o, m, p);
}
function $248fc3c53839d9ba$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $248fc3c53839d9ba$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $248fc3c53839d9ba$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($248fc3c53839d9ba$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $248fc3c53839d9ba$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $248fc3c53839d9ba$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $248fc3c53839d9ba$export$10c90e4f7922046c(v) {
    return this instanceof $248fc3c53839d9ba$export$10c90e4f7922046c ? (this.v = v, this) : new $248fc3c53839d9ba$export$10c90e4f7922046c(v);
}
function $248fc3c53839d9ba$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $248fc3c53839d9ba$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $248fc3c53839d9ba$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $248fc3c53839d9ba$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $248fc3c53839d9ba$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $248fc3c53839d9ba$export$19a8beecd37a4c45 === "function" ? $248fc3c53839d9ba$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $248fc3c53839d9ba$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $248fc3c53839d9ba$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $248fc3c53839d9ba$var$ownKeys = function ownKeys1(o) {
    $248fc3c53839d9ba$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $248fc3c53839d9ba$var$ownKeys(o);
};
function $248fc3c53839d9ba$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $248fc3c53839d9ba$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $248fc3c53839d9ba$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $248fc3c53839d9ba$var$__setModuleDefault(result, mod);
    return result;
}
function $248fc3c53839d9ba$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $248fc3c53839d9ba$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $248fc3c53839d9ba$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $248fc3c53839d9ba$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $248fc3c53839d9ba$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $248fc3c53839d9ba$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $248fc3c53839d9ba$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $248fc3c53839d9ba$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $248fc3c53839d9ba$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $248fc3c53839d9ba$export$2e2bcd8739ae039 = {
    __extends: $248fc3c53839d9ba$export$a8ba968b8961cb8a,
    __assign: $248fc3c53839d9ba$export$18ce0697a983be9b,
    __rest: $248fc3c53839d9ba$export$3c9a16f847548506,
    __decorate: $248fc3c53839d9ba$export$29e00dfd3077644b,
    __param: $248fc3c53839d9ba$export$d5ad3fd78186038f,
    __esDecorate: $248fc3c53839d9ba$export$3a84e1ae4e97e9b0,
    __runInitializers: $248fc3c53839d9ba$export$d831c04e792af3d,
    __propKey: $248fc3c53839d9ba$export$6a2a36740a146cb8,
    __setFunctionName: $248fc3c53839d9ba$export$d1a06452d3489bc7,
    __metadata: $248fc3c53839d9ba$export$f1db080c865becb9,
    __awaiter: $248fc3c53839d9ba$export$1050f835b63b671e,
    __generator: $248fc3c53839d9ba$export$67ebef60e6f28a6,
    __createBinding: $248fc3c53839d9ba$export$45d3717a4c69092e,
    __exportStar: $248fc3c53839d9ba$export$f33643c0debef087,
    __values: $248fc3c53839d9ba$export$19a8beecd37a4c45,
    __read: $248fc3c53839d9ba$export$8d051b38c9118094,
    __spread: $248fc3c53839d9ba$export$afc72e2116322959,
    __spreadArrays: $248fc3c53839d9ba$export$6388937ca91ccae8,
    __spreadArray: $248fc3c53839d9ba$export$1216008129fb82ed,
    __await: $248fc3c53839d9ba$export$10c90e4f7922046c,
    __asyncGenerator: $248fc3c53839d9ba$export$e427f37a30a4de9b,
    __asyncDelegator: $248fc3c53839d9ba$export$bbd80228419bb833,
    __asyncValues: $248fc3c53839d9ba$export$e3b29a3d6162315f,
    __makeTemplateObject: $248fc3c53839d9ba$export$4fb47efe1390b86f,
    __importStar: $248fc3c53839d9ba$export$c21735bcef00d192,
    __importDefault: $248fc3c53839d9ba$export$da59b14a69baef04,
    __classPrivateFieldGet: $248fc3c53839d9ba$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $248fc3c53839d9ba$export$d40a35129aaff81f,
    __classPrivateFieldIn: $248fc3c53839d9ba$export$81fdc39f203e4e04,
    __addDisposableResource: $248fc3c53839d9ba$export$88ac25d8e944e405,
    __disposeResources: $248fc3c53839d9ba$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $248fc3c53839d9ba$export$889dfb5d17574b0b
};


var $9761593eb1d92c30$var$EventListener = /*#__PURE__*/ function() {
    "use strict";
    function EventListener(eventTarget, eventName, eventOptions) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, EventListener);
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(EventListener, [
        {
            key: "connect",
            value: function connect() {
                this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
            }
        },
        {
            key: "bindingConnected",
            value: function bindingConnected(binding) {
                this.unorderedBindings.add(binding);
            }
        },
        {
            key: "bindingDisconnected",
            value: function bindingDisconnected(binding) {
                this.unorderedBindings["delete"](binding);
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var extendedEvent = $9761593eb1d92c30$var$extendEvent(event);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var binding = _step.value;
                        if (extendedEvent.immediatePropagationStopped) break;
                        else binding.handleEvent(extendedEvent);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasBindings",
            value: function hasBindings() {
                return this.unorderedBindings.size > 0;
            }
        },
        {
            key: "bindings",
            get: function get() {
                return Array.from(this.unorderedBindings).sort(function(left, right) {
                    var leftIndex = left.index, rightIndex = right.index;
                    return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
                });
            }
        }
    ]);
    return EventListener;
}();
function $9761593eb1d92c30$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        var stopImmediatePropagation = event.stopImmediatePropagation;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation: function() {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
var $9761593eb1d92c30$var$Dispatcher = /*#__PURE__*/ function() {
    "use strict";
    function Dispatcher(application) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Dispatcher);
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Dispatcher, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.eventListeners.forEach(function(eventListener) {
                        return eventListener.connect();
                    });
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.eventListeners.forEach(function(eventListener) {
                        return eventListener.disconnect();
                    });
                }
            }
        },
        {
            key: "eventListeners",
            get: function get() {
                return Array.from(this.eventListenerMaps.values()).reduce(function(listeners, map) {
                    return listeners.concat(Array.from(map.values()));
                }, []);
            }
        },
        {
            key: "bindingConnected",
            value: function bindingConnected(binding) {
                this.fetchEventListenerForBinding(binding).bindingConnected(binding);
            }
        },
        {
            key: "bindingDisconnected",
            value: function bindingDisconnected(binding) {
                var clearEventListeners = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
                if (clearEventListeners) this.clearEventListenersForBinding(binding);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.application.handleError(error, "Error ".concat(message), detail);
            }
        },
        {
            key: "clearEventListenersForBinding",
            value: function clearEventListenersForBinding(binding) {
                var eventListener = this.fetchEventListenerForBinding(binding);
                if (!eventListener.hasBindings()) {
                    eventListener.disconnect();
                    this.removeMappedEventListenerFor(binding);
                }
            }
        },
        {
            key: "removeMappedEventListenerFor",
            value: function removeMappedEventListenerFor(binding) {
                var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
                var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
                var cacheKey = this.cacheKey(eventName, eventOptions);
                eventListenerMap["delete"](cacheKey);
                if (eventListenerMap.size == 0) this.eventListenerMaps["delete"](eventTarget);
            }
        },
        {
            key: "fetchEventListenerForBinding",
            value: function fetchEventListenerForBinding(binding) {
                var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
                return this.fetchEventListener(eventTarget, eventName, eventOptions);
            }
        },
        {
            key: "fetchEventListener",
            value: function fetchEventListener(eventTarget, eventName, eventOptions) {
                var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
                var cacheKey = this.cacheKey(eventName, eventOptions);
                var eventListener = eventListenerMap.get(cacheKey);
                if (!eventListener) {
                    eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
                    eventListenerMap.set(cacheKey, eventListener);
                }
                return eventListener;
            }
        },
        {
            key: "createEventListener",
            value: function createEventListener(eventTarget, eventName, eventOptions) {
                var eventListener = new $9761593eb1d92c30$var$EventListener(eventTarget, eventName, eventOptions);
                if (this.started) eventListener.connect();
                return eventListener;
            }
        },
        {
            key: "fetchEventListenerMapForEventTarget",
            value: function fetchEventListenerMapForEventTarget(eventTarget) {
                var eventListenerMap = this.eventListenerMaps.get(eventTarget);
                if (!eventListenerMap) {
                    eventListenerMap = new Map();
                    this.eventListenerMaps.set(eventTarget, eventListenerMap);
                }
                return eventListenerMap;
            }
        },
        {
            key: "cacheKey",
            value: function cacheKey(eventName, eventOptions) {
                var parts = [
                    eventName
                ];
                Object.keys(eventOptions).sort().forEach(function(key) {
                    parts.push("".concat(eventOptions[key] ? "" : "!").concat(key));
                });
                return parts.join(":");
            }
        }
    ]);
    return Dispatcher;
}();
var $9761593eb1d92c30$var$defaultActionDescriptorFilters = {
    stop: function(param) {
        var event = param.event, value = param.value;
        if (value) event.stopPropagation();
        return true;
    },
    prevent: function(param) {
        var event = param.event, value = param.value;
        if (value) event.preventDefault();
        return true;
    },
    self: function(param) {
        var event = param.event, value = param.value, element = param.element;
        if (value) return element === event.target;
        else return true;
    }
};
var $9761593eb1d92c30$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $9761593eb1d92c30$var$parseActionDescriptorString(descriptorString) {
    var source = descriptorString.trim();
    var matches = source.match($9761593eb1d92c30$var$descriptorPattern) || [];
    var eventName = matches[2];
    var keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += ".".concat(keyFilter);
        keyFilter = "";
    }
    return {
        eventTarget: $9761593eb1d92c30$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $9761593eb1d92c30$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $9761593eb1d92c30$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $9761593eb1d92c30$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce(function(options, token) {
        return Object.assign(options, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, token.replace(/^!/, ""), !/^!/.test(token)));
    }, {});
}
function $9761593eb1d92c30$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $9761593eb1d92c30$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, function(_, _char) {
        return _char.toUpperCase();
    });
}
function $9761593eb1d92c30$var$namespaceCamelize(value) {
    return $9761593eb1d92c30$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $9761593eb1d92c30$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $9761593eb1d92c30$var$dasherize(value) {
    return value.replace(/([A-Z])/g, function(_, _char) {
        return "-".concat(_char.toLowerCase());
    });
}
function $9761593eb1d92c30$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $9761593eb1d92c30$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $9761593eb1d92c30$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
var $9761593eb1d92c30$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
var $9761593eb1d92c30$var$Action = /*#__PURE__*/ function() {
    "use strict";
    function Action(element, index, descriptor, schema) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Action);
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $9761593eb1d92c30$var$getDefaultEventNameForElement(element) || $9761593eb1d92c30$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $9761593eb1d92c30$var$error("missing identifier");
        this.methodName = descriptor.methodName || $9761593eb1d92c30$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Action, [
        {
            key: "toString",
            value: function toString() {
                var eventFilter = this.keyFilter ? ".".concat(this.keyFilter) : "";
                var eventTarget = this.eventTargetName ? "@".concat(this.eventTargetName) : "";
                return "".concat(this.eventName).concat(eventFilter).concat(eventTarget, "->").concat(this.identifier, "#").concat(this.methodName);
            }
        },
        {
            key: "shouldIgnoreKeyboardEvent",
            value: function shouldIgnoreKeyboardEvent(event) {
                if (!this.keyFilter) return false;
                var filters = this.keyFilter.split("+");
                if (this.keyFilterDissatisfied(event, filters)) return true;
                var standardFilter = filters.filter(function(key) {
                    return !$9761593eb1d92c30$var$allModifiers.includes(key);
                })[0];
                if (!standardFilter) return false;
                if (!$9761593eb1d92c30$var$hasProperty(this.keyMappings, standardFilter)) $9761593eb1d92c30$var$error("contains unknown key filter: ".concat(this.keyFilter));
                return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
            }
        },
        {
            key: "shouldIgnoreMouseEvent",
            value: function shouldIgnoreMouseEvent(event) {
                if (!this.keyFilter) return false;
                var filters = [
                    this.keyFilter
                ];
                if (this.keyFilterDissatisfied(event, filters)) return true;
                return false;
            }
        },
        {
            key: "params",
            get: function get() {
                var params = {};
                var pattern = new RegExp("^data-".concat(this.identifier, "-(.+)-param$"), "i");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(this.element.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
                        var match = name.match(pattern);
                        var key = match && match[1];
                        if (key) params[$9761593eb1d92c30$var$camelize(key)] = $9761593eb1d92c30$var$typecast(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return params;
            }
        },
        {
            key: "eventTargetName",
            get: function get() {
                return $9761593eb1d92c30$var$stringifyEventTarget(this.eventTarget);
            }
        },
        {
            key: "keyMappings",
            get: function get() {
                return this.schema.keyMappings;
            }
        },
        {
            key: "keyFilterDissatisfied",
            value: function keyFilterDissatisfied(event, filters) {
                var _allModifiers_map = (0, $1733e6e3a24db77c$export$71511d61b312f219)($9761593eb1d92c30$var$allModifiers.map(function(modifier) {
                    return filters.includes(modifier);
                }), 4), meta = _allModifiers_map[0], ctrl = _allModifiers_map[1], alt = _allModifiers_map[2], shift = _allModifiers_map[3];
                return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
            }
        }
    ], [
        {
            key: "forToken",
            value: function forToken(token, schema) {
                return new this(token.element, token.index, $9761593eb1d92c30$var$parseActionDescriptorString(token.content), schema);
            }
        }
    ]);
    return Action;
}();
var $9761593eb1d92c30$var$defaultEventNames = {
    a: function() {
        return "click";
    },
    button: function() {
        return "click";
    },
    form: function() {
        return "submit";
    },
    details: function() {
        return "toggle";
    },
    input: function(e) {
        return e.getAttribute("type") == "submit" ? "click" : "input";
    },
    select: function() {
        return "change";
    },
    textarea: function() {
        return "input";
    }
};
function $9761593eb1d92c30$var$getDefaultEventNameForElement(element) {
    var tagName = element.tagName.toLowerCase();
    if (tagName in $9761593eb1d92c30$var$defaultEventNames) return $9761593eb1d92c30$var$defaultEventNames[tagName](element);
}
function $9761593eb1d92c30$var$error(message) {
    throw new Error(message);
}
function $9761593eb1d92c30$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
var $9761593eb1d92c30$var$Binding = /*#__PURE__*/ function() {
    "use strict";
    function Binding(context, action) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Binding);
        this.context = context;
        this.action = action;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Binding, [
        {
            key: "index",
            get: function get() {
                return this.action.index;
            }
        },
        {
            key: "eventTarget",
            get: function get() {
                return this.action.eventTarget;
            }
        },
        {
            key: "eventOptions",
            get: function get() {
                return this.action.eventOptions;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var actionEvent = this.prepareActionEvent(event);
                if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
            }
        },
        {
            key: "eventName",
            get: function get() {
                return this.action.eventName;
            }
        },
        {
            key: "method",
            get: function get() {
                var method = this.controller[this.methodName];
                if (typeof method == "function") return method;
                throw new Error('Action "'.concat(this.action, '" references undefined method "').concat(this.methodName, '"'));
            }
        },
        {
            key: "applyEventModifiers",
            value: function applyEventModifiers(event) {
                var element = this.action.element;
                var actionDescriptorFilters = this.context.application.actionDescriptorFilters;
                var controller = this.context.controller;
                var passes = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this.eventOptions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $1733e6e3a24db77c$export$71511d61b312f219)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                        if (name in actionDescriptorFilters) {
                            var filter = actionDescriptorFilters[name];
                            passes = passes && filter({
                                name: name,
                                value: value,
                                event: event,
                                element: element,
                                controller: controller
                            });
                        } else continue;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return passes;
            }
        },
        {
            key: "prepareActionEvent",
            value: function prepareActionEvent(event) {
                return Object.assign(event, {
                    params: this.action.params
                });
            }
        },
        {
            key: "invokeWithEvent",
            value: function invokeWithEvent(event) {
                var target = event.target, currentTarget = event.currentTarget;
                try {
                    this.method.call(this.controller, event);
                    this.context.logDebugActivity(this.methodName, {
                        event: event,
                        target: target,
                        currentTarget: currentTarget,
                        action: this.methodName
                    });
                } catch (error) {
                    var _this = this, identifier = _this.identifier, controller = _this.controller, element = _this.element, index = _this.index;
                    var detail = {
                        identifier: identifier,
                        controller: controller,
                        element: element,
                        index: index,
                        event: event
                    };
                    this.context.handleError(error, 'invoking action "'.concat(this.action, '"'), detail);
                }
            }
        },
        {
            key: "willBeInvokedByEvent",
            value: function willBeInvokedByEvent(event) {
                var eventTarget = event.target;
                if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
                if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
                if (this.element === eventTarget) return true;
                else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
                else return this.scope.containsElement(this.action.element);
            }
        },
        {
            key: "controller",
            get: function get() {
                return this.context.controller;
            }
        },
        {
            key: "methodName",
            get: function get() {
                return this.action.methodName;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        }
    ]);
    return Binding;
}();
var $9761593eb1d92c30$export$12e07a2a9f87578a = /*#__PURE__*/ function() {
    "use strict";
    function ElementObserver(element, delegate) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ElementObserver);
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ElementObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.mutationObserver.observe(this.element, this.mutationObserverInit);
                    this.refresh();
                }
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                if (this.started) {
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
                callback();
                if (!this.started) {
                    this.mutationObserver.observe(this.element, this.mutationObserverInit);
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.mutationObserver.takeRecords();
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (this.started) {
                    var matches = new Set(this.matchElementsInTree());
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(this.elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (!matches.has(element)) this.removeElement(element);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Array.from(matches)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var element1 = _step1.value;
                            this.addElement(element1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "processMutations",
            value: function processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        this.processMutation(mutation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutation",
            value: function processMutation(mutation) {
                if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
                else if (mutation.type == "childList") {
                    this.processRemovedNodes(mutation.removedNodes);
                    this.processAddedNodes(mutation.addedNodes);
                }
            }
        },
        {
            key: "processAttributeChange",
            value: function processAttributeChange(element, attributeName) {
                if (this.elements.has(element)) {
                    if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
                    else this.removeElement(element);
                } else if (this.matchElement(element)) this.addElement(element);
            }
        },
        {
            key: "processRemovedNodes",
            value: function processRemovedNodes(nodes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var element = this.elementFromNode(node);
                        if (element) this.processTree(element, this.removeElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processAddedNodes",
            value: function processAddedNodes(nodes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var element = this.elementFromNode(node);
                        if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                return this.delegate.matchElement(element);
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree() {
                var tree = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.element;
                return this.delegate.matchElementsInTree(tree);
            }
        },
        {
            key: "processTree",
            value: function processTree(tree, processor) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.matchElementsInTree(tree)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        processor.call(this, element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "elementFromNode",
            value: function elementFromNode(node) {
                if (node.nodeType == Node.ELEMENT_NODE) return node;
            }
        },
        {
            key: "elementIsActive",
            value: function elementIsActive(element) {
                if (element.isConnected != this.element.isConnected) return false;
                else return this.element.contains(element);
            }
        },
        {
            key: "addElement",
            value: function addElement(element) {
                if (!this.elements.has(element)) {
                    if (this.elementIsActive(element)) {
                        this.elements.add(element);
                        if (this.delegate.elementMatched) this.delegate.elementMatched(element);
                    }
                }
            }
        },
        {
            key: "removeElement",
            value: function removeElement(element) {
                if (this.elements.has(element)) {
                    this.elements["delete"](element);
                    if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
                }
            }
        }
    ]);
    return ElementObserver;
}();
var $9761593eb1d92c30$export$fe68319d413d05cb = /*#__PURE__*/ function() {
    "use strict";
    function AttributeObserver(element, attributeName, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AttributeObserver);
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $9761593eb1d92c30$export$12e07a2a9f87578a(element, this);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AttributeObserver, [
        {
            key: "element",
            get: function get() {
                return this.elementObserver.element;
            }
        },
        {
            key: "selector",
            get: function get() {
                return "[".concat(this.attributeName, "]");
            }
        },
        {
            key: "start",
            value: function start() {
                this.elementObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.elementObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.elementObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.elementObserver.refresh();
            }
        },
        {
            key: "started",
            get: function get() {
                return this.elementObserver.started;
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                return element.hasAttribute(this.attributeName);
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree(tree) {
                var match = this.matchElement(tree) ? [
                    tree
                ] : [];
                var matches = Array.from(tree.querySelectorAll(this.selector));
                return match.concat(matches);
            }
        },
        {
            key: "elementMatched",
            value: function elementMatched(element) {
                if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
            }
        },
        {
            key: "elementUnmatched",
            value: function elementUnmatched(element) {
                if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
            }
        },
        {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(element, attributeName) {
                if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
            }
        }
    ]);
    return AttributeObserver;
}();
function $9761593eb1d92c30$export$e16d8520af44a096(map, key, value) {
    $9761593eb1d92c30$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $9761593eb1d92c30$export$1d2f21e549771e67(map, key, value) {
    $9761593eb1d92c30$export$e7aa7bc5c1b3cfb3(map, key)["delete"](value);
    $9761593eb1d92c30$export$d6cf75919f12ca5a(map, key);
}
function $9761593eb1d92c30$export$e7aa7bc5c1b3cfb3(map, key) {
    var values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $9761593eb1d92c30$export$d6cf75919f12ca5a(map, key) {
    var values = map.get(key);
    if (values != null && values.size == 0) map["delete"](key);
}
var $9761593eb1d92c30$export$8bd4ad37b76db6ba = /*#__PURE__*/ function() {
    "use strict";
    function Multimap() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Multimap);
        this.valuesByKey = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Multimap, [
        {
            key: "keys",
            get: function get() {
                return Array.from(this.valuesByKey.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                var sets = Array.from(this.valuesByKey.values());
                return sets.reduce(function(values, set) {
                    return values.concat(Array.from(set));
                }, []);
            }
        },
        {
            key: "size",
            get: function get() {
                var sets = Array.from(this.valuesByKey.values());
                return sets.reduce(function(size, set) {
                    return size + set.size;
                }, 0);
            }
        },
        {
            key: "add",
            value: function add1(key, value) {
                $9761593eb1d92c30$export$e16d8520af44a096(this.valuesByKey, key, value);
            }
        },
        {
            key: "delete",
            value: function _delete(key, value) {
                $9761593eb1d92c30$export$1d2f21e549771e67(this.valuesByKey, key, value);
            }
        },
        {
            key: "has",
            value: function has(key, value) {
                var values = this.valuesByKey.get(key);
                return values != null && values.has(value);
            }
        },
        {
            key: "hasKey",
            value: function hasKey(key) {
                return this.valuesByKey.has(key);
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                var sets = Array.from(this.valuesByKey.values());
                return sets.some(function(set) {
                    return set.has(value);
                });
            }
        },
        {
            key: "getValuesForKey",
            value: function getValuesForKey(key) {
                var values = this.valuesByKey.get(key);
                return values ? Array.from(values) : [];
            }
        },
        {
            key: "getKeysForValue",
            value: function getKeysForValue(value) {
                return Array.from(this.valuesByKey).filter(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), _key = _param[0], values = _param[1];
                    return values.has(value);
                }).map(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), key = _param[0], _values = _param[1];
                    return key;
                });
            }
        }
    ]);
    return Multimap;
}();
var $9761593eb1d92c30$export$a7c3d2c2552a674d = /*#__PURE__*/ function(Multimap) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(IndexedMultimap, Multimap);
    function IndexedMultimap() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, IndexedMultimap);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, IndexedMultimap);
        _this.keysByValue = new Map();
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(IndexedMultimap, [
        {
            key: "values",
            get: function get() {
                return Array.from(this.keysByValue.keys());
            }
        },
        {
            key: "add",
            value: function add1(key, value) {
                (0, $b12a51be9d81d1bc$export$71511d61b312f219)((0, $9c9f503bd82065f0$export$71511d61b312f219)(IndexedMultimap.prototype), "add", this).call(this, key, value);
                $9761593eb1d92c30$export$e16d8520af44a096(this.keysByValue, value, key);
            }
        },
        {
            key: "delete",
            value: function _delete(key, value) {
                (0, $b12a51be9d81d1bc$export$71511d61b312f219)((0, $9c9f503bd82065f0$export$71511d61b312f219)(IndexedMultimap.prototype), "delete", this).call(this, key, value);
                $9761593eb1d92c30$export$1d2f21e549771e67(this.keysByValue, value, key);
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                return this.keysByValue.has(value);
            }
        },
        {
            key: "getKeysForValue",
            value: function getKeysForValue(value) {
                var set = this.keysByValue.get(value);
                return set ? Array.from(set) : [];
            }
        }
    ]);
    return IndexedMultimap;
}($9761593eb1d92c30$export$8bd4ad37b76db6ba);
var $9761593eb1d92c30$export$116e0b48509995b = /*#__PURE__*/ function() {
    "use strict";
    function SelectorObserver(element, selector, delegate, details) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SelectorObserver);
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $9761593eb1d92c30$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SelectorObserver, [
        {
            key: "started",
            get: function get() {
                return this.elementObserver.started;
            }
        },
        {
            key: "selector",
            get: function get() {
                return this._selector;
            },
            set: function set(selector) {
                this._selector = selector;
                this.refresh();
            }
        },
        {
            key: "start",
            value: function start() {
                this.elementObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.elementObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.elementObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.elementObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.elementObserver.element;
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                var selector = this.selector;
                if (selector) {
                    var matches = element.matches(selector);
                    if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
                    return matches;
                } else return false;
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree(tree) {
                var _this = this;
                var selector = this.selector;
                if (selector) {
                    var match = this.matchElement(tree) ? [
                        tree
                    ] : [];
                    var matches = Array.from(tree.querySelectorAll(selector)).filter(function(match) {
                        return _this.matchElement(match);
                    });
                    return match.concat(matches);
                } else return [];
            }
        },
        {
            key: "elementMatched",
            value: function elementMatched(element) {
                var selector = this.selector;
                if (selector) this.selectorMatched(element, selector);
            }
        },
        {
            key: "elementUnmatched",
            value: function elementUnmatched(element) {
                var selectors = this.matchesByElement.getKeysForValue(element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var selector = _step.value;
                        this.selectorUnmatched(element, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(element, _attributeName) {
                var selector = this.selector;
                if (selector) {
                    var matches = this.matchElement(element);
                    var matchedBefore = this.matchesByElement.has(selector, element);
                    if (matches && !matchedBefore) this.selectorMatched(element, selector);
                    else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
                }
            }
        },
        {
            key: "selectorMatched",
            value: function selectorMatched(element, selector) {
                this.delegate.selectorMatched(element, selector, this.details);
                this.matchesByElement.add(selector, element);
            }
        },
        {
            key: "selectorUnmatched",
            value: function selectorUnmatched(element, selector) {
                this.delegate.selectorUnmatched(element, selector, this.details);
                this.matchesByElement["delete"](selector, element);
            }
        }
    ]);
    return SelectorObserver;
}();
var $9761593eb1d92c30$export$da226bebbf7f6caa = /*#__PURE__*/ function() {
    "use strict";
    function StringMapObserver(element, delegate) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, StringMapObserver);
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(StringMapObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.mutationObserver.observe(this.element, {
                        attributes: true,
                        attributeOldValue: true
                    });
                    this.refresh();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.mutationObserver.takeRecords();
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = this.knownAttributeNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attributeName = _step.value;
                        this.refreshAttribute(attributeName, null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutations",
            value: function processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        this.processMutation(mutation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutation",
            value: function processMutation(mutation) {
                var attributeName = mutation.attributeName;
                if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
            }
        },
        {
            key: "refreshAttribute",
            value: function refreshAttribute(attributeName, oldValue) {
                var key = this.delegate.getStringMapKeyForAttribute(attributeName);
                if (key != null) {
                    if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
                    var value = this.element.getAttribute(attributeName);
                    if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
                    if (value == null) {
                        var _$oldValue = this.stringMap.get(attributeName);
                        this.stringMap["delete"](attributeName);
                        if (_$oldValue) this.stringMapKeyRemoved(key, attributeName, _$oldValue);
                    } else this.stringMap.set(attributeName, value);
                }
            }
        },
        {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(key, attributeName) {
                if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
            }
        },
        {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(value, key, oldValue) {
                if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
            }
        },
        {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(key, attributeName, oldValue) {
                if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
            }
        },
        {
            key: "knownAttributeNames",
            get: function get() {
                return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
            }
        },
        {
            key: "currentAttributeNames",
            get: function get() {
                return Array.from(this.element.attributes).map(function(attribute) {
                    return attribute.name;
                });
            }
        },
        {
            key: "recordedAttributeNames",
            get: function get() {
                return Array.from(this.stringMap.keys());
            }
        }
    ]);
    return StringMapObserver;
}();
var $9761593eb1d92c30$export$3aa21c2f03ef6b3b = /*#__PURE__*/ function() {
    "use strict";
    function TokenListObserver(element, attributeName, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TokenListObserver);
        this.attributeObserver = new $9761593eb1d92c30$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TokenListObserver, [
        {
            key: "started",
            get: function get() {
                return this.attributeObserver.started;
            }
        },
        {
            key: "start",
            value: function start() {
                this.attributeObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.attributeObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.attributeObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.attributeObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.attributeObserver.element;
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return this.attributeObserver.attributeName;
            }
        },
        {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(element) {
                this.tokensMatched(this.readTokensForElement(element));
            }
        },
        {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(element) {
                var _this_refreshTokensForElement = (0, $1733e6e3a24db77c$export$71511d61b312f219)(this.refreshTokensForElement(element), 2), unmatchedTokens = _this_refreshTokensForElement[0], matchedTokens = _this_refreshTokensForElement[1];
                this.tokensUnmatched(unmatchedTokens);
                this.tokensMatched(matchedTokens);
            }
        },
        {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(element) {
                this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
            }
        },
        {
            key: "tokensMatched",
            value: function tokensMatched(tokens) {
                var _this = this;
                tokens.forEach(function(token) {
                    return _this.tokenMatched(token);
                });
            }
        },
        {
            key: "tokensUnmatched",
            value: function tokensUnmatched(tokens) {
                var _this = this;
                tokens.forEach(function(token) {
                    return _this.tokenUnmatched(token);
                });
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(token) {
                this.delegate.tokenMatched(token);
                this.tokensByElement.add(token.element, token);
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(token) {
                this.delegate.tokenUnmatched(token);
                this.tokensByElement["delete"](token.element, token);
            }
        },
        {
            key: "refreshTokensForElement",
            value: function refreshTokensForElement(element) {
                var previousTokens = this.tokensByElement.getValuesForKey(element);
                var currentTokens = this.readTokensForElement(element);
                var firstDifferingIndex = $9761593eb1d92c30$var$zip(previousTokens, currentTokens).findIndex(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), previousToken = _param[0], currentToken = _param[1];
                    return !$9761593eb1d92c30$var$tokensAreEqual(previousToken, currentToken);
                });
                if (firstDifferingIndex == -1) return [
                    [],
                    []
                ];
                else return [
                    previousTokens.slice(firstDifferingIndex),
                    currentTokens.slice(firstDifferingIndex)
                ];
            }
        },
        {
            key: "readTokensForElement",
            value: function readTokensForElement(element) {
                var attributeName = this.attributeName;
                var tokenString = element.getAttribute(attributeName) || "";
                return $9761593eb1d92c30$var$parseTokenString(tokenString, element, attributeName);
            }
        }
    ]);
    return TokenListObserver;
}();
function $9761593eb1d92c30$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter(function(content) {
        return content.length;
    }).map(function(content, index) {
        return {
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        };
    });
}
function $9761593eb1d92c30$var$zip(left, right) {
    var length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, function(_, index) {
        return [
            left[index],
            right[index]
        ];
    });
}
function $9761593eb1d92c30$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
var $9761593eb1d92c30$export$d27fa4c7330a452e = /*#__PURE__*/ function() {
    "use strict";
    function ValueListObserver(element, attributeName, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ValueListObserver);
        this.tokenListObserver = new $9761593eb1d92c30$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ValueListObserver, [
        {
            key: "started",
            get: function get() {
                return this.tokenListObserver.started;
            }
        },
        {
            key: "start",
            value: function start() {
                this.tokenListObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.tokenListObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.tokenListObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.tokenListObserver.element;
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return this.tokenListObserver.attributeName;
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(token) {
                var element = token.element;
                var value = this.fetchParseResultForToken(token).value;
                if (value) {
                    this.fetchValuesByTokenForElement(element).set(token, value);
                    this.delegate.elementMatchedValue(element, value);
                }
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(token) {
                var element = token.element;
                var value = this.fetchParseResultForToken(token).value;
                if (value) {
                    this.fetchValuesByTokenForElement(element)["delete"](token);
                    this.delegate.elementUnmatchedValue(element, value);
                }
            }
        },
        {
            key: "fetchParseResultForToken",
            value: function fetchParseResultForToken(token) {
                var parseResult = this.parseResultsByToken.get(token);
                if (!parseResult) {
                    parseResult = this.parseToken(token);
                    this.parseResultsByToken.set(token, parseResult);
                }
                return parseResult;
            }
        },
        {
            key: "fetchValuesByTokenForElement",
            value: function fetchValuesByTokenForElement(element) {
                var valuesByToken = this.valuesByTokenByElement.get(element);
                if (!valuesByToken) {
                    valuesByToken = new Map();
                    this.valuesByTokenByElement.set(element, valuesByToken);
                }
                return valuesByToken;
            }
        },
        {
            key: "parseToken",
            value: function parseToken(token) {
                try {
                    var value = this.delegate.parseValueForToken(token);
                    return {
                        value: value
                    };
                } catch (error) {
                    return {
                        error: error
                    };
                }
            }
        }
    ]);
    return ValueListObserver;
}();
var $9761593eb1d92c30$var$BindingObserver = /*#__PURE__*/ function() {
    "use strict";
    function BindingObserver(context, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, BindingObserver);
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(BindingObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.valueListObserver) {
                    this.valueListObserver = new $9761593eb1d92c30$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
                    this.valueListObserver.start();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.valueListObserver) {
                    this.valueListObserver.stop();
                    delete this.valueListObserver;
                    this.disconnectAllActions();
                }
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "actionAttribute",
            get: function get() {
                return this.schema.actionAttribute;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.context.schema;
            }
        },
        {
            key: "bindings",
            get: function get() {
                return Array.from(this.bindingsByAction.values());
            }
        },
        {
            key: "connectAction",
            value: function connectAction(action) {
                var binding = new $9761593eb1d92c30$var$Binding(this.context, action);
                this.bindingsByAction.set(action, binding);
                this.delegate.bindingConnected(binding);
            }
        },
        {
            key: "disconnectAction",
            value: function disconnectAction(action) {
                var binding = this.bindingsByAction.get(action);
                if (binding) {
                    this.bindingsByAction["delete"](action);
                    this.delegate.bindingDisconnected(binding);
                }
            }
        },
        {
            key: "disconnectAllActions",
            value: function disconnectAllActions() {
                var _this = this;
                this.bindings.forEach(function(binding) {
                    return _this.delegate.bindingDisconnected(binding, true);
                });
                this.bindingsByAction.clear();
            }
        },
        {
            key: "parseValueForToken",
            value: function parseValueForToken(token) {
                var action = $9761593eb1d92c30$var$Action.forToken(token, this.schema);
                if (action.identifier == this.identifier) return action;
            }
        },
        {
            key: "elementMatchedValue",
            value: function elementMatchedValue(element, action) {
                this.connectAction(action);
            }
        },
        {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(element, action) {
                this.disconnectAction(action);
            }
        }
    ]);
    return BindingObserver;
}();
var $9761593eb1d92c30$var$ValueObserver = /*#__PURE__*/ function() {
    "use strict";
    function ValueObserver(context, receiver) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ValueObserver);
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $9761593eb1d92c30$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ValueObserver, [
        {
            key: "start",
            value: function start() {
                this.stringMapObserver.start();
                this.invokeChangedCallbacksForDefaultValues();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.stringMapObserver.stop();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "controller",
            get: function get() {
                return this.context.controller;
            }
        },
        {
            key: "getStringMapKeyForAttribute",
            value: function getStringMapKeyForAttribute(attributeName) {
                if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
            }
        },
        {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(key, attributeName) {
                var descriptor = this.valueDescriptorMap[attributeName];
                if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
            }
        },
        {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(value, name, oldValue) {
                var descriptor = this.valueDescriptorNameMap[name];
                if (value === null) return;
                if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
                this.invokeChangedCallback(name, value, oldValue);
            }
        },
        {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(key, attributeName, oldValue) {
                var descriptor = this.valueDescriptorNameMap[key];
                if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
                else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
            }
        },
        {
            key: "invokeChangedCallbacksForDefaultValues",
            value: function invokeChangedCallbacksForDefaultValues() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.valueDescriptors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, key = _step_value.key, name = _step_value.name, defaultValue = _step_value.defaultValue, writer = _step_value.writer;
                        if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "invokeChangedCallback",
            value: function invokeChangedCallback(name, rawValue, rawOldValue) {
                var changedMethodName = "".concat(name, "Changed");
                var changedMethod = this.receiver[changedMethodName];
                if (typeof changedMethod == "function") {
                    var descriptor = this.valueDescriptorNameMap[name];
                    try {
                        var value = descriptor.reader(rawValue);
                        var oldValue = rawOldValue;
                        if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                        changedMethod.call(this.receiver, value, oldValue);
                    } catch (error) {
                        if (error instanceof TypeError) error.message = 'Stimulus Value "'.concat(this.context.identifier, ".").concat(descriptor.name, '" - ').concat(error.message);
                        throw error;
                    }
                }
            }
        },
        {
            key: "valueDescriptors",
            get: function get() {
                var valueDescriptorMap = this.valueDescriptorMap;
                return Object.keys(valueDescriptorMap).map(function(key) {
                    return valueDescriptorMap[key];
                });
            }
        },
        {
            key: "valueDescriptorNameMap",
            get: function get() {
                var _this = this;
                var descriptors = {};
                Object.keys(this.valueDescriptorMap).forEach(function(key) {
                    var descriptor = _this.valueDescriptorMap[key];
                    descriptors[descriptor.name] = descriptor;
                });
                return descriptors;
            }
        },
        {
            key: "hasValue",
            value: function hasValue(attributeName) {
                var descriptor = this.valueDescriptorNameMap[attributeName];
                var hasMethodName = "has".concat($9761593eb1d92c30$var$capitalize(descriptor.name));
                return this.receiver[hasMethodName];
            }
        }
    ]);
    return ValueObserver;
}();
var $9761593eb1d92c30$var$TargetObserver = /*#__PURE__*/ function() {
    "use strict";
    function TargetObserver(context, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TargetObserver);
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TargetObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.tokenListObserver) {
                    this.tokenListObserver = new $9761593eb1d92c30$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
                    this.tokenListObserver.start();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.tokenListObserver) {
                    this.disconnectAllTargets();
                    this.tokenListObserver.stop();
                    delete this.tokenListObserver;
                }
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(param) {
                var element = param.element, name = param.content;
                if (this.scope.containsElement(element)) this.connectTarget(element, name);
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(param) {
                var element = param.element, name = param.content;
                this.disconnectTarget(element, name);
            }
        },
        {
            key: "connectTarget",
            value: function connectTarget(element, name) {
                var _this = this;
                var _a;
                if (!this.targetsByName.has(name, element)) {
                    this.targetsByName.add(name, element);
                    (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.targetConnected(element, name);
                    });
                }
            }
        },
        {
            key: "disconnectTarget",
            value: function disconnectTarget(element, name) {
                var _this = this;
                var _a;
                if (this.targetsByName.has(name, element)) {
                    this.targetsByName["delete"](name, element);
                    (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.targetDisconnected(element, name);
                    });
                }
            }
        },
        {
            key: "disconnectAllTargets",
            value: function disconnectAllTargets() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = this.targetsByName.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var name = _step.value;
                        try {
                            for(var _iterator1 = this.targetsByName.getValuesForKey(name)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var element = _step1.value;
                                this.disconnectTarget(element, name);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return "data-".concat(this.context.identifier, "-target");
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        }
    ]);
    return TargetObserver;
}();
function $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, propertyName) {
    var ancestors = $9761593eb1d92c30$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce(function(values, constructor) {
        $9761593eb1d92c30$var$getOwnStaticArrayValues(constructor, propertyName).forEach(function(name) {
            return values.add(name);
        });
        return values;
    }, new Set()));
}
function $9761593eb1d92c30$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    var ancestors = $9761593eb1d92c30$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce(function(pairs, constructor) {
        var _pairs;
        (_pairs = pairs).push.apply(_pairs, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)($9761593eb1d92c30$var$getOwnStaticObjectPairs(constructor, propertyName)));
        return pairs;
    }, []);
}
function $9761593eb1d92c30$var$getAncestorsForConstructor(constructor) {
    var ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $9761593eb1d92c30$var$getOwnStaticArrayValues(constructor, propertyName) {
    var definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $9761593eb1d92c30$var$getOwnStaticObjectPairs(constructor, propertyName) {
    var definition = constructor[propertyName];
    return definition ? Object.keys(definition).map(function(key) {
        return [
            key,
            definition[key]
        ];
    }) : [];
}
var $9761593eb1d92c30$var$OutletObserver = /*#__PURE__*/ function() {
    "use strict";
    function OutletObserver(context, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, OutletObserver);
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(OutletObserver, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                if (!this.started) {
                    this.outletDefinitions.forEach(function(outletName) {
                        _this.setupSelectorObserverForOutlet(outletName);
                        _this.setupAttributeObserverForOutlet(outletName);
                    });
                    this.started = true;
                    this.dependentContexts.forEach(function(context) {
                        return context.refresh();
                    });
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.selectorObserverMap.forEach(function(observer) {
                    return observer.refresh();
                });
                this.attributeObserverMap.forEach(function(observer) {
                    return observer.refresh();
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.disconnectAllOutlets();
                    this.stopSelectorObservers();
                    this.stopAttributeObservers();
                }
            }
        },
        {
            key: "stopSelectorObservers",
            value: function stopSelectorObservers() {
                if (this.selectorObserverMap.size > 0) {
                    this.selectorObserverMap.forEach(function(observer) {
                        return observer.stop();
                    });
                    this.selectorObserverMap.clear();
                }
            }
        },
        {
            key: "stopAttributeObservers",
            value: function stopAttributeObservers() {
                if (this.attributeObserverMap.size > 0) {
                    this.attributeObserverMap.forEach(function(observer) {
                        return observer.stop();
                    });
                    this.attributeObserverMap.clear();
                }
            }
        },
        {
            key: "selectorMatched",
            value: function selectorMatched(element, _selector, param) {
                var outletName = param.outletName;
                var outlet = this.getOutlet(element, outletName);
                if (outlet) this.connectOutlet(outlet, element, outletName);
            }
        },
        {
            key: "selectorUnmatched",
            value: function selectorUnmatched(element, _selector, param) {
                var outletName = param.outletName;
                var outlet = this.getOutletFromMap(element, outletName);
                if (outlet) this.disconnectOutlet(outlet, element, outletName);
            }
        },
        {
            key: "selectorMatchElement",
            value: function selectorMatchElement(element, param) {
                var outletName = param.outletName;
                var selector = this.selector(outletName);
                var hasOutlet = this.hasOutlet(element, outletName);
                var hasOutletController = element.matches("[".concat(this.schema.controllerAttribute, "~=").concat(outletName, "]"));
                if (selector) return hasOutlet && hasOutletController && element.matches(selector);
                else return false;
            }
        },
        {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "connectOutlet",
            value: function connectOutlet(outlet, element, outletName) {
                var _this = this;
                var _a;
                if (!this.outletElementsByName.has(outletName, element)) {
                    this.outletsByName.add(outletName, outlet);
                    this.outletElementsByName.add(outletName, element);
                    (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.outletConnected(outlet, element, outletName);
                    });
                }
            }
        },
        {
            key: "disconnectOutlet",
            value: function disconnectOutlet(outlet, element, outletName) {
                var _this = this;
                var _a;
                if (this.outletElementsByName.has(outletName, element)) {
                    this.outletsByName["delete"](outletName, outlet);
                    this.outletElementsByName["delete"](outletName, element);
                    (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.outletDisconnected(outlet, element, outletName);
                    });
                }
            }
        },
        {
            key: "disconnectAllOutlets",
            value: function disconnectAllOutlets() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.outletElementsByName.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var outletName = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator1 = this.outletElementsByName.getValuesForKey(outletName)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                var element = _step1.value;
                                try {
                                    for(var _iterator2 = this.outletsByName.getValuesForKey(outletName)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                                        var outlet = _step2.value;
                                        this.disconnectOutlet(outlet, element, outletName);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "updateSelectorObserverForOutlet",
            value: function updateSelectorObserverForOutlet(outletName) {
                var observer = this.selectorObserverMap.get(outletName);
                if (observer) observer.selector = this.selector(outletName);
            }
        },
        {
            key: "setupSelectorObserverForOutlet",
            value: function setupSelectorObserverForOutlet(outletName) {
                var selector = this.selector(outletName);
                var selectorObserver = new $9761593eb1d92c30$export$116e0b48509995b(document.body, selector, this, {
                    outletName: outletName
                });
                this.selectorObserverMap.set(outletName, selectorObserver);
                selectorObserver.start();
            }
        },
        {
            key: "setupAttributeObserverForOutlet",
            value: function setupAttributeObserverForOutlet(outletName) {
                var attributeName = this.attributeNameForOutletName(outletName);
                var attributeObserver = new $9761593eb1d92c30$export$fe68319d413d05cb(this.scope.element, attributeName, this);
                this.attributeObserverMap.set(outletName, attributeObserver);
                attributeObserver.start();
            }
        },
        {
            key: "selector",
            value: function selector(outletName) {
                return this.scope.outlets.getSelectorForOutletName(outletName);
            }
        },
        {
            key: "attributeNameForOutletName",
            value: function attributeNameForOutletName(outletName) {
                return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
            }
        },
        {
            key: "getOutletNameFromOutletAttributeName",
            value: function getOutletNameFromOutletAttributeName(attributeName) {
                var _this = this;
                return this.outletDefinitions.find(function(outletName) {
                    return _this.attributeNameForOutletName(outletName) === attributeName;
                });
            }
        },
        {
            key: "outletDependencies",
            get: function get() {
                var dependencies = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
                this.router.modules.forEach(function(module) {
                    var constructor = module.definition.controllerConstructor;
                    var outlets = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "outlets");
                    outlets.forEach(function(outlet) {
                        return dependencies.add(outlet, module.identifier);
                    });
                });
                return dependencies;
            }
        },
        {
            key: "outletDefinitions",
            get: function get() {
                return this.outletDependencies.getKeysForValue(this.identifier);
            }
        },
        {
            key: "dependentControllerIdentifiers",
            get: function get() {
                return this.outletDependencies.getValuesForKey(this.identifier);
            }
        },
        {
            key: "dependentContexts",
            get: function get() {
                var identifiers = this.dependentControllerIdentifiers;
                return this.router.contexts.filter(function(context) {
                    return identifiers.includes(context.identifier);
                });
            }
        },
        {
            key: "hasOutlet",
            value: function hasOutlet(element, outletName) {
                return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
            }
        },
        {
            key: "getOutlet",
            value: function getOutlet(element, outletName) {
                return this.application.getControllerForElementAndIdentifier(element, outletName);
            }
        },
        {
            key: "getOutletFromMap",
            value: function getOutletFromMap(element, outletName) {
                return this.outletsByName.getValuesForKey(outletName).find(function(outlet) {
                    return outlet.element === element;
                });
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.context.schema;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "application",
            get: function get() {
                return this.context.application;
            }
        },
        {
            key: "router",
            get: function get() {
                return this.application.router;
            }
        }
    ]);
    return OutletObserver;
}();
var $9761593eb1d92c30$export$841858b892ce1f4c = /*#__PURE__*/ function() {
    "use strict";
    function Context(module, scope) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Context);
        this.logDebugActivity = function(functionName) {
            var detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var identifier = _this.identifier, controller = _this.controller, element = _this.element;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            _this.application.logDebugActivity(_this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $9761593eb1d92c30$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $9761593eb1d92c30$var$ValueObserver(this, this.controller);
        this.targetObserver = new $9761593eb1d92c30$var$TargetObserver(this, this);
        this.outletObserver = new $9761593eb1d92c30$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Context, [
        {
            key: "connect",
            value: function connect() {
                this.bindingObserver.start();
                this.valueObserver.start();
                this.targetObserver.start();
                this.outletObserver.start();
                try {
                    this.controller.connect();
                    this.logDebugActivity("connect");
                } catch (error) {
                    this.handleError(error, "connecting controller");
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.outletObserver.refresh();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                try {
                    this.controller.disconnect();
                    this.logDebugActivity("disconnect");
                } catch (error) {
                    this.handleError(error, "disconnecting controller");
                }
                this.outletObserver.stop();
                this.targetObserver.stop();
                this.valueObserver.stop();
                this.bindingObserver.stop();
            }
        },
        {
            key: "application",
            get: function get() {
                return this.module.application;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.module.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.application.schema;
            }
        },
        {
            key: "dispatcher",
            get: function get() {
                return this.application.dispatcher;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "parentElement",
            get: function get() {
                return this.element.parentElement;
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this, identifier = _this.identifier, controller = _this.controller, element = _this.element;
                detail = Object.assign({
                    identifier: identifier,
                    controller: controller,
                    element: element
                }, detail);
                this.application.handleError(error, "Error ".concat(message), detail);
            }
        },
        {
            key: "targetConnected",
            value: function targetConnected(element, name) {
                this.invokeControllerMethod("".concat(name, "TargetConnected"), element);
            }
        },
        {
            key: "targetDisconnected",
            value: function targetDisconnected(element, name) {
                this.invokeControllerMethod("".concat(name, "TargetDisconnected"), element);
            }
        },
        {
            key: "outletConnected",
            value: function outletConnected(outlet, element, name) {
                this.invokeControllerMethod("".concat($9761593eb1d92c30$var$namespaceCamelize(name), "OutletConnected"), outlet, element);
            }
        },
        {
            key: "outletDisconnected",
            value: function outletDisconnected(outlet, element, name) {
                this.invokeControllerMethod("".concat($9761593eb1d92c30$var$namespaceCamelize(name), "OutletDisconnected"), outlet, element);
            }
        },
        {
            key: "invokeControllerMethod",
            value: function invokeControllerMethod(methodName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _controller;
                var controller = this.controller;
                if (typeof controller[methodName] == "function") (_controller = controller)[methodName].apply(_controller, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
            }
        }
    ]);
    return Context;
}();
function $9761593eb1d92c30$var$bless(constructor) {
    return $9761593eb1d92c30$var$shadow(constructor, $9761593eb1d92c30$var$getBlessedProperties(constructor));
}
function $9761593eb1d92c30$var$shadow(constructor, properties) {
    var shadowConstructor = $9761593eb1d92c30$var$extend(constructor);
    var shadowProperties = $9761593eb1d92c30$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $9761593eb1d92c30$var$getBlessedProperties(constructor) {
    var blessings = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce(function(blessedProperties, blessing) {
        var properties = blessing(constructor);
        for(var key in properties){
            var descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $9761593eb1d92c30$var$getShadowProperties(prototype, properties) {
    return $9761593eb1d92c30$var$getOwnKeys(properties).reduce(function(shadowProperties, key) {
        var descriptor = $9761593eb1d92c30$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, key, descriptor));
        return shadowProperties;
    }, {});
}
function $9761593eb1d92c30$var$getShadowedDescriptor(prototype, properties, key) {
    var shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    var shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        var descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
var $9761593eb1d92c30$var$getOwnKeys = function() {
    if (typeof Object.getOwnPropertySymbols == "function") return function(object) {
        return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(Object.getOwnPropertyNames(object)).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(Object.getOwnPropertySymbols(object)));
    };
    else return Object.getOwnPropertyNames;
}();
var $9761593eb1d92c30$var$extend = function _target() {
    var extendWithReflect = function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, this instanceof extended ? this.constructor : void 0);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    };
    var testReflectExtension = function testReflectExtension() {
        var a = function a() {
            this.a.call(this);
        };
        var b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    };
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return function(constructor) {
            return /*#__PURE__*/ function(constructor) {
                "use strict";
                (0, $28f6179e2b599279$export$71511d61b312f219)(extended, constructor);
                function extended() {
                    (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, extended);
                    return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, extended, arguments);
                }
                return extended;
            }(constructor);
        };
    }
}();
function $9761593eb1d92c30$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $9761593eb1d92c30$var$bless(definition.controllerConstructor)
    };
}
var $9761593eb1d92c30$var$Module = /*#__PURE__*/ function() {
    "use strict";
    function Module(application, definition) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Module);
        this.application = application;
        this.definition = $9761593eb1d92c30$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Module, [
        {
            key: "identifier",
            get: function get() {
                return this.definition.identifier;
            }
        },
        {
            key: "controllerConstructor",
            get: function get() {
                return this.definition.controllerConstructor;
            }
        },
        {
            key: "contexts",
            get: function get() {
                return Array.from(this.connectedContexts);
            }
        },
        {
            key: "connectContextForScope",
            value: function connectContextForScope(scope) {
                var context = this.fetchContextForScope(scope);
                this.connectedContexts.add(context);
                context.connect();
            }
        },
        {
            key: "disconnectContextForScope",
            value: function disconnectContextForScope(scope) {
                var context = this.contextsByScope.get(scope);
                if (context) {
                    this.connectedContexts["delete"](context);
                    context.disconnect();
                }
            }
        },
        {
            key: "fetchContextForScope",
            value: function fetchContextForScope(scope) {
                var context = this.contextsByScope.get(scope);
                if (!context) {
                    context = new $9761593eb1d92c30$export$841858b892ce1f4c(this, scope);
                    this.contextsByScope.set(scope, context);
                }
                return context;
            }
        }
    ]);
    return Module;
}();
var $9761593eb1d92c30$var$ClassMap = /*#__PURE__*/ function() {
    "use strict";
    function ClassMap(scope) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ClassMap);
        this.scope = scope;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ClassMap, [
        {
            key: "has",
            value: function has(name) {
                return this.data.has(this.getDataKey(name));
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.getAll(name)[0];
            }
        },
        {
            key: "getAll",
            value: function getAll(name) {
                var tokenString = this.data.get(this.getDataKey(name)) || "";
                return $9761593eb1d92c30$var$tokenize(tokenString);
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName(name) {
                return this.data.getAttributeNameForKey(this.getDataKey(name));
            }
        },
        {
            key: "getDataKey",
            value: function getDataKey(name) {
                return "".concat(name, "-class");
            }
        },
        {
            key: "data",
            get: function get() {
                return this.scope.data;
            }
        }
    ]);
    return ClassMap;
}();
var $9761593eb1d92c30$var$DataMap = /*#__PURE__*/ function() {
    "use strict";
    function DataMap(scope) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, DataMap);
        this.scope = scope;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(DataMap, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "get",
            value: function get(key) {
                var name = this.getAttributeNameForKey(key);
                return this.element.getAttribute(name);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var name = this.getAttributeNameForKey(key);
                this.element.setAttribute(name, value);
                return this.get(key);
            }
        },
        {
            key: "has",
            value: function has(key) {
                var name = this.getAttributeNameForKey(key);
                return this.element.hasAttribute(name);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                if (this.has(key)) {
                    var name = this.getAttributeNameForKey(key);
                    this.element.removeAttribute(name);
                    return true;
                } else return false;
            }
        },
        {
            key: "getAttributeNameForKey",
            value: function getAttributeNameForKey(key) {
                return "data-".concat(this.identifier, "-").concat($9761593eb1d92c30$var$dasherize(key));
            }
        }
    ]);
    return DataMap;
}();
var $9761593eb1d92c30$var$Guide = /*#__PURE__*/ function() {
    "use strict";
    function Guide(logger) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Guide);
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Guide, [
        {
            key: "warn",
            value: function warn(object, key, message) {
                var warnedKeys = this.warnedKeysByObject.get(object);
                if (!warnedKeys) {
                    warnedKeys = new Set();
                    this.warnedKeysByObject.set(object, warnedKeys);
                }
                if (!warnedKeys.has(key)) {
                    warnedKeys.add(key);
                    this.logger.warn(message, object);
                }
            }
        }
    ]);
    return Guide;
}();
function $9761593eb1d92c30$var$attributeValueContainsToken(attributeName, token) {
    return "[".concat(attributeName, '~="').concat(token, '"]');
}
var $9761593eb1d92c30$var$TargetSet = /*#__PURE__*/ function() {
    "use strict";
    function TargetSet(scope) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TargetSet);
        this.scope = scope;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TargetSet, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.scope.schema;
            }
        },
        {
            key: "has",
            value: function has(targetName) {
                return this.find(targetName) != null;
            }
        },
        {
            key: "find",
            value: function find() {
                var _this = this;
                for(var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++){
                    targetNames[_key] = arguments[_key];
                }
                return targetNames.reduce(function(target, targetName) {
                    return target || _this.findTarget(targetName) || _this.findLegacyTarget(targetName);
                }, undefined);
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var _this = this;
                for(var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++){
                    targetNames[_key] = arguments[_key];
                }
                return targetNames.reduce(function(targets, targetName) {
                    return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(targets).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this.findAllTargets(targetName)), (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this.findAllLegacyTargets(targetName)));
                }, []);
            }
        },
        {
            key: "findTarget",
            value: function findTarget(targetName) {
                var selector = this.getSelectorForTargetName(targetName);
                return this.scope.findElement(selector);
            }
        },
        {
            key: "findAllTargets",
            value: function findAllTargets(targetName) {
                var selector = this.getSelectorForTargetName(targetName);
                return this.scope.findAllElements(selector);
            }
        },
        {
            key: "getSelectorForTargetName",
            value: function getSelectorForTargetName(targetName) {
                var attributeName = this.schema.targetAttributeForScope(this.identifier);
                return $9761593eb1d92c30$var$attributeValueContainsToken(attributeName, targetName);
            }
        },
        {
            key: "findLegacyTarget",
            value: function findLegacyTarget(targetName) {
                var selector = this.getLegacySelectorForTargetName(targetName);
                return this.deprecate(this.scope.findElement(selector), targetName);
            }
        },
        {
            key: "findAllLegacyTargets",
            value: function findAllLegacyTargets(targetName) {
                var _this = this;
                var selector = this.getLegacySelectorForTargetName(targetName);
                return this.scope.findAllElements(selector).map(function(element) {
                    return _this.deprecate(element, targetName);
                });
            }
        },
        {
            key: "getLegacySelectorForTargetName",
            value: function getLegacySelectorForTargetName(targetName) {
                var targetDescriptor = "".concat(this.identifier, ".").concat(targetName);
                return $9761593eb1d92c30$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
            }
        },
        {
            key: "deprecate",
            value: function deprecate(element, targetName) {
                if (element) {
                    var identifier = this.identifier;
                    var attributeName = this.schema.targetAttribute;
                    var revisedAttributeName = this.schema.targetAttributeForScope(identifier);
                    this.guide.warn(element, "target:".concat(targetName), "Please replace ".concat(attributeName, '="').concat(identifier, ".").concat(targetName, '" with ').concat(revisedAttributeName, '="').concat(targetName, '". ') + "The ".concat(attributeName, " attribute is deprecated and will be removed in a future version of Stimulus."));
                }
                return element;
            }
        },
        {
            key: "guide",
            get: function get() {
                return this.scope.guide;
            }
        }
    ]);
    return TargetSet;
}();
var $9761593eb1d92c30$var$OutletSet = /*#__PURE__*/ function() {
    "use strict";
    function OutletSet(scope, controllerElement) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, OutletSet);
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(OutletSet, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.scope.schema;
            }
        },
        {
            key: "has",
            value: function has(outletName) {
                return this.find(outletName) != null;
            }
        },
        {
            key: "find",
            value: function find() {
                var _this = this;
                for(var _len = arguments.length, outletNames = new Array(_len), _key = 0; _key < _len; _key++){
                    outletNames[_key] = arguments[_key];
                }
                return outletNames.reduce(function(outlet, outletName) {
                    return outlet || _this.findOutlet(outletName);
                }, undefined);
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var _this = this;
                for(var _len = arguments.length, outletNames = new Array(_len), _key = 0; _key < _len; _key++){
                    outletNames[_key] = arguments[_key];
                }
                return outletNames.reduce(function(outlets, outletName) {
                    return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(outlets).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this.findAllOutlets(outletName)));
                }, []);
            }
        },
        {
            key: "getSelectorForOutletName",
            value: function getSelectorForOutletName(outletName) {
                var attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
                return this.controllerElement.getAttribute(attributeName);
            }
        },
        {
            key: "findOutlet",
            value: function findOutlet(outletName) {
                var selector = this.getSelectorForOutletName(outletName);
                if (selector) return this.findElement(selector, outletName);
            }
        },
        {
            key: "findAllOutlets",
            value: function findAllOutlets(outletName) {
                var selector = this.getSelectorForOutletName(outletName);
                return selector ? this.findAllElements(selector, outletName) : [];
            }
        },
        {
            key: "findElement",
            value: function findElement(selector, outletName) {
                var _this = this;
                var elements = this.scope.queryElements(selector);
                return elements.filter(function(element) {
                    return _this.matchesElement(element, selector, outletName);
                })[0];
            }
        },
        {
            key: "findAllElements",
            value: function findAllElements(selector, outletName) {
                var _this = this;
                var elements = this.scope.queryElements(selector);
                return elements.filter(function(element) {
                    return _this.matchesElement(element, selector, outletName);
                });
            }
        },
        {
            key: "matchesElement",
            value: function matchesElement(element, selector, outletName) {
                var controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
                return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
            }
        }
    ]);
    return OutletSet;
}();
var $9761593eb1d92c30$var$Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope(schema, element, identifier, logger) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Scope);
        this.targets = new $9761593eb1d92c30$var$TargetSet(this);
        this.classes = new $9761593eb1d92c30$var$ClassMap(this);
        this.data = new $9761593eb1d92c30$var$DataMap(this);
        this.containsElement = function(element) {
            return element.closest(_this.controllerSelector) === _this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $9761593eb1d92c30$var$Guide(logger);
        this.outlets = new $9761593eb1d92c30$var$OutletSet(this.documentScope, element);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Scope, [
        {
            key: "findElement",
            value: function findElement(selector) {
                return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
            }
        },
        {
            key: "findAllElements",
            value: function findAllElements(selector) {
                return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(this.element.matches(selector) ? [
                    this.element
                ] : []).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(this.queryElements(selector).filter(this.containsElement)));
            }
        },
        {
            key: "queryElements",
            value: function queryElements(selector) {
                return Array.from(this.element.querySelectorAll(selector));
            }
        },
        {
            key: "controllerSelector",
            get: function get() {
                return $9761593eb1d92c30$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
            }
        },
        {
            key: "isDocumentScope",
            get: function get() {
                return this.element === document.documentElement;
            }
        },
        {
            key: "documentScope",
            get: function get() {
                return this.isDocumentScope ? this : new Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
            }
        }
    ]);
    return Scope;
}();
var $9761593eb1d92c30$var$ScopeObserver = /*#__PURE__*/ function() {
    "use strict";
    function ScopeObserver(element, schema, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ScopeObserver);
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $9761593eb1d92c30$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ScopeObserver, [
        {
            key: "start",
            value: function start() {
                this.valueListObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.valueListObserver.stop();
            }
        },
        {
            key: "controllerAttribute",
            get: function get() {
                return this.schema.controllerAttribute;
            }
        },
        {
            key: "parseValueForToken",
            value: function parseValueForToken(token) {
                var element = token.element, identifier = token.content;
                return this.parseValueForElementAndIdentifier(element, identifier);
            }
        },
        {
            key: "parseValueForElementAndIdentifier",
            value: function parseValueForElementAndIdentifier(element, identifier) {
                var scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
                var scope = scopesByIdentifier.get(identifier);
                if (!scope) {
                    scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
                    scopesByIdentifier.set(identifier, scope);
                }
                return scope;
            }
        },
        {
            key: "elementMatchedValue",
            value: function elementMatchedValue(element, value) {
                var referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
                this.scopeReferenceCounts.set(value, referenceCount);
                if (referenceCount == 1) this.delegate.scopeConnected(value);
            }
        },
        {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(element, value) {
                var referenceCount = this.scopeReferenceCounts.get(value);
                if (referenceCount) {
                    this.scopeReferenceCounts.set(value, referenceCount - 1);
                    if (referenceCount == 1) this.delegate.scopeDisconnected(value);
                }
            }
        },
        {
            key: "fetchScopesByIdentifierForElement",
            value: function fetchScopesByIdentifierForElement(element) {
                var scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
                if (!scopesByIdentifier) {
                    scopesByIdentifier = new Map();
                    this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
                }
                return scopesByIdentifier;
            }
        }
    ]);
    return ScopeObserver;
}();
var $9761593eb1d92c30$var$Router = /*#__PURE__*/ function() {
    "use strict";
    function Router(application) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Router);
        this.application = application;
        this.scopeObserver = new $9761593eb1d92c30$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Router, [
        {
            key: "element",
            get: function get() {
                return this.application.element;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.application.schema;
            }
        },
        {
            key: "logger",
            get: function get() {
                return this.application.logger;
            }
        },
        {
            key: "controllerAttribute",
            get: function get() {
                return this.schema.controllerAttribute;
            }
        },
        {
            key: "modules",
            get: function get() {
                return Array.from(this.modulesByIdentifier.values());
            }
        },
        {
            key: "contexts",
            get: function get() {
                return this.modules.reduce(function(contexts, module) {
                    return contexts.concat(module.contexts);
                }, []);
            }
        },
        {
            key: "start",
            value: function start() {
                this.scopeObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scopeObserver.stop();
            }
        },
        {
            key: "loadDefinition",
            value: function loadDefinition(definition) {
                this.unloadIdentifier(definition.identifier);
                var module = new $9761593eb1d92c30$var$Module(this.application, definition);
                this.connectModule(module);
                var afterLoad = definition.controllerConstructor.afterLoad;
                if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
            }
        },
        {
            key: "unloadIdentifier",
            value: function unloadIdentifier(identifier) {
                var module = this.modulesByIdentifier.get(identifier);
                if (module) this.disconnectModule(module);
            }
        },
        {
            key: "getContextForElementAndIdentifier",
            value: function getContextForElementAndIdentifier(element, identifier) {
                var module = this.modulesByIdentifier.get(identifier);
                if (module) return module.contexts.find(function(context) {
                    return context.element == element;
                });
            }
        },
        {
            key: "proposeToConnectScopeForElementAndIdentifier",
            value: function proposeToConnectScopeForElementAndIdentifier(element, identifier) {
                var scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
                if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
                else console.error("Couldn't find or create scope for identifier: \"".concat(identifier, '" and element:'), element);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message, detail) {
                this.application.handleError(error, message, detail);
            }
        },
        {
            key: "createScopeForElementAndIdentifier",
            value: function createScopeForElementAndIdentifier(element, identifier) {
                return new $9761593eb1d92c30$var$Scope(this.schema, element, identifier, this.logger);
            }
        },
        {
            key: "scopeConnected",
            value: function scopeConnected(scope) {
                this.scopesByIdentifier.add(scope.identifier, scope);
                var module = this.modulesByIdentifier.get(scope.identifier);
                if (module) module.connectContextForScope(scope);
            }
        },
        {
            key: "scopeDisconnected",
            value: function scopeDisconnected(scope) {
                this.scopesByIdentifier["delete"](scope.identifier, scope);
                var module = this.modulesByIdentifier.get(scope.identifier);
                if (module) module.disconnectContextForScope(scope);
            }
        },
        {
            key: "connectModule",
            value: function connectModule(module) {
                this.modulesByIdentifier.set(module.identifier, module);
                var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
                scopes.forEach(function(scope) {
                    return module.connectContextForScope(scope);
                });
            }
        },
        {
            key: "disconnectModule",
            value: function disconnectModule(module) {
                this.modulesByIdentifier["delete"](module.identifier);
                var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
                scopes.forEach(function(scope) {
                    return module.disconnectContextForScope(scope);
                });
            }
        }
    ]);
    return Router;
}();
var $9761593eb1d92c30$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: function(identifier) {
        return "data-".concat(identifier, "-target");
    },
    outletAttributeForScope: function(identifier, outlet) {
        return "data-".concat(identifier, "-").concat(outlet, "-outlet");
    },
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $9761593eb1d92c30$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map(function(c) {
        return [
            c,
            c
        ];
    }))), $9761593eb1d92c30$var$objectFromEntries("0123456789".split("").map(function(n) {
        return [
            n,
            n
        ];
    })))
};
function $9761593eb1d92c30$var$objectFromEntries(array) {
    return array.reduce(function(memo, param) {
        var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), k = _param[0], v = _param[1];
        return Object.assign(Object.assign({}, memo), (0, $a6437d79afda84c4$export$71511d61b312f219)({}, k, v));
    }, {});
}
var $9761593eb1d92c30$export$16975c34e60e1e61 = /*#__PURE__*/ function() {
    "use strict";
    function Application() {
        var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.documentElement, schema = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9761593eb1d92c30$export$1db618b7b2275ea1;
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Application);
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = function(identifier, functionName) {
            var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (_this.debug) _this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $9761593eb1d92c30$var$Dispatcher(this);
        this.router = new $9761593eb1d92c30$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $9761593eb1d92c30$var$defaultActionDescriptorFilters);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Application, [
        {
            key: "start",
            value: function start() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9761593eb1d92c30$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                this.logDebugActivity("application", "starting");
                                this.dispatcher.start();
                                this.router.start();
                                this.logDebugActivity("application", "start");
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.logDebugActivity("application", "stopping");
                this.dispatcher.stop();
                this.router.stop();
                this.logDebugActivity("application", "stop");
            }
        },
        {
            key: "register",
            value: function register(identifier, controllerConstructor) {
                this.load({
                    identifier: identifier,
                    controllerConstructor: controllerConstructor
                });
            }
        },
        {
            key: "registerActionOption",
            value: function registerActionOption(name, filter) {
                this.actionDescriptorFilters[name] = filter;
            }
        },
        {
            key: "load",
            value: function load(head) {
                var _this = this;
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var definitions = Array.isArray(head) ? head : [
                    head
                ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(rest));
                definitions.forEach(function(definition) {
                    if (definition.controllerConstructor.shouldLoad) _this.router.loadDefinition(definition);
                });
            }
        },
        {
            key: "unload",
            value: function unload(head) {
                var _this = this;
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var identifiers = Array.isArray(head) ? head : [
                    head
                ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(rest));
                identifiers.forEach(function(identifier) {
                    return _this.router.unloadIdentifier(identifier);
                });
            }
        },
        {
            key: "controllers",
            get: function get() {
                return this.router.contexts.map(function(context) {
                    return context.controller;
                });
            }
        },
        {
            key: "getControllerForElementAndIdentifier",
            value: function getControllerForElementAndIdentifier(element, identifier) {
                var context = this.router.getContextForElementAndIdentifier(element, identifier);
                return context ? context.controller : null;
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message, detail) {
                var _a;
                this.logger.error("%s\n\n%o\n\n%o", message, error, detail);
                (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
            }
        },
        {
            key: "logFormattedMessage",
            value: function logFormattedMessage(identifier, functionName) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                detail = Object.assign({
                    application: this
                }, detail);
                this.logger.groupCollapsed("".concat(identifier, " #").concat(functionName));
                this.logger.log("details:", Object.assign({}, detail));
                this.logger.groupEnd();
            }
        }
    ], [
        {
            key: "start",
            value: function start(element, schema) {
                var application = new this(element, schema);
                application.start();
                return application;
            }
        }
    ]);
    return Application;
}();
function $9761593eb1d92c30$var$domReady() {
    return new Promise(function(resolve) {
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", function() {
            return resolve();
        });
        else resolve();
    });
}
function $9761593eb1d92c30$var$ClassPropertiesBlessing(constructor) {
    var classes = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce(function(properties, classDefinition) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $9761593eb1d92c30$var$propertiesForClassDefinition(key) {
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(key, "Class"), {
        get: function() {
            var classes = this.classes;
            if (classes.has(key)) return classes.get(key);
            else {
                var attribute = classes.getAttributeName(key);
                throw new Error('Missing attribute "'.concat(attribute, '"'));
            }
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(key, "Classes"), {
        get: function() {
            return this.classes.getAll(key);
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(key), "Class"), {
        get: function() {
            return this.classes.has(key);
        }
    }), _obj;
}
function $9761593eb1d92c30$var$OutletPropertiesBlessing(constructor) {
    var outlets = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce(function(properties, outletDefinition) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $9761593eb1d92c30$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $9761593eb1d92c30$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    var outletController = $9761593eb1d92c30$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $9761593eb1d92c30$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $9761593eb1d92c30$var$propertiesForOutletDefinition(name) {
    var camelizedName = $9761593eb1d92c30$var$namespaceCamelize(name);
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "Outlet"), {
        get: function() {
            var outletElement = this.outlets.find(name);
            var selector = this.outlets.getSelectorForOutletName(name);
            if (outletElement) {
                var outletController = $9761593eb1d92c30$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                if (outletController) return outletController;
                throw new Error('The provided outlet element is missing an outlet controller "'.concat(name, '" instance for host controller "').concat(this.identifier, '"'));
            }
            throw new Error('Missing outlet element "'.concat(name, '" for host controller "').concat(this.identifier, '". Stimulus couldn\'t find a matching outlet element using selector "').concat(selector, '".'));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "Outlets"), {
        get: function() {
            var _this = this;
            var outlets = this.outlets.findAll(name);
            if (outlets.length > 0) return outlets.map(function(outletElement) {
                var outletController = $9761593eb1d92c30$var$getControllerAndEnsureConnectedScope(_this, outletElement, name);
                if (outletController) return outletController;
                console.warn('The provided outlet element is missing an outlet controller "'.concat(name, '" instance for host controller "').concat(_this.identifier, '"'), outletElement);
            }).filter(function(controller) {
                return controller;
            });
            return [];
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "OutletElement"), {
        get: function() {
            var outletElement = this.outlets.find(name);
            var selector = this.outlets.getSelectorForOutletName(name);
            if (outletElement) return outletElement;
            else throw new Error('Missing outlet element "'.concat(name, '" for host controller "').concat(this.identifier, '". Stimulus couldn\'t find a matching outlet element using selector "').concat(selector, '".'));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "OutletElements"), {
        get: function() {
            return this.outlets.findAll(name);
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(camelizedName), "Outlet"), {
        get: function() {
            return this.outlets.has(name);
        }
    }), _obj;
}
function $9761593eb1d92c30$var$TargetPropertiesBlessing(constructor) {
    var targets = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce(function(properties, targetDefinition) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $9761593eb1d92c30$var$propertiesForTargetDefinition(name) {
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(name, "Target"), {
        get: function() {
            var target = this.targets.find(name);
            if (target) return target;
            else throw new Error('Missing target element "'.concat(name, '" for "').concat(this.identifier, '" controller'));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(name, "Targets"), {
        get: function() {
            return this.targets.findAll(name);
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(name), "Target"), {
        get: function() {
            return this.targets.has(name);
        }
    }), _obj;
}
function $9761593eb1d92c30$var$ValuePropertiesBlessing(constructor) {
    var valueDefinitionPairs = $9761593eb1d92c30$var$readInheritableStaticObjectPairs(constructor, "values");
    var propertyDescriptorMap = {
        valueDescriptorMap: {
            get: function() {
                var _this = this;
                return valueDefinitionPairs.reduce(function(result, valueDefinitionPair) {
                    var valueDescriptor = $9761593eb1d92c30$var$parseValueDefinitionPair(valueDefinitionPair, _this.identifier);
                    var attributeName = _this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, attributeName, valueDescriptor));
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce(function(properties, valueDefinitionPair) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $9761593eb1d92c30$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    var definition = $9761593eb1d92c30$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    var key = definition.key, name = definition.name, read = definition.reader, write = definition.writer;
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, name, {
        get: function() {
            var value = this.data.get(key);
            if (value !== null) return read(value);
            else return definition.defaultValue;
        },
        set: function(value) {
            if (value === undefined) this.data["delete"](key);
            else this.data.set(key, write(value));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(name)), {
        get: function() {
            return this.data.has(key) || definition.hasCustomDefaultValue;
        }
    }), _obj;
}
function $9761593eb1d92c30$var$parseValueDefinitionPair(param, controller) {
    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), token = _param[0], typeDefinition = _param[1];
    return $9761593eb1d92c30$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $9761593eb1d92c30$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $9761593eb1d92c30$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(defaultValue)){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $9761593eb1d92c30$var$parseValueTypeObject(payload) {
    var controller = payload.controller, token = payload.token, typeObject = payload.typeObject;
    var hasType = $9761593eb1d92c30$var$isSomething(typeObject.type);
    var hasDefault = $9761593eb1d92c30$var$isSomething(typeObject["default"]);
    var fullObject = hasType && hasDefault;
    var onlyType = hasType && !hasDefault;
    var onlyDefault = !hasType && hasDefault;
    var typeFromObject = $9761593eb1d92c30$var$parseValueTypeConstant(typeObject.type);
    var typeFromDefaultValue = $9761593eb1d92c30$var$parseValueTypeDefault(payload.typeObject["default"]);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        var propertyPath = controller ? "".concat(controller, ".").concat(token) : token;
        throw new Error('The specified default value for the Stimulus Value "'.concat(propertyPath, '" must match the defined type "').concat(typeFromObject, '". The provided default value of "').concat(typeObject["default"], '" is of type "').concat(typeFromDefaultValue, '".'));
    }
    if (fullObject) return typeFromObject;
}
function $9761593eb1d92c30$var$parseValueTypeDefinition(payload) {
    var controller = payload.controller, token = payload.token, typeDefinition = payload.typeDefinition;
    var typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    var typeFromObject = $9761593eb1d92c30$var$parseValueTypeObject(typeObject);
    var typeFromDefaultValue = $9761593eb1d92c30$var$parseValueTypeDefault(typeDefinition);
    var typeFromConstant = $9761593eb1d92c30$var$parseValueTypeConstant(typeDefinition);
    var type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    var propertyPath = controller ? "".concat(controller, ".").concat(typeDefinition) : token;
    throw new Error('Unknown value type "'.concat(propertyPath, '" for "').concat(token, '" value'));
}
function $9761593eb1d92c30$var$defaultValueForDefinition(typeDefinition) {
    var constant = $9761593eb1d92c30$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $9761593eb1d92c30$var$defaultValuesByType[constant];
    var hasDefault = $9761593eb1d92c30$var$hasProperty(typeDefinition, "default");
    var hasType = $9761593eb1d92c30$var$hasProperty(typeDefinition, "type");
    var typeObject = typeDefinition;
    if (hasDefault) return typeObject["default"];
    if (hasType) {
        var type = typeObject.type;
        var constantFromType = $9761593eb1d92c30$var$parseValueTypeConstant(type);
        if (constantFromType) return $9761593eb1d92c30$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $9761593eb1d92c30$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    var token = payload.token, typeDefinition = payload.typeDefinition;
    var key = "".concat($9761593eb1d92c30$var$dasherize(token), "-value");
    var type = $9761593eb1d92c30$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $9761593eb1d92c30$var$camelize(key),
        get defaultValue () {
            return $9761593eb1d92c30$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $9761593eb1d92c30$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $9761593eb1d92c30$var$readers[type],
        writer: $9761593eb1d92c30$var$writers[type] || $9761593eb1d92c30$var$writers["default"]
    };
}
var $9761593eb1d92c30$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
var $9761593eb1d92c30$var$readers = {
    array: function(value) {
        var array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError('expected value of type "array" but instead got value "'.concat(value, '" of type "').concat($9761593eb1d92c30$var$parseValueTypeDefault(array), '"'));
        return array;
    },
    boolean: function(value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number: function(value) {
        return Number(value.replace(/_/g, ""));
    },
    object: function(value) {
        var object = JSON.parse(value);
        if (object === null || (typeof object === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(object)) != "object" || Array.isArray(object)) throw new TypeError('expected value of type "object" but instead got value "'.concat(value, '" of type "').concat($9761593eb1d92c30$var$parseValueTypeDefault(object), '"'));
        return object;
    },
    string: function(value) {
        return value;
    }
};
var $9761593eb1d92c30$var$writers = {
    "default": $9761593eb1d92c30$var$writeString,
    array: $9761593eb1d92c30$var$writeJSON,
    object: $9761593eb1d92c30$var$writeJSON
};
function $9761593eb1d92c30$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $9761593eb1d92c30$var$writeString(value) {
    return "".concat(value);
}
var $9761593eb1d92c30$export$bd0bf19f25da8474 = /*#__PURE__*/ function() {
    "use strict";
    function Controller(context) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Controller);
        this.context = context;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Controller, [
        {
            key: "application",
            get: function get() {
                return this.context.application;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "targets",
            get: function get() {
                return this.scope.targets;
            }
        },
        {
            key: "outlets",
            get: function get() {
                return this.scope.outlets;
            }
        },
        {
            key: "classes",
            get: function get() {
                return this.scope.classes;
            }
        },
        {
            key: "data",
            get: function get() {
                return this.scope.data;
            }
        },
        {
            key: "initialize",
            value: function initialize() {}
        },
        {
            key: "connect",
            value: function connect() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        },
        {
            key: "dispatch",
            value: function dispatch(eventName) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_target = _ref.target, target = _ref_target === void 0 ? this.element : _ref_target, _ref_detail = _ref.detail, detail = _ref_detail === void 0 ? {} : _ref_detail, _ref_prefix = _ref.prefix, prefix = _ref_prefix === void 0 ? this.identifier : _ref_prefix, _ref_bubbles = _ref.bubbles, bubbles = _ref_bubbles === void 0 ? true : _ref_bubbles, _ref_cancelable = _ref.cancelable, cancelable = _ref_cancelable === void 0 ? true : _ref_cancelable;
                var type = prefix ? "".concat(prefix, ":").concat(eventName) : eventName;
                var event = new CustomEvent(type, {
                    detail: detail,
                    bubbles: bubbles,
                    cancelable: cancelable
                });
                target.dispatchEvent(event);
                return event;
            }
        }
    ], [
        {
            key: "shouldLoad",
            get: function get() {
                return true;
            }
        },
        {
            key: "afterLoad",
            value: function afterLoad(_identifier, _application) {
                return;
            }
        }
    ]);
    return Controller;
}();
$9761593eb1d92c30$export$bd0bf19f25da8474.blessings = [
    $9761593eb1d92c30$var$ClassPropertiesBlessing,
    $9761593eb1d92c30$var$TargetPropertiesBlessing,
    $9761593eb1d92c30$var$ValuePropertiesBlessing,
    $9761593eb1d92c30$var$OutletPropertiesBlessing
];
$9761593eb1d92c30$export$bd0bf19f25da8474.targets = [];
$9761593eb1d92c30$export$bd0bf19f25da8474.outlets = [];
$9761593eb1d92c30$export$bd0bf19f25da8474.values = {};









function $6c5afe00ef2f00bb$var$_defineProperty(e, r, t) {
    return (r = $6c5afe00ef2f00bb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6c5afe00ef2f00bb$var$_toPropertyKey(t) {
    var i = $6c5afe00ef2f00bb$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $6c5afe00ef2f00bb$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6c5afe00ef2f00bb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_class, Controller);
    function _class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $6c5afe00ef2f00bb$var$_defineProperty(_this, "items", []);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_class, [
        {
            key: "connect",
            value: function connect() {
                var items = this.element.getElementsByClassName('accordion-item');
                for(var i = 0; i < items.length; i++)this.items.push(items[i]);
                console.log(items);
            }
        },
        {
            key: "closeAll",
            value: function closeAll(e) {
                this.items.forEach(function(item) {
                    item.classList.remove('active');
                });
            }
        },
        {
            key: "toggle",
            value: function toggle(e) {
                console.log(e);
                var el = e.currentTarget, i = el.dataset.key, item = this.items[i];
                if (!item) return;
                var content = item.getElementsByClassName('accordion-content');
                content = content.length ? content[0] : null;
                if (!content) return;
                var isOpen = item.classList.contains('active');
                if (isOpen) item.classList.remove('active');
                else {
                    item.classList.remove('active');
                    item.classList.add('active');
                }
            }
        }
    ]);
    return _class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));









var $2be48b05c8019145$export$d7eeb7266a7f734a = function(w) {
    var width = w.innerWidth && w.document.documentElement.clientWidth ? Math.min(w.innerWidth, w.document.documentElement.clientWidth) : w.innerWidth || w.document.documentElement.clientWidth || w.document.getElementsByTagName("body")[0].clientWidth;
    return {
        h: w.document.documentElement.clientHeight,
        w: width
    };
};
var $2be48b05c8019145$export$c4a223a8ba9e4ea5 = function(w) {
    return w.scrollY || w.document.documentElement.scrollTop;
};
var $2be48b05c8019145$export$61fc7d43ac8f84b0 = function(fn) {
    var timeout;
    return function debounce() {
        if (timeout) window.cancelAnimationFrame(timeout);
        timeout = window.requestAnimationFrame(fn);
    };
};
var $2be48b05c8019145$export$27a0fc5ea7ce230 = function(items, isActive, classes) {
    var active = classes.active.length ? classes.active.split(" ") : [];
    var inactive = classes.inactive.length ? classes.inactive.split(" ") : [];
    items.forEach(function(item, i) {
        var _item_classList, _item_classList1, _item_classList2, _item_classList3;
        if (active.length) (_item_classList = item.classList).remove.apply(_item_classList, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(active));
        if (inactive.length) (_item_classList1 = item.classList).remove.apply(_item_classList1, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(inactive));
        if (isActive(item, i)) {
            if (active.length) (_item_classList2 = item.classList).add.apply(_item_classList2, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(active));
        } else if (inactive.length) (_item_classList3 = item.classList).add.apply(_item_classList3, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(inactive));
    });
};


function $ce37487ff92820e5$var$_defineProperty(e, r, t) {
    return (r = $ce37487ff92820e5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ce37487ff92820e5$var$_toPropertyKey(t) {
    var i = $ce37487ff92820e5$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $ce37487ff92820e5$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ce37487ff92820e5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.body = document.getElementsByTagName('body')[0];
                this.top = 0;
                this.element['burgerController'] = this;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.navOpenTarget.classList.remove('active');
                this.navCloseTarget.classList.remove('active');
            }
        },
        {
            key: "open",
            value: function open(e, modal) {
                if (modal) {
                    this.modalTarget.classList.remove('active');
                    this.modalTarget.classList.add('active');
                    this.menuTarget.classList.remove('active');
                    this.navTarget.classList.remove('menu');
                    this.navTarget.classList.remove('modal');
                    this.navTarget.classList.add('modal');
                } else {
                    this.modalTarget.classList.remove('active');
                    this.navTarget.classList.remove('modal');
                    this.navTarget.classList.remove('menu');
                    this.navTarget.classList.add('menu');
                    this.menuTarget.classList.remove('active');
                    this.menuTarget.classList.add('active');
                }
                this.reset();
                this.top = (0, $2be48b05c8019145$export$c4a223a8ba9e4ea5)(window);
                this.navTarget.classList.remove('active');
                this.navTarget.classList.add('active');
                this.navCloseTarget.classList.add('active');
                this.body.classList.remove('menuOpen');
                this.body.classList.add('menuOpen');
            }
        },
        {
            key: "openUrl",
            value: function openUrl(url) {
                var _this = this;
                fetch(url).then(function(r) {
                    return r.text();
                }).then(function(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var element = doc.getElementById('modalContent');
                    _this.modalContentTarget.innerHTML = element.innerHTML;
                    _this.open(null, true);
                });
            }
        },
        {
            key: "openModal",
            value: function openModal(e) {
                var el = e.currentTarget;
                var url = el.getAttribute('href');
                if (!el) return;
                e.preventDefault();
                this.openUrl(url);
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                this.reset();
                this.navTarget.classList.remove('fadeInLeft');
                this.navTarget.classList.add('fadeOutLeft');
                this.body.classList.remove('menuOpen');
                window.scroll(0, this.top);
                setTimeout(function() {
                    _this.navTarget.classList.remove('active');
                    _this.navTarget.classList.remove('fadeOutLeft');
                    _this.navTarget.classList.add('fadeInLeft');
                    _this.navTarget.classList.remove('active');
                    _this.navOpenTarget.classList.add('active');
                }, 250);
            }
        },
        {
            key: "top",
            value: function top() {
                var el = window;
                el.scrollTop = 0;
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$ce37487ff92820e5$var$_defineProperty($ce37487ff92820e5$export$2e2bcd8739ae039, "targets", [
    'navOpen',
    'navClose',
    'nav',
    'menu',
    'modal',
    'modalContent'
]);











function $3ed6d74d3634f417$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $3ed6d74d3634f417$var$isString(subject) {
    return typeof subject === 'string';
}
function $3ed6d74d3634f417$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $3ed6d74d3634f417$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $3ed6d74d3634f417$var$mathAbs(n) {
    return Math.abs(n);
}
function $3ed6d74d3634f417$var$mathSign(n) {
    return Math.sign(n);
}
function $3ed6d74d3634f417$var$deltaAbs(valueB, valueA) {
    return $3ed6d74d3634f417$var$mathAbs(valueB - valueA);
}
function $3ed6d74d3634f417$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($3ed6d74d3634f417$var$mathAbs(valueB) <= $3ed6d74d3634f417$var$mathAbs(valueA)) return 0;
    var diff = $3ed6d74d3634f417$var$deltaAbs($3ed6d74d3634f417$var$mathAbs(valueB), $3ed6d74d3634f417$var$mathAbs(valueA));
    return $3ed6d74d3634f417$var$mathAbs(diff / valueB);
}
function $3ed6d74d3634f417$var$roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}
function $3ed6d74d3634f417$var$arrayKeys(array) {
    return $3ed6d74d3634f417$var$objectKeys(array).map(Number);
}
function $3ed6d74d3634f417$var$arrayLast(array) {
    return array[$3ed6d74d3634f417$var$arrayLastIndex(array)];
}
function $3ed6d74d3634f417$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $3ed6d74d3634f417$var$arrayIsLastIndex(array, index) {
    return index === $3ed6d74d3634f417$var$arrayLastIndex(array);
}
function $3ed6d74d3634f417$var$arrayFromNumber(n) {
    var startAt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Array.from(Array(n), function(_, i) {
        return startAt + i;
    });
}
function $3ed6d74d3634f417$var$objectKeys(object) {
    return Object.keys(object);
}
function $3ed6d74d3634f417$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce(function(mergedObjects, currentObject) {
        $3ed6d74d3634f417$var$objectKeys(currentObject).forEach(function(key) {
            var valueA = mergedObjects[key];
            var valueB = currentObject[key];
            var areObjects = $3ed6d74d3634f417$var$isObject(valueA) && $3ed6d74d3634f417$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $3ed6d74d3634f417$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $3ed6d74d3634f417$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $3ed6d74d3634f417$var$Alignment(align, viewSize) {
    var predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($3ed6d74d3634f417$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    var self = {
        measure: measure
    };
    return self;
}
function $3ed6d74d3634f417$var$EventStore() {
    var listeners = [];
    function add(node, type, handler) {
        var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
            passive: true
        };
        var removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = function() {
                return node.removeEventListener(type, handler, options);
            };
        } else {
            var legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = function() {
                return legacyMediaQueryList.removeListener(handler);
            };
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter(function(remove) {
            return remove();
        });
    }
    var self = {
        add: add,
        clear: clear
    };
    return self;
}
function $3ed6d74d3634f417$var$Animations(ownerDocument, ownerWindow, update, render) {
    var documentVisibleHandler = $3ed6d74d3634f417$var$EventStore();
    var fixedTimeStep = 1000 / 60;
    var lastTimeStamp = null;
    var accumulatedTime = 0;
    var animationId = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', function() {
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        var timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        var alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    var self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $3ed6d74d3634f417$var$Axis(axis, contentDirection) {
    var isRightToLeft = contentDirection === 'rtl';
    var isVertical = axis === 'y';
    var scroll = isVertical ? 'y' : 'x';
    var cross = isVertical ? 'x' : 'y';
    var sign = !isVertical && isRightToLeft ? -1 : 1;
    var startEdge = getStartEdge();
    var endEdge = getEndEdge();
    function measureSize(nodeRect) {
        var height = nodeRect.height, width = nodeRect.width;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    var self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $3ed6d74d3634f417$var$Limit() {
    var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var length = $3ed6d74d3634f417$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    var self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $3ed6d74d3634f417$var$Counter(max, start, loop) {
    var constrain = $3ed6d74d3634f417$var$Limit(0, max).constrain;
    var loopEnd = max + 1;
    var counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $3ed6d74d3634f417$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $3ed6d74d3634f417$var$Counter(max, get(), loop);
    }
    var self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $3ed6d74d3634f417$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    var crossAxis = axis.cross, direction = axis.direction;
    var focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    var nonPassiveEvent = {
        passive: false
    };
    var initEvents = $3ed6d74d3634f417$var$EventStore();
    var dragEvents = $3ed6d74d3634f417$var$EventStore();
    var goToNextThreshold = $3ed6d74d3634f417$var$Limit(50, 225).constrain(percentOfView.measure(20));
    var snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    var freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    var baseSpeed = dragFree ? 43 : 25;
    var isMoving = false;
    var startScroll = 0;
    var startCross = 0;
    var pointerIsDown = false;
    var preventScroll = false;
    var preventClick = false;
    var isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($3ed6d74d3634f417$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        var node = rootNode;
        initEvents.add(node, 'dragstart', function(evt) {
            return evt.preventDefault();
        }, nonPassiveEvent).add(node, 'touchmove', function() {
            return undefined;
        }, nonPassiveEvent).add(node, 'touchend', function() {
            return undefined;
        }).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        var node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        var nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        var boost = dragFree ? freeForceBoost : snapForceBoost;
        var type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        var next = index.add($3ed6d74d3634f417$var$mathSign(force) * -1);
        var baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $3ed6d74d3634f417$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        var isMouseEvt = $3ed6d74d3634f417$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $3ed6d74d3634f417$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        var isTouchEvt = !$3ed6d74d3634f417$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        var lastScroll = dragTracker.readPoint(evt);
        var lastCross = dragTracker.readPoint(evt, crossAxis);
        var diffScroll = $3ed6d74d3634f417$var$deltaAbs(lastScroll, startScroll);
        var diffCross = $3ed6d74d3634f417$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        var diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        var currentLocation = scrollTarget.byDistance(0, false);
        var targetChanged = currentLocation.index !== index.get();
        var rawForce = dragTracker.pointerUp(evt) * forceBoost();
        var force = allowedForce(direction(rawForce), targetChanged);
        var forceFactor = $3ed6d74d3634f417$var$factorAbs(rawForce, force);
        var speed = baseSpeed - 10 * forceFactor;
        var friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    var self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $3ed6d74d3634f417$var$DragTracker(axis, ownerWindow) {
    var logInterval = 170;
    var startEvent;
    var lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        var property = evtAxis || axis.scroll;
        var coord = "client".concat(property === 'x' ? 'X' : 'Y');
        return ($3ed6d74d3634f417$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        var diff = readPoint(evt) - readPoint(lastEvent);
        var expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        var diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        var diffTime = readTime(evt) - readTime(startEvent);
        var expired = readTime(evt) - readTime(lastEvent) > logInterval;
        var force = diffDrag / diffTime;
        var isFlick = diffTime && !expired && $3ed6d74d3634f417$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    var self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $3ed6d74d3634f417$var$NodeRects() {
    function measure(node) {
        var offsetTop = node.offsetTop, offsetLeft = node.offsetLeft, offsetWidth = node.offsetWidth, offsetHeight = node.offsetHeight;
        var offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    var self = {
        measure: measure
    };
    return self;
}
function $3ed6d74d3634f417$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    var self = {
        measure: measure
    };
    return self;
}
function $3ed6d74d3634f417$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    var observeNodes = [
        container
    ].concat(slides);
    var resizeObserver;
    var containerSize;
    var slideSizes = [];
    var destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    if (destroyed) return;
                    var isContainer = entry.target === container;
                    var slideIndex = slides.indexOf(entry.target);
                    var lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                    var newSize = readSize(isContainer ? container : slides[slideIndex]);
                    var diffSize = $3ed6d74d3634f417$var$mathAbs(newSize - lastSize);
                    if (diffSize >= 0.5) {
                        emblaApi.reInit();
                        eventHandler.emit('resize');
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        resizeObserver = new ResizeObserver(function(entries) {
            if ($3ed6d74d3634f417$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(function() {
            observeNodes.forEach(function(node) {
                return resizeObserver.observe(node);
            });
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    var self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    var scrollVelocity = 0;
    var scrollDirection = 0;
    var scrollDuration = baseDuration;
    var scrollFriction = baseFriction;
    var rawLocation = location.get();
    var rawLocationPrevious = 0;
    function seek() {
        var displacement = target.get() - location.get();
        var isInstant = !scrollDuration;
        var scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $3ed6d74d3634f417$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        var diff = target.get() - offsetLocation.get();
        return $3ed6d74d3634f417$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    var self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    var pullBackThreshold = percentOfView.measure(10);
    var edgeOffsetTolerance = percentOfView.measure(50);
    var frictionLimit = $3ed6d74d3634f417$var$Limit(0.1, 0.99);
    var disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        var edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        var diffToEdge = $3ed6d74d3634f417$var$mathAbs(limit[edge] - location.get());
        var diffToTarget = target.get() - location.get();
        var friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $3ed6d74d3634f417$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    var self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    var scrollBounds = $3ed6d74d3634f417$var$Limit(-contentSize + viewSize, 0);
    var snapsBounded = measureBounded();
    var scrollContainLimit = findScrollContainLimit();
    var snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $3ed6d74d3634f417$var$deltaAbs(bound, snap) <= 1;
    }
    function findScrollContainLimit() {
        var startSnap = snapsBounded[0];
        var endSnap = $3ed6d74d3634f417$var$arrayLast(snapsBounded);
        var min = snapsBounded.lastIndexOf(startSnap);
        var max = snapsBounded.indexOf(endSnap) + 1;
        return $3ed6d74d3634f417$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map(function(snapAligned, index) {
            var min = scrollBounds.min, max = scrollBounds.max;
            var snap = scrollBounds.constrain(snapAligned);
            var isFirst = !index;
            var isLast = $3ed6d74d3634f417$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map(function(scrollBound) {
            return parseFloat(scrollBound.toFixed(3));
        });
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        var min = scrollContainLimit.min, max = scrollContainLimit.max;
        return snapsBounded.slice(min, max);
    }
    var self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    var max = scrollSnaps[0];
    var min = loop ? max - contentSize : $3ed6d74d3634f417$var$arrayLast(scrollSnaps);
    var limit = $3ed6d74d3634f417$var$Limit(min, max);
    var self = {
        limit: limit
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollLooper(contentSize, limit, location, vectors) {
    var jointSafety = 0.1;
    var min = limit.min + jointSafety;
    var max = limit.max + jointSafety;
    var _Limit = $3ed6d74d3634f417$var$Limit(min, max), reachedMin = _Limit.reachedMin, reachedMax = _Limit.reachedMax;
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        var loopDistance = contentSize * (direction * -1);
        vectors.forEach(function(v) {
            return v.add(loopDistance);
        });
    }
    var self = {
        loop: loop
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollProgress(limit) {
    var max = limit.max, length = limit.length;
    function get(n) {
        var currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    var self = {
        get: get
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    var startEdge = axis.startEdge, endEdge = axis.endEdge;
    var groupSlides = slidesToScroll.groupSlides;
    var alignments = measureSizes().map(alignment.measure);
    var snaps = measureUnaligned();
    var snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map(function(rects) {
            return $3ed6d74d3634f417$var$arrayLast(rects)[endEdge] - rects[0][startEdge];
        }).map($3ed6d74d3634f417$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map(function(rect) {
            return containerRect[startEdge] - rect[startEdge];
        }).map(function(snap) {
            return -$3ed6d74d3634f417$var$mathAbs(snap);
        });
    }
    function measureAligned() {
        return groupSlides(snaps).map(function(g) {
            return g[0];
        }).map(function(snap, index) {
            return snap + alignments[index];
        });
    }
    var self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $3ed6d74d3634f417$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    var groupSlides = slidesToScroll.groupSlides;
    var min = scrollContainLimit.min, max = scrollContainLimit.max;
    var slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        var groupedSlideIndexes = groupSlides(slideIndexes);
        var doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map(function(group, index, groups) {
            var isFirst = !index;
            var isLast = $3ed6d74d3634f417$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                var range = $3ed6d74d3634f417$var$arrayLast(groups[0]) + 1;
                return $3ed6d74d3634f417$var$arrayFromNumber(range);
            }
            if (isLast) {
                var range1 = $3ed6d74d3634f417$var$arrayLastIndex(slideIndexes) - $3ed6d74d3634f417$var$arrayLast(groups)[0] + 1;
                return $3ed6d74d3634f417$var$arrayFromNumber(range1, $3ed6d74d3634f417$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    var self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    var reachedAny = limit.reachedAny, removeOffset = limit.removeOffset, constrain = limit.constrain;
    function minDistance(distances) {
        return distances.concat().sort(function(a, b) {
            return $3ed6d74d3634f417$var$mathAbs(a) - $3ed6d74d3634f417$var$mathAbs(b);
        })[0];
    }
    function findTargetSnap(target) {
        var distance = loop ? removeOffset(target) : constrain(target);
        var ascDiffsToSnaps = scrollSnaps.map(function(snap, index) {
            return {
                diff: shortcut(snap - distance, 0),
                index: index
            };
        }).sort(function(d1, d2) {
            return $3ed6d74d3634f417$var$mathAbs(d1.diff) - $3ed6d74d3634f417$var$mathAbs(d2.diff);
        });
        var index = ascDiffsToSnaps[0].index;
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        var targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        var matchingTargets = targets.filter(function(t) {
            return $3ed6d74d3634f417$var$mathSign(t) === direction;
        });
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $3ed6d74d3634f417$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        var diffToSnap = scrollSnaps[index] - targetVector.get();
        var distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        var target = targetVector.get() + distance;
        var _findTargetSnap = findTargetSnap(target), index = _findTargetSnap.index, targetSnapDistance = _findTargetSnap.distance;
        var reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        var diffToSnap = scrollSnaps[index] - targetSnapDistance;
        var snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    var self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $3ed6d74d3634f417$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        var distanceDiff = target.distance;
        var indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        var target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        var targetIndex = indexCurrent.clone().set(n);
        var target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    var self = {
        distance: distance,
        index: index
    };
    return self;
}
function $3ed6d74d3634f417$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    var focusListenerOptions = {
        passive: true,
        capture: true
    };
    var lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            var nowTime = new Date().getTime();
            var diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit('slideFocusStart');
            root.scrollLeft = 0;
            var group = slideRegistry.findIndex(function(group) {
                return group.includes(index);
            });
            if (!$3ed6d74d3634f417$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        }
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach(function(slide, slideIndex) {
            eventStore.add(slide, 'focus', function(evt) {
                if ($3ed6d74d3634f417$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    var self = {
        init: init
    };
    return self;
}
function $3ed6d74d3634f417$var$Vector1D(initialValue) {
    var value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $3ed6d74d3634f417$var$isNumber(n) ? n : n.get();
    }
    var self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $3ed6d74d3634f417$var$Translate(axis, container) {
    var translate = axis.scroll === 'x' ? x : y;
    var containerStyle = container.style;
    var previousTarget = null;
    var disabled = false;
    function x(n) {
        return "translate3d(".concat(n, "px,0px,0px)");
    }
    function y(n) {
        return "translate3d(0px,".concat(n, "px,0px)");
    }
    function to(target) {
        if (disabled) return;
        var newTarget = $3ed6d74d3634f417$var$roundToTwoDecimals(axis.direction(target));
        if (newTarget === previousTarget) return;
        containerStyle.transform = translate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    var self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $3ed6d74d3634f417$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    var roundingSafety = 0.5;
    var ascItems = $3ed6d74d3634f417$var$arrayKeys(slideSizesWithGaps);
    var descItems = $3ed6d74d3634f417$var$arrayKeys(slideSizesWithGaps).reverse();
    var loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce(function(a, i) {
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce(function(a, i) {
            var remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map(function(snap, index) {
            return {
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            };
        });
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        var slideBounds = findSlideBounds(offset);
        return indexes.map(function(index) {
            var initial = isEndEdge ? 0 : -contentSize;
            var altered = isEndEdge ? contentSize : 0;
            var boundEdge = isEndEdge ? 'end' : 'start';
            var loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $3ed6d74d3634f417$var$Vector1D(-1),
                translate: $3ed6d74d3634f417$var$Translate(axis, slides[index]),
                target: function() {
                    return location.get() > loopPoint ? initial : altered;
                }
            };
        });
    }
    function startPoints() {
        var gap = scrollSnaps[0];
        var indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        var gap = viewSize - scrollSnaps[0] - 1;
        var indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(function(param) {
            var index = param.index;
            var otherIndexes = ascItems.filter(function(i) {
                return i !== index;
            });
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach(function(loopPoint) {
            var target = loopPoint.target, translate = loopPoint.translate, slideLocation = loopPoint.slideLocation;
            var shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach(function(loopPoint) {
            return loopPoint.translate.clear();
        });
    }
    var self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $3ed6d74d3634f417$var$SlidesHandler(container, eventHandler, watchSlides) {
    var mutationObserver;
    var destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mutation = _step.value;
                    if (mutation.type === 'childList') {
                        emblaApi.reInit();
                        eventHandler.emit('slidesChanged');
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        mutationObserver = new MutationObserver(function(mutations) {
            if (destroyed) return;
            if ($3ed6d74d3634f417$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    var self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3ed6d74d3634f417$var$SlidesInView(container, slides, eventHandler, threshold) {
    var intersectionEntryMap = {};
    var inViewCache = null;
    var notInViewCache = null;
    var intersectionObserver;
    var destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver(function(entries) {
            if (destroyed) return;
            entries.forEach(function(entry) {
                var index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach(function(slide) {
            return intersectionObserver.observe(slide);
        });
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $3ed6d74d3634f417$var$objectKeys(intersectionEntryMap).reduce(function(list, slideIndex) {
            var index = parseInt(slideIndex);
            var isIntersecting = intersectionEntryMap[index].isIntersecting;
            var inViewMatch = inView && isIntersecting;
            var notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get() {
        var inView = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        var slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    var self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $3ed6d74d3634f417$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    var measureSize = axis.measureSize, startEdge = axis.startEdge, endEdge = axis.endEdge;
    var withEdgeGap = slideRects[0] && readEdgeGap;
    var startGap = measureStartGap();
    var endGap = measureEndGap();
    var slideSizes = slideRects.map(measureSize);
    var slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        var slideRect = slideRects[0];
        return $3ed6d74d3634f417$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        var style = ownerWindow.getComputedStyle($3ed6d74d3634f417$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue("margin-".concat(endEdge)));
    }
    function measureWithGaps() {
        return slideRects.map(function(rect, index, rects) {
            var isFirst = !index;
            var isLast = $3ed6d74d3634f417$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($3ed6d74d3634f417$var$mathAbs);
    }
    var self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $3ed6d74d3634f417$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    var startEdge = axis.startEdge, endEdge = axis.endEdge, direction = axis.direction;
    var groupByNumber = $3ed6d74d3634f417$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $3ed6d74d3634f417$var$arrayKeys(array).filter(function(i) {
            return i % groupSize === 0;
        }).map(function(i) {
            return array.slice(i, i + groupSize);
        });
    }
    function bySize(array) {
        if (!array.length) return [];
        return $3ed6d74d3634f417$var$arrayKeys(array).reduce(function(groups, rectB, index) {
            var rectA = $3ed6d74d3634f417$var$arrayLast(groups) || 0;
            var isFirst = rectA === 0;
            var isLast = rectB === $3ed6d74d3634f417$var$arrayLastIndex(array);
            var edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            var edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            var gapA = !loop && isFirst ? direction(startGap) : 0;
            var gapB = !loop && isLast ? direction(endGap) : 0;
            var chunkSize = $3ed6d74d3634f417$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map(function(currentSize, index, groups) {
            var previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    var self = {
        groupSlides: groupSlides
    };
    return self;
}
function $3ed6d74d3634f417$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    var align = options.align, scrollAxis = options.axis, direction = options.direction, startIndex = options.startIndex, loop = options.loop, duration = options.duration, dragFree = options.dragFree, dragThreshold = options.dragThreshold, inViewThreshold = options.inViewThreshold, groupSlides = options.slidesToScroll, skipSnaps = options.skipSnaps, containScroll = options.containScroll, watchResize = options.watchResize, watchSlides = options.watchSlides, watchDrag = options.watchDrag, watchFocus = options.watchFocus;
    // Measurements
    var pixelTolerance = 2;
    var nodeRects = $3ed6d74d3634f417$var$NodeRects();
    var containerRect = nodeRects.measure(container);
    var slideRects = slides.map(nodeRects.measure);
    var axis = $3ed6d74d3634f417$var$Axis(scrollAxis, direction);
    var viewSize = axis.measureSize(containerRect);
    var percentOfView = $3ed6d74d3634f417$var$PercentOfView(viewSize);
    var alignment = $3ed6d74d3634f417$var$Alignment(align, viewSize);
    var containSnaps = !loop && !!containScroll;
    var readEdgeGap = loop || !!containScroll;
    var _SlideSizes = $3ed6d74d3634f417$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow), slideSizes = _SlideSizes.slideSizes, slideSizesWithGaps = _SlideSizes.slideSizesWithGaps, startGap = _SlideSizes.startGap, endGap = _SlideSizes.endGap;
    var slidesToScroll = $3ed6d74d3634f417$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    var _ScrollSnaps = $3ed6d74d3634f417$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll), snaps = _ScrollSnaps.snaps, snapsAligned = _ScrollSnaps.snapsAligned;
    var contentSize = -$3ed6d74d3634f417$var$arrayLast(snaps) + $3ed6d74d3634f417$var$arrayLast(slideSizesWithGaps);
    var _ScrollContain = $3ed6d74d3634f417$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance), snapsContained = _ScrollContain.snapsContained, scrollContainLimit = _ScrollContain.scrollContainLimit;
    var scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    var limit = $3ed6d74d3634f417$var$ScrollLimit(contentSize, scrollSnaps, loop).limit;
    // Indexes
    var index = $3ed6d74d3634f417$var$Counter($3ed6d74d3634f417$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    var indexPrevious = index.clone();
    var slideIndexes = $3ed6d74d3634f417$var$arrayKeys(slides);
    // Animation
    var update = function(param) {
        var dragHandler = param.dragHandler, scrollBody = param.scrollBody, scrollBounds = param.scrollBounds, loop = param.options.loop;
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    var render = function(param, alpha) {
        var scrollBody = param.scrollBody, translate = param.translate, location = param.location, offsetLocation = param.offsetLocation, previousLocation = param.previousLocation, scrollLooper = param.scrollLooper, slideLooper = param.slideLooper, dragHandler = param.dragHandler, animation = param.animation, _$eventHandler = param.eventHandler, scrollBounds = param.scrollBounds, loop = param.options.loop;
        var shouldSettle = scrollBody.settled();
        var withinBounds = !scrollBounds.shouldConstrain();
        var hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        var hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
        if (hasSettledAndIdle) animation.stop();
        var interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
        if (hasSettledAndIdle) _$eventHandler.emit('settle');
        if (!hasSettled) _$eventHandler.emit('scroll');
    };
    var animation = $3ed6d74d3634f417$var$Animations(ownerDocument, ownerWindow, function() {
        return update(engine);
    }, function(alpha) {
        return render(engine, alpha);
    });
    // Shared
    var friction = 0.68;
    var startLocation = scrollSnaps[index.get()];
    var location = $3ed6d74d3634f417$var$Vector1D(startLocation);
    var previousLocation = $3ed6d74d3634f417$var$Vector1D(startLocation);
    var offsetLocation = $3ed6d74d3634f417$var$Vector1D(startLocation);
    var target = $3ed6d74d3634f417$var$Vector1D(startLocation);
    var scrollBody = $3ed6d74d3634f417$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    var scrollTarget = $3ed6d74d3634f417$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    var scrollTo = $3ed6d74d3634f417$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    var scrollProgress = $3ed6d74d3634f417$var$ScrollProgress(limit);
    var eventStore = $3ed6d74d3634f417$var$EventStore();
    var slidesInView = $3ed6d74d3634f417$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    var slideRegistry = $3ed6d74d3634f417$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes).slideRegistry;
    var slideFocus = $3ed6d74d3634f417$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    var engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $3ed6d74d3634f417$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $3ed6d74d3634f417$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $3ed6d74d3634f417$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $3ed6d74d3634f417$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $3ed6d74d3634f417$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $3ed6d74d3634f417$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $3ed6d74d3634f417$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $3ed6d74d3634f417$var$Translate(axis, container)
    };
    return engine;
}
function $3ed6d74d3634f417$var$EventHandler() {
    var listeners = {};
    var api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach(function(e) {
            return e(api, evt);
        });
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter(function(e) {
            return e !== cb;
        });
        return self;
    }
    function clear() {
        listeners = {};
    }
    var self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
var $3ed6d74d3634f417$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $3ed6d74d3634f417$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $3ed6d74d3634f417$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        var _$optionsAtMedia = options.breakpoints || {};
        var matchedMediaOptions = $3ed6d74d3634f417$var$objectKeys(_$optionsAtMedia).filter(function(media) {
            return ownerWindow.matchMedia(media).matches;
        }).map(function(media) {
            return _$optionsAtMedia[media];
        }).reduce(function(a, mediaOption) {
            return mergeOptions(a, mediaOption);
        }, {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map(function(options) {
            return $3ed6d74d3634f417$var$objectKeys(options.breakpoints || {});
        }).reduce(function(acc, mediaQueries) {
            return acc.concat(mediaQueries);
        }, []).map(ownerWindow.matchMedia);
    }
    var self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $3ed6d74d3634f417$var$PluginsHandler(optionsHandler) {
    var activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(function(param) {
            var options = param.options;
            return optionsHandler.optionsAtMedia(options).active !== false;
        });
        activePlugins.forEach(function(plugin) {
            return plugin.init(emblaApi, optionsHandler);
        });
        return plugins.reduce(function(map, plugin) {
            return Object.assign(map, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, plugin.name, plugin));
        }, {});
    }
    function destroy() {
        activePlugins = activePlugins.filter(function(plugin) {
            return plugin.destroy();
        });
    }
    var self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3ed6d74d3634f417$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    var ownerDocument = root.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var optionsHandler = $3ed6d74d3634f417$var$OptionsHandler(ownerWindow);
    var pluginsHandler = $3ed6d74d3634f417$var$PluginsHandler(optionsHandler);
    var mediaHandlers = $3ed6d74d3634f417$var$EventStore();
    var eventHandler = $3ed6d74d3634f417$var$EventHandler();
    var mergeOptions = optionsHandler.mergeOptions, optionsAtMedia = optionsHandler.optionsAtMedia, optionsMediaQueries = optionsHandler.optionsMediaQueries;
    var on = eventHandler.on, off = eventHandler.off, emit = eventHandler.emit;
    var reInit = reActivate;
    var destroyed = false;
    var engine;
    var optionsBase = mergeOptions($3ed6d74d3634f417$var$defaultOptions, $3ed6d74d3634f417$export$2e2bcd8739ae039.globalOptions);
    var options = mergeOptions(optionsBase);
    var pluginList = [];
    var pluginApis;
    var container;
    var slides;
    function storeElements() {
        var userContainer = options.container, userSlides = options.slides;
        var customContainer = $3ed6d74d3634f417$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        var customSlides = $3ed6d74d3634f417$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        var engine = $3ed6d74d3634f417$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            var optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase
        ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(pluginList.map(function(param) {
            var options = param.options;
            return options;
        })))).forEach(function(query) {
            return mediaHandlers.add(query, 'change', reActivate);
        });
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        var startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        var next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        var prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        var next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        var prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    var self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(function() {
        return eventHandler.emit('init');
    }, 0);
    return self;
}
$3ed6d74d3634f417$export$2e2bcd8739ae039.globalOptions = undefined;


var $3ddd76c302b2a610$var$addTogglePrevNextBtnsActive = function(emblaApi, prevBtn, nextBtn) {
    var togglePrevNextBtnsState = function() {
        if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
        else prevBtn.setAttribute('disabled', 'disabled');
        if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
        else nextBtn.setAttribute('disabled', 'disabled');
    };
    emblaApi.on('select', togglePrevNextBtnsState).on('init', togglePrevNextBtnsState).on('reInit', togglePrevNextBtnsState);
    return function() {
        prevBtn.removeAttribute('disabled');
        nextBtn.removeAttribute('disabled');
    };
};
var $3ddd76c302b2a610$export$604ab292679fc001 = function(emblaApi, prevBtn, nextBtn) {
    var scrollPrev = function() {
        emblaApi.scrollPrev();
    };
    var scrollNext = function() {
        emblaApi.scrollNext();
    };
    prevBtn.addEventListener('click', scrollPrev, false);
    nextBtn.addEventListener('click', scrollNext, false);
    var removeTogglePrevNextBtnsActive = $3ddd76c302b2a610$var$addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn);
    return function() {
        removeTogglePrevNextBtnsActive();
        prevBtn.removeEventListener('click', scrollPrev, false);
        nextBtn.removeEventListener('click', scrollNext, false);
    };
};


var $b7b99c64549af2e8$export$facf7ea5340ed01e = function(emblaApi, dotsNode) {
    var dotNodes = [];
    var addDotBtnsWithClickHandlers = function() {
        dotsNode.innerHTML = emblaApi.scrollSnapList().map(function() {
            return '<button class="embla__dot" type="button"></button>';
        }).join('');
        var scrollTo = function(index) {
            emblaApi.scrollTo(index);
        };
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
        dotNodes.forEach(function(dotNode, index) {
            dotNode.addEventListener('click', function() {
                return scrollTo(index);
            }, false);
        });
    };
    var toggleDotBtnsActive = function() {
        var previous = emblaApi.previousScrollSnap();
        var selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove('embla__dot--selected');
        dotNodes[selected].classList.add('embla__dot--selected');
    };
    emblaApi.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive);
    return function() {
        dotsNode.innerHTML = '';
    };
};


function $b6691ef87a57683b$var$_defineProperty(e, r, t) {
    return (r = $b6691ef87a57683b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b6691ef87a57683b$var$_toPropertyKey(t) {
    var i = $b6691ef87a57683b$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $b6691ef87a57683b$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b6691ef87a57683b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_class, Controller);
    function _class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $b6691ef87a57683b$var$_defineProperty(_this, "items", []);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_class, [
        {
            key: "connect",
            value: function connect() {
                var config = JSON.parse(atob(this.element.dataset.config));
                var _config_slidesToScroll;
                var options = {
                    slidesToScroll: (_config_slidesToScroll = config.slidesToScroll) !== null && _config_slidesToScroll !== void 0 ? _config_slidesToScroll : 1
                };
                var emblaNode = this.element;
                var viewportNode = emblaNode.querySelector('.embla__viewport');
                var prevBtnNode = emblaNode.querySelector('.embla__button--prev');
                var nextBtnNode = emblaNode.querySelector('.embla__button--next');
                var dotsNode = emblaNode.querySelector('.embla__dots');
                var emblaApi = (0, $3ed6d74d3634f417$export$2e2bcd8739ae039)(viewportNode, options);
                var removePrevNextBtnsClickHandlers = (0, $3ddd76c302b2a610$export$604ab292679fc001)(emblaApi, prevBtnNode, nextBtnNode);
                var removeDotBtnsAndClickHandlers = (0, $b7b99c64549af2e8$export$facf7ea5340ed01e)(emblaApi, dotsNode);
                emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
                emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
            }
        }
    ]);
    return _class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));







var $052589c5dcbd5464$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_class, Controller);
    function _class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _class);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _class, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_class, [
        {
            key: "connect",
            value: function connect() {
                if (document.cookie.indexOf('cookie-note=1') === -1) this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                this.element.classList.add('active');
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.element.classList.remove('active');
            }
        },
        {
            key: "ok",
            value: function ok() {
                document.cookie = 'cookie-note=1;path=/;max-age=864000';
                this.hide();
            }
        }
    ]);
    return _class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));









/*! choices.js v11.1.0 | © 2025 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 






var $25957c27585b4297$var$extendStatics = function extendStatics1(d, b) {
    $25957c27585b4297$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $25957c27585b4297$var$extendStatics(d, b);
};
function $25957c27585b4297$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $25957c27585b4297$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $25957c27585b4297$var$__assign = function __assign1() {
    $25957c27585b4297$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25957c27585b4297$var$__assign.apply(this, arguments);
};
function $25957c27585b4297$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $25957c27585b4297$var$ActionType = {
    ADD_CHOICE: 'ADD_CHOICE',
    REMOVE_CHOICE: 'REMOVE_CHOICE',
    FILTER_CHOICES: 'FILTER_CHOICES',
    ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
    CLEAR_CHOICES: 'CLEAR_CHOICES',
    ADD_GROUP: 'ADD_GROUP',
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM'
};
var $25957c27585b4297$var$EventType = {
    showDropdown: 'showDropdown',
    hideDropdown: 'hideDropdown',
    change: 'change',
    choice: 'choice',
    search: 'search',
    addItem: 'addItem',
    removeItem: 'removeItem',
    highlightItem: 'highlightItem',
    highlightChoice: 'highlightChoice',
    unhighlightItem: 'unhighlightItem'
};
var $25957c27585b4297$var$KeyCodeMap = {
    TAB_KEY: 9,
    SHIFT_KEY: 16,
    BACK_KEY: 46,
    DELETE_KEY: 8,
    ENTER_KEY: 13,
    A_KEY: 65,
    ESC_KEY: 27,
    UP_KEY: 38,
    DOWN_KEY: 40,
    PAGE_UP_KEY: 33,
    PAGE_DOWN_KEY: 34
};
var $25957c27585b4297$var$ObjectsInConfig = [
    'fuseOptions',
    'classNames'
];
var $25957c27585b4297$var$PassedElementTypes = {
    Text: 'text',
    SelectOne: 'select-one',
    SelectMultiple: 'select-multiple'
};
var $25957c27585b4297$var$addChoice = function addChoice(choice) {
    return {
        type: $25957c27585b4297$var$ActionType.ADD_CHOICE,
        choice: choice
    };
};
var $25957c27585b4297$var$removeChoice = function removeChoice(choice) {
    return {
        type: $25957c27585b4297$var$ActionType.REMOVE_CHOICE,
        choice: choice
    };
};
var $25957c27585b4297$var$filterChoices = function filterChoices(results) {
    return {
        type: $25957c27585b4297$var$ActionType.FILTER_CHOICES,
        results: results
    };
};
var $25957c27585b4297$var$activateChoices = function activateChoices(active) {
    return {
        type: $25957c27585b4297$var$ActionType.ACTIVATE_CHOICES,
        active: active
    };
};
var $25957c27585b4297$var$addGroup = function addGroup(group) {
    return {
        type: $25957c27585b4297$var$ActionType.ADD_GROUP,
        group: group
    };
};
var $25957c27585b4297$var$addItem = function addItem(item) {
    return {
        type: $25957c27585b4297$var$ActionType.ADD_ITEM,
        item: item
    };
};
var $25957c27585b4297$var$removeItem$1 = function removeItem$1(item) {
    return {
        type: $25957c27585b4297$var$ActionType.REMOVE_ITEM,
        item: item
    };
};
var $25957c27585b4297$var$highlightItem = function highlightItem(item, highlighted) {
    return {
        type: $25957c27585b4297$var$ActionType.HIGHLIGHT_ITEM,
        item: item,
        highlighted: highlighted
    };
};
var $25957c27585b4297$var$getRandomNumber = function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
};
var $25957c27585b4297$var$generateChars = function generateChars(length) {
    return Array.from({
        length: length
    }, function() {
        return $25957c27585b4297$var$getRandomNumber(0, 36).toString(36);
    }).join('');
};
var $25957c27585b4297$var$generateId = function generateId(element, prefix) {
    var id = element.id || element.name && "".concat(element.name, "-").concat($25957c27585b4297$var$generateChars(2)) || $25957c27585b4297$var$generateChars(4);
    id = id.replace(/(:|\.|\[|\]|,)/g, '');
    id = "".concat(prefix, "-").concat(id);
    return id;
};
var $25957c27585b4297$var$getAdjacentEl = function getAdjacentEl(startEl, selector, direction) {
    if (direction === void 0) direction = 1;
    var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
    var sibling = startEl[prop];
    while(sibling){
        if (sibling.matches(selector)) return sibling;
        sibling = sibling[prop];
    }
    return null;
};
var $25957c27585b4297$var$isScrolledIntoView = function isScrolledIntoView(element, parent, direction) {
    if (direction === void 0) direction = 1;
    var isVisible;
    if (direction > 0) // In view from bottom
    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
    else // In view from top
    isVisible = element.offsetTop >= parent.scrollTop;
    return isVisible;
};
var $25957c27585b4297$var$sanitise = function sanitise1(value) {
    if (typeof value !== 'string') {
        if (value === null || value === undefined) return '';
        if ((typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)) === 'object') {
            if ('raw' in value) return $25957c27585b4297$var$sanitise(value.raw);
            if ('trusted' in value) return value.trusted;
        }
        return value;
    }
    return value.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/'/g, '&#039;').replace(/"/g, '&quot;');
};
var $25957c27585b4297$var$strToEl = function() {
    var tmpEl = document.createElement('div');
    return function(str) {
        tmpEl.innerHTML = str.trim();
        var firstChild = tmpEl.children[0];
        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
        return firstChild;
    };
}();
var $25957c27585b4297$var$resolveNoticeFunction = function resolveNoticeFunction(fn, value) {
    return typeof fn === 'function' ? fn($25957c27585b4297$var$sanitise(value), value) : fn;
};
var $25957c27585b4297$var$resolveStringFunction = function resolveStringFunction(fn) {
    return typeof fn === 'function' ? fn() : fn;
};
var $25957c27585b4297$var$unwrapStringForRaw = function unwrapStringForRaw(s) {
    if (typeof s === 'string') return s;
    if ((typeof s === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(s)) === 'object') {
        if ('trusted' in s) return s.trusted;
        if ('raw' in s) return s.raw;
    }
    return '';
};
var $25957c27585b4297$var$unwrapStringForEscaped = function unwrapStringForEscaped(s) {
    if (typeof s === 'string') return s;
    if ((typeof s === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(s)) === 'object') {
        if ('escaped' in s) return s.escaped;
        if ('trusted' in s) return s.trusted;
    }
    return '';
};
var $25957c27585b4297$var$escapeForTemplate = function escapeForTemplate(allowHTML, s) {
    return allowHTML ? $25957c27585b4297$var$unwrapStringForEscaped(s) : $25957c27585b4297$var$sanitise(s);
};
var $25957c27585b4297$var$setElementHtml = function setElementHtml(el, allowHtml, html) {
    el.innerHTML = $25957c27585b4297$var$escapeForTemplate(allowHtml, html);
};
var $25957c27585b4297$var$sortByAlpha = function sortByAlpha(_a, _b) {
    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
    return $25957c27585b4297$var$unwrapStringForRaw(label).localeCompare($25957c27585b4297$var$unwrapStringForRaw(label2), [], {
        sensitivity: 'base',
        ignorePunctuation: true,
        numeric: true
    });
};
var $25957c27585b4297$var$sortByRank = function sortByRank(a, b) {
    return a.rank - b.rank;
};
var $25957c27585b4297$var$dispatchEvent = function dispatchEvent(element, type, customArgs) {
    if (customArgs === void 0) customArgs = null;
    var event = new CustomEvent(type, {
        detail: customArgs,
        bubbles: true,
        cancelable: true
    });
    return element.dispatchEvent(event);
};
/**
 * Returns an array of keys present on the first but missing on the second object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $25957c27585b4297$var$diff = function diff(a, b) {
    var aKeys = Object.keys(a).sort();
    var bKeys = Object.keys(b).sort();
    return aKeys.filter(function(i) {
        return bKeys.indexOf(i) < 0;
    });
};
var $25957c27585b4297$var$getClassNames = function getClassNames(ClassNames) {
    return Array.isArray(ClassNames) ? ClassNames : [
        ClassNames
    ];
};
var $25957c27585b4297$var$getClassNamesSelector = function getClassNamesSelector(option) {
    if (option && Array.isArray(option)) return option.map(function(item) {
        return ".".concat(item);
    }).join('');
    return ".".concat(option);
};
var $25957c27585b4297$var$addClassesToElement = function addClassesToElement(element, className) {
    var _a;
    (_a = element.classList).add.apply(_a, $25957c27585b4297$var$getClassNames(className));
};
var $25957c27585b4297$var$removeClassesFromElement = function removeClassesFromElement(element, className) {
    var _a;
    (_a = element.classList).remove.apply(_a, $25957c27585b4297$var$getClassNames(className));
};
var $25957c27585b4297$var$parseCustomProperties = function parseCustomProperties(customProperties) {
    if (typeof customProperties !== 'undefined') try {
        return JSON.parse(customProperties);
    } catch (e) {
        return customProperties;
    }
    return {};
};
var $25957c27585b4297$var$updateClassList = function updateClassList(item, add, remove) {
    var itemEl = item.itemEl;
    if (itemEl) {
        $25957c27585b4297$var$removeClassesFromElement(itemEl, remove);
        $25957c27585b4297$var$addClassesToElement(itemEl, add);
    }
};
var $25957c27585b4297$var$Dropdown = /** @class */ function() {
    function Dropdown(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames;
        this.element = element;
        this.classNames = classNames;
        this.type = type;
        this.isActive = false;
    }
    /**
     * Show dropdown to user by adding active state class
     */ Dropdown.prototype.show = function() {
        $25957c27585b4297$var$addClassesToElement(this.element, this.classNames.activeState);
        this.element.setAttribute('aria-expanded', 'true');
        this.isActive = true;
        return this;
    };
    /**
     * Hide dropdown from user
     */ Dropdown.prototype.hide = function() {
        $25957c27585b4297$var$removeClassesFromElement(this.element, this.classNames.activeState);
        this.element.setAttribute('aria-expanded', 'false');
        this.isActive = false;
        return this;
    };
    return Dropdown;
}();
var $25957c27585b4297$var$Container = /** @class */ function() {
    function Container(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
        this.element = element;
        this.classNames = classNames;
        this.type = type;
        this.position = position;
        this.isOpen = false;
        this.isFlipped = false;
        this.isDisabled = false;
        this.isLoading = false;
    }
    /**
     * Determine whether container should be flipped based on passed
     * dropdown position
     */ Container.prototype.shouldFlip = function(dropdownPos, dropdownHeight) {
        // If flip is enabled and the dropdown bottom position is
        // greater than the window height flip the dropdown.
        var shouldFlip = false;
        if (this.position === 'auto') shouldFlip = this.element.getBoundingClientRect().top - dropdownHeight >= 0 && !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
        else if (this.position === 'top') shouldFlip = true;
        return shouldFlip;
    };
    Container.prototype.setActiveDescendant = function(activeDescendantID) {
        this.element.setAttribute('aria-activedescendant', activeDescendantID);
    };
    Container.prototype.removeActiveDescendant = function() {
        this.element.removeAttribute('aria-activedescendant');
    };
    Container.prototype.open = function(dropdownPos, dropdownHeight) {
        $25957c27585b4297$var$addClassesToElement(this.element, this.classNames.openState);
        this.element.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
        if (this.shouldFlip(dropdownPos, dropdownHeight)) {
            $25957c27585b4297$var$addClassesToElement(this.element, this.classNames.flippedState);
            this.isFlipped = true;
        }
    };
    Container.prototype.close = function() {
        $25957c27585b4297$var$removeClassesFromElement(this.element, this.classNames.openState);
        this.element.setAttribute('aria-expanded', 'false');
        this.removeActiveDescendant();
        this.isOpen = false;
        // A dropdown flips if it does not have space within the page
        if (this.isFlipped) {
            $25957c27585b4297$var$removeClassesFromElement(this.element, this.classNames.flippedState);
            this.isFlipped = false;
        }
    };
    Container.prototype.addFocusState = function() {
        $25957c27585b4297$var$addClassesToElement(this.element, this.classNames.focusState);
    };
    Container.prototype.removeFocusState = function() {
        $25957c27585b4297$var$removeClassesFromElement(this.element, this.classNames.focusState);
    };
    Container.prototype.enable = function() {
        $25957c27585b4297$var$removeClassesFromElement(this.element, this.classNames.disabledState);
        this.element.removeAttribute('aria-disabled');
        if (this.type === $25957c27585b4297$var$PassedElementTypes.SelectOne) this.element.setAttribute('tabindex', '0');
        this.isDisabled = false;
    };
    Container.prototype.disable = function() {
        $25957c27585b4297$var$addClassesToElement(this.element, this.classNames.disabledState);
        this.element.setAttribute('aria-disabled', 'true');
        if (this.type === $25957c27585b4297$var$PassedElementTypes.SelectOne) this.element.setAttribute('tabindex', '-1');
        this.isDisabled = true;
    };
    Container.prototype.wrap = function(element) {
        var el = this.element;
        var parentNode = element.parentNode;
        if (parentNode) {
            if (element.nextSibling) parentNode.insertBefore(el, element.nextSibling);
            else parentNode.appendChild(el);
        }
        el.appendChild(element);
    };
    Container.prototype.unwrap = function(element) {
        var el = this.element;
        var parentNode = el.parentNode;
        if (parentNode) {
            // Move passed element outside this element
            parentNode.insertBefore(element, el);
            // Remove this element
            parentNode.removeChild(el);
        }
    };
    Container.prototype.addLoadingState = function() {
        $25957c27585b4297$var$addClassesToElement(this.element, this.classNames.loadingState);
        this.element.setAttribute('aria-busy', 'true');
        this.isLoading = true;
    };
    Container.prototype.removeLoadingState = function() {
        $25957c27585b4297$var$removeClassesFromElement(this.element, this.classNames.loadingState);
        this.element.removeAttribute('aria-busy');
        this.isLoading = false;
    };
    return Container;
}();
var $25957c27585b4297$var$Input = /** @class */ function() {
    function Input(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
        this.element = element;
        this.type = type;
        this.classNames = classNames;
        this.preventPaste = preventPaste;
        this.isFocussed = this.element.isEqualNode(document.activeElement);
        this.isDisabled = element.disabled;
        this._onPaste = this._onPaste.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
    }
    Object.defineProperty(Input.prototype, "placeholder", {
        set: function set(placeholder) {
            this.element.placeholder = placeholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "value", {
        get: function get() {
            return this.element.value;
        },
        set: function set(value) {
            this.element.value = value;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.addEventListeners = function() {
        var el = this.element;
        el.addEventListener('paste', this._onPaste);
        el.addEventListener('input', this._onInput, {
            passive: true
        });
        el.addEventListener('focus', this._onFocus, {
            passive: true
        });
        el.addEventListener('blur', this._onBlur, {
            passive: true
        });
    };
    Input.prototype.removeEventListeners = function() {
        var el = this.element;
        el.removeEventListener('input', this._onInput);
        el.removeEventListener('paste', this._onPaste);
        el.removeEventListener('focus', this._onFocus);
        el.removeEventListener('blur', this._onBlur);
    };
    Input.prototype.enable = function() {
        var el = this.element;
        el.removeAttribute('disabled');
        this.isDisabled = false;
    };
    Input.prototype.disable = function() {
        var el = this.element;
        el.setAttribute('disabled', '');
        this.isDisabled = true;
    };
    Input.prototype.focus = function() {
        if (!this.isFocussed) this.element.focus();
    };
    Input.prototype.blur = function() {
        if (this.isFocussed) this.element.blur();
    };
    Input.prototype.clear = function(setWidth) {
        if (setWidth === void 0) setWidth = true;
        this.element.value = '';
        if (setWidth) this.setWidth();
        return this;
    };
    /**
     * Set the correct input width based on placeholder
     * value or input value
     */ Input.prototype.setWidth = function() {
        // Resize input to contents or placeholder
        var element = this.element;
        element.style.minWidth = "".concat(element.placeholder.length + 1, "ch");
        element.style.width = "".concat(element.value.length + 1, "ch");
    };
    Input.prototype.setActiveDescendant = function(activeDescendantID) {
        this.element.setAttribute('aria-activedescendant', activeDescendantID);
    };
    Input.prototype.removeActiveDescendant = function() {
        this.element.removeAttribute('aria-activedescendant');
    };
    Input.prototype._onInput = function() {
        if (this.type !== $25957c27585b4297$var$PassedElementTypes.SelectOne) this.setWidth();
    };
    Input.prototype._onPaste = function(event) {
        if (this.preventPaste) event.preventDefault();
    };
    Input.prototype._onFocus = function() {
        this.isFocussed = true;
    };
    Input.prototype._onBlur = function() {
        this.isFocussed = false;
    };
    return Input;
}();
var $25957c27585b4297$var$SCROLLING_SPEED = 4;
var $25957c27585b4297$var$List = /** @class */ function() {
    function List(_a) {
        var element = _a.element;
        this.element = element;
        this.scrollPos = this.element.scrollTop;
        this.height = this.element.offsetHeight;
    }
    List.prototype.prepend = function(node) {
        var child = this.element.firstElementChild;
        if (child) this.element.insertBefore(node, child);
        else this.element.append(node);
    };
    List.prototype.scrollToTop = function() {
        this.element.scrollTop = 0;
    };
    List.prototype.scrollToChildElement = function(element, direction) {
        var _this = this;
        if (!element) return;
        var listHeight = this.element.offsetHeight;
        // Scroll position of dropdown
        var listScrollPosition = this.element.scrollTop + listHeight;
        var elementHeight = element.offsetHeight;
        // Distance from bottom of element to top of parent
        var elementPos = element.offsetTop + elementHeight;
        // Difference between the element and scroll position
        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
        requestAnimationFrame(function() {
            _this._animateScroll(destination, direction);
        });
    };
    List.prototype._scrollDown = function(scrollPos, strength, destination) {
        var easing = (destination - scrollPos) / strength;
        var distance = easing > 1 ? easing : 1;
        this.element.scrollTop = scrollPos + distance;
    };
    List.prototype._scrollUp = function(scrollPos, strength, destination) {
        var easing = (scrollPos - destination) / strength;
        var distance = easing > 1 ? easing : 1;
        this.element.scrollTop = scrollPos - distance;
    };
    List.prototype._animateScroll = function(destination, direction) {
        var _this = this;
        var strength = $25957c27585b4297$var$SCROLLING_SPEED;
        var choiceListScrollTop = this.element.scrollTop;
        var continueAnimation = false;
        if (direction > 0) {
            this._scrollDown(choiceListScrollTop, strength, destination);
            if (choiceListScrollTop < destination) continueAnimation = true;
        } else {
            this._scrollUp(choiceListScrollTop, strength, destination);
            if (choiceListScrollTop > destination) continueAnimation = true;
        }
        if (continueAnimation) requestAnimationFrame(function() {
            _this._animateScroll(destination, direction);
        });
    };
    return List;
}();
var $25957c27585b4297$var$WrappedElement = /** @class */ function() {
    function WrappedElement(_a) {
        var element = _a.element, classNames = _a.classNames;
        this.element = element;
        this.classNames = classNames;
        this.isDisabled = false;
    }
    Object.defineProperty(WrappedElement.prototype, "isActive", {
        get: function get() {
            return this.element.dataset.choice === 'active';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedElement.prototype, "dir", {
        get: function get() {
            return this.element.dir;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedElement.prototype, "value", {
        get: function get() {
            return this.element.value;
        },
        set: function set(value) {
            this.element.setAttribute('value', value);
            this.element.value = value;
        },
        enumerable: false,
        configurable: true
    });
    WrappedElement.prototype.conceal = function() {
        var el = this.element;
        // Hide passed input
        $25957c27585b4297$var$addClassesToElement(el, this.classNames.input);
        el.hidden = true;
        // Remove element from tab index
        el.tabIndex = -1;
        // Backup original styles if any
        var origStyle = el.getAttribute('style');
        if (origStyle) el.setAttribute('data-choice-orig-style', origStyle);
        el.setAttribute('data-choice', 'active');
    };
    WrappedElement.prototype.reveal = function() {
        var el = this.element;
        // Reinstate passed element
        $25957c27585b4297$var$removeClassesFromElement(el, this.classNames.input);
        el.hidden = false;
        el.removeAttribute('tabindex');
        // Recover original styles if any
        var origStyle = el.getAttribute('data-choice-orig-style');
        if (origStyle) {
            el.removeAttribute('data-choice-orig-style');
            el.setAttribute('style', origStyle);
        } else el.removeAttribute('style');
        el.removeAttribute('data-choice');
    };
    WrappedElement.prototype.enable = function() {
        this.element.removeAttribute('disabled');
        this.element.disabled = false;
        this.isDisabled = false;
    };
    WrappedElement.prototype.disable = function() {
        this.element.setAttribute('disabled', '');
        this.element.disabled = true;
        this.isDisabled = true;
    };
    WrappedElement.prototype.triggerEvent = function(eventType, data) {
        $25957c27585b4297$var$dispatchEvent(this.element, eventType, data || {});
    };
    return WrappedElement;
}();
var $25957c27585b4297$var$WrappedInput = /** @class */ function(_super) {
    $25957c27585b4297$var$__extends(WrappedInput, _super);
    function WrappedInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WrappedInput;
}($25957c27585b4297$var$WrappedElement);
var $25957c27585b4297$var$coerceBool = function coerceBool(arg, defaultValue) {
    if (defaultValue === void 0) defaultValue = true;
    return typeof arg === 'undefined' ? defaultValue : !!arg;
};
var $25957c27585b4297$var$stringToHtmlClass = function stringToHtmlClass(input) {
    if (typeof input === 'string') // eslint-disable-next-line no-param-reassign
    input = input.split(' ').filter(function(s) {
        return s.length;
    });
    if (Array.isArray(input) && input.length) return input;
    return undefined;
};
var $25957c27585b4297$var$mapInputToChoice = function mapInputToChoice1(value, allowGroup, allowRawString) {
    if (allowRawString === void 0) allowRawString = true;
    if (typeof value === 'string') {
        var sanitisedValue = $25957c27585b4297$var$sanitise(value);
        var userValue = allowRawString || sanitisedValue === value ? value : {
            escaped: sanitisedValue,
            raw: value
        };
        var result_1 = $25957c27585b4297$var$mapInputToChoice({
            value: value,
            label: userValue,
            selected: true
        }, false);
        return result_1;
    }
    var groupOrChoice = value;
    if ('choices' in groupOrChoice) {
        if (!allowGroup) // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/optgroup
        throw new TypeError("optGroup is not allowed");
        var group = groupOrChoice;
        var _$choices = group.choices.map(function(e) {
            return $25957c27585b4297$var$mapInputToChoice(e, false);
        });
        var result_2 = {
            id: 0,
            label: $25957c27585b4297$var$unwrapStringForRaw(group.label) || group.value,
            active: !!_$choices.length,
            disabled: !!group.disabled,
            choices: _$choices
        };
        return result_2;
    }
    var choice = groupOrChoice;
    var result = {
        id: 0,
        group: null,
        score: 0,
        rank: 0,
        value: choice.value,
        label: choice.label || choice.value,
        active: $25957c27585b4297$var$coerceBool(choice.active),
        selected: $25957c27585b4297$var$coerceBool(choice.selected, false),
        disabled: $25957c27585b4297$var$coerceBool(choice.disabled, false),
        placeholder: $25957c27585b4297$var$coerceBool(choice.placeholder, false),
        highlighted: false,
        labelClass: $25957c27585b4297$var$stringToHtmlClass(choice.labelClass),
        labelDescription: choice.labelDescription,
        customProperties: choice.customProperties
    };
    return result;
};
var $25957c27585b4297$var$isHtmlInputElement = function isHtmlInputElement(e) {
    return e.tagName === 'INPUT';
};
var $25957c27585b4297$var$isHtmlSelectElement = function isHtmlSelectElement(e) {
    return e.tagName === 'SELECT';
};
var $25957c27585b4297$var$isHtmlOption = function isHtmlOption(e) {
    return e.tagName === 'OPTION';
};
var $25957c27585b4297$var$isHtmlOptgroup = function isHtmlOptgroup(e) {
    return e.tagName === 'OPTGROUP';
};
var $25957c27585b4297$var$WrappedSelect = /** @class */ function(_super) {
    $25957c27585b4297$var$__extends(WrappedSelect, _super);
    function WrappedSelect(_a) {
        var element = _a.element, classNames = _a.classNames, template = _a.template, extractPlaceholder = _a.extractPlaceholder;
        var _this = _super.call(this, {
            element: element,
            classNames: classNames
        }) || this;
        _this.template = template;
        _this.extractPlaceholder = extractPlaceholder;
        return _this;
    }
    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
        get: function get() {
            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
            this.element.querySelector('option[placeholder]');
        },
        enumerable: false,
        configurable: true
    });
    WrappedSelect.prototype.addOptions = function(choices) {
        var _this = this;
        var fragment = document.createDocumentFragment();
        choices.forEach(function(obj) {
            var choice = obj;
            if (choice.element) return;
            var option = _this.template(choice);
            fragment.appendChild(option);
            choice.element = option;
        });
        this.element.appendChild(fragment);
    };
    WrappedSelect.prototype.optionsAsChoices = function() {
        var _this = this;
        var _$choices = [];
        this.element.querySelectorAll(':scope > option, :scope > optgroup').forEach(function(e) {
            if ($25957c27585b4297$var$isHtmlOption(e)) _$choices.push(_this._optionToChoice(e));
            else if ($25957c27585b4297$var$isHtmlOptgroup(e)) _$choices.push(_this._optgroupToChoice(e));
        // todo: hr as empty optgroup, requires displaying empty opt-groups to be useful
        });
        return _$choices;
    };
    // eslint-disable-next-line class-methods-use-this
    WrappedSelect.prototype._optionToChoice = function(option) {
        // option.value returns the label if there is no value attribute, which can break legacy placeholder attribute support
        if (!option.hasAttribute('value') && option.hasAttribute('placeholder')) {
            option.setAttribute('value', '');
            option.value = '';
        }
        return {
            id: 0,
            group: null,
            score: 0,
            rank: 0,
            value: option.value,
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option
            // This attribute is text for the label indicating the meaning of the option. If the `label` attribute isn't defined, its value is that of the element text content (ie `innerText`).
            label: option.label,
            element: option,
            active: true,
            // this returns true if nothing is selected on initial load, which will break placeholder support
            selected: this.extractPlaceholder ? option.selected : option.hasAttribute('selected'),
            disabled: option.disabled,
            highlighted: false,
            placeholder: this.extractPlaceholder && (!option.value || option.hasAttribute('placeholder')),
            labelClass: typeof option.dataset.labelClass !== 'undefined' ? $25957c27585b4297$var$stringToHtmlClass(option.dataset.labelClass) : undefined,
            labelDescription: typeof option.dataset.labelDescription !== 'undefined' ? option.dataset.labelDescription : undefined,
            customProperties: $25957c27585b4297$var$parseCustomProperties(option.dataset.customProperties)
        };
    };
    WrappedSelect.prototype._optgroupToChoice = function(optgroup) {
        var _this = this;
        var options = optgroup.querySelectorAll('option');
        var _$choices = Array.from(options).map(function(option) {
            return _this._optionToChoice(option);
        });
        return {
            id: 0,
            label: optgroup.label || '',
            element: optgroup,
            active: !!_$choices.length,
            disabled: optgroup.disabled,
            choices: _$choices
        };
    };
    return WrappedSelect;
}($25957c27585b4297$var$WrappedElement);
var $25957c27585b4297$var$DEFAULT_CLASSNAMES = {
    containerOuter: [
        'choices'
    ],
    containerInner: [
        'choices__inner'
    ],
    input: [
        'choices__input'
    ],
    inputCloned: [
        'choices__input--cloned'
    ],
    list: [
        'choices__list'
    ],
    listItems: [
        'choices__list--multiple'
    ],
    listSingle: [
        'choices__list--single'
    ],
    listDropdown: [
        'choices__list--dropdown'
    ],
    item: [
        'choices__item'
    ],
    itemSelectable: [
        'choices__item--selectable'
    ],
    itemDisabled: [
        'choices__item--disabled'
    ],
    itemChoice: [
        'choices__item--choice'
    ],
    description: [
        'choices__description'
    ],
    placeholder: [
        'choices__placeholder'
    ],
    group: [
        'choices__group'
    ],
    groupHeading: [
        'choices__heading'
    ],
    button: [
        'choices__button'
    ],
    activeState: [
        'is-active'
    ],
    focusState: [
        'is-focused'
    ],
    openState: [
        'is-open'
    ],
    disabledState: [
        'is-disabled'
    ],
    highlightedState: [
        'is-highlighted'
    ],
    selectedState: [
        'is-selected'
    ],
    flippedState: [
        'is-flipped'
    ],
    loadingState: [
        'is-loading'
    ],
    notice: [
        'choices__notice'
    ],
    addChoice: [
        'choices__item--selectable',
        'add-choice'
    ],
    noResults: [
        'has-no-results'
    ],
    noChoices: [
        'has-no-choices'
    ]
};
var $25957c27585b4297$var$DEFAULT_CONFIG = {
    items: [],
    choices: [],
    silent: false,
    renderChoiceLimit: -1,
    maxItemCount: -1,
    closeDropdownOnSelect: 'auto',
    singleModeForMultiSelect: false,
    addChoices: false,
    addItems: true,
    addItemFilter: function addItemFilter(value) {
        return !!value && value !== '';
    },
    removeItems: true,
    removeItemButton: false,
    removeItemButtonAlignLeft: false,
    editItems: false,
    allowHTML: false,
    allowHtmlUserInput: false,
    duplicateItemsAllowed: true,
    delimiter: ',',
    paste: true,
    searchEnabled: true,
    searchChoices: true,
    searchFloor: 1,
    searchResultLimit: 4,
    searchFields: [
        'label',
        'value'
    ],
    position: 'auto',
    resetScrollPosition: true,
    shouldSort: true,
    shouldSortItems: false,
    sorter: $25957c27585b4297$var$sortByAlpha,
    shadowRoot: null,
    placeholder: true,
    placeholderValue: null,
    searchPlaceholderValue: null,
    prependValue: null,
    appendValue: null,
    renderSelectedChoices: 'auto',
    loadingText: 'Loading...',
    noResultsText: 'No results found',
    noChoicesText: 'No choices to choose from',
    itemSelectText: 'Press to select',
    uniqueItemText: 'Only unique values can be added',
    customAddItemText: 'Only values matching specific conditions can be added',
    addItemText: function addItemText(value) {
        return "Press Enter to add <b>\"".concat(value, "\"</b>");
    },
    removeItemIconText: function removeItemIconText() {
        return "Remove item";
    },
    removeItemLabelText: function removeItemLabelText(value) {
        return "Remove item: ".concat(value);
    },
    maxItemText: function maxItemText(maxItemCount) {
        return "Only ".concat(maxItemCount, " values can be added");
    },
    valueComparer: function valueComparer(value1, value2) {
        return value1 === value2;
    },
    fuseOptions: {
        includeScore: true
    },
    labelId: '',
    callbackOnInit: null,
    callbackOnCreateTemplates: null,
    classNames: $25957c27585b4297$var$DEFAULT_CLASSNAMES,
    appendGroupInSearch: false
};
var $25957c27585b4297$var$removeItem = function removeItem(item) {
    var itemEl = item.itemEl;
    if (itemEl) {
        itemEl.remove();
        item.itemEl = undefined;
    }
};
function $25957c27585b4297$var$items(s, action, context) {
    var state = s;
    var update = true;
    switch(action.type){
        case $25957c27585b4297$var$ActionType.ADD_ITEM:
            action.item.selected = true;
            var el = action.item.element;
            if (el) {
                el.selected = true;
                el.setAttribute('selected', '');
            }
            state.push(action.item);
            break;
        case $25957c27585b4297$var$ActionType.REMOVE_ITEM:
            action.item.selected = false;
            var el = action.item.element;
            if (el) {
                el.selected = false;
                el.removeAttribute('selected');
                // For a select-one, if all options are deselected, the first item is selected. To set a black value, select.value needs to be set
                var select = el.parentElement;
                if (select && $25957c27585b4297$var$isHtmlSelectElement(select) && select.type === $25957c27585b4297$var$PassedElementTypes.SelectOne) select.value = '';
            }
            // this is mixing concerns, but this is *so much faster*
            $25957c27585b4297$var$removeItem(action.item);
            state = state.filter(function(choice) {
                return choice.id !== action.item.id;
            });
            break;
        case $25957c27585b4297$var$ActionType.REMOVE_CHOICE:
            $25957c27585b4297$var$removeItem(action.choice);
            state = state.filter(function(item) {
                return item.id !== action.choice.id;
            });
            break;
        case $25957c27585b4297$var$ActionType.HIGHLIGHT_ITEM:
            var highlighted = action.highlighted;
            var item = state.find(function(obj) {
                return obj.id === action.item.id;
            });
            if (item && item.highlighted !== highlighted) {
                item.highlighted = highlighted;
                if (context) $25957c27585b4297$var$updateClassList(item, highlighted ? context.classNames.highlightedState : context.classNames.selectedState, highlighted ? context.classNames.selectedState : context.classNames.highlightedState);
            }
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
function $25957c27585b4297$var$groups(s, action) {
    var state = s;
    var update = true;
    switch(action.type){
        case $25957c27585b4297$var$ActionType.ADD_GROUP:
            state.push(action.group);
            break;
        case $25957c27585b4297$var$ActionType.CLEAR_CHOICES:
            state = [];
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
/* eslint-disable */ function $25957c27585b4297$var$choices(s, action, context) {
    var state = s;
    var update = true;
    switch(action.type){
        case $25957c27585b4297$var$ActionType.ADD_CHOICE:
            state.push(action.choice);
            break;
        case $25957c27585b4297$var$ActionType.REMOVE_CHOICE:
            action.choice.choiceEl = undefined;
            if (action.choice.group) action.choice.group.choices = action.choice.group.choices.filter(function(obj) {
                return obj.id !== action.choice.id;
            });
            state = state.filter(function(obj) {
                return obj.id !== action.choice.id;
            });
            break;
        case $25957c27585b4297$var$ActionType.ADD_ITEM:
        case $25957c27585b4297$var$ActionType.REMOVE_ITEM:
            action.item.choiceEl = undefined;
            break;
        case $25957c27585b4297$var$ActionType.FILTER_CHOICES:
            // avoid O(n^2) algorithm complexity when searching/filtering choices
            var scoreLookup_1 = [];
            action.results.forEach(function(result) {
                scoreLookup_1[result.item.id] = result;
            });
            state.forEach(function(choice) {
                var result = scoreLookup_1[choice.id];
                if (result !== undefined) {
                    choice.score = result.score;
                    choice.rank = result.rank;
                    choice.active = true;
                } else {
                    choice.score = 0;
                    choice.rank = 0;
                    choice.active = false;
                }
                if (context && context.appendGroupInSearch) choice.choiceEl = undefined;
            });
            break;
        case $25957c27585b4297$var$ActionType.ACTIVATE_CHOICES:
            state.forEach(function(choice) {
                choice.active = action.active;
                if (context && context.appendGroupInSearch) choice.choiceEl = undefined;
            });
            break;
        case $25957c27585b4297$var$ActionType.CLEAR_CHOICES:
            state = [];
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
var $25957c27585b4297$var$reducers = {
    groups: $25957c27585b4297$var$groups,
    items: $25957c27585b4297$var$items,
    choices: $25957c27585b4297$var$choices
};
var $25957c27585b4297$var$Store = /** @class */ function() {
    function Store(context) {
        this._state = this.defaultState;
        this._listeners = [];
        this._txn = 0;
        this._context = context;
    }
    Object.defineProperty(Store.prototype, "defaultState", {
        // eslint-disable-next-line class-methods-use-this
        get: function get() {
            return {
                groups: [],
                items: [],
                choices: []
            };
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line class-methods-use-this
    Store.prototype.changeSet = function(init) {
        return {
            groups: init,
            items: init,
            choices: init
        };
    };
    Store.prototype.reset = function() {
        this._state = this.defaultState;
        var changes = this.changeSet(true);
        if (this._txn) this._changeSet = changes;
        else this._listeners.forEach(function(l) {
            return l(changes);
        });
    };
    Store.prototype.subscribe = function(onChange) {
        this._listeners.push(onChange);
        return this;
    };
    Store.prototype.dispatch = function(action) {
        var _this = this;
        var state = this._state;
        var hasChanges = false;
        var changes = this._changeSet || this.changeSet(false);
        Object.keys($25957c27585b4297$var$reducers).forEach(function(key) {
            var stateUpdate = $25957c27585b4297$var$reducers[key](state[key], action, _this._context);
            if (stateUpdate.update) {
                hasChanges = true;
                changes[key] = true;
                state[key] = stateUpdate.state;
            }
        });
        if (hasChanges) {
            if (this._txn) this._changeSet = changes;
            else this._listeners.forEach(function(l) {
                return l(changes);
            });
        }
    };
    Store.prototype.withTxn = function(func) {
        this._txn++;
        try {
            func();
        } finally{
            this._txn = Math.max(0, this._txn - 1);
            if (!this._txn) {
                var changeSet_1 = this._changeSet;
                if (changeSet_1) {
                    this._changeSet = undefined;
                    this._listeners.forEach(function(l) {
                        return l(changeSet_1);
                    });
                }
            }
        }
    };
    Object.defineProperty(Store.prototype, "state", {
        /**
         * Get store object
         */ get: function get() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "items", {
        /**
         * Get items from store
         */ get: function get() {
            return this.state.items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
        /**
         * Get highlighted items from store
         */ get: function get() {
            return this.items.filter(function(item) {
                return item.active && item.highlighted;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "choices", {
        /**
         * Get choices from store
         */ get: function get() {
            return this.state.choices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "activeChoices", {
        /**
         * Get active choices from store
         */ get: function get() {
            return this.choices.filter(function(choice) {
                return choice.active;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "searchableChoices", {
        /**
         * Get choices that can be searched (excluding placeholders or disabled choices)
         */ get: function get() {
            return this.choices.filter(function(choice) {
                return !choice.disabled && !choice.placeholder;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "groups", {
        /**
         * Get groups from store
         */ get: function get() {
            return this.state.groups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "activeGroups", {
        /**
         * Get active groups from store
         */ get: function get() {
            var _this = this;
            return this.state.groups.filter(function(group) {
                var isActive = group.active && !group.disabled;
                var hasActiveOptions = _this.state.choices.some(function(choice) {
                    return choice.active && !choice.disabled;
                });
                return isActive && hasActiveOptions;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.inTxn = function() {
        return this._txn > 0;
    };
    /**
     * Get single choice by it's ID
     */ Store.prototype.getChoiceById = function(id) {
        return this.activeChoices.find(function(choice) {
            return choice.id === id;
        });
    };
    /**
     * Get group by group id
     */ Store.prototype.getGroupById = function(id) {
        return this.groups.find(function(group) {
            return group.id === id;
        });
    };
    return Store;
}();
var $25957c27585b4297$var$NoticeTypes = {
    noChoices: 'no-choices',
    noResults: 'no-results',
    addChoice: 'add-choice',
    generic: ''
};
function $25957c27585b4297$var$_defineProperty(e, r, t) {
    return (r = $25957c27585b4297$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $25957c27585b4297$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $25957c27585b4297$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $25957c27585b4297$var$ownKeys(Object(t), !0).forEach(function(r) {
            $25957c27585b4297$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $25957c27585b4297$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $25957c27585b4297$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $25957c27585b4297$var$_toPropertyKey(t) {
    var i = $25957c27585b4297$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $25957c27585b4297$var$isArray(value) {
    return !Array.isArray ? $25957c27585b4297$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
var $25957c27585b4297$var$INFINITY = 1 / 0;
function $25957c27585b4297$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    var result = value + '';
    return result == '0' && 1 / value == -$25957c27585b4297$var$INFINITY ? '-0' : result;
}
function $25957c27585b4297$var$toString(value) {
    return value == null ? '' : $25957c27585b4297$var$baseToString(value);
}
function $25957c27585b4297$var$isString(value) {
    return typeof value === 'string';
}
function $25957c27585b4297$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $25957c27585b4297$var$isBoolean(value) {
    return value === true || value === false || $25957c27585b4297$var$isObjectLike(value) && $25957c27585b4297$var$getTag(value) == '[object Boolean]';
}
function $25957c27585b4297$var$isObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)) === 'object';
}
// Checks if `value` is object-like.
function $25957c27585b4297$var$isObjectLike(value) {
    return $25957c27585b4297$var$isObject(value) && value !== null;
}
function $25957c27585b4297$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $25957c27585b4297$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $25957c27585b4297$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
var $25957c27585b4297$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
var $25957c27585b4297$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
var $25957c27585b4297$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function(key) {
    return "Invalid value for key ".concat(key);
};
var $25957c27585b4297$var$PATTERN_LENGTH_TOO_LARGE = function(max) {
    return "Pattern length exceeds max of ".concat(max, ".");
};
var $25957c27585b4297$var$MISSING_KEY_PROPERTY = function(name) {
    return "Missing ".concat(name, " property in key");
};
var $25957c27585b4297$var$INVALID_KEY_WEIGHT_VALUE = function(key) {
    return "Property 'weight' in key '".concat(key, "' must be a positive integer");
};
var $25957c27585b4297$var$hasOwn = Object.prototype.hasOwnProperty;
var $25957c27585b4297$var$KeyStore = /*#__PURE__*/ function() {
    "use strict";
    function KeyStore(keys) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, KeyStore);
        this._keys = [];
        this._keyMap = {};
        var totalWeight = 0;
        keys.forEach(function(key) {
            var obj = $25957c27585b4297$var$createKey(key);
            _this._keys.push(obj);
            _this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach(function(key) {
            key.weight /= totalWeight;
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(KeyStore, [
        {
            key: "get",
            value: function get(keyId) {
                return this._keyMap[keyId];
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this._keys;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return JSON.stringify(this._keys);
            }
        }
    ]);
    return KeyStore;
}();
function $25957c27585b4297$var$createKey(key) {
    var path = null;
    var id = null;
    var src = null;
    var weight = 1;
    var getFn = null;
    if ($25957c27585b4297$var$isString(key) || $25957c27585b4297$var$isArray(key)) {
        src = key;
        path = $25957c27585b4297$var$createKeyPath(key);
        id = $25957c27585b4297$var$createKeyId(key);
    } else {
        if (!$25957c27585b4297$var$hasOwn.call(key, 'name')) throw new Error($25957c27585b4297$var$MISSING_KEY_PROPERTY('name'));
        var name = key.name;
        src = name;
        if ($25957c27585b4297$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($25957c27585b4297$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $25957c27585b4297$var$createKeyPath(name);
        id = $25957c27585b4297$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $25957c27585b4297$var$createKeyPath(key) {
    return $25957c27585b4297$var$isArray(key) ? key : key.split('.');
}
function $25957c27585b4297$var$createKeyId(key) {
    return $25957c27585b4297$var$isArray(key) ? key.join('.') : key;
}
function $25957c27585b4297$var$get(obj, path) {
    var list = [];
    var arr = false;
    var deepGet = function(obj, path, index) {
        if (!$25957c27585b4297$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            var key = path[index];
            var value = obj[key];
            if (!$25957c27585b4297$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($25957c27585b4297$var$isString(value) || $25957c27585b4297$var$isNumber(value) || $25957c27585b4297$var$isBoolean(value))) list.push($25957c27585b4297$var$toString(value));
            else if ($25957c27585b4297$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(var i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $25957c27585b4297$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
var $25957c27585b4297$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
var $25957c27585b4297$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: function(a, b) {
        return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
    }
};
var $25957c27585b4297$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
var $25957c27585b4297$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $25957c27585b4297$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $25957c27585b4297$var$Config = $25957c27585b4297$var$_objectSpread2($25957c27585b4297$var$_objectSpread2($25957c27585b4297$var$_objectSpread2($25957c27585b4297$var$_objectSpread2({}, $25957c27585b4297$var$BasicOptions), $25957c27585b4297$var$MatchOptions), $25957c27585b4297$var$FuzzyOptions), $25957c27585b4297$var$AdvancedOptions);
var $25957c27585b4297$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $25957c27585b4297$var$norm() {
    var weight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, mantissa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    var cache = new Map();
    var m = Math.pow(10, mantissa);
    return {
        get: function(value) {
            var numTokens = value.match($25957c27585b4297$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            var norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            var n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear: function() {
            cache.clear();
        }
    };
}
var $25957c27585b4297$var$FuseIndex = /*#__PURE__*/ function() {
    "use strict";
    function FuseIndex() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $25957c27585b4297$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $25957c27585b4297$var$Config.fieldNormWeight : _ref_fieldNormWeight;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, FuseIndex);
        this.norm = $25957c27585b4297$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(FuseIndex, [
        {
            key: "setSources",
            value: function setSources() {
                var docs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.docs = docs;
            }
        },
        {
            key: "setIndexRecords",
            value: function setIndexRecords() {
                var records = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.records = records;
            }
        },
        {
            key: "setKeys",
            value: function setKeys() {
                var _this = this;
                var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.keys = keys;
                this._keysMap = {};
                keys.forEach(function(key, idx) {
                    _this._keysMap[key.id] = idx;
                });
            }
        },
        {
            key: "create",
            value: function create() {
                var _this = this;
                if (this.isCreated || !this.docs.length) return;
                this.isCreated = true;
                // List is Array<String>
                if ($25957c27585b4297$var$isString(this.docs[0])) this.docs.forEach(function(doc, docIndex) {
                    _this._addString(doc, docIndex);
                });
                else // List is Array<Object>
                this.docs.forEach(function(doc, docIndex) {
                    _this._addObject(doc, docIndex);
                });
                this.norm.clear();
            }
        },
        {
            // Adds a doc to the end of the index
            key: "add",
            value: function add(doc) {
                var idx = this.size();
                if ($25957c27585b4297$var$isString(doc)) this._addString(doc, idx);
                else this._addObject(doc, idx);
            }
        },
        {
            // Removes the doc at the specified index of the index
            key: "removeAt",
            value: function removeAt(idx) {
                this.records.splice(idx, 1);
                // Change ref index of every subsquent doc
                for(var i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
            }
        },
        {
            key: "getValueForItemAtKeyId",
            value: function getValueForItemAtKeyId(item, keyId) {
                return item[this._keysMap[keyId]];
            }
        },
        {
            key: "size",
            value: function size() {
                return this.records.length;
            }
        },
        {
            key: "_addString",
            value: function _addString(doc, docIndex) {
                if (!$25957c27585b4297$var$isDefined(doc) || $25957c27585b4297$var$isBlank(doc)) return;
                var record = {
                    v: doc,
                    i: docIndex,
                    n: this.norm.get(doc)
                };
                this.records.push(record);
            }
        },
        {
            key: "_addObject",
            value: function _addObject(doc, docIndex) {
                var _this = this;
                var record = {
                    i: docIndex,
                    $: {}
                };
                // Iterate over every key (i.e, path), and fetch the value at that key
                this.keys.forEach(function(key, keyIndex) {
                    var value = key.getFn ? key.getFn(doc) : _this.getFn(doc, key.path);
                    if (!$25957c27585b4297$var$isDefined(value)) return;
                    if ($25957c27585b4297$var$isArray(value)) {
                        var subRecords = [];
                        var stack = [
                            {
                                nestedArrIndex: -1,
                                value: value
                            }
                        ];
                        while(stack.length){
                            var _stack_pop = stack.pop(), nestedArrIndex = _stack_pop.nestedArrIndex, value1 = _stack_pop.value;
                            if (!$25957c27585b4297$var$isDefined(value1)) continue;
                            if ($25957c27585b4297$var$isString(value1) && !$25957c27585b4297$var$isBlank(value1)) {
                                var subRecord = {
                                    v: value1,
                                    i: nestedArrIndex,
                                    n: _this.norm.get(value1)
                                };
                                subRecords.push(subRecord);
                            } else if ($25957c27585b4297$var$isArray(value1)) value1.forEach(function(item, k) {
                                stack.push({
                                    nestedArrIndex: k,
                                    value: item
                                });
                            });
                        }
                        record.$[keyIndex] = subRecords;
                    } else if ($25957c27585b4297$var$isString(value) && !$25957c27585b4297$var$isBlank(value)) {
                        var subRecord1 = {
                            v: value,
                            n: _this.norm.get(value)
                        };
                        record.$[keyIndex] = subRecord1;
                    }
                });
                this.records.push(record);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    keys: this.keys,
                    records: this.records
                };
            }
        }
    ]);
    return FuseIndex;
}();
function $25957c27585b4297$var$createIndex(keys, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $25957c27585b4297$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $25957c27585b4297$var$Config.fieldNormWeight : _ref_fieldNormWeight;
    var myIndex = new $25957c27585b4297$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($25957c27585b4297$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $25957c27585b4297$var$parseIndex(data) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $25957c27585b4297$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $25957c27585b4297$var$Config.fieldNormWeight : _ref_fieldNormWeight;
    var keys = data.keys, records = data.records;
    var myIndex = new $25957c27585b4297$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $25957c27585b4297$var$computeScore$1(pattern) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_errors = _ref.errors, errors = _ref_errors === void 0 ? 0 : _ref_errors, _ref_currentLocation = _ref.currentLocation, currentLocation = _ref_currentLocation === void 0 ? 0 : _ref_currentLocation, _ref_expectedLocation = _ref.expectedLocation, expectedLocation = _ref_expectedLocation === void 0 ? 0 : _ref_expectedLocation, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $25957c27585b4297$var$Config.distance : _ref_distance, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $25957c27585b4297$var$Config.ignoreLocation : _ref_ignoreLocation;
    var accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    var proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $25957c27585b4297$var$convertMaskToIndices() {
    var matchmask = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], minMatchCharLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $25957c27585b4297$var$Config.minMatchCharLength;
    var indices = [];
    var start = -1;
    var end = -1;
    var i = 0;
    for(var len = matchmask.length; i < len; i += 1){
        var match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
var $25957c27585b4297$var$MAX_BITS = 32;
function $25957c27585b4297$var$search(text, pattern, patternAlphabet) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $25957c27585b4297$var$Config.location : _ref_location, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $25957c27585b4297$var$Config.distance : _ref_distance, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $25957c27585b4297$var$Config.threshold : _ref_threshold, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $25957c27585b4297$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $25957c27585b4297$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $25957c27585b4297$var$Config.includeMatches : _ref_includeMatches, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $25957c27585b4297$var$Config.ignoreLocation : _ref_ignoreLocation;
    if (pattern.length > $25957c27585b4297$var$MAX_BITS) throw new Error($25957c27585b4297$var$PATTERN_LENGTH_TOO_LARGE($25957c27585b4297$var$MAX_BITS));
    var patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    var textLen = text.length;
    // Handle the case when location > text.length
    var expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    var currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    var bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    var computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    var matchMask = computeMatches ? Array(textLen) : [];
    var index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        var score = $25957c27585b4297$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            var i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    var lastBitArr = [];
    var finalScore = 1;
    var binMax = patternLen + textLen;
    var mask = 1 << patternLen - 1;
    for(var i1 = 0; i1 < patternLen; i1 += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        var binMin = 0;
        var binMid = binMax;
        while(binMin < binMid){
            var score1 = $25957c27585b4297$var$computeScore$1(pattern, {
                errors: i1,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score1 <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        var start = Math.max(1, expectedLocation - binMid + 1);
        var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        var bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i1) - 1;
        for(var j = finish; j >= start; j -= 1){
            var currentLocation = j - 1;
            var charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i1) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $25957c27585b4297$var$computeScore$1(pattern, {
                    errors: i1,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        var score2 = $25957c27585b4297$var$computeScore$1(pattern, {
            errors: i1 + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score2 > currentThreshold) break;
        lastBitArr = bitArr;
    }
    var result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        var indices = $25957c27585b4297$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $25957c27585b4297$var$createPatternAlphabet(pattern) {
    var mask = {};
    for(var i = 0, len = pattern.length; i < len; i += 1){
        var _char = pattern.charAt(i);
        mask[_char] = (mask[_char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
var $25957c27585b4297$var$BitapSearch = /*#__PURE__*/ function() {
    "use strict";
    function BitapSearch(pattern) {
        var _this = this;
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $25957c27585b4297$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $25957c27585b4297$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $25957c27585b4297$var$Config.distance : _ref_distance, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $25957c27585b4297$var$Config.includeMatches : _ref_includeMatches, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $25957c27585b4297$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $25957c27585b4297$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $25957c27585b4297$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $25957c27585b4297$var$Config.ignoreLocation : _ref_ignoreLocation;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, BitapSearch);
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        var addChunk = function(pattern, startIndex) {
            _this.chunks.push({
                pattern: pattern,
                alphabet: $25957c27585b4297$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        var len = this.pattern.length;
        if (len > $25957c27585b4297$var$MAX_BITS) {
            var i = 0;
            var remainder = len % $25957c27585b4297$var$MAX_BITS;
            var end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $25957c27585b4297$var$MAX_BITS), i);
                i += $25957c27585b4297$var$MAX_BITS;
            }
            if (remainder) {
                var startIndex = len - $25957c27585b4297$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(BitapSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                var _this_options = this.options, isCaseSensitive = _this_options.isCaseSensitive, includeMatches = _this_options.includeMatches;
                if (!isCaseSensitive) text = text.toLowerCase();
                // Exact match
                if (this.pattern === text) {
                    var result = {
                        isMatch: true,
                        score: 0
                    };
                    if (includeMatches) result.indices = [
                        [
                            0,
                            text.length - 1
                        ]
                    ];
                    return result;
                }
                // Otherwise, use Bitap algorithm
                var _this_options1 = this.options, location = _this_options1.location, distance = _this_options1.distance, threshold = _this_options1.threshold, findAllMatches = _this_options1.findAllMatches, minMatchCharLength = _this_options1.minMatchCharLength, ignoreLocation = _this_options1.ignoreLocation;
                var allIndices = [];
                var totalScore = 0;
                var hasMatches = false;
                this.chunks.forEach(function(param) {
                    var pattern = param.pattern, alphabet = param.alphabet, startIndex = param.startIndex;
                    var _search = $25957c27585b4297$var$search(text, pattern, alphabet, {
                        location: location + startIndex,
                        distance: distance,
                        threshold: threshold,
                        findAllMatches: findAllMatches,
                        minMatchCharLength: minMatchCharLength,
                        includeMatches: includeMatches,
                        ignoreLocation: ignoreLocation
                    }), isMatch = _search.isMatch, score = _search.score, indices = _search.indices;
                    if (isMatch) hasMatches = true;
                    totalScore += score;
                    if (isMatch && indices) allIndices = (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(allIndices).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(indices));
                });
                var result1 = {
                    isMatch: hasMatches,
                    score: hasMatches ? totalScore / this.chunks.length : 1
                };
                if (hasMatches && includeMatches) result1.indices = allIndices;
                return result1;
            }
        }
    ]);
    return BitapSearch;
}();
var $25957c27585b4297$var$BaseMatch = /*#__PURE__*/ function() {
    "use strict";
    function BaseMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, BaseMatch);
        this.pattern = pattern;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(BaseMatch, [
        {
            key: "search",
            value: function search() {}
        }
    ], [
        {
            key: "isMultiMatch",
            value: function isMultiMatch(pattern) {
                return $25957c27585b4297$var$getMatch(pattern, this.multiRegex);
            }
        },
        {
            key: "isSingleMatch",
            value: function isSingleMatch(pattern) {
                return $25957c27585b4297$var$getMatch(pattern, this.singleRegex);
            }
        }
    ]);
    return BaseMatch;
}();
function $25957c27585b4297$var$getMatch(pattern, exp) {
    var matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
var $25957c27585b4297$var$ExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(ExactMatch, BaseMatch);
    function ExactMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ExactMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, ExactMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = text === this.pattern;
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        this.pattern.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'exact';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^="(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^=(.*)$/;
            }
        }
    ]);
    return ExactMatch;
}($25957c27585b4297$var$BaseMatch);
// Token: !fire
var $25957c27585b4297$var$InverseExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(InverseExactMatch, BaseMatch);
    function InverseExactMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InverseExactMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, InverseExactMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InverseExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var index = text.indexOf(this.pattern);
                var isMatch = index === -1;
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'inverse-exact';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^!"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^!(.*)$/;
            }
        }
    ]);
    return InverseExactMatch;
}($25957c27585b4297$var$BaseMatch);
// Token: ^file
var $25957c27585b4297$var$PrefixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(PrefixExactMatch, BaseMatch);
    function PrefixExactMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, PrefixExactMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, PrefixExactMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(PrefixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = text.startsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        this.pattern.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'prefix-exact';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^\^"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^\^(.*)$/;
            }
        }
    ]);
    return PrefixExactMatch;
}($25957c27585b4297$var$BaseMatch);
// Token: !^fire
var $25957c27585b4297$var$InversePrefixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(InversePrefixExactMatch, BaseMatch);
    function InversePrefixExactMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InversePrefixExactMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, InversePrefixExactMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InversePrefixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = !text.startsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'inverse-prefix-exact';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^!\^"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^!\^(.*)$/;
            }
        }
    ]);
    return InversePrefixExactMatch;
}($25957c27585b4297$var$BaseMatch);
// Token: .file$
var $25957c27585b4297$var$SuffixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SuffixExactMatch, BaseMatch);
    function SuffixExactMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SuffixExactMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SuffixExactMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SuffixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = text.endsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        text.length - this.pattern.length,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'suffix-exact';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^"(.*)"\$$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^(.*)\$$/;
            }
        }
    ]);
    return SuffixExactMatch;
}($25957c27585b4297$var$BaseMatch);
// Token: !.file$
var $25957c27585b4297$var$InverseSuffixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(InverseSuffixExactMatch, BaseMatch);
    function InverseSuffixExactMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InverseSuffixExactMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, InverseSuffixExactMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InverseSuffixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = !text.endsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'inverse-suffix-exact';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^!"(.*)"\$$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^!(.*)\$$/;
            }
        }
    ]);
    return InverseSuffixExactMatch;
}($25957c27585b4297$var$BaseMatch);
var $25957c27585b4297$var$FuzzyMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(FuzzyMatch, BaseMatch);
    function FuzzyMatch(pattern) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $25957c27585b4297$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $25957c27585b4297$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $25957c27585b4297$var$Config.distance : _ref_distance, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $25957c27585b4297$var$Config.includeMatches : _ref_includeMatches, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $25957c27585b4297$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $25957c27585b4297$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $25957c27585b4297$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $25957c27585b4297$var$Config.ignoreLocation : _ref_ignoreLocation;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, FuzzyMatch);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, FuzzyMatch, [
            pattern
        ]);
        _this._bitapSearch = new $25957c27585b4297$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(FuzzyMatch, [
        {
            key: "search",
            value: function search(text) {
                return this._bitapSearch.searchIn(text);
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'fuzzy';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^(.*)$/;
            }
        }
    ]);
    return FuzzyMatch;
}($25957c27585b4297$var$BaseMatch);
// Token: 'file
var $25957c27585b4297$var$IncludeMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(IncludeMatch, BaseMatch);
    function IncludeMatch(pattern) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, IncludeMatch);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, IncludeMatch, [
            pattern
        ]);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(IncludeMatch, [
        {
            key: "search",
            value: function search(text) {
                var location = 0;
                var index;
                var indices = [];
                var patternLen = this.pattern.length;
                // Get all exact matches
                while((index = text.indexOf(this.pattern, location)) > -1){
                    location = index + patternLen;
                    indices.push([
                        index,
                        location - 1
                    ]);
                }
                var isMatch = !!indices.length;
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: indices
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return 'include';
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^'"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^'(.*)$/;
            }
        }
    ]);
    return IncludeMatch;
}($25957c27585b4297$var$BaseMatch);
// ❗Order is important. DO NOT CHANGE.
var $25957c27585b4297$var$searchers = [
    $25957c27585b4297$var$ExactMatch,
    $25957c27585b4297$var$IncludeMatch,
    $25957c27585b4297$var$PrefixExactMatch,
    $25957c27585b4297$var$InversePrefixExactMatch,
    $25957c27585b4297$var$InverseSuffixExactMatch,
    $25957c27585b4297$var$SuffixExactMatch,
    $25957c27585b4297$var$InverseExactMatch,
    $25957c27585b4297$var$FuzzyMatch
];
var $25957c27585b4297$var$searchersLen = $25957c27585b4297$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
var $25957c27585b4297$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
var $25957c27585b4297$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $25957c27585b4297$var$parseQuery(pattern) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return pattern.split($25957c27585b4297$var$OR_TOKEN).map(function(item) {
        var query = item.trim().split($25957c27585b4297$var$SPACE_RE).filter(function(item) {
            return item && !!item.trim();
        });
        var results = [];
        for(var i = 0, len = query.length; i < len; i += 1){
            var queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            var found = false;
            var idx = -1;
            while(!found && ++idx < $25957c27585b4297$var$searchersLen){
                var searcher = $25957c27585b4297$var$searchers[idx];
                var token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $25957c27585b4297$var$searchersLen){
                var searcher1 = $25957c27585b4297$var$searchers[idx];
                var token1 = searcher1.isSingleMatch(queryItem);
                if (token1) {
                    results.push(new searcher1(token1, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
var $25957c27585b4297$var$MultiMatchSet = new Set([
    $25957c27585b4297$var$FuzzyMatch.type,
    $25957c27585b4297$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ var $25957c27585b4297$var$ExtendedSearch = /*#__PURE__*/ function() {
    "use strict";
    function ExtendedSearch(pattern) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $25957c27585b4297$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $25957c27585b4297$var$Config.includeMatches : _ref_includeMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $25957c27585b4297$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $25957c27585b4297$var$Config.ignoreLocation : _ref_ignoreLocation, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $25957c27585b4297$var$Config.findAllMatches : _ref_findAllMatches, _ref_location = _ref.location, location = _ref_location === void 0 ? $25957c27585b4297$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $25957c27585b4297$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $25957c27585b4297$var$Config.distance : _ref_distance;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ExtendedSearch);
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $25957c27585b4297$var$parseQuery(this.pattern, this.options);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ExtendedSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                var query = this.query;
                if (!query) return {
                    isMatch: false,
                    score: 1
                };
                var _this_options = this.options, includeMatches = _this_options.includeMatches, isCaseSensitive = _this_options.isCaseSensitive;
                text = isCaseSensitive ? text : text.toLowerCase();
                var numMatches = 0;
                var allIndices = [];
                var totalScore = 0;
                // ORs
                for(var i = 0, qLen = query.length; i < qLen; i += 1){
                    var searchers = query[i];
                    // Reset indices
                    allIndices.length = 0;
                    numMatches = 0;
                    // ANDs
                    for(var j = 0, pLen = searchers.length; j < pLen; j += 1){
                        var searcher = searchers[j];
                        var _searcher_search = searcher.search(text), isMatch = _searcher_search.isMatch, indices = _searcher_search.indices, score = _searcher_search.score;
                        if (isMatch) {
                            numMatches += 1;
                            totalScore += score;
                            if (includeMatches) {
                                var type = searcher.constructor.type;
                                if ($25957c27585b4297$var$MultiMatchSet.has(type)) allIndices = (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(allIndices).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(indices));
                                else allIndices.push(indices);
                            }
                        } else {
                            totalScore = 0;
                            numMatches = 0;
                            allIndices.length = 0;
                            break;
                        }
                    }
                    // OR condition, so if TRUE, return
                    if (numMatches) {
                        var result = {
                            isMatch: true,
                            score: totalScore / numMatches
                        };
                        if (includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                // Nothing was matched
                return {
                    isMatch: false,
                    score: 1
                };
            }
        }
    ], [
        {
            key: "condition",
            value: function condition(_, options) {
                return options.useExtendedSearch;
            }
        }
    ]);
    return ExtendedSearch;
}();
var $25957c27585b4297$var$registeredSearchers = [];
function $25957c27585b4297$var$register() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _registeredSearchers;
    (_registeredSearchers = $25957c27585b4297$var$registeredSearchers).push.apply(_registeredSearchers, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
}
function $25957c27585b4297$var$createSearcher(pattern, options) {
    for(var i = 0, len = $25957c27585b4297$var$registeredSearchers.length; i < len; i += 1){
        var searcherClass = $25957c27585b4297$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $25957c27585b4297$var$BitapSearch(pattern, options);
}
var $25957c27585b4297$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
var $25957c27585b4297$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
var $25957c27585b4297$var$isExpression = function(query) {
    return !!(query[$25957c27585b4297$var$LogicalOperator.AND] || query[$25957c27585b4297$var$LogicalOperator.OR]);
};
var $25957c27585b4297$var$isPath = function(query) {
    return !!query[$25957c27585b4297$var$KeyType.PATH];
};
var $25957c27585b4297$var$isLeaf = function(query) {
    return !$25957c27585b4297$var$isArray(query) && $25957c27585b4297$var$isObject(query) && !$25957c27585b4297$var$isExpression(query);
};
var $25957c27585b4297$var$convertToExplicit = function(query) {
    return (0, $a6437d79afda84c4$export$71511d61b312f219)({}, $25957c27585b4297$var$LogicalOperator.AND, Object.keys(query).map(function(key) {
        return (0, $a6437d79afda84c4$export$71511d61b312f219)({}, key, query[key]);
    }));
};
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $25957c27585b4297$var$parse(query, options) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_auto = _ref.auto, auto = _ref_auto === void 0 ? true : _ref_auto;
    var next = function(query) {
        var keys = Object.keys(query);
        var isQueryPath = $25957c27585b4297$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$25957c27585b4297$var$isExpression(query)) return next($25957c27585b4297$var$convertToExplicit(query));
        if ($25957c27585b4297$var$isLeaf(query)) {
            var key = isQueryPath ? query[$25957c27585b4297$var$KeyType.PATH] : keys[0];
            var pattern = isQueryPath ? query[$25957c27585b4297$var$KeyType.PATTERN] : query[key];
            if (!$25957c27585b4297$var$isString(pattern)) throw new Error($25957c27585b4297$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            var obj = {
                keyId: $25957c27585b4297$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $25957c27585b4297$var$createSearcher(pattern, options);
            return obj;
        }
        var node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach(function(key) {
            var value = query[key];
            if ($25957c27585b4297$var$isArray(value)) value.forEach(function(item) {
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$25957c27585b4297$var$isExpression(query)) query = $25957c27585b4297$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $25957c27585b4297$var$computeScore(results, param) {
    var _param_ignoreFieldNorm = param.ignoreFieldNorm, ignoreFieldNorm = _param_ignoreFieldNorm === void 0 ? $25957c27585b4297$var$Config.ignoreFieldNorm : _param_ignoreFieldNorm;
    results.forEach(function(result) {
        var totalScore = 1;
        result.matches.forEach(function(param) {
            var key = param.key, norm = param.norm, score = param.score;
            var weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $25957c27585b4297$var$transformMatches(result, data) {
    var matches = result.matches;
    data.matches = [];
    if (!$25957c27585b4297$var$isDefined(matches)) return;
    matches.forEach(function(match) {
        if (!$25957c27585b4297$var$isDefined(match.indices) || !match.indices.length) return;
        var indices = match.indices, value = match.value;
        var obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $25957c27585b4297$var$transformScore(result, data) {
    data.score = result.score;
}
function $25957c27585b4297$var$format(results, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $25957c27585b4297$var$Config.includeMatches : _ref_includeMatches, _ref_includeScore = _ref.includeScore, includeScore = _ref_includeScore === void 0 ? $25957c27585b4297$var$Config.includeScore : _ref_includeScore;
    var transformers = [];
    if (includeMatches) transformers.push($25957c27585b4297$var$transformMatches);
    if (includeScore) transformers.push($25957c27585b4297$var$transformScore);
    return results.map(function(result) {
        var idx = result.idx;
        var data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach(function(transformer) {
            transformer(result, data);
        });
        return data;
    });
}
var $25957c27585b4297$var$Fuse = /*#__PURE__*/ function() {
    "use strict";
    function Fuse(docs) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, index = arguments.length > 2 ? arguments[2] : void 0;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Fuse);
        this.options = $25957c27585b4297$var$_objectSpread2($25957c27585b4297$var$_objectSpread2({}, $25957c27585b4297$var$Config), options);
        this.options.useExtendedSearch;
        this._keyStore = new $25957c27585b4297$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Fuse, [
        {
            key: "setCollection",
            value: function setCollection(docs, index) {
                this._docs = docs;
                if (index && !(index instanceof $25957c27585b4297$var$FuseIndex)) throw new Error($25957c27585b4297$var$INCORRECT_INDEX_TYPE);
                this._myIndex = index || $25957c27585b4297$var$createIndex(this.options.keys, this._docs, {
                    getFn: this.options.getFn,
                    fieldNormWeight: this.options.fieldNormWeight
                });
            }
        },
        {
            key: "add",
            value: function add(doc) {
                if (!$25957c27585b4297$var$isDefined(doc)) return;
                this._docs.push(doc);
                this._myIndex.add(doc);
            }
        },
        {
            key: "remove",
            value: function remove() {
                var predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
                    return false;
                };
                var results = [];
                for(var i = 0, len = this._docs.length; i < len; i += 1){
                    var doc = this._docs[i];
                    if (predicate(doc, i)) {
                        this.removeAt(i);
                        i -= 1;
                        len -= 1;
                        results.push(doc);
                    }
                }
                return results;
            }
        },
        {
            key: "removeAt",
            value: function removeAt(idx) {
                this._docs.splice(idx, 1);
                this._myIndex.removeAt(idx);
            }
        },
        {
            key: "getIndex",
            value: function getIndex() {
                return this._myIndex;
            }
        },
        {
            key: "search",
            value: function search(query) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_limit = _ref.limit, limit = _ref_limit === void 0 ? -1 : _ref_limit;
                var _this_options = this.options, includeMatches = _this_options.includeMatches, includeScore = _this_options.includeScore, shouldSort = _this_options.shouldSort, sortFn = _this_options.sortFn, ignoreFieldNorm = _this_options.ignoreFieldNorm;
                var results = $25957c27585b4297$var$isString(query) ? $25957c27585b4297$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                $25957c27585b4297$var$computeScore(results, {
                    ignoreFieldNorm: ignoreFieldNorm
                });
                if (shouldSort) results.sort(sortFn);
                if ($25957c27585b4297$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
                return $25957c27585b4297$var$format(results, this._docs, {
                    includeMatches: includeMatches,
                    includeScore: includeScore
                });
            }
        },
        {
            key: "_searchStringList",
            value: function _searchStringList(query) {
                var searcher = $25957c27585b4297$var$createSearcher(query, this.options);
                var records = this._myIndex.records;
                var results = [];
                // Iterate over every string in the index
                records.forEach(function(param) {
                    var text = param.v, idx = param.i, norm = param.n;
                    if (!$25957c27585b4297$var$isDefined(text)) return;
                    var _searcher_searchIn = searcher.searchIn(text), isMatch = _searcher_searchIn.isMatch, score = _searcher_searchIn.score, indices = _searcher_searchIn.indices;
                    if (isMatch) results.push({
                        item: text,
                        idx: idx,
                        matches: [
                            {
                                score: score,
                                value: text,
                                norm: norm,
                                indices: indices
                            }
                        ]
                    });
                });
                return results;
            }
        },
        {
            key: "_searchLogical",
            value: function _searchLogical(query) {
                var _this = this;
                var expression = $25957c27585b4297$var$parse(query, this.options);
                var evaluate = function(node, item, idx) {
                    if (!node.children) {
                        var keyId = node.keyId, searcher = node.searcher;
                        var matches = _this._findMatches({
                            key: _this._keyStore.get(keyId),
                            value: _this._myIndex.getValueForItemAtKeyId(item, keyId),
                            searcher: searcher
                        });
                        if (matches && matches.length) return [
                            {
                                idx: idx,
                                item: item,
                                matches: matches
                            }
                        ];
                        return [];
                    }
                    var res = [];
                    for(var i = 0, len = node.children.length; i < len; i += 1){
                        var _res;
                        var child = node.children[i];
                        var result = evaluate(child, item, idx);
                        if (result.length) (_res = res).push.apply(_res, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(result));
                        else if (node.operator === $25957c27585b4297$var$LogicalOperator.AND) return [];
                    }
                    return res;
                };
                var records = this._myIndex.records;
                var resultMap = {};
                var results = [];
                records.forEach(function(param) {
                    var item = param.$, idx = param.i;
                    if ($25957c27585b4297$var$isDefined(item)) {
                        var expResults = evaluate(expression, item, idx);
                        if (expResults.length) {
                            // Dedupe when adding
                            if (!resultMap[idx]) {
                                resultMap[idx] = {
                                    idx: idx,
                                    item: item,
                                    matches: []
                                };
                                results.push(resultMap[idx]);
                            }
                            expResults.forEach(function(param) {
                                var matches = param.matches;
                                var _resultMap_idx_matches;
                                (_resultMap_idx_matches = resultMap[idx].matches).push.apply(_resultMap_idx_matches, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(matches));
                            });
                        }
                    }
                });
                return results;
            }
        },
        {
            key: "_searchObjectList",
            value: function _searchObjectList(query) {
                var _this = this;
                var searcher = $25957c27585b4297$var$createSearcher(query, this.options);
                var _this__myIndex = this._myIndex, keys = _this__myIndex.keys, records = _this__myIndex.records;
                var results = [];
                // List is Array<Object>
                records.forEach(function(param) {
                    var item = param.$, idx = param.i;
                    if (!$25957c27585b4297$var$isDefined(item)) return;
                    var matches = [];
                    // Iterate over every key (i.e, path), and fetch the value at that key
                    keys.forEach(function(key, keyIndex) {
                        var _matches;
                        (_matches = matches).push.apply(_matches, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this._findMatches({
                            key: key,
                            value: item[keyIndex],
                            searcher: searcher
                        })));
                    });
                    if (matches.length) results.push({
                        idx: idx,
                        item: item,
                        matches: matches
                    });
                });
                return results;
            }
        },
        {
            key: "_findMatches",
            value: function _findMatches(param) {
                var key = param.key, value = param.value, searcher = param.searcher;
                if (!$25957c27585b4297$var$isDefined(value)) return [];
                var matches = [];
                if ($25957c27585b4297$var$isArray(value)) value.forEach(function(param) {
                    var text = param.v, idx = param.i, norm = param.n;
                    if (!$25957c27585b4297$var$isDefined(text)) return;
                    var _searcher_searchIn = searcher.searchIn(text), isMatch = _searcher_searchIn.isMatch, score = _searcher_searchIn.score, indices = _searcher_searchIn.indices;
                    if (isMatch) matches.push({
                        score: score,
                        key: key,
                        value: text,
                        idx: idx,
                        norm: norm,
                        indices: indices
                    });
                });
                else {
                    var text = value.v, norm = value.n;
                    var _searcher_searchIn = searcher.searchIn(text), isMatch = _searcher_searchIn.isMatch, score = _searcher_searchIn.score, indices = _searcher_searchIn.indices;
                    if (isMatch) matches.push({
                        score: score,
                        key: key,
                        value: text,
                        norm: norm,
                        indices: indices
                    });
                }
                return matches;
            }
        }
    ]);
    return Fuse;
}();
$25957c27585b4297$var$Fuse.version = '7.0.0';
$25957c27585b4297$var$Fuse.createIndex = $25957c27585b4297$var$createIndex;
$25957c27585b4297$var$Fuse.parseIndex = $25957c27585b4297$var$parseIndex;
$25957c27585b4297$var$Fuse.config = $25957c27585b4297$var$Config;
$25957c27585b4297$var$Fuse.parseQuery = $25957c27585b4297$var$parse;
$25957c27585b4297$var$register($25957c27585b4297$var$ExtendedSearch);
var $25957c27585b4297$var$SearchByFuse = /** @class */ function() {
    function SearchByFuse(config) {
        this._haystack = [];
        this._fuseOptions = $25957c27585b4297$var$__assign($25957c27585b4297$var$__assign({}, config.fuseOptions), {
            keys: $25957c27585b4297$var$__spreadArray([], config.searchFields, true),
            includeMatches: true
        });
    }
    SearchByFuse.prototype.index = function(data) {
        this._haystack = data;
        if (this._fuse) this._fuse.setCollection(data);
    };
    SearchByFuse.prototype.reset = function() {
        this._haystack = [];
        this._fuse = undefined;
    };
    SearchByFuse.prototype.isEmptyIndex = function() {
        return !this._haystack.length;
    };
    SearchByFuse.prototype.search = function(needle) {
        if (!this._fuse) this._fuse = new $25957c27585b4297$var$Fuse(this._haystack, this._fuseOptions);
        var results = this._fuse.search(needle);
        return results.map(function(value, i) {
            return {
                item: value.item,
                score: value.score || 0,
                rank: i + 1
            };
        });
    };
    return SearchByFuse;
}();
function $25957c27585b4297$var$getSearcher(config) {
    return new $25957c27585b4297$var$SearchByFuse(config);
}
/**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option.
 * `Choices.defaults.templates` allows access to the default template methods from `callbackOnCreateTemplates`
 */ var $25957c27585b4297$var$isEmptyObject = function isEmptyObject(obj) {
    // eslint-disable-next-line no-restricted-syntax
    for(var prop in obj){
        if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
    }
    return true;
};
var $25957c27585b4297$var$assignCustomProperties = function assignCustomProperties(el, choice, withCustomProperties) {
    var dataset = el.dataset;
    var customProperties = choice.customProperties, labelClass = choice.labelClass, labelDescription = choice.labelDescription;
    if (labelClass) dataset.labelClass = $25957c27585b4297$var$getClassNames(labelClass).join(' ');
    if (labelDescription) dataset.labelDescription = labelDescription;
    if (withCustomProperties && customProperties) {
        if (typeof customProperties === 'string') dataset.customProperties = customProperties;
        else if ((typeof customProperties === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(customProperties)) === 'object' && !$25957c27585b4297$var$isEmptyObject(customProperties)) dataset.customProperties = JSON.stringify(customProperties);
    }
};
var $25957c27585b4297$var$addAriaLabel = function addAriaLabel(docRoot, id, element) {
    var label = id && docRoot.querySelector("label[for='".concat(id, "']"));
    var text = label && label.innerText;
    if (text) element.setAttribute('aria-label', text);
};
var $25957c27585b4297$var$templates = {
    containerOuter: function containerOuter(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
        var containerOuter = _a.classNames.containerOuter;
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, containerOuter);
        div.dataset.type = passedElementType;
        if (dir) div.dir = dir;
        if (isSelectOneElement) div.tabIndex = 0;
        if (isSelectElement) {
            div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
            if (searchEnabled) div.setAttribute('aria-autocomplete', 'list');
            else if (!labelId) $25957c27585b4297$var$addAriaLabel(this._docRoot, this.passedElement.element.id, div);
            div.setAttribute('aria-haspopup', 'true');
            div.setAttribute('aria-expanded', 'false');
        }
        if (labelId) div.setAttribute('aria-labelledby', labelId);
        return div;
    },
    containerInner: function containerInner(_a) {
        var containerInner = _a.classNames.containerInner;
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, containerInner);
        return div;
    },
    itemList: function itemList(_a, isSelectOneElement) {
        var searchEnabled = _a.searchEnabled, _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, list);
        $25957c27585b4297$var$addClassesToElement(div, isSelectOneElement ? listSingle : listItems);
        if (this._isSelectElement && searchEnabled) div.setAttribute('role', 'listbox');
        return div;
    },
    placeholder: function placeholder(_a, value) {
        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, placeholder);
        $25957c27585b4297$var$setElementHtml(div, allowHTML, value);
        return div;
    },
    item: function item(_a, choice, removeItemButton) {
        var allowHTML = _a.allowHTML, removeItemButtonAlignLeft = _a.removeItemButtonAlignLeft, removeItemIconText = _a.removeItemIconText, removeItemLabelText = _a.removeItemLabelText, _b = _a.classNames, item = _b.item, button = _b.button, highlightedState = _b.highlightedState, itemSelectable = _b.itemSelectable, placeholder = _b.placeholder;
        var rawValue = $25957c27585b4297$var$unwrapStringForRaw(choice.value);
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, item);
        if (choice.labelClass) {
            var spanLabel = document.createElement('span');
            $25957c27585b4297$var$setElementHtml(spanLabel, allowHTML, choice.label);
            $25957c27585b4297$var$addClassesToElement(spanLabel, choice.labelClass);
            div.appendChild(spanLabel);
        } else $25957c27585b4297$var$setElementHtml(div, allowHTML, choice.label);
        div.dataset.item = '';
        div.dataset.id = choice.id;
        div.dataset.value = rawValue;
        $25957c27585b4297$var$assignCustomProperties(div, choice, true);
        if (choice.disabled || this.containerOuter.isDisabled) div.setAttribute('aria-disabled', 'true');
        if (this._isSelectElement) {
            div.setAttribute('aria-selected', 'true');
            div.setAttribute('role', 'option');
        }
        if (choice.placeholder) {
            $25957c27585b4297$var$addClassesToElement(div, placeholder);
            div.dataset.placeholder = '';
        }
        $25957c27585b4297$var$addClassesToElement(div, choice.highlighted ? highlightedState : itemSelectable);
        if (removeItemButton) {
            if (choice.disabled) $25957c27585b4297$var$removeClassesFromElement(div, itemSelectable);
            div.dataset.deletable = '';
            var removeButton = document.createElement('button');
            removeButton.type = 'button';
            $25957c27585b4297$var$addClassesToElement(removeButton, button);
            $25957c27585b4297$var$setElementHtml(removeButton, true, $25957c27585b4297$var$resolveNoticeFunction(removeItemIconText, choice.value));
            var REMOVE_ITEM_LABEL = $25957c27585b4297$var$resolveNoticeFunction(removeItemLabelText, choice.value);
            if (REMOVE_ITEM_LABEL) removeButton.setAttribute('aria-label', REMOVE_ITEM_LABEL);
            removeButton.dataset.button = '';
            if (removeItemButtonAlignLeft) div.insertAdjacentElement('afterbegin', removeButton);
            else div.appendChild(removeButton);
        }
        return div;
    },
    choiceList: function choiceList(_a, isSelectOneElement) {
        var list = _a.classNames.list;
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, list);
        if (!isSelectOneElement) div.setAttribute('aria-multiselectable', 'true');
        div.setAttribute('role', 'listbox');
        return div;
    },
    choiceGroup: function choiceGroup(_a, _b) {
        var allowHTML = _a.allowHTML, _c = _a.classNames, group = _c.group, groupHeading = _c.groupHeading, itemDisabled = _c.itemDisabled;
        var id = _b.id, label = _b.label, disabled = _b.disabled;
        var rawLabel = $25957c27585b4297$var$unwrapStringForRaw(label);
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, group);
        if (disabled) $25957c27585b4297$var$addClassesToElement(div, itemDisabled);
        div.setAttribute('role', 'group');
        div.dataset.group = '';
        div.dataset.id = id;
        div.dataset.value = rawLabel;
        if (disabled) div.setAttribute('aria-disabled', 'true');
        var heading = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(heading, groupHeading);
        $25957c27585b4297$var$setElementHtml(heading, allowHTML, label || '');
        div.appendChild(heading);
        return div;
    },
    choice: function choice(_a, _choice, selectText, groupName) {
        var allowHTML = _a.allowHTML, _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, itemSelectable = _b.itemSelectable, selectedState = _b.selectedState, itemDisabled = _b.itemDisabled, description = _b.description, placeholder = _b.placeholder;
        // eslint-disable-next-line prefer-destructuring
        var label = _choice.label;
        var rawValue = $25957c27585b4297$var$unwrapStringForRaw(_choice.value);
        var div = document.createElement('div');
        div.id = _choice.elementId;
        $25957c27585b4297$var$addClassesToElement(div, item);
        $25957c27585b4297$var$addClassesToElement(div, itemChoice);
        if (groupName && typeof label === 'string') {
            label = $25957c27585b4297$var$escapeForTemplate(allowHTML, label);
            label += " (".concat(groupName, ")");
            label = {
                trusted: label
            };
        }
        var describedBy = div;
        if (_choice.labelClass) {
            var spanLabel = document.createElement('span');
            $25957c27585b4297$var$setElementHtml(spanLabel, allowHTML, label);
            $25957c27585b4297$var$addClassesToElement(spanLabel, _choice.labelClass);
            describedBy = spanLabel;
            div.appendChild(spanLabel);
        } else $25957c27585b4297$var$setElementHtml(div, allowHTML, label);
        if (_choice.labelDescription) {
            var descId = "".concat(_choice.elementId, "-description");
            describedBy.setAttribute('aria-describedby', descId);
            var spanDesc = document.createElement('span');
            $25957c27585b4297$var$setElementHtml(spanDesc, allowHTML, _choice.labelDescription);
            spanDesc.id = descId;
            $25957c27585b4297$var$addClassesToElement(spanDesc, description);
            div.appendChild(spanDesc);
        }
        if (_choice.selected) $25957c27585b4297$var$addClassesToElement(div, selectedState);
        if (_choice.placeholder) $25957c27585b4297$var$addClassesToElement(div, placeholder);
        div.setAttribute('role', _choice.group ? 'treeitem' : 'option');
        div.dataset.choice = '';
        div.dataset.id = _choice.id;
        div.dataset.value = rawValue;
        if (selectText) div.dataset.selectText = selectText;
        if (_choice.group) div.dataset.groupId = "".concat(_choice.group.id);
        $25957c27585b4297$var$assignCustomProperties(div, _choice, false);
        if (_choice.disabled) {
            $25957c27585b4297$var$addClassesToElement(div, itemDisabled);
            div.dataset.choiceDisabled = '';
            div.setAttribute('aria-disabled', 'true');
        } else {
            $25957c27585b4297$var$addClassesToElement(div, itemSelectable);
            div.dataset.choiceSelectable = '';
        }
        return div;
    },
    input: function input(_a, placeholderValue) {
        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned, labelId = _a.labelId;
        var inp = document.createElement('input');
        inp.type = 'search';
        $25957c27585b4297$var$addClassesToElement(inp, input);
        $25957c27585b4297$var$addClassesToElement(inp, inputCloned);
        inp.autocomplete = 'off';
        inp.autocapitalize = 'off';
        inp.spellcheck = false;
        inp.setAttribute('aria-autocomplete', 'list');
        if (placeholderValue) inp.setAttribute('aria-label', placeholderValue);
        else if (!labelId) $25957c27585b4297$var$addAriaLabel(this._docRoot, this.passedElement.element.id, inp);
        return inp;
    },
    dropdown: function dropdown(_a) {
        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
        var div = document.createElement('div');
        $25957c27585b4297$var$addClassesToElement(div, list);
        $25957c27585b4297$var$addClassesToElement(div, listDropdown);
        div.setAttribute('aria-expanded', 'false');
        return div;
    },
    notice: function notice(_a, innerHTML, type) {
        var _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, addChoice = _b.addChoice, noResults = _b.noResults, noChoices = _b.noChoices, noticeItem = _b.notice;
        if (type === void 0) type = $25957c27585b4297$var$NoticeTypes.generic;
        var notice = document.createElement('div');
        $25957c27585b4297$var$setElementHtml(notice, true, innerHTML);
        $25957c27585b4297$var$addClassesToElement(notice, item);
        $25957c27585b4297$var$addClassesToElement(notice, itemChoice);
        $25957c27585b4297$var$addClassesToElement(notice, noticeItem);
        // eslint-disable-next-line default-case
        switch(type){
            case $25957c27585b4297$var$NoticeTypes.addChoice:
                $25957c27585b4297$var$addClassesToElement(notice, addChoice);
                break;
            case $25957c27585b4297$var$NoticeTypes.noResults:
                $25957c27585b4297$var$addClassesToElement(notice, noResults);
                break;
            case $25957c27585b4297$var$NoticeTypes.noChoices:
                $25957c27585b4297$var$addClassesToElement(notice, noChoices);
                break;
        }
        if (type === $25957c27585b4297$var$NoticeTypes.addChoice) {
            notice.dataset.choiceSelectable = '';
            notice.dataset.choice = '';
        }
        return notice;
    },
    option: function option(choice) {
        // HtmlOptionElement's label value does not support HTML, so the avoid double escaping unwrap the untrusted string.
        var labelValue = $25957c27585b4297$var$unwrapStringForRaw(choice.label);
        var opt = new Option(labelValue, choice.value, false, choice.selected);
        $25957c27585b4297$var$assignCustomProperties(opt, choice, true);
        opt.disabled = choice.disabled;
        if (choice.selected) opt.setAttribute('selected', '');
        return opt;
    }
};
/** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var $25957c27585b4297$var$IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
var $25957c27585b4297$var$USER_DEFAULTS = {};
var $25957c27585b4297$var$parseDataSetId = function parseDataSetId(element) {
    if (!element) return undefined;
    return element.dataset.id ? parseInt(element.dataset.id, 10) : undefined;
};
var $25957c27585b4297$var$selectableChoiceIdentifier = '[data-choice-selectable]';
/**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var $25957c27585b4297$export$2e2bcd8739ae039 = /** @class */ function() {
    function Choices(element, userConfig) {
        if (element === void 0) element = '[data-choice]';
        if (userConfig === void 0) userConfig = {};
        var _this = this;
        this.initialisedOK = undefined;
        this._hasNonChoicePlaceholder = false;
        this._lastAddedChoiceId = 0;
        this._lastAddedGroupId = 0;
        var defaults = Choices.defaults;
        this.config = $25957c27585b4297$var$__assign($25957c27585b4297$var$__assign($25957c27585b4297$var$__assign({}, defaults.allOptions), defaults.options), userConfig);
        $25957c27585b4297$var$ObjectsInConfig.forEach(function(key) {
            _this.config[key] = $25957c27585b4297$var$__assign($25957c27585b4297$var$__assign($25957c27585b4297$var$__assign({}, defaults.allOptions[key]), defaults.options[key]), userConfig[key]);
        });
        var config = this.config;
        if (!config.silent) this._validateConfig();
        var docRoot = config.shadowRoot || document.documentElement;
        this._docRoot = docRoot;
        var passedElement = typeof element === 'string' ? docRoot.querySelector(element) : element;
        if (!passedElement || (typeof passedElement === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(passedElement)) !== 'object' || !($25957c27585b4297$var$isHtmlInputElement(passedElement) || $25957c27585b4297$var$isHtmlSelectElement(passedElement))) {
            if (!passedElement && typeof element === 'string') throw TypeError("Selector ".concat(element, " failed to find an element"));
            throw TypeError("Expected one of the following types text|select-one|select-multiple");
        }
        var elementType = passedElement.type;
        var isText = elementType === $25957c27585b4297$var$PassedElementTypes.Text;
        if (isText || config.maxItemCount !== 1) config.singleModeForMultiSelect = false;
        if (config.singleModeForMultiSelect) elementType = $25957c27585b4297$var$PassedElementTypes.SelectMultiple;
        var isSelectOne = elementType === $25957c27585b4297$var$PassedElementTypes.SelectOne;
        var isSelectMultiple = elementType === $25957c27585b4297$var$PassedElementTypes.SelectMultiple;
        var isSelect = isSelectOne || isSelectMultiple;
        this._elementType = elementType;
        this._isTextElement = isText;
        this._isSelectOneElement = isSelectOne;
        this._isSelectMultipleElement = isSelectMultiple;
        this._isSelectElement = isSelectOne || isSelectMultiple;
        this._canAddUserChoices = isText && config.addItems || isSelect && config.addChoices;
        if (typeof config.renderSelectedChoices !== 'boolean') config.renderSelectedChoices = config.renderSelectedChoices === 'always' || isSelectOne;
        if (config.closeDropdownOnSelect === 'auto') config.closeDropdownOnSelect = isText || isSelectOne || config.singleModeForMultiSelect;
        else config.closeDropdownOnSelect = $25957c27585b4297$var$coerceBool(config.closeDropdownOnSelect);
        if (config.placeholder) {
            if (config.placeholderValue) this._hasNonChoicePlaceholder = true;
            else if (passedElement.dataset.placeholder) {
                this._hasNonChoicePlaceholder = true;
                config.placeholderValue = passedElement.dataset.placeholder;
            }
        }
        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
            config.addItemFilter = re.test.bind(re);
        }
        if (this._isTextElement) this.passedElement = new $25957c27585b4297$var$WrappedInput({
            element: passedElement,
            classNames: config.classNames
        });
        else {
            var selectEl = passedElement;
            this.passedElement = new $25957c27585b4297$var$WrappedSelect({
                element: selectEl,
                classNames: config.classNames,
                template: function template(data) {
                    return _this._templates.option(data);
                },
                extractPlaceholder: config.placeholder && !this._hasNonChoicePlaceholder
            });
        }
        this.initialised = false;
        this._store = new $25957c27585b4297$var$Store(config);
        this._currentValue = '';
        config.searchEnabled = !isText && config.searchEnabled || isSelectMultiple;
        this._canSearch = config.searchEnabled;
        this._isScrollingOnIe = false;
        this._highlightPosition = 0;
        this._wasTap = true;
        this._placeholderValue = this._generatePlaceholderValue();
        this._baseId = $25957c27585b4297$var$generateId(passedElement, 'choices-');
        /**
         * setting direction in cases where it's explicitly set on passedElement
         * or when calculated direction is different from the document
         */ this._direction = passedElement.dir;
        if (!this._direction) {
            var elementDirection = window.getComputedStyle(passedElement).direction;
            var documentDirection = window.getComputedStyle(document.documentElement).direction;
            if (elementDirection !== documentDirection) this._direction = elementDirection;
        }
        this._idNames = {
            itemChoice: 'item-choice'
        };
        this._templates = defaults.templates;
        this._render = this._render.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onTouchMove = this._onTouchMove.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);
        this._onMouseDown = this._onMouseDown.bind(this);
        this._onMouseOver = this._onMouseOver.bind(this);
        this._onFormReset = this._onFormReset.bind(this);
        this._onSelectKey = this._onSelectKey.bind(this);
        this._onEnterKey = this._onEnterKey.bind(this);
        this._onEscapeKey = this._onEscapeKey.bind(this);
        this._onDirectionKey = this._onDirectionKey.bind(this);
        this._onDeleteKey = this._onDeleteKey.bind(this);
        // If element has already been initialised with Choices, fail silently
        if (this.passedElement.isActive) {
            if (!config.silent) console.warn('Trying to initialise Choices on element already initialised', {
                element: element
            });
            this.initialised = true;
            this.initialisedOK = false;
            return;
        }
        // Let's go
        this.init();
        // preserve the selected item list after setup for form reset
        this._initialItems = this._store.items.map(function(choice) {
            return choice.value;
        });
    }
    Object.defineProperty(Choices, "defaults", {
        get: function get() {
            return Object.preventExtensions({
                get options () {
                    return $25957c27585b4297$var$USER_DEFAULTS;
                },
                get allOptions () {
                    return $25957c27585b4297$var$DEFAULT_CONFIG;
                },
                get templates () {
                    return $25957c27585b4297$var$templates;
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Choices.prototype.init = function() {
        if (this.initialised || this.initialisedOK !== undefined) return;
        this._searcher = $25957c27585b4297$var$getSearcher(this.config);
        this._loadChoices();
        this._createTemplates();
        this._createElements();
        this._createStructure();
        if (this._isTextElement && !this.config.addItems || this.passedElement.element.hasAttribute('disabled') || !!this.passedElement.element.closest('fieldset:disabled')) this.disable();
        else {
            this.enable();
            this._addEventListeners();
        }
        // should be triggered **after** disabled state to avoid additional re-draws
        this._initStore();
        this.initialised = true;
        this.initialisedOK = true;
        var callbackOnInit = this.config.callbackOnInit;
        // Run callback if it is a function
        if (typeof callbackOnInit === 'function') callbackOnInit.call(this);
    };
    Choices.prototype.destroy = function() {
        if (!this.initialised) return;
        this._removeEventListeners();
        this.passedElement.reveal();
        this.containerOuter.unwrap(this.passedElement.element);
        this._store._listeners = []; // prevents select/input value being wiped
        this.clearStore(false);
        this._stopSearch();
        this._templates = Choices.defaults.templates;
        this.initialised = false;
        this.initialisedOK = undefined;
    };
    Choices.prototype.enable = function() {
        if (this.passedElement.isDisabled) this.passedElement.enable();
        if (this.containerOuter.isDisabled) {
            this._addEventListeners();
            this.input.enable();
            this.containerOuter.enable();
        }
        return this;
    };
    Choices.prototype.disable = function() {
        if (!this.passedElement.isDisabled) this.passedElement.disable();
        if (!this.containerOuter.isDisabled) {
            this._removeEventListeners();
            this.input.disable();
            this.containerOuter.disable();
        }
        return this;
    };
    Choices.prototype.highlightItem = function(item, runEvent) {
        if (runEvent === void 0) runEvent = true;
        if (!item || !item.id) return this;
        var choice = this._store.items.find(function(c) {
            return c.id === item.id;
        });
        if (!choice || choice.highlighted) return this;
        this._store.dispatch($25957c27585b4297$var$highlightItem(choice, true));
        if (runEvent) this.passedElement.triggerEvent($25957c27585b4297$var$EventType.highlightItem, this._getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.unhighlightItem = function(item, runEvent) {
        if (runEvent === void 0) runEvent = true;
        if (!item || !item.id) return this;
        var choice = this._store.items.find(function(c) {
            return c.id === item.id;
        });
        if (!choice || !choice.highlighted) return this;
        this._store.dispatch($25957c27585b4297$var$highlightItem(choice, false));
        if (runEvent) this.passedElement.triggerEvent($25957c27585b4297$var$EventType.unhighlightItem, this._getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.highlightAll = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.forEach(function(item) {
                if (!item.highlighted) {
                    _this._store.dispatch($25957c27585b4297$var$highlightItem(item, true));
                    _this.passedElement.triggerEvent($25957c27585b4297$var$EventType.highlightItem, _this._getChoiceForOutput(item));
                }
            });
        });
        return this;
    };
    Choices.prototype.unhighlightAll = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.forEach(function(item) {
                if (item.highlighted) {
                    _this._store.dispatch($25957c27585b4297$var$highlightItem(item, false));
                    _this.passedElement.triggerEvent($25957c27585b4297$var$EventType.highlightItem, _this._getChoiceForOutput(item));
                }
            });
        });
        return this;
    };
    Choices.prototype.removeActiveItemsByValue = function(value) {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.filter(function(item) {
                return item.value === value;
            }).forEach(function(item) {
                return _this._removeItem(item);
            });
        });
        return this;
    };
    Choices.prototype.removeActiveItems = function(excludedId) {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.filter(function(_a) {
                var id = _a.id;
                return id !== excludedId;
            }).forEach(function(item) {
                return _this._removeItem(item);
            });
        });
        return this;
    };
    Choices.prototype.removeHighlightedItems = function(runEvent) {
        var _this = this;
        if (runEvent === void 0) runEvent = false;
        this._store.withTxn(function() {
            _this._store.highlightedActiveItems.forEach(function(item) {
                _this._removeItem(item);
                // If this action was performed by the user
                // trigger the event
                if (runEvent) _this._triggerChange(item.value);
            });
        });
        return this;
    };
    Choices.prototype.showDropdown = function(preventInputFocus) {
        var _this = this;
        if (this.dropdown.isActive) return this;
        if (preventInputFocus === undefined) // eslint-disable-next-line no-param-reassign
        preventInputFocus = !this._canSearch;
        requestAnimationFrame(function() {
            _this.dropdown.show();
            var rect = _this.dropdown.element.getBoundingClientRect();
            _this.containerOuter.open(rect.bottom, rect.height);
            if (!preventInputFocus) _this.input.focus();
            _this.passedElement.triggerEvent($25957c27585b4297$var$EventType.showDropdown);
        });
        return this;
    };
    Choices.prototype.hideDropdown = function(preventInputBlur) {
        var _this = this;
        if (!this.dropdown.isActive) return this;
        requestAnimationFrame(function() {
            _this.dropdown.hide();
            _this.containerOuter.close();
            if (!preventInputBlur && _this._canSearch) {
                _this.input.removeActiveDescendant();
                _this.input.blur();
            }
            _this.passedElement.triggerEvent($25957c27585b4297$var$EventType.hideDropdown);
        });
        return this;
    };
    Choices.prototype.getValue = function(valueOnly) {
        var _this = this;
        var values = this._store.items.map(function(item) {
            return valueOnly ? item.value : _this._getChoiceForOutput(item);
        });
        return this._isSelectOneElement || this.config.singleModeForMultiSelect ? values[0] : values;
    };
    Choices.prototype.setValue = function(items) {
        var _this = this;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed('setValue');
            return this;
        }
        this._store.withTxn(function() {
            items.forEach(function(value) {
                if (value) _this._addChoice($25957c27585b4297$var$mapInputToChoice(value, false));
            });
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.setChoiceByValue = function(value) {
        var _this = this;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed('setChoiceByValue');
            return this;
        }
        if (this._isTextElement) return this;
        this._store.withTxn(function() {
            // If only one value has been passed, convert to array
            var choiceValue = Array.isArray(value) ? value : [
                value
            ];
            // Loop through each value and
            choiceValue.forEach(function(val) {
                return _this._findAndSelectChoiceByValue(val);
            });
            _this.unhighlightAll();
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    /**
     * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
     * a value field name and a label field name.
     * This behaves the same as passing items via the choices option but can be called after initialising Choices.
     * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
     * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
     *
     * **Input types affected:** select-one, select-multiple
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices([
     *   {value: 'One', label: 'Label One', disabled: true},
     *   {value: 'Two', label: 'Label Two', selected: true},
     *   {value: 'Three', label: 'Label Three'},
     * ], 'value', 'label', false);
     * ```
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices(async () => {
     *   try {
     *      const items = await fetch('/items');
     *      return items.json()
     *   } catch(err) {
     *      console.error(err)
     *   }
     * });
     * ```
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices([{
     *   label: 'Group one',
     *   id: 1,
     *   disabled: false,
     *   choices: [
     *     {value: 'Child One', label: 'Child One', selected: true},
     *     {value: 'Child Two', label: 'Child Two',  disabled: true},
     *     {value: 'Child Three', label: 'Child Three'},
     *   ]
     * },
     * {
     *   label: 'Group two',
     *   id: 2,
     *   disabled: false,
     *   choices: [
     *     {value: 'Child Four', label: 'Child Four', disabled: true},
     *     {value: 'Child Five', label: 'Child Five'},
     *     {value: 'Child Six', label: 'Child Six', customProperties: {
     *       description: 'Custom description about child six',
     *       random: 'Another random custom property'
     *     }},
     *   ]
     * }], 'value', 'label', false);
     * ```
     */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices, clearSearchFlag, replaceItems) {
        var _this = this;
        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
        if (value === void 0) value = 'value';
        if (label === void 0) label = 'label';
        if (replaceChoices === void 0) replaceChoices = false;
        if (clearSearchFlag === void 0) clearSearchFlag = true;
        if (replaceItems === void 0) replaceItems = false;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed('setChoices');
            return this;
        }
        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
        if (typeof value !== 'string' || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
        if (typeof choicesArrayOrFetcher === 'function') {
            // it's a choices fetcher function
            var fetcher_1 = choicesArrayOrFetcher(this);
            if (typeof Promise === 'function' && fetcher_1 instanceof Promise) // that's a promise
            // eslint-disable-next-line no-promise-executor-return
            return new Promise(function(resolve) {
                return requestAnimationFrame(resolve);
            }).then(function() {
                return _this._handleLoadingState(true);
            }).then(function() {
                return fetcher_1;
            }).then(function(data) {
                return _this.setChoices(data, value, label, replaceChoices, clearSearchFlag, replaceItems);
            })["catch"](function(err) {
                if (!_this.config.silent) console.error(err);
            }).then(function() {
                return _this._handleLoadingState(false);
            }).then(function() {
                return _this;
            });
            // function returned something else than promise, let's check if it's an array of choices
            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1 === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(fetcher_1)));
            // recursion with results, it's sync and choices were cleared already
            return this.setChoices(fetcher_1, value, label, false);
        }
        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
        this.containerOuter.removeLoadingState();
        this._store.withTxn(function() {
            if (clearSearchFlag) _this._isSearching = false;
            // Clear choices if needed
            if (replaceChoices) _this.clearChoices(true, replaceItems);
            var isDefaultValue = value === 'value';
            var isDefaultLabel = label === 'label';
            choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                if ('choices' in groupOrChoice) {
                    var group = groupOrChoice;
                    if (!isDefaultLabel) group = $25957c27585b4297$var$__assign($25957c27585b4297$var$__assign({}, group), {
                        label: group[label]
                    });
                    _this._addGroup($25957c27585b4297$var$mapInputToChoice(group, true));
                } else {
                    var choice = groupOrChoice;
                    if (!isDefaultLabel || !isDefaultValue) choice = $25957c27585b4297$var$__assign($25957c27585b4297$var$__assign({}, choice), {
                        value: choice[value],
                        label: choice[label]
                    });
                    var choiceFull = $25957c27585b4297$var$mapInputToChoice(choice, false);
                    _this._addChoice(choiceFull);
                    if (choiceFull.placeholder && !_this._hasNonChoicePlaceholder) _this._placeholderValue = $25957c27585b4297$var$unwrapStringForEscaped(choiceFull.label);
                }
            });
            _this.unhighlightAll();
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.refresh = function(withEvents, selectFirstOption, deselectAll) {
        var _this = this;
        if (withEvents === void 0) withEvents = false;
        if (selectFirstOption === void 0) selectFirstOption = false;
        if (deselectAll === void 0) deselectAll = false;
        if (!this._isSelectElement) {
            if (!this.config.silent) console.warn('refresh method can only be used on choices backed by a <select> element');
            return this;
        }
        this._store.withTxn(function() {
            var choicesFromOptions = _this.passedElement.optionsAsChoices();
            // Build the list of items which require preserving
            var existingItems = {};
            if (!deselectAll) _this._store.items.forEach(function(choice) {
                if (choice.id && choice.active && choice.selected) existingItems[choice.value] = true;
            });
            _this.clearStore(false);
            var updateChoice = function updateChoice(choice) {
                if (deselectAll) _this._store.dispatch($25957c27585b4297$var$removeItem$1(choice));
                else if (existingItems[choice.value]) choice.selected = true;
            };
            choicesFromOptions.forEach(function(groupOrChoice) {
                if ('choices' in groupOrChoice) {
                    groupOrChoice.choices.forEach(updateChoice);
                    return;
                }
                updateChoice(groupOrChoice);
            });
            /* @todo only generate add events for the added options instead of all
            if (withEvents) {
              items.forEach((choice) => {
                if (existingItems[choice.value]) {
                  this.passedElement.triggerEvent(
                    EventType.removeItem,
                    this._getChoiceForEvent(choice),
                  );
                }
              });
            }
            */ // load new choices & items
            _this._addPredefinedChoices(choicesFromOptions, selectFirstOption, withEvents);
            // re-do search if required
            if (_this._isSearching) _this._searchChoices(_this.input.value);
        });
        return this;
    };
    Choices.prototype.removeChoice = function(value) {
        var choice = this._store.choices.find(function(c) {
            return c.value === value;
        });
        if (!choice) return this;
        this._clearNotice();
        this._store.dispatch($25957c27585b4297$var$removeChoice(choice));
        // @todo integrate with Store
        this._searcher.reset();
        if (choice.selected) this.passedElement.triggerEvent($25957c27585b4297$var$EventType.removeItem, this._getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.clearChoices = function(clearOptions, clearItems) {
        var _this = this;
        if (clearOptions === void 0) clearOptions = true;
        if (clearItems === void 0) clearItems = false;
        if (clearOptions) {
            if (clearItems) this.passedElement.element.replaceChildren('');
            else this.passedElement.element.querySelectorAll(':not([selected])').forEach(function(el) {
                el.remove();
            });
        }
        this.itemList.element.replaceChildren('');
        this.choiceList.element.replaceChildren('');
        this._clearNotice();
        this._store.withTxn(function() {
            var _$items = clearItems ? [] : _this._store.items;
            _this._store.reset();
            _$items.forEach(function(item) {
                _this._store.dispatch($25957c27585b4297$var$addChoice(item));
                _this._store.dispatch($25957c27585b4297$var$addItem(item));
            });
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.clearStore = function(clearOptions) {
        if (clearOptions === void 0) clearOptions = true;
        this.clearChoices(clearOptions, true);
        this._stopSearch();
        this._lastAddedChoiceId = 0;
        this._lastAddedGroupId = 0;
        return this;
    };
    Choices.prototype.clearInput = function() {
        var shouldSetInputWidth = !this._isSelectOneElement;
        this.input.clear(shouldSetInputWidth);
        this._stopSearch();
        return this;
    };
    Choices.prototype._validateConfig = function() {
        var config = this.config;
        var invalidConfigOptions = $25957c27585b4297$var$diff(config, $25957c27585b4297$var$DEFAULT_CONFIG);
        if (invalidConfigOptions.length) console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
        if (config.allowHTML && config.allowHtmlUserInput) {
            if (config.addItems) console.warn('Warning: allowHTML/allowHtmlUserInput/addItems all being true is strongly not recommended and may lead to XSS attacks');
            if (config.addChoices) console.warn('Warning: allowHTML/allowHtmlUserInput/addChoices all being true is strongly not recommended and may lead to XSS attacks');
        }
    };
    Choices.prototype._render = function(changes) {
        if (changes === void 0) changes = {
            choices: true,
            groups: true,
            items: true
        };
        if (this._store.inTxn()) return;
        if (this._isSelectElement) {
            if (changes.choices || changes.groups) this._renderChoices();
        }
        if (changes.items) this._renderItems();
    };
    Choices.prototype._renderChoices = function() {
        var _this = this;
        if (!this._canAddItems()) return; // block rendering choices if the input limit is reached.
        var _a = this, config = _a.config, isSearching = _a._isSearching;
        var _b = this._store, activeGroups = _b.activeGroups, activeChoices = _b.activeChoices;
        var renderLimit = 0;
        if (isSearching && config.searchResultLimit > 0) renderLimit = config.searchResultLimit;
        else if (config.renderChoiceLimit > 0) renderLimit = config.renderChoiceLimit;
        if (this._isSelectElement) {
            var backingOptions = activeChoices.filter(function(choice) {
                return !choice.element;
            });
            if (backingOptions.length) this.passedElement.addOptions(backingOptions);
        }
        var fragment = document.createDocumentFragment();
        var renderableChoices = function renderableChoices(choices) {
            return choices.filter(function(choice) {
                return !choice.placeholder && (isSearching ? !!choice.rank : config.renderSelectedChoices || !choice.selected);
            });
        };
        var selectableChoices = false;
        var renderChoices = function renderChoices(choices, withinGroup, groupLabel) {
            if (isSearching) // sortByRank is used to ensure stable sorting, as scores are non-unique
            // this additionally ensures fuseOptions.sortFn is not ignored
            choices.sort($25957c27585b4297$var$sortByRank);
            else if (config.shouldSort) choices.sort(config.sorter);
            var choiceLimit = choices.length;
            choiceLimit = !withinGroup && renderLimit && choiceLimit > renderLimit ? renderLimit : choiceLimit;
            choiceLimit--;
            choices.every(function(choice, index) {
                // choiceEl being empty signals the contents has probably significantly changed
                var dropdownItem = choice.choiceEl || _this._templates.choice(config, choice, config.itemSelectText, groupLabel);
                choice.choiceEl = dropdownItem;
                fragment.appendChild(dropdownItem);
                if (isSearching || !choice.selected) selectableChoices = true;
                return index < choiceLimit;
            });
        };
        if (activeChoices.length) {
            if (config.resetScrollPosition) requestAnimationFrame(function() {
                return _this.choiceList.scrollToTop();
            });
            if (!this._hasNonChoicePlaceholder && !isSearching && this._isSelectOneElement) // If we have a placeholder choice along with groups
            renderChoices(activeChoices.filter(function(choice) {
                return choice.placeholder && !choice.group;
            }), false, undefined);
            // If we have grouped options
            if (activeGroups.length && !isSearching) {
                if (config.shouldSort) activeGroups.sort(config.sorter);
                // render Choices without group first, regardless of sort, otherwise they won't be distinguishable
                // from the last group
                renderChoices(activeChoices.filter(function(choice) {
                    return !choice.placeholder && !choice.group;
                }), false, undefined);
                activeGroups.forEach(function(group) {
                    var groupChoices = renderableChoices(group.choices);
                    if (groupChoices.length) {
                        if (group.label) {
                            var dropdownGroup = group.groupEl || _this._templates.choiceGroup(_this.config, group);
                            group.groupEl = dropdownGroup;
                            dropdownGroup.remove();
                            fragment.appendChild(dropdownGroup);
                        }
                        renderChoices(groupChoices, true, config.appendGroupInSearch && isSearching ? group.label : undefined);
                    }
                });
            } else renderChoices(renderableChoices(activeChoices), false, undefined);
        }
        if (!selectableChoices && (isSearching || !fragment.children.length || !config.renderSelectedChoices)) {
            if (!this._notice) this._notice = {
                text: $25957c27585b4297$var$resolveStringFunction(isSearching ? config.noResultsText : config.noChoicesText),
                type: isSearching ? $25957c27585b4297$var$NoticeTypes.noResults : $25957c27585b4297$var$NoticeTypes.noChoices
            };
            fragment.replaceChildren('');
        }
        this._renderNotice(fragment);
        this.choiceList.element.replaceChildren(fragment);
        if (selectableChoices) this._highlightChoice();
    };
    Choices.prototype._renderItems = function() {
        var _this = this;
        var _$items = this._store.items || [];
        var itemList = this.itemList.element;
        var config = this.config;
        var fragment = document.createDocumentFragment();
        var itemFromList = function itemFromList(item) {
            return itemList.querySelector("[data-item][data-id=\"".concat(item.id, "\"]"));
        };
        var addItemToFragment = function addItemToFragment(item) {
            var el = item.itemEl;
            if (el && el.parentElement) return;
            el = itemFromList(item) || _this._templates.item(config, item, config.removeItemButton);
            item.itemEl = el;
            fragment.appendChild(el);
        };
        // new items
        _$items.forEach(addItemToFragment);
        var addedItems = !!fragment.childNodes.length;
        if (this._isSelectOneElement) {
            var existingItems = itemList.children.length;
            if (addedItems || existingItems > 1) {
                var placeholder = itemList.querySelector($25957c27585b4297$var$getClassNamesSelector(config.classNames.placeholder));
                if (placeholder) placeholder.remove();
            } else if (!addedItems && !existingItems && this._placeholderValue) {
                addedItems = true;
                addItemToFragment($25957c27585b4297$var$mapInputToChoice({
                    selected: true,
                    value: '',
                    label: this._placeholderValue,
                    placeholder: true
                }, false));
            }
        }
        if (addedItems) {
            itemList.append(fragment);
            if (config.shouldSortItems && !this._isSelectOneElement) {
                _$items.sort(config.sorter);
                // push sorting into the DOM
                _$items.forEach(function(item) {
                    var el = itemFromList(item);
                    if (el) {
                        el.remove();
                        fragment.append(el);
                    }
                });
                itemList.append(fragment);
            }
        }
        if (this._isTextElement) // Update the value of the hidden input
        this.passedElement.value = _$items.map(function(_a) {
            var value = _a.value;
            return value;
        }).join(config.delimiter);
    };
    Choices.prototype._displayNotice = function(text, type, openDropdown) {
        if (openDropdown === void 0) openDropdown = true;
        var oldNotice = this._notice;
        if (oldNotice && (oldNotice.type === type && oldNotice.text === text || oldNotice.type === $25957c27585b4297$var$NoticeTypes.addChoice && (type === $25957c27585b4297$var$NoticeTypes.noResults || type === $25957c27585b4297$var$NoticeTypes.noChoices))) {
            if (openDropdown) this.showDropdown(true);
            return;
        }
        this._clearNotice();
        this._notice = text ? {
            text: text,
            type: type
        } : undefined;
        this._renderNotice();
        if (openDropdown && text) this.showDropdown(true);
    };
    Choices.prototype._clearNotice = function() {
        if (!this._notice) return;
        var noticeElement = this.choiceList.element.querySelector($25957c27585b4297$var$getClassNamesSelector(this.config.classNames.notice));
        if (noticeElement) noticeElement.remove();
        this._notice = undefined;
    };
    Choices.prototype._renderNotice = function(fragment) {
        var noticeConf = this._notice;
        if (noticeConf) {
            var notice = this._templates.notice(this.config, noticeConf.text, noticeConf.type);
            if (fragment) fragment.append(notice);
            else this.choiceList.prepend(notice);
        }
    };
    // eslint-disable-next-line class-methods-use-this
    Choices.prototype._getChoiceForOutput = function(choice, keyCode) {
        return {
            id: choice.id,
            highlighted: choice.highlighted,
            labelClass: choice.labelClass,
            labelDescription: choice.labelDescription,
            customProperties: choice.customProperties,
            disabled: choice.disabled,
            active: choice.active,
            label: choice.label,
            placeholder: choice.placeholder,
            value: choice.value,
            groupValue: choice.group ? choice.group.label : undefined,
            element: choice.element,
            keyCode: keyCode
        };
    };
    Choices.prototype._triggerChange = function(value) {
        if (value === undefined || value === null) return;
        this.passedElement.triggerEvent($25957c27585b4297$var$EventType.change, {
            value: value
        });
    };
    Choices.prototype._handleButtonAction = function(element) {
        var _this = this;
        var _$items = this._store.items;
        if (!_$items.length || !this.config.removeItems || !this.config.removeItemButton) return;
        var id = element && $25957c27585b4297$var$parseDataSetId(element.parentElement);
        var itemToRemove = id && _$items.find(function(item) {
            return item.id === id;
        });
        if (!itemToRemove) return;
        this._store.withTxn(function() {
            // Remove item associated with button
            _this._removeItem(itemToRemove);
            _this._triggerChange(itemToRemove.value);
            if (_this._isSelectOneElement && !_this._hasNonChoicePlaceholder) {
                var placeholderChoice = (_this.config.shouldSort ? _this._store.choices.reverse() : _this._store.choices).find(function(choice) {
                    return choice.placeholder;
                });
                if (placeholderChoice) {
                    _this._addItem(placeholderChoice);
                    _this.unhighlightAll();
                    if (placeholderChoice.value) _this._triggerChange(placeholderChoice.value);
                }
            }
        });
    };
    Choices.prototype._handleItemAction = function(element, hasShiftKey) {
        var _this = this;
        if (hasShiftKey === void 0) hasShiftKey = false;
        var _$items = this._store.items;
        if (!_$items.length || !this.config.removeItems || this._isSelectOneElement) return;
        var id = $25957c27585b4297$var$parseDataSetId(element);
        if (!id) return;
        // We only want to select one item with a click
        // so we deselect any items that aren't the target
        // unless shift is being pressed
        _$items.forEach(function(item) {
            if (item.id === id && !item.highlighted) _this.highlightItem(item);
            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
        });
        // Focus input as without focus, a user cannot do anything with a
        // highlighted item
        this.input.focus();
    };
    Choices.prototype._handleChoiceAction = function(element) {
        var _this = this;
        // If we are clicking on an option
        var id = $25957c27585b4297$var$parseDataSetId(element);
        var choice = id && this._store.getChoiceById(id);
        if (!choice || choice.disabled) return false;
        var hasActiveDropdown = this.dropdown.isActive;
        if (!choice.selected) {
            if (!this._canAddItems()) return true; // causes _onEnterKey to early out
            this._store.withTxn(function() {
                _this._addItem(choice, true, true);
                _this.clearInput();
                _this.unhighlightAll();
            });
            this._triggerChange(choice.value);
        }
        // We want to close the dropdown if we are dealing with a single select box
        if (hasActiveDropdown && this.config.closeDropdownOnSelect) {
            this.hideDropdown(true);
            this.containerOuter.element.focus();
        }
        return true;
    };
    Choices.prototype._handleBackspace = function(items) {
        var config = this.config;
        if (!config.removeItems || !items.length) return;
        var lastItem = items[items.length - 1];
        var hasHighlightedItems = items.some(function(item) {
            return item.highlighted;
        });
        // If editing the last item is allowed and there are not other selected items,
        // we can edit the item value. Otherwise if we can remove items, remove all selected items
        if (config.editItems && !hasHighlightedItems && lastItem) {
            this.input.value = lastItem.value;
            this.input.setWidth();
            this._removeItem(lastItem);
            this._triggerChange(lastItem.value);
        } else {
            if (!hasHighlightedItems) // Highlight last item if none already highlighted
            this.highlightItem(lastItem, false);
            this.removeHighlightedItems(true);
        }
    };
    Choices.prototype._loadChoices = function() {
        var _a;
        var _this = this;
        var config = this.config;
        if (this._isTextElement) {
            // Assign preset items from passed object first
            this._presetChoices = config.items.map(function(e) {
                return $25957c27585b4297$var$mapInputToChoice(e, false);
            });
            // Add any values passed from attribute
            if (this.passedElement.value) {
                var elementItems = this.passedElement.value.split(config.delimiter).map(function(e) {
                    return $25957c27585b4297$var$mapInputToChoice(e, false, _this.config.allowHtmlUserInput);
                });
                this._presetChoices = this._presetChoices.concat(elementItems);
            }
            this._presetChoices.forEach(function(choice) {
                choice.selected = true;
            });
        } else if (this._isSelectElement) {
            // Assign preset choices from passed object
            this._presetChoices = config.choices.map(function(e) {
                return $25957c27585b4297$var$mapInputToChoice(e, true);
            });
            // Create array of choices from option elements
            var choicesFromOptions = this.passedElement.optionsAsChoices();
            if (choicesFromOptions) (_a = this._presetChoices).push.apply(_a, choicesFromOptions);
        }
    };
    Choices.prototype._handleLoadingState = function(setLoading) {
        if (setLoading === void 0) setLoading = true;
        var el = this.itemList.element;
        if (setLoading) {
            this.disable();
            this.containerOuter.addLoadingState();
            if (this._isSelectOneElement) el.replaceChildren(this._templates.placeholder(this.config, this.config.loadingText));
            else this.input.placeholder = this.config.loadingText;
        } else {
            this.enable();
            this.containerOuter.removeLoadingState();
            if (this._isSelectOneElement) {
                el.replaceChildren('');
                this._render();
            } else this.input.placeholder = this._placeholderValue || '';
        }
    };
    Choices.prototype._handleSearch = function(value) {
        if (!this.input.isFocussed) return;
        // Check that we have a value to search and the input was an alphanumeric character
        if (value !== null && typeof value !== 'undefined' && value.length >= this.config.searchFloor) {
            var resultCount = this.config.searchChoices ? this._searchChoices(value) : 0;
            if (resultCount !== null) // Trigger search event
            this.passedElement.triggerEvent($25957c27585b4297$var$EventType.search, {
                value: value,
                resultCount: resultCount
            });
        } else if (this._store.choices.some(function(option) {
            return !option.active;
        })) this._stopSearch();
    };
    Choices.prototype._canAddItems = function() {
        var config = this.config;
        var maxItemCount = config.maxItemCount, maxItemText = config.maxItemText;
        if (!config.singleModeForMultiSelect && maxItemCount > 0 && maxItemCount <= this._store.items.length) {
            this.choiceList.element.replaceChildren('');
            this._notice = undefined;
            this._displayNotice(typeof maxItemText === 'function' ? maxItemText(maxItemCount) : maxItemText, $25957c27585b4297$var$NoticeTypes.addChoice);
            return false;
        }
        if (this._notice && this._notice.type === $25957c27585b4297$var$NoticeTypes.addChoice) this._clearNotice();
        return true;
    };
    Choices.prototype._canCreateItem = function(value) {
        var config = this.config;
        var canAddItem = true;
        var notice = '';
        if (canAddItem && typeof config.addItemFilter === 'function' && !config.addItemFilter(value)) {
            canAddItem = false;
            notice = $25957c27585b4297$var$resolveNoticeFunction(config.customAddItemText, value);
        }
        if (canAddItem) {
            var foundChoice = this._store.choices.find(function(choice) {
                return config.valueComparer(choice.value, value);
            });
            if (foundChoice) {
                if (this._isSelectElement) {
                    // for exact matches, do not prompt to add it as a custom choice
                    this._displayNotice('', $25957c27585b4297$var$NoticeTypes.addChoice);
                    return false;
                }
                if (!config.duplicateItemsAllowed) {
                    canAddItem = false;
                    notice = $25957c27585b4297$var$resolveNoticeFunction(config.uniqueItemText, value);
                }
            }
        }
        if (canAddItem) notice = $25957c27585b4297$var$resolveNoticeFunction(config.addItemText, value);
        if (notice) this._displayNotice(notice, $25957c27585b4297$var$NoticeTypes.addChoice);
        return canAddItem;
    };
    Choices.prototype._searchChoices = function(value) {
        var newValue = value.trim().replace(/\s{2,}/, ' ');
        // signal input didn't change search
        if (!newValue.length || newValue === this._currentValue) return null;
        var searcher = this._searcher;
        if (searcher.isEmptyIndex()) searcher.index(this._store.searchableChoices);
        // If new value matches the desired length and is not the same as the current value with a space
        var results = searcher.search(newValue);
        this._currentValue = newValue;
        this._highlightPosition = 0;
        this._isSearching = true;
        var notice = this._notice;
        var noticeType = notice && notice.type;
        if (noticeType !== $25957c27585b4297$var$NoticeTypes.addChoice) {
            if (!results.length) this._displayNotice($25957c27585b4297$var$resolveStringFunction(this.config.noResultsText), $25957c27585b4297$var$NoticeTypes.noResults);
            else this._clearNotice();
        }
        this._store.dispatch($25957c27585b4297$var$filterChoices(results));
        return results.length;
    };
    Choices.prototype._stopSearch = function() {
        if (this._isSearching) {
            this._currentValue = '';
            this._isSearching = false;
            this._clearNotice();
            this._store.dispatch($25957c27585b4297$var$activateChoices(true));
            this.passedElement.triggerEvent($25957c27585b4297$var$EventType.search, {
                value: '',
                resultCount: 0
            });
        }
    };
    Choices.prototype._addEventListeners = function() {
        var documentElement = this._docRoot;
        var outerElement = this.containerOuter.element;
        var inputElement = this.input.element;
        // capture events - can cancel event processing or propagation
        documentElement.addEventListener('touchend', this._onTouchEnd, true);
        outerElement.addEventListener('keydown', this._onKeyDown, true);
        outerElement.addEventListener('mousedown', this._onMouseDown, true);
        // passive events - doesn't call `preventDefault` or `stopPropagation`
        documentElement.addEventListener('click', this._onClick, {
            passive: true
        });
        documentElement.addEventListener('touchmove', this._onTouchMove, {
            passive: true
        });
        this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
            passive: true
        });
        if (this._isSelectOneElement) {
            outerElement.addEventListener('focus', this._onFocus, {
                passive: true
            });
            outerElement.addEventListener('blur', this._onBlur, {
                passive: true
            });
        }
        inputElement.addEventListener('keyup', this._onKeyUp, {
            passive: true
        });
        inputElement.addEventListener('input', this._onInput, {
            passive: true
        });
        inputElement.addEventListener('focus', this._onFocus, {
            passive: true
        });
        inputElement.addEventListener('blur', this._onBlur, {
            passive: true
        });
        if (inputElement.form) inputElement.form.addEventListener('reset', this._onFormReset, {
            passive: true
        });
        this.input.addEventListeners();
    };
    Choices.prototype._removeEventListeners = function() {
        var documentElement = this._docRoot;
        var outerElement = this.containerOuter.element;
        var inputElement = this.input.element;
        documentElement.removeEventListener('touchend', this._onTouchEnd, true);
        outerElement.removeEventListener('keydown', this._onKeyDown, true);
        outerElement.removeEventListener('mousedown', this._onMouseDown, true);
        documentElement.removeEventListener('click', this._onClick);
        documentElement.removeEventListener('touchmove', this._onTouchMove);
        this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
        if (this._isSelectOneElement) {
            outerElement.removeEventListener('focus', this._onFocus);
            outerElement.removeEventListener('blur', this._onBlur);
        }
        inputElement.removeEventListener('keyup', this._onKeyUp);
        inputElement.removeEventListener('input', this._onInput);
        inputElement.removeEventListener('focus', this._onFocus);
        inputElement.removeEventListener('blur', this._onBlur);
        if (inputElement.form) inputElement.form.removeEventListener('reset', this._onFormReset);
        this.input.removeEventListeners();
    };
    Choices.prototype._onKeyDown = function(event) {
        var keyCode = event.keyCode;
        var hasActiveDropdown = this.dropdown.isActive;
        /*
        See:
        https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        https://en.wikipedia.org/wiki/UTF-16#Code_points_from_U+010000_to_U+10FFFF - UTF-16 surrogate pairs
        https://stackoverflow.com/a/70866532 - "Unidentified" for mobile
        http://www.unicode.org/versions/Unicode5.2.0/ch16.pdf#G19635 - U+FFFF is reserved (Section 16.7)
    
        Logic: when a key event is sent, `event.key` represents its printable value _or_ one
        of a large list of special values indicating meta keys/functionality. In addition,
        key events for compose functionality contain a value of `Dead` when mid-composition.
    
        I can't quite verify it, but non-English IMEs may also be able to generate key codes
        for code points in the surrogate-pair range, which could potentially be seen as having
        key.length > 1. Since `Fn` is one of the special keys, we can't distinguish by that
        alone.
    
        Here, key.length === 1 means we know for sure the input was printable and not a special
        `key` value. When the length is greater than 1, it could be either a printable surrogate
        pair or a special `key` value. We can tell the difference by checking if the _character
        code_ value (not code point!) is in the "surrogate pair" range or not.
    
        We don't use .codePointAt because an invalid code point would return 65535, which wouldn't
        pass the >= 0x10000 check we would otherwise use.
    
        > ...The Unicode Standard sets aside 66 noncharacter code points. The last two code points
        > of each plane are noncharacters: U+FFFE and U+FFFF on the BMP...
        */ var wasPrintableChar = event.key.length === 1 || event.key.length === 2 && event.key.charCodeAt(0) >= 0xd800 || event.key === 'Unidentified';
        /*
          We do not show the dropdown if focusing out with esc or navigating through input fields.
          An activated search can still be opened with any other key.
         */ if (!this._isTextElement && !hasActiveDropdown && keyCode !== $25957c27585b4297$var$KeyCodeMap.ESC_KEY && keyCode !== $25957c27585b4297$var$KeyCodeMap.TAB_KEY && keyCode !== $25957c27585b4297$var$KeyCodeMap.SHIFT_KEY) {
            this.showDropdown();
            if (!this.input.isFocussed && wasPrintableChar) {
                /*
                  We update the input value with the pressed key as
                  the input was not focussed at the time of key press
                  therefore does not have the value of the key.
                */ this.input.value += event.key;
                // browsers interpret a space as pagedown
                if (event.key === ' ') event.preventDefault();
            }
        }
        switch(keyCode){
            case $25957c27585b4297$var$KeyCodeMap.A_KEY:
                return this._onSelectKey(event, this.itemList.element.hasChildNodes());
            case $25957c27585b4297$var$KeyCodeMap.ENTER_KEY:
                return this._onEnterKey(event, hasActiveDropdown);
            case $25957c27585b4297$var$KeyCodeMap.ESC_KEY:
                return this._onEscapeKey(event, hasActiveDropdown);
            case $25957c27585b4297$var$KeyCodeMap.UP_KEY:
            case $25957c27585b4297$var$KeyCodeMap.PAGE_UP_KEY:
            case $25957c27585b4297$var$KeyCodeMap.DOWN_KEY:
            case $25957c27585b4297$var$KeyCodeMap.PAGE_DOWN_KEY:
                return this._onDirectionKey(event, hasActiveDropdown);
            case $25957c27585b4297$var$KeyCodeMap.DELETE_KEY:
            case $25957c27585b4297$var$KeyCodeMap.BACK_KEY:
                return this._onDeleteKey(event, this._store.items, this.input.isFocussed);
        }
    };
    Choices.prototype._onKeyUp = function() {
        this._canSearch = this.config.searchEnabled;
    };
    Choices.prototype._onInput = function() {
        var value = this.input.value;
        if (!value) {
            if (this._isTextElement) this.hideDropdown(true);
            else this._stopSearch();
            return;
        }
        if (!this._canAddItems()) return;
        if (this._canSearch) // do the search even if the entered text can not be added
        this._handleSearch(value);
        if (!this._canAddUserChoices) return;
        // determine if a notice needs to be displayed for why a search result can't be added
        this._canCreateItem(value);
        if (this._isSelectElement) {
            this._highlightPosition = 0; // reset to select the notice and/or exact match
            this._highlightChoice();
        }
    };
    Choices.prototype._onSelectKey = function(event, hasItems) {
        // If CTRL + A or CMD + A have been pressed and there are items to select
        if ((event.ctrlKey || event.metaKey) && hasItems) {
            this._canSearch = false;
            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
            if (shouldHightlightAll) this.highlightAll();
        }
    };
    Choices.prototype._onEnterKey = function(event, hasActiveDropdown) {
        var _this = this;
        var value = this.input.value;
        var target = event.target;
        event.preventDefault();
        if (target && target.hasAttribute('data-button')) {
            this._handleButtonAction(target);
            return;
        }
        if (!hasActiveDropdown) {
            if (this._isSelectElement || this._notice) this.showDropdown();
            return;
        }
        var highlightedChoice = this.dropdown.element.querySelector($25957c27585b4297$var$getClassNamesSelector(this.config.classNames.highlightedState));
        if (highlightedChoice && this._handleChoiceAction(highlightedChoice)) return;
        if (!target || !value) {
            this.hideDropdown(true);
            return;
        }
        if (!this._canAddItems()) return;
        var addedItem = false;
        this._store.withTxn(function() {
            addedItem = _this._findAndSelectChoiceByValue(value, true);
            if (!addedItem) {
                if (!_this._canAddUserChoices) return;
                if (!_this._canCreateItem(value)) return;
                _this._addChoice($25957c27585b4297$var$mapInputToChoice(value, false, _this.config.allowHtmlUserInput), true, true);
                addedItem = true;
            }
            _this.clearInput();
            _this.unhighlightAll();
        });
        if (!addedItem) return;
        this._triggerChange(value);
        if (this.config.closeDropdownOnSelect) this.hideDropdown(true);
    };
    Choices.prototype._onEscapeKey = function(event, hasActiveDropdown) {
        if (hasActiveDropdown) {
            event.stopPropagation();
            this.hideDropdown(true);
            this._stopSearch();
            this.containerOuter.element.focus();
        }
    };
    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
        var keyCode = event.keyCode;
        // If up or down key is pressed, traverse through options
        if (hasActiveDropdown || this._isSelectOneElement) {
            this.showDropdown();
            this._canSearch = false;
            var directionInt = keyCode === $25957c27585b4297$var$KeyCodeMap.DOWN_KEY || keyCode === $25957c27585b4297$var$KeyCodeMap.PAGE_DOWN_KEY ? 1 : -1;
            var skipKey = event.metaKey || keyCode === $25957c27585b4297$var$KeyCodeMap.PAGE_DOWN_KEY || keyCode === $25957c27585b4297$var$KeyCodeMap.PAGE_UP_KEY;
            var nextEl = void 0;
            if (skipKey) {
                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat($25957c27585b4297$var$selectableChoiceIdentifier, ":last-of-type"));
                else nextEl = this.dropdown.element.querySelector($25957c27585b4297$var$selectableChoiceIdentifier);
            } else {
                var currentEl = this.dropdown.element.querySelector($25957c27585b4297$var$getClassNamesSelector(this.config.classNames.highlightedState));
                if (currentEl) nextEl = $25957c27585b4297$var$getAdjacentEl(currentEl, $25957c27585b4297$var$selectableChoiceIdentifier, directionInt);
                else nextEl = this.dropdown.element.querySelector($25957c27585b4297$var$selectableChoiceIdentifier);
            }
            if (nextEl) {
                // We prevent default to stop the cursor moving
                // when pressing the arrow
                if (!$25957c27585b4297$var$isScrolledIntoView(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                this._highlightChoice(nextEl);
            }
            // Prevent default to maintain cursor position whilst
            // traversing dropdown options
            event.preventDefault();
        }
    };
    Choices.prototype._onDeleteKey = function(event, items, hasFocusedInput) {
        // If backspace or delete key is pressed and the input has no value
        if (!this._isSelectOneElement && !event.target.value && hasFocusedInput) {
            this._handleBackspace(items);
            event.preventDefault();
        }
    };
    Choices.prototype._onTouchMove = function() {
        if (this._wasTap) this._wasTap = false;
    };
    Choices.prototype._onTouchEnd = function(event) {
        var target = (event || event.touches[0]).target;
        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
        if (touchWasWithinContainer) {
            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
            if (containerWasExactTarget) {
                if (this._isTextElement) this.input.focus();
                else if (this._isSelectMultipleElement) this.showDropdown();
            }
            // Prevents focus event firing
            event.stopPropagation();
        }
        this._wasTap = true;
    };
    /**
     * Handles mousedown event in capture mode for containetOuter.element
     */ Choices.prototype._onMouseDown = function(event) {
        var target = event.target;
        if (!(target instanceof HTMLElement)) return;
        // If we have our mouse down on the scrollbar and are on IE11...
        if ($25957c27585b4297$var$IS_IE11 && this.choiceList.element.contains(target)) {
            // check if click was on a scrollbar area
            var firstChoice = this.choiceList.element.firstElementChild;
            this._isScrollingOnIe = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
        }
        if (target === this.input.element) return;
        var item = target.closest('[data-button],[data-item],[data-choice]');
        if (item instanceof HTMLElement) {
            if ('button' in item.dataset) this._handleButtonAction(item);
            else if ('item' in item.dataset) this._handleItemAction(item, event.shiftKey);
            else if ('choice' in item.dataset) this._handleChoiceAction(item);
        }
        event.preventDefault();
    };
    /**
     * Handles mouseover event over this.dropdown
     * @param {MouseEvent} event
     */ Choices.prototype._onMouseOver = function(_a) {
        var target = _a.target;
        if (target instanceof HTMLElement && 'choice' in target.dataset) this._highlightChoice(target);
    };
    Choices.prototype._onClick = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var clickWasWithinContainer = containerOuter.element.contains(target);
        if (clickWasWithinContainer) {
            if (!this.dropdown.isActive && !containerOuter.isDisabled) {
                if (this._isTextElement) {
                    if (document.activeElement !== this.input.element) this.input.focus();
                } else {
                    this.showDropdown();
                    containerOuter.element.focus();
                }
            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
        } else {
            containerOuter.removeFocusState();
            this.hideDropdown(true);
            this.unhighlightAll();
        }
    };
    Choices.prototype._onFocus = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var focusWasWithinContainer = target && containerOuter.element.contains(target);
        if (!focusWasWithinContainer) return;
        var targetIsInput = target === this.input.element;
        if (this._isTextElement) {
            if (targetIsInput) containerOuter.addFocusState();
        } else if (this._isSelectMultipleElement) {
            if (targetIsInput) {
                this.showDropdown(true);
                // If element is a select box, the focused element is the container and the dropdown
                // isn't already open, focus and show dropdown
                containerOuter.addFocusState();
            }
        } else {
            containerOuter.addFocusState();
            if (targetIsInput) this.showDropdown(true);
        }
    };
    Choices.prototype._onBlur = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var blurWasWithinContainer = target && containerOuter.element.contains(target);
        if (blurWasWithinContainer && !this._isScrollingOnIe) {
            if (target === this.input.element) {
                containerOuter.removeFocusState();
                this.hideDropdown(true);
                if (this._isTextElement || this._isSelectMultipleElement) this.unhighlightAll();
            } else if (target === this.containerOuter.element) {
                // Remove the focus state when the past outerContainer was the target
                containerOuter.removeFocusState();
                // Also close the dropdown if search is disabled
                if (!this._canSearch) this.hideDropdown(true);
            }
        } else {
            // On IE11, clicking the scollbar blurs our input and thus
            // closes the dropdown. To stop this, we refocus our input
            // if we know we are on IE *and* are scrolling.
            this._isScrollingOnIe = false;
            this.input.element.focus();
        }
    };
    Choices.prototype._onFormReset = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this.clearInput();
            _this.hideDropdown();
            _this.refresh(false, false, true);
            if (_this._initialItems.length) _this.setChoiceByValue(_this._initialItems);
        });
    };
    Choices.prototype._highlightChoice = function(el) {
        if (el === void 0) el = null;
        var _$choices = Array.from(this.dropdown.element.querySelectorAll($25957c27585b4297$var$selectableChoiceIdentifier));
        if (!_$choices.length) return;
        var passedEl = el;
        var highlightedState = this.config.classNames.highlightedState;
        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll($25957c27585b4297$var$getClassNamesSelector(highlightedState)));
        // Remove any highlighted choices
        highlightedChoices.forEach(function(choice) {
            $25957c27585b4297$var$removeClassesFromElement(choice, highlightedState);
            choice.setAttribute('aria-selected', 'false');
        });
        if (passedEl) this._highlightPosition = _$choices.indexOf(passedEl);
        else {
            // Highlight choice based on last known highlight location
            if (_$choices.length > this._highlightPosition) // If we have an option to highlight
            passedEl = _$choices[this._highlightPosition];
            else // Otherwise highlight the option before
            passedEl = _$choices[_$choices.length - 1];
            if (!passedEl) passedEl = _$choices[0];
        }
        $25957c27585b4297$var$addClassesToElement(passedEl, highlightedState);
        passedEl.setAttribute('aria-selected', 'true');
        this.passedElement.triggerEvent($25957c27585b4297$var$EventType.highlightChoice, {
            el: passedEl
        });
        if (this.dropdown.isActive) {
            // IE11 ignores aria-label and blocks virtual keyboard
            // if aria-activedescendant is set without a dropdown
            this.input.setActiveDescendant(passedEl.id);
            this.containerOuter.setActiveDescendant(passedEl.id);
        }
    };
    Choices.prototype._addItem = function(item, withEvents, userTriggered) {
        if (withEvents === void 0) withEvents = true;
        if (userTriggered === void 0) userTriggered = false;
        if (!item.id) throw new TypeError('item.id must be set before _addItem is called for a choice/item');
        if (this.config.singleModeForMultiSelect || this._isSelectOneElement) this.removeActiveItems(item.id);
        this._store.dispatch($25957c27585b4297$var$addItem(item));
        if (withEvents) {
            this.passedElement.triggerEvent($25957c27585b4297$var$EventType.addItem, this._getChoiceForOutput(item));
            if (userTriggered) this.passedElement.triggerEvent($25957c27585b4297$var$EventType.choice, this._getChoiceForOutput(item));
        }
    };
    Choices.prototype._removeItem = function(item) {
        if (!item.id) return;
        this._store.dispatch($25957c27585b4297$var$removeItem$1(item));
        var notice = this._notice;
        if (notice && notice.type === $25957c27585b4297$var$NoticeTypes.noChoices) this._clearNotice();
        this.passedElement.triggerEvent($25957c27585b4297$var$EventType.removeItem, this._getChoiceForOutput(item));
    };
    Choices.prototype._addChoice = function(choice, withEvents, userTriggered) {
        if (withEvents === void 0) withEvents = true;
        if (userTriggered === void 0) userTriggered = false;
        if (choice.id) throw new TypeError('Can not re-add a choice which has already been added');
        var config = this.config;
        if (!config.duplicateItemsAllowed && this._store.choices.find(function(c) {
            return config.valueComparer(c.value, choice.value);
        })) return;
        // Generate unique id, in-place update is required so chaining _addItem works as expected
        this._lastAddedChoiceId++;
        choice.id = this._lastAddedChoiceId;
        choice.elementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choice.id);
        var prependValue = config.prependValue, appendValue = config.appendValue;
        if (prependValue) choice.value = prependValue + choice.value;
        if (appendValue) choice.value += appendValue.toString();
        if ((prependValue || appendValue) && choice.element) choice.element.value = choice.value;
        this._clearNotice();
        this._store.dispatch($25957c27585b4297$var$addChoice(choice));
        if (choice.selected) this._addItem(choice, withEvents, userTriggered);
    };
    Choices.prototype._addGroup = function(group, withEvents) {
        var _this = this;
        if (withEvents === void 0) withEvents = true;
        if (group.id) throw new TypeError('Can not re-add a group which has already been added');
        this._store.dispatch($25957c27585b4297$var$addGroup(group));
        if (!group.choices) return;
        // add unique id for the group(s), and do not store the full list of choices in this group
        this._lastAddedGroupId++;
        group.id = this._lastAddedGroupId;
        group.choices.forEach(function(item) {
            item.group = group;
            if (group.disabled) item.disabled = true;
            _this._addChoice(item, withEvents);
        });
    };
    Choices.prototype._createTemplates = function() {
        var _this = this;
        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
        var userTemplates = {};
        if (typeof callbackOnCreateTemplates === 'function') userTemplates = callbackOnCreateTemplates.call(this, $25957c27585b4297$var$strToEl, $25957c27585b4297$var$escapeForTemplate, $25957c27585b4297$var$getClassNames);
        var templating = {};
        Object.keys(this._templates).forEach(function(name) {
            if (name in userTemplates) templating[name] = userTemplates[name].bind(_this);
            else templating[name] = _this._templates[name].bind(_this);
        });
        this._templates = templating;
    };
    Choices.prototype._createElements = function() {
        var templating = this._templates;
        var _a = this, config = _a.config, isSelectOneElement = _a._isSelectOneElement;
        var position = config.position, classNames = config.classNames;
        var elementType = this._elementType;
        this.containerOuter = new $25957c27585b4297$var$Container({
            element: templating.containerOuter(config, this._direction, this._isSelectElement, isSelectOneElement, config.searchEnabled, elementType, config.labelId),
            classNames: classNames,
            type: elementType,
            position: position
        });
        this.containerInner = new $25957c27585b4297$var$Container({
            element: templating.containerInner(config),
            classNames: classNames,
            type: elementType,
            position: position
        });
        this.input = new $25957c27585b4297$var$Input({
            element: templating.input(config, this._placeholderValue),
            classNames: classNames,
            type: elementType,
            preventPaste: !config.paste
        });
        this.choiceList = new $25957c27585b4297$var$List({
            element: templating.choiceList(config, isSelectOneElement)
        });
        this.itemList = new $25957c27585b4297$var$List({
            element: templating.itemList(config, isSelectOneElement)
        });
        this.dropdown = new $25957c27585b4297$var$Dropdown({
            element: templating.dropdown(config),
            classNames: classNames,
            type: elementType
        });
    };
    Choices.prototype._createStructure = function() {
        var _a = this, containerInner = _a.containerInner, containerOuter = _a.containerOuter, passedElement = _a.passedElement;
        var dropdownElement = this.dropdown.element;
        // Hide original element
        passedElement.conceal();
        // Wrap input in container preserving DOM ordering
        containerInner.wrap(passedElement.element);
        // Wrapper inner container with outer container
        containerOuter.wrap(containerInner.element);
        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || '';
        else {
            if (this._placeholderValue) this.input.placeholder = this._placeholderValue;
            this.input.setWidth();
        }
        containerOuter.element.appendChild(containerInner.element);
        containerOuter.element.appendChild(dropdownElement);
        containerInner.element.appendChild(this.itemList.element);
        dropdownElement.appendChild(this.choiceList.element);
        if (!this._isSelectOneElement) containerInner.element.appendChild(this.input.element);
        else if (this.config.searchEnabled) dropdownElement.insertBefore(this.input.element, dropdownElement.firstChild);
        this._highlightPosition = 0;
        this._isSearching = false;
    };
    Choices.prototype._initStore = function() {
        var _this = this;
        this._store.subscribe(this._render).withTxn(function() {
            _this._addPredefinedChoices(_this._presetChoices, _this._isSelectOneElement && !_this._hasNonChoicePlaceholder, false);
        });
        if (!this._store.choices.length || this._isSelectOneElement && this._hasNonChoicePlaceholder) this._render();
    };
    Choices.prototype._addPredefinedChoices = function(choices, selectFirstOption, withEvents) {
        var _this = this;
        if (selectFirstOption === void 0) selectFirstOption = false;
        if (withEvents === void 0) withEvents = true;
        if (selectFirstOption) {
            /**
             * If there is a selected choice already or the choice is not the first in
             * the array, add each choice normally.
             *
             * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
             */ var noSelectedChoices = choices.findIndex(function(choice) {
                return choice.selected;
            }) === -1;
            if (noSelectedChoices) choices.some(function(choice) {
                if (choice.disabled || 'choices' in choice) return false;
                choice.selected = true;
                return true;
            });
        }
        choices.forEach(function(item) {
            if ('choices' in item) {
                if (_this._isSelectElement) _this._addGroup(item, withEvents);
            } else _this._addChoice(item, withEvents);
        });
    };
    Choices.prototype._findAndSelectChoiceByValue = function(value, userTriggered) {
        var _this = this;
        if (userTriggered === void 0) userTriggered = false;
        // Check 'value' property exists and the choice isn't already selected
        var foundChoice = this._store.choices.find(function(choice) {
            return _this.config.valueComparer(choice.value, value);
        });
        if (foundChoice && !foundChoice.disabled && !foundChoice.selected) {
            this._addItem(foundChoice, true, userTriggered);
            return true;
        }
        return false;
    };
    Choices.prototype._generatePlaceholderValue = function() {
        var config = this.config;
        if (!config.placeholder) return null;
        if (this._hasNonChoicePlaceholder) return config.placeholderValue;
        if (this._isSelectElement) {
            var placeholderOption = this.passedElement.placeholderOption;
            return placeholderOption ? placeholderOption.text : null;
        }
        return null;
    };
    Choices.prototype._warnChoicesInitFailed = function(caller) {
        if (this.config.silent) return;
        if (!this.initialised) throw new TypeError("".concat(caller, " called on a non-initialised instance of Choices"));
        else if (!this.initialisedOK) throw new TypeError("".concat(caller, " called for an element which has multiple instances of Choices initialised on it"));
    };
    Choices.version = '11.1.0';
    return Choices;
}();


function $4f2160f59d07c6b0$var$_defineProperty(e, r, t) {
    return (r = $4f2160f59d07c6b0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4f2160f59d07c6b0$var$_toPropertyKey(t) {
    var i = $4f2160f59d07c6b0$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $4f2160f59d07c6b0$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4f2160f59d07c6b0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $4f2160f59d07c6b0$var$_defineProperty(_this, "containerId", null);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                this.containerId = this.element.dataset.containerId;
                var items = JSON.parse(atob(this.element.dataset.items));
                this.choices = new (0, $25957c27585b4297$export$2e2bcd8739ae039)(this.inputTarget, {
                    items: items !== null && items !== void 0 ? items : [],
                    removeItemButton: true
                });
                this.inputTarget.addEventListener('addItem', function() {
                    _this.handleChange();
                });
                this.inputTarget.addEventListener('removeItem', function() {
                    _this.handleChange();
                });
            }
        },
        {
            key: "handleChange",
            value: function handleChange() {
                var tags = this.getTags();
                var url = new URL(window.location.href);
                var params = new URLSearchParams();
                if (tags.length > 0) tags.forEach(function(tag) {
                    params.append('tags[]', tag);
                });
                url.search = params.toString();
                this.load(url.toString());
            }
        },
        {
            key: "load",
            value: function load(url) {
                var containerId = "tag_".concat(this.containerId);
                fetch(url).then(function(r) {
                    return r.text();
                }).then(function(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var element = doc.getElementById(containerId);
                    document.getElementById(containerId).innerHTML = element.innerHTML;
                });
            }
        },
        {
            key: "getTags",
            value: function getTags() {
                return this.choices.getValue(true);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.choices) this.choices.destroy();
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$4f2160f59d07c6b0$var$_defineProperty($4f2160f59d07c6b0$export$2e2bcd8739ae039, "targets", [
    'input'
]);








function $a153307ea713bd69$var$_defineProperty(e, r, t) {
    return (r = $a153307ea713bd69$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a153307ea713bd69$var$_toPropertyKey(t) {
    var i = $a153307ea713bd69$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $a153307ea713bd69$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a153307ea713bd69$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.seconds = parseInt(this.element.dataset.seconds);
                this.cancelId = requestAnimationFrame(this.update.bind(this));
            }
        },
        {
            key: "update",
            value: function update() {
                var delta = this.seconds - Math.floor(Date.now() / 1000);
                var days = Math.floor(delta / 86400);
                delta -= days * 86400;
                var hours = Math.floor(delta / 3600) % 24;
                delta -= hours * 3600;
                var minutes = Math.floor(delta / 60) % 60;
                delta -= minutes * 60;
                var seconds = delta % 60;
                this.daysTarget.innerHTML = days;
                this.hoursTarget.innerHTML = hours;
                this.minutesTarget.innerHTML = minutes;
                this.secondsTarget.innerHTML = seconds;
                this.cancelId = requestAnimationFrame(this.update.bind(this));
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.cancelId) window.cancelAnimationFrame(this.cancelId);
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$a153307ea713bd69$var$_defineProperty($a153307ea713bd69$export$2e2bcd8739ae039, "targets", [
    'days',
    'hours',
    'minutes',
    'seconds'
]);















'use strict';
function $547100571c4e1abe$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
var $c6fd95db66a95a37$var$toString = Object.prototype.toString;
var $c6fd95db66a95a37$var$getPrototypeOf = Object.getPrototypeOf;
var $c6fd95db66a95a37$var$iterator = Symbol.iterator, $c6fd95db66a95a37$var$toStringTag = Symbol.toStringTag;
var $c6fd95db66a95a37$var$kindOf = function(cache) {
    return function(thing) {
        var str = $c6fd95db66a95a37$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $c6fd95db66a95a37$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $c6fd95db66a95a37$var$kindOf(thing) === type;
    };
};
var $c6fd95db66a95a37$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $c6fd95db66a95a37$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $c6fd95db66a95a37$var$isUndefined = $c6fd95db66a95a37$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c6fd95db66a95a37$var$isBuffer(val) {
    return val !== null && !$c6fd95db66a95a37$var$isUndefined(val) && val.constructor !== null && !$c6fd95db66a95a37$var$isUndefined(val.constructor) && $c6fd95db66a95a37$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $c6fd95db66a95a37$var$isArrayBuffer = $c6fd95db66a95a37$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c6fd95db66a95a37$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c6fd95db66a95a37$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $c6fd95db66a95a37$var$isString = $c6fd95db66a95a37$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $c6fd95db66a95a37$var$isFunction = $c6fd95db66a95a37$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $c6fd95db66a95a37$var$isNumber = $c6fd95db66a95a37$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $c6fd95db66a95a37$var$isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $c6fd95db66a95a37$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $c6fd95db66a95a37$var$isPlainObject = function(val) {
    if ($c6fd95db66a95a37$var$kindOf(val) !== 'object') return false;
    var prototype = $c6fd95db66a95a37$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c6fd95db66a95a37$var$toStringTag in val) && !($c6fd95db66a95a37$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ var $c6fd95db66a95a37$var$isEmptyObject = function(val) {
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c6fd95db66a95a37$var$isObject(val) || $c6fd95db66a95a37$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $c6fd95db66a95a37$var$isDate = $c6fd95db66a95a37$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c6fd95db66a95a37$var$isFile = $c6fd95db66a95a37$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $c6fd95db66a95a37$var$isBlob = $c6fd95db66a95a37$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c6fd95db66a95a37$var$isFileList = $c6fd95db66a95a37$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $c6fd95db66a95a37$var$isStream = function(val) {
    return $c6fd95db66a95a37$var$isObject(val) && $c6fd95db66a95a37$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $c6fd95db66a95a37$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c6fd95db66a95a37$var$isFunction(thing.append) && ((kind = $c6fd95db66a95a37$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c6fd95db66a95a37$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $c6fd95db66a95a37$var$isURLSearchParams = $c6fd95db66a95a37$var$kindOfTest('URLSearchParams');
var $c6fd95db66a95a37$var$_map = (0, $1733e6e3a24db77c$export$71511d61b312f219)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c6fd95db66a95a37$var$kindOfTest), 4), $c6fd95db66a95a37$var$isReadableStream = $c6fd95db66a95a37$var$_map[0], $c6fd95db66a95a37$var$isRequest = $c6fd95db66a95a37$var$_map[1], $c6fd95db66a95a37$var$isResponse = $c6fd95db66a95a37$var$_map[2], $c6fd95db66a95a37$var$isHeaders = $c6fd95db66a95a37$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $c6fd95db66a95a37$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c6fd95db66a95a37$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c6fd95db66a95a37$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c6fd95db66a95a37$var$isBuffer(obj)) return;
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c6fd95db66a95a37$var$findKey(obj, key) {
    if ($c6fd95db66a95a37$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $c6fd95db66a95a37$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
}();
var $c6fd95db66a95a37$var$isContextDefined = function(context) {
    return !$c6fd95db66a95a37$var$isUndefined(context) && context !== $c6fd95db66a95a37$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c6fd95db66a95a37$var$merge() {
    var _ref = $c6fd95db66a95a37$var$isContextDefined(this) && this || {}, caseless = _ref.caseless, skipUndefined = _ref.skipUndefined;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $c6fd95db66a95a37$var$findKey(result, key) || key;
        if ($c6fd95db66a95a37$var$isPlainObject(result[targetKey]) && $c6fd95db66a95a37$var$isPlainObject(val)) result[targetKey] = $c6fd95db66a95a37$var$merge(result[targetKey], val);
        else if ($c6fd95db66a95a37$var$isPlainObject(val)) result[targetKey] = $c6fd95db66a95a37$var$merge({}, val);
        else if ($c6fd95db66a95a37$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c6fd95db66a95a37$var$isUndefined(val)) result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $c6fd95db66a95a37$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $c6fd95db66a95a37$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $c6fd95db66a95a37$var$forEach(b, function(val, key) {
        if (thisArg && $c6fd95db66a95a37$var$isFunction(val)) a[key] = (0, $547100571c4e1abe$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $c6fd95db66a95a37$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $c6fd95db66a95a37$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $c6fd95db66a95a37$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c6fd95db66a95a37$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $c6fd95db66a95a37$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $c6fd95db66a95a37$var$toArray = function(thing) {
    if (!thing) return null;
    if ($c6fd95db66a95a37$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$c6fd95db66a95a37$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $c6fd95db66a95a37$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && $c6fd95db66a95a37$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $c6fd95db66a95a37$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[$c6fd95db66a95a37$var$iterator];
    var _iterator = generator.call(obj);
    var result;
    while((result = _iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $c6fd95db66a95a37$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $c6fd95db66a95a37$var$isHTMLForm = $c6fd95db66a95a37$var$kindOfTest('HTMLFormElement');
var $c6fd95db66a95a37$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $c6fd95db66a95a37$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $c6fd95db66a95a37$var$isRegExp = $c6fd95db66a95a37$var$kindOfTest('RegExp');
var $c6fd95db66a95a37$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $c6fd95db66a95a37$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $c6fd95db66a95a37$var$freezeMethods = function(obj) {
    $c6fd95db66a95a37$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($c6fd95db66a95a37$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$c6fd95db66a95a37$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
var $c6fd95db66a95a37$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $c6fd95db66a95a37$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $c6fd95db66a95a37$var$noop = function() {};
var $c6fd95db66a95a37$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c6fd95db66a95a37$var$isSpecCompliantForm(thing) {
    return !!(thing && $c6fd95db66a95a37$var$isFunction(thing.append) && thing[$c6fd95db66a95a37$var$toStringTag] === 'FormData' && thing[$c6fd95db66a95a37$var$iterator]);
}
var $c6fd95db66a95a37$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($c6fd95db66a95a37$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c6fd95db66a95a37$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                var target = $c6fd95db66a95a37$var$isArray(source) ? [] : {};
                $c6fd95db66a95a37$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$c6fd95db66a95a37$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $c6fd95db66a95a37$var$isAsyncFn = $c6fd95db66a95a37$var$kindOfTest('AsyncFunction');
var $c6fd95db66a95a37$var$isThenable = function(thing) {
    return thing && ($c6fd95db66a95a37$var$isObject(thing) || $c6fd95db66a95a37$var$isFunction(thing)) && $c6fd95db66a95a37$var$isFunction(thing.then) && $c6fd95db66a95a37$var$isFunction(thing["catch"]);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var $c6fd95db66a95a37$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $c6fd95db66a95a37$var$_global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === $c6fd95db66a95a37$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $c6fd95db66a95a37$var$_global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', $c6fd95db66a95a37$var$isFunction($c6fd95db66a95a37$var$_global.postMessage));
var $c6fd95db66a95a37$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c6fd95db66a95a37$var$_global) : $c6fd95db66a95a37$var$_setImmediate;
// *********************
var $c6fd95db66a95a37$var$isIterable = function(thing) {
    return thing != null && $c6fd95db66a95a37$var$isFunction(thing[$c6fd95db66a95a37$var$iterator]);
};
var $c6fd95db66a95a37$export$2e2bcd8739ae039 = {
    isArray: $c6fd95db66a95a37$var$isArray,
    isArrayBuffer: $c6fd95db66a95a37$var$isArrayBuffer,
    isBuffer: $c6fd95db66a95a37$var$isBuffer,
    isFormData: $c6fd95db66a95a37$var$isFormData,
    isArrayBufferView: $c6fd95db66a95a37$var$isArrayBufferView,
    isString: $c6fd95db66a95a37$var$isString,
    isNumber: $c6fd95db66a95a37$var$isNumber,
    isBoolean: $c6fd95db66a95a37$var$isBoolean,
    isObject: $c6fd95db66a95a37$var$isObject,
    isPlainObject: $c6fd95db66a95a37$var$isPlainObject,
    isEmptyObject: $c6fd95db66a95a37$var$isEmptyObject,
    isReadableStream: $c6fd95db66a95a37$var$isReadableStream,
    isRequest: $c6fd95db66a95a37$var$isRequest,
    isResponse: $c6fd95db66a95a37$var$isResponse,
    isHeaders: $c6fd95db66a95a37$var$isHeaders,
    isUndefined: $c6fd95db66a95a37$var$isUndefined,
    isDate: $c6fd95db66a95a37$var$isDate,
    isFile: $c6fd95db66a95a37$var$isFile,
    isBlob: $c6fd95db66a95a37$var$isBlob,
    isRegExp: $c6fd95db66a95a37$var$isRegExp,
    isFunction: $c6fd95db66a95a37$var$isFunction,
    isStream: $c6fd95db66a95a37$var$isStream,
    isURLSearchParams: $c6fd95db66a95a37$var$isURLSearchParams,
    isTypedArray: $c6fd95db66a95a37$var$isTypedArray,
    isFileList: $c6fd95db66a95a37$var$isFileList,
    forEach: $c6fd95db66a95a37$var$forEach,
    merge: $c6fd95db66a95a37$var$merge,
    extend: $c6fd95db66a95a37$var$extend,
    trim: $c6fd95db66a95a37$var$trim,
    stripBOM: $c6fd95db66a95a37$var$stripBOM,
    inherits: $c6fd95db66a95a37$var$inherits,
    toFlatObject: $c6fd95db66a95a37$var$toFlatObject,
    kindOf: $c6fd95db66a95a37$var$kindOf,
    kindOfTest: $c6fd95db66a95a37$var$kindOfTest,
    endsWith: $c6fd95db66a95a37$var$endsWith,
    toArray: $c6fd95db66a95a37$var$toArray,
    forEachEntry: $c6fd95db66a95a37$var$forEachEntry,
    matchAll: $c6fd95db66a95a37$var$matchAll,
    isHTMLForm: $c6fd95db66a95a37$var$isHTMLForm,
    hasOwnProperty: $c6fd95db66a95a37$var$hasOwnProperty,
    hasOwnProp: $c6fd95db66a95a37$var$hasOwnProperty,
    reduceDescriptors: $c6fd95db66a95a37$var$reduceDescriptors,
    freezeMethods: $c6fd95db66a95a37$var$freezeMethods,
    toObjectSet: $c6fd95db66a95a37$var$toObjectSet,
    toCamelCase: $c6fd95db66a95a37$var$toCamelCase,
    noop: $c6fd95db66a95a37$var$noop,
    toFiniteNumber: $c6fd95db66a95a37$var$toFiniteNumber,
    findKey: $c6fd95db66a95a37$var$findKey,
    global: $c6fd95db66a95a37$var$_global,
    isContextDefined: $c6fd95db66a95a37$var$isContextDefined,
    isSpecCompliantForm: $c6fd95db66a95a37$var$isSpecCompliantForm,
    toJSONObject: $c6fd95db66a95a37$var$toJSONObject,
    isAsyncFn: $c6fd95db66a95a37$var$isAsyncFn,
    isThenable: $c6fd95db66a95a37$var$isThenable,
    setImmediate: $c6fd95db66a95a37$var$_setImmediate,
    asap: $c6fd95db66a95a37$var$asap,
    isIterable: $c6fd95db66a95a37$var$isIterable
};













'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $82194958dcf3d811$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).inherits($82194958dcf3d811$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var $82194958dcf3d811$var$prototype = $82194958dcf3d811$var$AxiosError.prototype;
var $82194958dcf3d811$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach(function(code) {
    $82194958dcf3d811$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($82194958dcf3d811$var$AxiosError, $82194958dcf3d811$var$descriptors);
Object.defineProperty($82194958dcf3d811$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$82194958dcf3d811$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($82194958dcf3d811$var$prototype);
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== 'isAxiosError';
    });
    var msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    var errCode = code == null && error ? error.code : code;
    $82194958dcf3d811$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $82194958dcf3d811$export$2e2bcd8739ae039 = $82194958dcf3d811$var$AxiosError;


// eslint-disable-next-line strict
var $983413b2a0eaae0e$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 




var $438a2a62f0a90b29$export$a143d493d941bafc;
var $438a2a62f0a90b29$export$e4cf37d7f6fb9e0a;
var $438a2a62f0a90b29$export$f99ded8fe4b79145;
var $438a2a62f0a90b29$export$599f31c3813fae4d;
'use strict';
var $623efc618916115a$export$a48f0734ac7c2329;
var $623efc618916115a$export$d622b2ad8d90c771;
var $623efc618916115a$export$6100ba28696e12de;
'use strict';
$623efc618916115a$export$a48f0734ac7c2329 = $623efc618916115a$var$byteLength;
$623efc618916115a$export$d622b2ad8d90c771 = $623efc618916115a$var$toByteArray;
$623efc618916115a$export$6100ba28696e12de = $623efc618916115a$var$fromByteArray;
var $623efc618916115a$var$lookup = [];
var $623efc618916115a$var$revLookup = [];
var $623efc618916115a$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $623efc618916115a$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $623efc618916115a$var$i = 0, $623efc618916115a$var$len = $623efc618916115a$var$code.length; $623efc618916115a$var$i < $623efc618916115a$var$len; ++$623efc618916115a$var$i){
    $623efc618916115a$var$lookup[$623efc618916115a$var$i] = $623efc618916115a$var$code[$623efc618916115a$var$i];
    $623efc618916115a$var$revLookup[$623efc618916115a$var$code.charCodeAt($623efc618916115a$var$i)] = $623efc618916115a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$623efc618916115a$var$revLookup['-'.charCodeAt(0)] = 62;
$623efc618916115a$var$revLookup['_'.charCodeAt(0)] = 63;
function $623efc618916115a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $623efc618916115a$var$byteLength(b64) {
    var lens = $623efc618916115a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $623efc618916115a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $623efc618916115a$var$toByteArray(b64) {
    var tmp;
    var lens = $623efc618916115a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $623efc618916115a$var$Arr($623efc618916115a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $623efc618916115a$var$revLookup[b64.charCodeAt(i)] << 18 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $623efc618916115a$var$revLookup[b64.charCodeAt(i)] << 2 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $623efc618916115a$var$revLookup[b64.charCodeAt(i)] << 10 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $623efc618916115a$var$tripletToBase64(num) {
    return $623efc618916115a$var$lookup[num >> 18 & 0x3F] + $623efc618916115a$var$lookup[num >> 12 & 0x3F] + $623efc618916115a$var$lookup[num >> 6 & 0x3F] + $623efc618916115a$var$lookup[num & 0x3F];
}
function $623efc618916115a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($623efc618916115a$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $623efc618916115a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($623efc618916115a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($623efc618916115a$var$lookup[tmp >> 2] + $623efc618916115a$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($623efc618916115a$var$lookup[tmp >> 10] + $623efc618916115a$var$lookup[tmp >> 4 & 0x3F] + $623efc618916115a$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a38d2305e673c028$export$aafa59e2e03f2942;
var $a38d2305e673c028$export$68d8715fc104d294;
$a38d2305e673c028$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a38d2305e673c028$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $438a2a62f0a90b29$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$438a2a62f0a90b29$export$a143d493d941bafc = $438a2a62f0a90b29$var$Buffer;
$438a2a62f0a90b29$export$e4cf37d7f6fb9e0a = $438a2a62f0a90b29$var$SlowBuffer;
$438a2a62f0a90b29$export$f99ded8fe4b79145 = 50;
var $438a2a62f0a90b29$var$K_MAX_LENGTH = 0x7fffffff;
$438a2a62f0a90b29$export$599f31c3813fae4d = $438a2a62f0a90b29$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $438a2a62f0a90b29$var$Buffer.TYPED_ARRAY_SUPPORT = $438a2a62f0a90b29$var$typedArraySupport();
if (!$438a2a62f0a90b29$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $438a2a62f0a90b29$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($438a2a62f0a90b29$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$438a2a62f0a90b29$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($438a2a62f0a90b29$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$438a2a62f0a90b29$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $438a2a62f0a90b29$var$createBuffer(length) {
    if (length > $438a2a62f0a90b29$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $438a2a62f0a90b29$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $438a2a62f0a90b29$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $438a2a62f0a90b29$var$allocUnsafe(arg);
    }
    return $438a2a62f0a90b29$var$from(arg, encodingOrOffset, length);
}
$438a2a62f0a90b29$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $438a2a62f0a90b29$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $438a2a62f0a90b29$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $438a2a62f0a90b29$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)));
    if ($438a2a62f0a90b29$var$isInstance(value, ArrayBuffer) || value && $438a2a62f0a90b29$var$isInstance(value.buffer, ArrayBuffer)) return $438a2a62f0a90b29$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($438a2a62f0a90b29$var$isInstance(value, SharedArrayBuffer) || value && $438a2a62f0a90b29$var$isInstance(value.buffer, SharedArrayBuffer))) return $438a2a62f0a90b29$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $438a2a62f0a90b29$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $438a2a62f0a90b29$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $438a2a62f0a90b29$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $438a2a62f0a90b29$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $438a2a62f0a90b29$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($438a2a62f0a90b29$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($438a2a62f0a90b29$var$Buffer, Uint8Array);
function $438a2a62f0a90b29$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $438a2a62f0a90b29$var$alloc(size, fill, encoding) {
    $438a2a62f0a90b29$var$assertSize(size);
    if (size <= 0) return $438a2a62f0a90b29$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $438a2a62f0a90b29$var$createBuffer(size).fill(fill, encoding) : $438a2a62f0a90b29$var$createBuffer(size).fill(fill);
    return $438a2a62f0a90b29$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $438a2a62f0a90b29$var$Buffer.alloc = function(size, fill, encoding) {
    return $438a2a62f0a90b29$var$alloc(size, fill, encoding);
};
function $438a2a62f0a90b29$var$allocUnsafe(size) {
    $438a2a62f0a90b29$var$assertSize(size);
    return $438a2a62f0a90b29$var$createBuffer(size < 0 ? 0 : $438a2a62f0a90b29$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $438a2a62f0a90b29$var$Buffer.allocUnsafe = function(size) {
    return $438a2a62f0a90b29$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $438a2a62f0a90b29$var$Buffer.allocUnsafeSlow = function(size) {
    return $438a2a62f0a90b29$var$allocUnsafe(size);
};
function $438a2a62f0a90b29$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$438a2a62f0a90b29$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $438a2a62f0a90b29$var$byteLength(string, encoding) | 0;
    var buf = $438a2a62f0a90b29$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $438a2a62f0a90b29$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $438a2a62f0a90b29$var$checked(array.length) | 0;
    var buf = $438a2a62f0a90b29$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $438a2a62f0a90b29$var$fromArrayView(arrayView) {
    if ($438a2a62f0a90b29$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $438a2a62f0a90b29$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $438a2a62f0a90b29$var$fromArrayLike(arrayView);
}
function $438a2a62f0a90b29$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $438a2a62f0a90b29$var$Buffer.prototype);
    return buf;
}
function $438a2a62f0a90b29$var$fromObject(obj) {
    if ($438a2a62f0a90b29$var$Buffer.isBuffer(obj)) {
        var len = $438a2a62f0a90b29$var$checked(obj.length) | 0;
        var buf = $438a2a62f0a90b29$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $438a2a62f0a90b29$var$numberIsNaN(obj.length)) return $438a2a62f0a90b29$var$createBuffer(0);
        return $438a2a62f0a90b29$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $438a2a62f0a90b29$var$fromArrayLike(obj.data);
}
function $438a2a62f0a90b29$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $438a2a62f0a90b29$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $438a2a62f0a90b29$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $438a2a62f0a90b29$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $438a2a62f0a90b29$var$Buffer.alloc(+length);
}
$438a2a62f0a90b29$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $438a2a62f0a90b29$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$438a2a62f0a90b29$var$Buffer.compare = function compare(a, b) {
    if ($438a2a62f0a90b29$var$isInstance(a, Uint8Array)) a = $438a2a62f0a90b29$var$Buffer.from(a, a.offset, a.byteLength);
    if ($438a2a62f0a90b29$var$isInstance(b, Uint8Array)) b = $438a2a62f0a90b29$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(a) || !$438a2a62f0a90b29$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$438a2a62f0a90b29$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$438a2a62f0a90b29$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $438a2a62f0a90b29$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $438a2a62f0a90b29$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($438a2a62f0a90b29$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$438a2a62f0a90b29$var$Buffer.isBuffer(buf)) buf = $438a2a62f0a90b29$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$438a2a62f0a90b29$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $438a2a62f0a90b29$var$byteLength(string, encoding) {
    if ($438a2a62f0a90b29$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $438a2a62f0a90b29$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $438a2a62f0a90b29$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $438a2a62f0a90b29$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $438a2a62f0a90b29$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$438a2a62f0a90b29$var$Buffer.byteLength = $438a2a62f0a90b29$var$byteLength;
function $438a2a62f0a90b29$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $438a2a62f0a90b29$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $438a2a62f0a90b29$var$utf8Slice(this, start, end);
        case 'ascii':
            return $438a2a62f0a90b29$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $438a2a62f0a90b29$var$latin1Slice(this, start, end);
        case 'base64':
            return $438a2a62f0a90b29$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $438a2a62f0a90b29$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$438a2a62f0a90b29$var$Buffer.prototype._isBuffer = true;
function $438a2a62f0a90b29$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$438a2a62f0a90b29$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$438a2a62f0a90b29$var$swap(this, i, i + 1);
    return this;
};
$438a2a62f0a90b29$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $438a2a62f0a90b29$var$swap(this, i, i + 3);
        $438a2a62f0a90b29$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$438a2a62f0a90b29$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $438a2a62f0a90b29$var$swap(this, i, i + 7);
        $438a2a62f0a90b29$var$swap(this, i + 1, i + 6);
        $438a2a62f0a90b29$var$swap(this, i + 2, i + 5);
        $438a2a62f0a90b29$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$438a2a62f0a90b29$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $438a2a62f0a90b29$var$utf8Slice(this, 0, length);
    return $438a2a62f0a90b29$var$slowToString.apply(this, arguments);
};
$438a2a62f0a90b29$var$Buffer.prototype.toLocaleString = $438a2a62f0a90b29$var$Buffer.prototype.toString;
$438a2a62f0a90b29$var$Buffer.prototype.equals = function equals(b) {
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $438a2a62f0a90b29$var$Buffer.compare(this, b) === 0;
};
$438a2a62f0a90b29$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $438a2a62f0a90b29$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($438a2a62f0a90b29$var$customInspectSymbol) $438a2a62f0a90b29$var$Buffer.prototype[$438a2a62f0a90b29$var$customInspectSymbol] = $438a2a62f0a90b29$var$Buffer.prototype.inspect;
$438a2a62f0a90b29$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($438a2a62f0a90b29$var$isInstance(target, Uint8Array)) target = $438a2a62f0a90b29$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $438a2a62f0a90b29$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($438a2a62f0a90b29$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $438a2a62f0a90b29$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($438a2a62f0a90b29$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $438a2a62f0a90b29$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $438a2a62f0a90b29$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $438a2a62f0a90b29$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$438a2a62f0a90b29$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$438a2a62f0a90b29$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $438a2a62f0a90b29$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$438a2a62f0a90b29$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $438a2a62f0a90b29$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $438a2a62f0a90b29$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($438a2a62f0a90b29$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $438a2a62f0a90b29$var$utf8Write(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $438a2a62f0a90b29$var$asciiWrite(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$asciiToBytes(string), buf, offset, length);
}
function $438a2a62f0a90b29$var$base64Write(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$base64ToBytes(string), buf, offset, length);
}
function $438a2a62f0a90b29$var$ucs2Write(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$438a2a62f0a90b29$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $438a2a62f0a90b29$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $438a2a62f0a90b29$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $438a2a62f0a90b29$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $438a2a62f0a90b29$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $438a2a62f0a90b29$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$438a2a62f0a90b29$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $438a2a62f0a90b29$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $623efc618916115a$export$6100ba28696e12de(buf);
    else return $623efc618916115a$export$6100ba28696e12de(buf.slice(start, end));
}
function $438a2a62f0a90b29$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $438a2a62f0a90b29$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $438a2a62f0a90b29$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $438a2a62f0a90b29$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $438a2a62f0a90b29$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $438a2a62f0a90b29$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $438a2a62f0a90b29$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $438a2a62f0a90b29$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $438a2a62f0a90b29$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $438a2a62f0a90b29$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $438a2a62f0a90b29$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$438a2a62f0a90b29$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $438a2a62f0a90b29$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $438a2a62f0a90b29$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$438a2a62f0a90b29$var$Buffer.prototype.readUintLE = $438a2a62f0a90b29$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUintBE = $438a2a62f0a90b29$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint8 = $438a2a62f0a90b29$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint16LE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint16BE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint32LE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint32BE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$438a2a62f0a90b29$var$Buffer.prototype.readBigUInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$438a2a62f0a90b29$var$Buffer.prototype.readBigUInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$438a2a62f0a90b29$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$438a2a62f0a90b29$var$Buffer.prototype.readBigInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$438a2a62f0a90b29$var$Buffer.prototype.readBigInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$438a2a62f0a90b29$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$438a2a62f0a90b29$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$438a2a62f0a90b29$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 8, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$438a2a62f0a90b29$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 8, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $438a2a62f0a90b29$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$438a2a62f0a90b29$var$Buffer.prototype.writeUintLE = $438a2a62f0a90b29$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUintBE = $438a2a62f0a90b29$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint8 = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint16LE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint16BE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint32LE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint32BE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $438a2a62f0a90b29$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $438a2a62f0a90b29$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $438a2a62f0a90b29$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $438a2a62f0a90b29$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$438a2a62f0a90b29$var$Buffer.prototype.writeBigUInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$438a2a62f0a90b29$var$Buffer.prototype.writeBigUInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$438a2a62f0a90b29$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeBigInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$438a2a62f0a90b29$var$Buffer.prototype.writeBigInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $438a2a62f0a90b29$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $438a2a62f0a90b29$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $a38d2305e673c028$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$438a2a62f0a90b29$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeFloat(this, value, offset, true, noAssert);
};
$438a2a62f0a90b29$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeFloat(this, value, offset, false, noAssert);
};
function $438a2a62f0a90b29$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $a38d2305e673c028$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$438a2a62f0a90b29$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeDouble(this, value, offset, true, noAssert);
};
$438a2a62f0a90b29$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$438a2a62f0a90b29$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$438a2a62f0a90b29$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$438a2a62f0a90b29$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $438a2a62f0a90b29$var$Buffer.isBuffer(val) ? val : $438a2a62f0a90b29$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $438a2a62f0a90b29$var$errors = {};
function $438a2a62f0a90b29$var$E(sym, getMessage, Base) {
    $438a2a62f0a90b29$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $28f6179e2b599279$export$71511d61b312f219)(NodeError, Base);
        function NodeError() {
            (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, NodeError);
            var _this;
            _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $625388bbfb3cd523$export$71511d61b312f219)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$438a2a62f0a90b29$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$438a2a62f0a90b29$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(actual));
}, TypeError);
$438a2a62f0a90b29$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $438a2a62f0a90b29$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $438a2a62f0a90b29$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $438a2a62f0a90b29$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $438a2a62f0a90b29$var$checkBounds(buf, offset, byteLength) {
    $438a2a62f0a90b29$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $438a2a62f0a90b29$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $438a2a62f0a90b29$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $438a2a62f0a90b29$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $438a2a62f0a90b29$var$checkBounds(buf, offset, byteLength);
}
function $438a2a62f0a90b29$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $438a2a62f0a90b29$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $438a2a62f0a90b29$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $438a2a62f0a90b29$var$validateNumber(value, type);
        throw new $438a2a62f0a90b29$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $438a2a62f0a90b29$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $438a2a62f0a90b29$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $438a2a62f0a90b29$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $438a2a62f0a90b29$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($438a2a62f0a90b29$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $438a2a62f0a90b29$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $438a2a62f0a90b29$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $438a2a62f0a90b29$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $438a2a62f0a90b29$var$base64ToBytes(str) {
    return $623efc618916115a$export$d622b2ad8d90c771($438a2a62f0a90b29$var$base64clean(str));
}
function $438a2a62f0a90b29$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $438a2a62f0a90b29$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $438a2a62f0a90b29$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $438a2a62f0a90b29$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $438a2a62f0a90b29$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $438a2a62f0a90b29$var$BufferBigIntNotDefined : fn;
}
function $438a2a62f0a90b29$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $1eeade30cbff36ce$require$Buffer = $438a2a62f0a90b29$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $1eeade30cbff36ce$var$isVisitable(thing) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $1eeade30cbff36ce$var$removeBrackets(key) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $1eeade30cbff36ce$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $1eeade30cbff36ce$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $1eeade30cbff36ce$var$isFlatArray(arr) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(arr) && !arr.some($1eeade30cbff36ce$var$isVisitable);
}
var $1eeade30cbff36ce$var$predicates = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFlatObject((0, $c6fd95db66a95a37$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $1eeade30cbff36ce$var$toFormData(obj, formData, options) {
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $983413b2a0eaae0e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var useBlob = _Blob && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $1eeade30cbff36ce$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)) === 'object') {
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(value) && $1eeade30cbff36ce$var$isFlatArray(value) || ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFileList(value) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $1eeade30cbff36ce$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $1eeade30cbff36ce$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($1eeade30cbff36ce$var$isVisitable(value)) return true;
        formData.append($1eeade30cbff36ce$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($1eeade30cbff36ce$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $1eeade30cbff36ce$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $1eeade30cbff36ce$export$2e2bcd8739ae039 = $1eeade30cbff36ce$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $3ea7c6f17f32ff00$var$encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $3ea7c6f17f32ff00$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $1eeade30cbff36ce$export$2e2bcd8739ae039)(params, this, options);
}
var $3ea7c6f17f32ff00$var$prototype = $3ea7c6f17f32ff00$var$AxiosURLSearchParams.prototype;
$3ea7c6f17f32ff00$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$3ea7c6f17f32ff00$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $3ea7c6f17f32ff00$var$encode);
    } : $3ea7c6f17f32ff00$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $3ea7c6f17f32ff00$export$2e2bcd8739ae039 = $3ea7c6f17f32ff00$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $f9896427eceadcee$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $f9896427eceadcee$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $f9896427eceadcee$var$encode;
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $3ea7c6f17f32ff00$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}





'use strict';
var $b2b4d635b99ab9ff$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $b2b4d635b99ab9ff$export$2e2bcd8739ae039 = $b2b4d635b99ab9ff$var$InterceptorManager;





'use strict';
var $53b3f7096dbc152f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};




function $2cfc0dd9fa59fdb8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $a6437d79afda84c4$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}






'use strict';
var $9a92d05ddfce05cc$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $3ea7c6f17f32ff00$export$2e2bcd8739ae039);


'use strict';
var $65d6465ab8ae31e5$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $0d2074ee94622b01$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $a1c9841e029434f4$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $9a92d05ddfce05cc$export$2e2bcd8739ae039),
        FormData: (0, $65d6465ab8ae31e5$export$2e2bcd8739ae039),
        Blob: (0, $0d2074ee94622b01$export$2e2bcd8739ae039)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $96bd9a3362da6da6$exports = {};

$parcel$export($96bd9a3362da6da6$exports, "hasBrowserEnv", function () { return $96bd9a3362da6da6$export$c4996c4b7b93b0bf; });
$parcel$export($96bd9a3362da6da6$exports, "navigator", function () { return $96bd9a3362da6da6$export$ec7c8efa7f5790ae; });
$parcel$export($96bd9a3362da6da6$exports, "hasStandardBrowserEnv", function () { return $96bd9a3362da6da6$export$c0bcc9250309d66; });
$parcel$export($96bd9a3362da6da6$exports, "hasStandardBrowserWebWorkerEnv", function () { return $96bd9a3362da6da6$export$c81692cf5af97dac; });
$parcel$export($96bd9a3362da6da6$exports, "origin", function () { return $96bd9a3362da6da6$export$f710a83a91838a36; });

var $96bd9a3362da6da6$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
var $96bd9a3362da6da6$export$ec7c8efa7f5790ae = (typeof navigator === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $96bd9a3362da6da6$export$c0bcc9250309d66 = $96bd9a3362da6da6$export$c4996c4b7b93b0bf && (!$96bd9a3362da6da6$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($96bd9a3362da6da6$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $96bd9a3362da6da6$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var $96bd9a3362da6da6$export$f710a83a91838a36 = $96bd9a3362da6da6$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $4f26f8d637e1fdc5$export$2e2bcd8739ae039 = (0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, $96bd9a3362da6da6$exports, (0, $a1c9841e029434f4$export$2e2bcd8739ae039));


'use strict';
function $7b08810bd6fe6820$export$2e2bcd8739ae039(data, options) {
    return (0, $1eeade30cbff36ce$export$2e2bcd8739ae039)(data, new (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).isNode && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5defdff28a25b37d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5defdff28a25b37d$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5defdff28a25b37d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5defdff28a25b37d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(formData) && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($5defdff28a25b37d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5defdff28a25b37d$export$2e2bcd8739ae039 = $5defdff28a25b37d$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $7c8f8d5bb202b6a6$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $7c8f8d5bb202b6a6$var$defaults = {
    transitional: (0, $53b3f7096dbc152f$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5defdff28a25b37d$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBuffer(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isStream(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFile(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBlob(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $7b08810bd6fe6820$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $1eeade30cbff36ce$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $7c8f8d5bb202b6a6$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $7c8f8d5bb202b6a6$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isResponse(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $82194958dcf3d811$export$2e2bcd8739ae039).from(e, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], function(method) {
    $7c8f8d5bb202b6a6$var$defaults.headers[method] = {};
});
var $7c8f8d5bb202b6a6$export$2e2bcd8739ae039 = $7c8f8d5bb202b6a6$var$defaults;








'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $deaa86df7a7dca04$var$ignoreDuplicateOf = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $deaa86df7a7dca04$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $deaa86df7a7dca04$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
var $74fcf8410f1e027a$var$$internals = Symbol('internals');
function $74fcf8410f1e027a$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $74fcf8410f1e027a$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(value) ? value.map($74fcf8410f1e027a$var$normalizeValue) : String(value);
}
function $74fcf8410f1e027a$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $74fcf8410f1e027a$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $74fcf8410f1e027a$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $74fcf8410f1e027a$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, _char, str) {
        return _char.toUpperCase() + str;
    });
}
function $74fcf8410f1e027a$var$buildAccessors(obj, header) {
    var accessorName = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $74fcf8410f1e027a$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $74fcf8410f1e027a$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error('header name must be a non-empty string');
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $74fcf8410f1e027a$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$74fcf8410f1e027a$var$isValidHeaderName(header)) setHeaders((0, $deaa86df7a7dca04$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(header) && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isIterable(header)) {
                    var obj = {}, dest, key;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                            obj[key = entry[0]] = (dest = obj[key]) ? (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(dest) ? (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(dest).concat([
                                entry[1]
                            ]) : [
                                dest,
                                entry[1]
                            ] : entry[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setHeaders(obj, valueOrRewrite);
                } else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $74fcf8410f1e027a$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $74fcf8410f1e027a$var$parseTokens(value);
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $74fcf8410f1e027a$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $74fcf8410f1e027a$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $74fcf8410f1e027a$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $74fcf8410f1e027a$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $74fcf8410f1e027a$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $74fcf8410f1e027a$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $74fcf8410f1e027a$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $74fcf8410f1e027a$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: "getSetCookie",
            value: function getSetCookie() {
                return this.get("set-cookie") || [];
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$74fcf8410f1e027a$var$$internals] = this[$74fcf8410f1e027a$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $74fcf8410f1e027a$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $74fcf8410f1e027a$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$74fcf8410f1e027a$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).reduceDescriptors($74fcf8410f1e027a$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).freezeMethods($74fcf8410f1e027a$var$AxiosHeaders);
var $74fcf8410f1e027a$export$2e2bcd8739ae039 = $74fcf8410f1e027a$var$AxiosHeaders;


'use strict';
function $09abcdf599ca47fd$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $7c8f8d5bb202b6a6$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $ad1a5450a5160689$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $b4466f79dd14f203$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $82194958dcf3d811$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).inherits($b4466f79dd14f203$var$CanceledError, (0, $82194958dcf3d811$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $b4466f79dd14f203$export$2e2bcd8739ae039 = $b4466f79dd14f203$var$CanceledError;









'use strict';
function $c0c665f8f7f2c495$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $4aa597b942719605$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}






'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $f85ac55cb3f96026$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $f85ac55cb3f96026$export$2e2bcd8739ae039 = $f85ac55cb3f96026$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ 
function $db64eb36ffee3aef$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(void 0, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $db64eb36ffee3aef$export$2e2bcd8739ae039 = $db64eb36ffee3aef$var$throttle;



var $e224c15f6e2f6fba$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $f85ac55cb3f96026$export$2e2bcd8739ae039)(50, 250);
    return (0, $db64eb36ffee3aef$export$2e2bcd8739ae039)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, $a6437d79afda84c4$export$71511d61b312f219)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var $e224c15f6e2f6fba$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $e224c15f6e2f6fba$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).asap(function() {
            return fn.apply(void 0, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        });
    };
};






var $b68a4e7e99c6d789$export$2e2bcd8739ae039 = (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? function(origin, isMSIE) {
    return function(url) {
        url = new URL(url, (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    };
}(new URL((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).origin), (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).navigator.userAgent)) : function() {
    return true;
};




var $8e85fda76462c38e$export$2e2bcd8739ae039 = (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure) {
        var cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};


'use strict';
function $49f0e6122e6d6215$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $84aa1f6d68ee8578$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $a145a933c101048a$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeUrl = !(0, $49f0e6122e6d6215$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $84aa1f6d68ee8578$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
var $d6ec2a123bef168e$var$headersToObject = function(thing) {
    return thing instanceof (0, $74fcf8410f1e027a$export$2e2bcd8739ae039) ? (0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, thing) : thing;
};
function $d6ec2a123bef168e$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b, prop) {
            return mergeDeepProperties($d6ec2a123bef168e$var$headersToObject(a), $d6ec2a123bef168e$var$headersToObject(b), prop, true);
        }
    };
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(Object.keys((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $a37a65c5c782d854$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $f9896427eceadcee$export$2e2bcd8739ae039)((0, $a145a933c101048a$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            var formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            var allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(function(param) {
                var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), key = _param[0], val = _param[1];
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $b68a4e7e99c6d789$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8e85fda76462c38e$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


var $7d658be7e59b6c8f$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $7d658be7e59b6c8f$export$2e2bcd8739ae039 = $7d658be7e59b6c8f$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $a37a65c5c782d854$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0c665f8f7f2c495$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('Request aborted', (0, $82194958dcf3d811$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            var msg = event && event.message ? event.message : 'Network Error';
            var err = new (0, $82194958dcf3d811$export$2e2bcd8739ae039)(msg, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, $53b3f7096dbc152f$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $82194958dcf3d811$export$2e2bcd8739ae039).ETIMEDOUT : (0, $82194958dcf3d811$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $1733e6e3a24db77c$export$71511d61b312f219)((0, $e224c15f6e2f6fba$export$c1b28109d46c3592)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $1733e6e3a24db77c$export$71511d61b312f219)((0, $e224c15f6e2f6fba$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, $4aa597b942719605$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};




function $f0cc97789eddd92a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f0cc97789eddd92a$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f0cc97789eddd92a$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}











var $833f8f6a265fff68$var$composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $82194958dcf3d811$export$2e2bcd8739ae039) ? err : new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("timeout ".concat(timeout, " of ms exceeded"), (0, $82194958dcf3d811$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener('abort', onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).asap(unsubscribe);
        };
        return signal;
    }
};
var $833f8f6a265fff68$export$2e2bcd8739ae039 = $833f8f6a265fff68$var$composeSignals;


function $4b377a111adb43c4$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}


function $17e74aaec9f0c9e2$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $4b377a111adb43c4$export$71511d61b312f219)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}


function $58e2e9f5f01f626d$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $58e2e9f5f01f626d$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $58e2e9f5f01f626d$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $58e2e9f5f01f626d$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $58e2e9f5f01f626d$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $58e2e9f5f01f626d$var$AsyncFromSyncIterator(s);
}




function $dba6b08d41f84d66$export$71511d61b312f219(value) {
    return new (0, $4b377a111adb43c4$export$71511d61b312f219)(value, /* kind: await */ 0);
}



function $7470c90b63c2ed80$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $4b377a111adb43c4$export$71511d61b312f219);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$7470c90b63c2ed80$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$7470c90b63c2ed80$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$7470c90b63c2ed80$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$7470c90b63c2ed80$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $a1fec2d0f280b502$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $7470c90b63c2ed80$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}




var $d136e98d8c08ca6b$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $d136e98d8c08ca6b$export$f9f241124ee3198e = function readBytes(iterable, chunkSize) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $a1fec2d0f280b502$export$71511d61b312f219)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $58e2e9f5f01f626d$export$71511d61b312f219)($d136e98d8c08ca6b$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $248fc3c53839d9ba$export$19a8beecd37a4c45)((0, $17e74aaec9f0c9e2$export$71511d61b312f219)((0, $58e2e9f5f01f626d$export$71511d61b312f219)($d136e98d8c08ca6b$export$71b051935044bd5d(chunk, chunkSize))))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(_iterator["return"]())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $d136e98d8c08ca6b$var$readStream = function readStream(stream) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $a1fec2d0f280b502$export$71511d61b312f219)(function() {
        var reader, _ref, done, value;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $248fc3c53839d9ba$export$19a8beecd37a4c45)((0, $17e74aaec9f0c9e2$export$71511d61b312f219)((0, $58e2e9f5f01f626d$export$71511d61b312f219)(stream)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $d136e98d8c08ca6b$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $d136e98d8c08ca6b$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator["return"]();
        }
    }, {
        highWaterMark: 2
    });
};






var $f563560c7540a370$var$DEFAULT_CHUNK_SIZE = 65536;
var $f563560c7540a370$var$isFunction = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction;
var $f563560c7540a370$var$globalFetchAPI = function(param) {
    var Request = param.Request, Response = param.Response;
    return {
        Request: Request,
        Response: Response
    };
}((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).global);
var $f563560c7540a370$var$_utils_global = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).global, $f563560c7540a370$var$ReadableStream = $f563560c7540a370$var$_utils_global.ReadableStream, $f563560c7540a370$var$TextEncoder = $f563560c7540a370$var$_utils_global.TextEncoder;
var $f563560c7540a370$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
    } catch (e) {
        return false;
    }
};
var $f563560c7540a370$var$factory = function(env) {
    env = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $f563560c7540a370$var$globalFetchAPI, env);
    var envFetch = env.fetch, Request = env.Request, Response = env.Response;
    var isFetchSupported = envFetch ? $f563560c7540a370$var$isFunction(envFetch) : typeof fetch === 'function';
    var isRequestSupported = $f563560c7540a370$var$isFunction(Request);
    var isResponseSupported = $f563560c7540a370$var$isFunction(Response);
    if (!isFetchSupported) return false;
    var isReadableStreamSupported = isFetchSupported && $f563560c7540a370$var$isFunction($f563560c7540a370$var$ReadableStream);
    var encodeText = isFetchSupported && (typeof $f563560c7540a370$var$TextEncoder === 'function' ? function(encoder) {
        return function(str) {
            return encoder.encode(str);
        };
    }(new $f563560c7540a370$var$TextEncoder()) : function(str) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
            var _;
            return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            new Request(str).arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        })();
    });
    var supportsRequestStream = isRequestSupported && isReadableStreamSupported && $f563560c7540a370$var$test(function() {
        var duplexAccessed = false;
        var hasContentType = new Request((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).origin, {
            body: new $f563560c7540a370$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    var supportsResponseStream = isResponseSupported && isReadableStreamSupported && $f563560c7540a370$var$test(function() {
        return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isReadableStream(new Response('').body);
    });
    var resolvers = {
        stream: supportsResponseStream && function(res) {
            return res.body;
        }
    };
    isFetchSupported && function() {
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach(function(type) {
            !resolvers[type] && (resolvers[type] = function(res, config) {
                var method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    }();
    var getBodyLength = function(body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
            var _request;
            return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (body == null) return [
                            2,
                            0
                        ];
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBlob(body)) return [
                            2,
                            body.size
                        ];
                        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                            3,
                            2
                        ];
                        _request = new Request((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).origin, {
                            method: 'POST',
                            body: body
                        });
                        return [
                            4,
                            _request.arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 2:
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                            2,
                            body.byteLength
                        ];
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
                        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(body)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            encodeText(body)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var resolveBodyLength = function(headers, body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
            var length;
            return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                length = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
                return [
                    2,
                    length == null ? getBodyLength(body) : length
                ];
            });
        })();
    };
    return function(config) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
            var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, _fetch, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, resolvedOptions, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
            return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _resolveConfig = (0, $a37a65c5c782d854$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                        _fetch = envFetch || fetch;
                        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                        composedSignal = (0, $833f8f6a265fff68$export$2e2bcd8739ae039)([
                            signal,
                            cancelToken && cancelToken.toAbortSignal()
                        ], timeout);
                        request = null;
                        unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                            composedSignal.unsubscribe();
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        _tmp = onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head';
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            resolveBodyLength(headers, data)
                        ];
                    case 2:
                        _tmp = (requestContentLength = _state.sent()) !== 0;
                        _state.label = 3;
                    case 3:
                        if (_tmp) {
                            _request = new Request(url, {
                                method: 'POST',
                                body: data,
                                duplex: "half"
                            });
                            ;
                            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                            if (_request.body) {
                                _progressEventDecorator = (0, $1733e6e3a24db77c$export$71511d61b312f219)((0, $e224c15f6e2f6fba$export$d9fadd12586c18d6)(requestContentLength, (0, $e224c15f6e2f6fba$export$c1b28109d46c3592)((0, $e224c15f6e2f6fba$export$5d35863c355a22a9)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                                data = (0, $d136e98d8c08ca6b$export$b0119225647bd83)(_request.body, $f563560c7540a370$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                            }
                        }
                        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                        // Cloudflare Workers throws when credentials are defined
                        // see https://github.com/cloudflare/workerd/issues/902
                        isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
                        resolvedOptions = (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, fetchOptions), {
                            signal: composedSignal,
                            method: method.toUpperCase(),
                            headers: headers.normalize().toJSON(),
                            body: data,
                            duplex: "half",
                            credentials: isCredentialsSupported ? withCredentials : undefined
                        });
                        request = isRequestSupported && new Request(url, resolvedOptions);
                        return [
                            4,
                            isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions)
                        ];
                    case 4:
                        response = _state.sent();
                        isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                        if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                            options = {};
                            [
                                'status',
                                'statusText',
                                'headers'
                            ].forEach(function(prop) {
                                options[prop] = response[prop];
                            });
                            responseContentLength = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                            _ref = (0, $1733e6e3a24db77c$export$71511d61b312f219)(onDownloadProgress && (0, $e224c15f6e2f6fba$export$d9fadd12586c18d6)(responseContentLength, (0, $e224c15f6e2f6fba$export$c1b28109d46c3592)((0, $e224c15f6e2f6fba$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                            response = new Response((0, $d136e98d8c08ca6b$export$b0119225647bd83)(response.body, $f563560c7540a370$var$DEFAULT_CHUNK_SIZE, onProgress1, function() {
                                flush1 && flush1();
                                unsubscribe && unsubscribe();
                            }), options);
                        }
                        responseType = responseType || 'text';
                        return [
                            4,
                            resolvers[(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config)
                        ];
                    case 5:
                        responseData = _state.sent();
                        !isStreamResponse && unsubscribe && unsubscribe();
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                (0, $c0c665f8f7f2c495$export$2e2bcd8739ae039)(resolve, reject, {
                                    data: responseData,
                                    headers: (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(response.headers),
                                    status: response.status,
                                    statusText: response.statusText,
                                    config: config,
                                    request: request
                                });
                            })
                        ];
                    case 6:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 7:
                        err = _state.sent();
                        unsubscribe && unsubscribe();
                        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('Network Error', (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                            cause: err.cause || err
                        });
                        throw (0, $82194958dcf3d811$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
                    case 8:
                        return [
                            2
                        ];
                }
            });
        })();
    };
};
var $f563560c7540a370$var$seedCache = new Map();
var $f563560c7540a370$export$3105c6651375d4fa = function(config) {
    var env = config ? config.env : {};
    var fetch1 = env.fetch, Request = env.Request, Response = env.Response;
    var seeds = [
        Request,
        Response,
        fetch1
    ];
    var len = seeds.length, i = len, seed, target, map = $f563560c7540a370$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $f563560c7540a370$var$factory(env));
        map = target;
    }
    return target;
};
var $f563560c7540a370$var$adapter = $f563560c7540a370$export$3105c6651375d4fa();
var $f563560c7540a370$export$2e2bcd8739ae039 = $f563560c7540a370$var$adapter;



var $ecc2e934cf4b2586$var$knownAdapters = {
    http: (0, $983413b2a0eaae0e$export$2e2bcd8739ae039),
    xhr: (0, $7d658be7e59b6c8f$export$2e2bcd8739ae039),
    fetch: {
        get: $f563560c7540a370$export$3105c6651375d4fa
    }
};
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach($ecc2e934cf4b2586$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
var $ecc2e934cf4b2586$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
var $ecc2e934cf4b2586$var$isResolvedHandle = function(adapter) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
var $ecc2e934cf4b2586$export$2e2bcd8739ae039 = {
    getAdapter: function(adapters, config) {
        adapters = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!$ecc2e934cf4b2586$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $ecc2e934cf4b2586$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter && ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
            });
            var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($ecc2e934cf4b2586$var$renderReason).join('\n') : ' ' + $ecc2e934cf4b2586$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $ecc2e934cf4b2586$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $078d153ff3a29674$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(null, config);
}
function $078d153ff3a29674$export$2e2bcd8739ae039(config) {
    $078d153ff3a29674$var$throwIfCancellationRequested(config);
    config.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $09abcdf599ca47fd$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, $ecc2e934cf4b2586$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $7c8f8d5bb202b6a6$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $078d153ff3a29674$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $09abcdf599ca47fd$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ad1a5450a5160689$export$2e2bcd8739ae039)(reason)) {
            $078d153ff3a29674$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $09abcdf599ca47fd$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}





var $25c3930f89e6179f$export$a4ad2735b021c132 = "1.12.2";



'use strict';
var $f61feb979da78eab$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $f61feb979da78eab$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $f61feb979da78eab$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $f61feb979da78eab$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $25c3930f89e6179f$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$f61feb979da78eab$var$deprecatedWarnings[opt]) {
            $f61feb979da78eab$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$f61feb979da78eab$var$validators.spelling = function spelling(correctSpelling) {
    return function(value, opt) {
        // eslint-disable-next-line no-console
        console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $f61feb979da78eab$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(options)) !== 'object') throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('options must be an object', (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $f61feb979da78eab$export$2e2bcd8739ae039 = {
    assertOptions: $f61feb979da78eab$var$assertOptions,
    validators: $f61feb979da78eab$var$validators
};



'use strict';
var $32554a0f086aa968$var$validators = (0, $f61feb979da78eab$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $32554a0f086aa968$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Axios);
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $b2b4d635b99ab9ff$export$2e2bcd8739ae039)(),
            response: new (0, $b2b4d635b99ab9ff$export$2e2bcd8739ae039)()
        };
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var err, dummy, stack;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    dummy = {};
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $f61feb979da78eab$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $32554a0f086aa968$var$validators.transitional($32554a0f086aa968$var$validators["boolean"]),
                    forcedJSONParsing: $32554a0f086aa968$var$validators.transitional($32554a0f086aa968$var$validators["boolean"]),
                    clarifyTimeoutError: $32554a0f086aa968$var$validators.transitional($32554a0f086aa968$var$validators["boolean"])
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $f61feb979da78eab$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $32554a0f086aa968$var$validators["function"],
                        serialize: $32554a0f086aa968$var$validators["function"]
                    }, true);
                }
                // Set config.allowAbsoluteUrls
                if (config.allowAbsoluteUrls !== undefined) ;
                else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
                else config.allowAbsoluteUrls = true;
                (0, $f61feb979da78eab$export$2e2bcd8739ae039).assertOptions(config, {
                    baseUrl: $32554a0f086aa968$var$validators.spelling('baseURL'),
                    withXsrfToken: $32554a0f086aa968$var$validators.spelling('withXSRFToken')
                }, true);
                // Set config.method
                config.method = (config.method || this.defaults.method || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
                    'delete',
                    'get',
                    'head',
                    'post',
                    'put',
                    'patch',
                    'common'
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var _chain, _chain1;
                    var chain = [
                        (0, $078d153ff3a29674$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    (_chain = chain).unshift.apply(_chain, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(requestInterceptorChain));
                    (_chain1 = chain).push.apply(_chain1, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(responseInterceptorChain));
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $078d153ff3a29674$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $a145a933c101048a$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
                return (0, $f9896427eceadcee$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $32554a0f086aa968$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $32554a0f086aa968$var$Axios.prototype[method] = generateHTTPMethod();
    $32554a0f086aa968$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $32554a0f086aa968$export$2e2bcd8739ae039 = $32554a0f086aa968$var$Axios;









'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $d8cf381d353a4513$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $d8cf381d353a4513$export$2e2bcd8739ae039 = $d8cf381d353a4513$var$CancelToken;






'use strict';
function $3227eba814d38007$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $d4c636500f91910b$export$2e2bcd8739ae039(payload) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $1b327d89d2379b44$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($1b327d89d2379b44$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), key = _param[0], value = _param[1];
    $1b327d89d2379b44$var$HttpStatusCode[value] = key;
});
var $1b327d89d2379b44$export$2e2bcd8739ae039 = $1b327d89d2379b44$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $d8b49c18383d4ddb$var$createInstance(defaultConfig) {
    var context = new (0, $32554a0f086aa968$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $547100571c4e1abe$export$2e2bcd8739ae039)((0, $32554a0f086aa968$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).extend(instance, (0, $32554a0f086aa968$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $d8b49c18383d4ddb$var$createInstance((0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $d8b49c18383d4ddb$var$axios = $d8b49c18383d4ddb$var$createInstance((0, $7c8f8d5bb202b6a6$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$d8b49c18383d4ddb$var$axios.Axios = (0, $32554a0f086aa968$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$d8b49c18383d4ddb$var$axios.CanceledError = (0, $b4466f79dd14f203$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.CancelToken = (0, $d8cf381d353a4513$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.isCancel = (0, $ad1a5450a5160689$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.VERSION = (0, $25c3930f89e6179f$export$a4ad2735b021c132);
$d8b49c18383d4ddb$var$axios.toFormData = (0, $1eeade30cbff36ce$export$2e2bcd8739ae039);
// Expose AxiosError class
$d8b49c18383d4ddb$var$axios.AxiosError = (0, $82194958dcf3d811$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$d8b49c18383d4ddb$var$axios.Cancel = $d8b49c18383d4ddb$var$axios.CanceledError;
// Expose all/spread
$d8b49c18383d4ddb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$d8b49c18383d4ddb$var$axios.spread = (0, $3227eba814d38007$export$2e2bcd8739ae039);
// Expose isAxiosError
$d8b49c18383d4ddb$var$axios.isAxiosError = (0, $d4c636500f91910b$export$2e2bcd8739ae039);
// Expose mergeConfig
$d8b49c18383d4ddb$var$axios.mergeConfig = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.AxiosHeaders = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.formToJSON = function(thing) {
    return (0, $5defdff28a25b37d$export$2e2bcd8739ae039)((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$d8b49c18383d4ddb$var$axios.getAdapter = (0, $ecc2e934cf4b2586$export$2e2bcd8739ae039).getAdapter;
$d8b49c18383d4ddb$var$axios.HttpStatusCode = (0, $1b327d89d2379b44$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios["default"] = $d8b49c18383d4ddb$var$axios;
var // this module should only have a default export
$d8b49c18383d4ddb$export$2e2bcd8739ae039 = $d8b49c18383d4ddb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $a9e2c987c7f89efe$export$1c00760e9e5a4e95 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).Axios, $a9e2c987c7f89efe$export$c1fbed17c2f6a328 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).AxiosError, $a9e2c987c7f89efe$export$1ab0c6b20d94fa14 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).CanceledError, $a9e2c987c7f89efe$export$3b22524397b493c6 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).isCancel, $a9e2c987c7f89efe$export$fd08e3cb425f0d61 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).CancelToken, $a9e2c987c7f89efe$export$a4ad2735b021c132 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).VERSION, $a9e2c987c7f89efe$export$84bf76cd7afc7469 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).all, $a9e2c987c7f89efe$export$848c9b7ead0df967 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).Cancel, $a9e2c987c7f89efe$export$fbafdbe06a5b5a9a = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).isAxiosError, $a9e2c987c7f89efe$export$3ae0fd4797ed47c8 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).spread, $a9e2c987c7f89efe$export$10ae0d317ea97f8b = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).toFormData, $a9e2c987c7f89efe$export$4e7d6ff0f3e6520 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).AxiosHeaders, $a9e2c987c7f89efe$export$a972f69c851492b3 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).HttpStatusCode, $a9e2c987c7f89efe$export$86d7c59254d6a2c9 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).formToJSON, $a9e2c987c7f89efe$export$17ddc20a97d669e2 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).getAdapter, $a9e2c987c7f89efe$export$7ec1ebcfa9d8bd6a = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).mergeConfig;

















var $1fd43aa358ead3cf$var$_this = undefined;
function $1fd43aa358ead3cf$var$_defineProperty(e, r, t) {
    return (r = $1fd43aa358ead3cf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1fd43aa358ead3cf$var$_toPropertyKey(t) {
    var i = $1fd43aa358ead3cf$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $1fd43aa358ead3cf$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1fd43aa358ead3cf$var$AbstractFormField = /*#__PURE__*/ function() {
    "use strict";
    function AbstractFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AbstractFormField);
        $1fd43aa358ead3cf$var$_defineProperty(this, "name", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "isRequired", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "element", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "type", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "changeListeners", []);
        var name = options.name, isRequired = options.isRequired, type = options.type;
        this.element = element;
        this.name = name;
        this.type = type;
        this.isRequired = isRequired;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AbstractFormField, [
        {
            key: "onChange",
            value: function onChange(callback) {
                this.changeListeners.push(callback);
            }
        },
        {
            key: "handleChanges",
            value: function handleChanges() {
                var _this = this;
                this.changeListeners.forEach(function(fn) {
                    return fn(_this);
                });
            }
        },
        {
            key: "getLabel",
            value: function getLabel() {
                return this.label;
            }
        },
        {
            key: "getValue",
            value: function getValue() {}
        },
        {
            key: "setValue",
            value: function setValue() {}
        },
        {
            key: "isValid",
            value: function isValid() {}
        },
        {
            key: "validate",
            value: function validate() {
                this.element.classList.remove('has-error');
                if (!this.isValid()) this.element.classList.add('has-error');
            }
        },
        {
            key: "getName",
            value: function getName() {
                return this.name;
            }
        }
    ]);
    return AbstractFormField;
}();
$1fd43aa358ead3cf$var$AbstractFormField.prototype.getLabel = function() {
    return $1fd43aa358ead3cf$var$_this.label;
};
var $1fd43aa358ead3cf$export$2e2bcd8739ae039 = $1fd43aa358ead3cf$var$AbstractFormField;


var $bc7011be64c26b4e$var$CheckboxFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(CheckboxFormField, AbstractFormField);
    function CheckboxFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, CheckboxFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, CheckboxFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: "input"
            })
        ]);
        _this.input = element.querySelectorAll("input")[0];
        _this.input.addEventListener("click", _this.handleChanges.bind(_this));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(CheckboxFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return this.input.checked ? this.input.value : undefined;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                return this.input.checked;
            }
        }
    ]);
    return CheckboxFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $bc7011be64c26b4e$export$2e2bcd8739ae039 = $bc7011be64c26b4e$var$CheckboxFormField;









var $8279f1a00c51d7f9$var$CheckboxOtherFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(CheckboxOtherFormField, AbstractFormField);
    function CheckboxOtherFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, CheckboxOtherFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, CheckboxOtherFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: "input"
            })
        ]);
        _this.checkbox = _this.element.getElementsByClassName("checkbox-other-checkbox")[0];
        _this.other = _this.element.getElementsByClassName("checkbox-other-text")[0];
        _this.checkbox.addEventListener('click', _this.handleChanges.bind(_this));
        _this.checkbox.addEventListener('click', _this.enableOtherWhenChecked.bind(_this));
        _this.other.addEventListener('keyup', _this.handleChanges.bind(_this));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(CheckboxOtherFormField, [
        {
            key: "enableOtherWhenChecked",
            value: function enableOtherWhenChecked() {
                console.log('enableOtherWhenChecked');
                if (this.checkbox.checked) {
                    console.log(this.other);
                    this.other.parentElement.classList.remove("hidden");
                    this.other.setAttribute("required", "required");
                    this.other.focus();
                } else {
                    this.other.parentElement.classList.add("hidden");
                    this.other.removeAttribute("required");
                    this.other.value = "";
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.checkbox.checked ? this.other.value : '';
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                if (this.checkbox.checked) return this.other.value.length > 0;
                else return true;
            }
        }
    ]);
    return CheckboxOtherFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $8279f1a00c51d7f9$export$2e2bcd8739ae039 = $8279f1a00c51d7f9$var$CheckboxOtherFormField;











var $02a8fbdc45cbe028$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $02a8fbdc45cbe028$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: (typeof window === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function errorHandler(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function getWeek(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $fa594f80d9ef6ba5$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function ordinal(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $fa594f80d9ef6ba5$export$2e2bcd8739ae039 = $fa594f80d9ef6ba5$export$33e6c23ebe2ee669;


var $370ac348e838fd20$export$5d04458e2a6c373e = function pad(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $370ac348e838fd20$export$7d260a2a5f8bc19e = function _int(bool) {
    return bool === true ? 1 : 0;
};
function $370ac348e838fd20$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $370ac348e838fd20$export$3131421a7d01b4fb = function arrayify(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $88a859cc36abdb44$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $88a859cc36abdb44$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $88a859cc36abdb44$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $88a859cc36abdb44$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $88a859cc36abdb44$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $88a859cc36abdb44$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $88a859cc36abdb44$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $88a859cc36abdb44$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $88a859cc36abdb44$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $88a859cc36abdb44$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $88a859cc36abdb44$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $ea603045c1c9ecc8$var$doNothing = function doNothing() {
    return undefined;
};
var $ea603045c1c9ecc8$export$27a2dd9af757e89c = function monthToStr(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $ea603045c1c9ecc8$export$9490b78b888a863f = {
    D: $ea603045c1c9ecc8$var$doNothing,
    F: function F(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function G(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function H(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function J(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function K(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function M(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function S(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function U(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function W(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function Y(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function Z(_, ISODate) {
        return new Date(ISODate);
    },
    d: function d(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function h(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function i(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function j(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $ea603045c1c9ecc8$var$doNothing,
    m: function m(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function n(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function s(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function u(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $ea603045c1c9ecc8$var$doNothing,
    y: function y(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $ea603045c1c9ecc8$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $ea603045c1c9ecc8$export$55069460464ca7a9 = {
    Z: function Z(date) {
        return date.toISOString();
    },
    D: function D(date, locale, options) {
        return locale.weekdays.shorthand[$ea603045c1c9ecc8$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function F(date, locale, options) {
        return $ea603045c1c9ecc8$export$27a2dd9af757e89c($ea603045c1c9ecc8$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function G(date, locale, options) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)($ea603045c1c9ecc8$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function H(date) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function J(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function K(date, locale) {
        return locale.amPM[int(date.getHours() > 11)];
    },
    M: function M(date, locale) {
        return $ea603045c1c9ecc8$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function S(date) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function U(date) {
        return date.getTime() / 1000;
    },
    W: function W(date, _, options) {
        return options.getWeek(date);
    },
    Y: function Y(date) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function d(date) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function h(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function i(date) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function j(date) {
        return date.getDate();
    },
    l: function l(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function m(date) {
        return (0, $370ac348e838fd20$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function n(date) {
        return date.getMonth() + 1;
    },
    s: function s(date) {
        return date.getSeconds();
    },
    u: function u(date) {
        return date.getTime();
    },
    w: function w(date) {
        return date.getDay();
    },
    y: function y(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $a4b2a38ffbfa8b8a$export$ff1a0b75284ac636 = function createDateFormatter(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $02a8fbdc45cbe028$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $fa594f80d9ef6ba5$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $ea603045c1c9ecc8$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $ea603045c1c9ecc8$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $a4b2a38ffbfa8b8a$export$cfa2ef2687faeda2 = function createDateParser(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $02a8fbdc45cbe028$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $fa594f80d9ef6ba5$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $02a8fbdc45cbe028$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $ea603045c1c9ecc8$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $a4b2a38ffbfa8b8a$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $a4b2a38ffbfa8b8a$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $a4b2a38ffbfa8b8a$export$a4d69fb5f2026c35 = function isBetween(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $a4b2a38ffbfa8b8a$export$9fafc166baa96839 = function calculateSecondsSinceMidnight(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $a4b2a38ffbfa8b8a$export$a4ce0def660bfe9e = function parseSeconds(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $a4b2a38ffbfa8b8a$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $a4b2a38ffbfa8b8a$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function _loop_1(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $20c8b215f7377fdb$var$__assign = undefined && undefined.__assign || function() {
    $20c8b215f7377fdb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $20c8b215f7377fdb$var$__assign.apply(this, arguments);
};
var $20c8b215f7377fdb$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $20c8b215f7377fdb$var$DEBOUNCED_CHANGE_MS = 300;
function $20c8b215f7377fdb$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $20c8b215f7377fdb$var$__assign($20c8b215f7377fdb$var$__assign({}, (0, $02a8fbdc45cbe028$export$ebe90cb607ad99e)), $20c8b215f7377fdb$var$flatpickr.defaultConfig),
        l10n: (0, $fa594f80d9ef6ba5$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $a4b2a38ffbfa8b8a$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function getDaysInMonth(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $a4b2a38ffbfa8b8a$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $a4b2a38ffbfa8b8a$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $a4b2a38ffbfa8b8a$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $a4b2a38ffbfa8b8a$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $a4b2a38ffbfa8b8a$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function remove() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $370ac348e838fd20$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $370ac348e838fd20$export$61fc7d43ac8f84b0)(triggerChange, $20c8b215f7377fdb$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config["static"]) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function selText(e) {
                return (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config["static"]) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config["static"]) {
                var wrapper = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config["static"] && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $88a859cc36abdb44$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $88a859cc36abdb44$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function shouldBuildMonth(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $ea603045c1c9ecc8$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $88a859cc36abdb44$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $88a859cc36abdb44$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function get() {
                return self.__hidePrevMonthArrow;
            },
            set: function set(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function get() {
                return self.__hideNextMonthArrow;
            },
            set: function set(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $a4b2a38ffbfa8b8a$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $88a859cc36abdb44$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $88a859cc36abdb44$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $88a859cc36abdb44$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $370ac348e838fd20$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $88a859cc36abdb44$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $20c8b215f7377fdb$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $20c8b215f7377fdb$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $a4b2a38ffbfa8b8a$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config["static"] && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if ((typeof d === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(d)) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $a4b2a38ffbfa8b8a$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $a4b2a38ffbfa8b8a$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config["static"] && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $20c8b215f7377fdb$var$__assign($20c8b215f7377fdb$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function get() {
                return self.config._enable;
            },
            set: function set(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function get() {
                return self.config._disable;
            },
            set: function set(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $20c8b215f7377fdb$var$flatpickr.defaultConfig.dateFormat || (0, $02a8fbdc45cbe028$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $20c8b215f7377fdb$var$flatpickr.defaultConfig.altFormat || (0, $02a8fbdc45cbe028$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function get() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function get() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function minMaxTimeSetter(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function get() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function get() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $02a8fbdc45cbe028$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $370ac348e838fd20$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $02a8fbdc45cbe028$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $370ac348e838fd20$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if ((0, $0cd339a6e98df7f5$export$71511d61b312f219)(self.config.locale) !== "object" && typeof $20c8b215f7377fdb$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $20c8b215f7377fdb$var$__assign($20c8b215f7377fdb$var$__assign({}, $20c8b215f7377fdb$var$flatpickr.l10ns["default"]), (0, $0cd339a6e98df7f5$export$71511d61b312f219)(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? $20c8b215f7377fdb$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $ea603045c1c9ecc8$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $20c8b215f7377fdb$var$__assign($20c8b215f7377fdb$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $20c8b215f7377fdb$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $a4b2a38ffbfa8b8a$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $a4b2a38ffbfa8b8a$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config["static"]) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $88a859cc36abdb44$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function isSelectable(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $88a859cc36abdb44$export$25245567f53f158f)((0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && (typeof option === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(option)) === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $02a8fbdc45cbe028$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $370ac348e838fd20$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && (typeof rule === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(rule)) === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config["static"] && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $88a859cc36abdb44$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $ea603045c1c9ecc8$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $88a859cc36abdb44$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(isHourElem) && (0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $370ac348e838fd20$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $370ac348e838fd20$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $20c8b215f7377fdb$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $20c8b215f7377fdb$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $20c8b215f7377fdb$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $20c8b215f7377fdb$var$_flatpickr([
            this
        ], config);
    };
}
var $20c8b215f7377fdb$var$flatpickr = function flatpickr(selector, config) {
    if (typeof selector === "string") return $20c8b215f7377fdb$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $20c8b215f7377fdb$var$_flatpickr([
        selector
    ], config);
    else return $20c8b215f7377fdb$var$_flatpickr(selector, config);
};
$20c8b215f7377fdb$var$flatpickr.defaultConfig = {};
$20c8b215f7377fdb$var$flatpickr.l10ns = {
    en: $20c8b215f7377fdb$var$__assign({}, (0, $fa594f80d9ef6ba5$export$2e2bcd8739ae039)),
    "default": $20c8b215f7377fdb$var$__assign({}, (0, $fa594f80d9ef6ba5$export$2e2bcd8739ae039))
};
$20c8b215f7377fdb$var$flatpickr.localize = function(l10n) {
    $20c8b215f7377fdb$var$flatpickr.l10ns["default"] = $20c8b215f7377fdb$var$__assign($20c8b215f7377fdb$var$__assign({}, $20c8b215f7377fdb$var$flatpickr.l10ns["default"]), l10n);
};
$20c8b215f7377fdb$var$flatpickr.setDefaults = function(config) {
    $20c8b215f7377fdb$var$flatpickr.defaultConfig = $20c8b215f7377fdb$var$__assign($20c8b215f7377fdb$var$__assign({}, $20c8b215f7377fdb$var$flatpickr.defaultConfig), config);
};
$20c8b215f7377fdb$var$flatpickr.parseDate = (0, $a4b2a38ffbfa8b8a$export$cfa2ef2687faeda2)({});
$20c8b215f7377fdb$var$flatpickr.formatDate = (0, $a4b2a38ffbfa8b8a$export$ff1a0b75284ac636)({});
$20c8b215f7377fdb$var$flatpickr.compareDates = (0, $a4b2a38ffbfa8b8a$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $20c8b215f7377fdb$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $20c8b215f7377fdb$var$flatpickr;
var $20c8b215f7377fdb$export$2e2bcd8739ae039 = $20c8b215f7377fdb$var$flatpickr;


var $e338b6351d28b1c9$var$DateFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(DateFormField, AbstractFormField);
    function DateFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, DateFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, DateFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'input'
            })
        ]);
        _this.input = element.querySelectorAll('input')[0];
        _this.fp = (0, $20c8b215f7377fdb$export$2e2bcd8739ae039)(_this.input, {
            dateFormat: 'd.m.Y',
            allowInput: true,
            clickOpens: false,
            disableMobile: true
        });
        var calendarButton = element.querySelector('[data-date-picker-toggle]');
        calendarButton === null || calendarButton === void 0 ? void 0 : calendarButton.addEventListener('click', function() {
            if (_this.fp.isOpen) _this.fp.close();
            else _this.fp.open();
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(DateFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return this.input.value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
            // this.input.value = value;
            }
        },
        {
            key: "reset",
            value: function reset() {
            //this.input.value = '';
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                return this.input.value.trim() !== '';
            }
        }
    ]);
    return DateFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $e338b6351d28b1c9$export$2e2bcd8739ae039 = $e338b6351d28b1c9$var$DateFormField;










function $0e971c5a04e686db$var$_defineProperty(e, r, t) {
    return (r = $0e971c5a04e686db$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0e971c5a04e686db$var$_toPropertyKey(t) {
    var i = $0e971c5a04e686db$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $0e971c5a04e686db$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0e971c5a04e686db$var$RadiosFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(RadiosFormField, AbstractFormField);
    function RadiosFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, RadiosFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, RadiosFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'radios'
            })
        ]);
        $0e971c5a04e686db$var$_defineProperty(_this, "options", []);
        $0e971c5a04e686db$var$_defineProperty(_this, "other", null);
        var items = _this.element.getElementsByClassName('form-radio-input');
        var other = _this.element.getElementsByClassName('radio-other');
        if (other.length) _this.other = other[0];
        for(var i = 0; i < items.length; i++){
            _this.options.push(items[i]);
            items[i].addEventListener('click', function() {
                _this.handleChanges.bind(_this)();
                if (_this.other) _this.other.value = '';
            });
        }
        if (_this.other) _this.other.addEventListener('keyup', function() {
            _this.options.forEach(function(item) {
                item.checked = false;
            });
            _this.handleChanges.bind(_this)();
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(RadiosFormField, [
        {
            key: "getValue",
            value: function getValue() {
                var value = null;
                if (this.other && this.other.value.trim().length) value = this.other.value.trim();
                this.options.forEach(function(item) {
                    if (item.checked) value = item.value;
                });
                return value;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                var value = this.getValue();
                return value && value.length;
            }
        }
    ]);
    return RadiosFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $0e971c5a04e686db$export$2e2bcd8739ae039 = $0e971c5a04e686db$var$RadiosFormField;









var $179db65871bc5893$var$InputFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(InputFormField, AbstractFormField);
    function InputFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InputFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, InputFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'input'
            })
        ]);
        _this.input = element.querySelectorAll('input')[0];
        _this.input.addEventListener('keyup', _this.handleChanges.bind(_this));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InputFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return this.input.value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                this.input.value = value;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                if (this.input.getAttribute('type') === 'email') return /\S+@\S+\.\S+/.test(this.input.value);
                if (this.input.getAttribute('type') === 'date' && this.input.getAttribute('min')) {
                    var inputDate = new Date(this.input.value);
                    var currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    return inputDate > currentDate;
                }
                return this.input.value.trim() !== '';
            }
        }
    ]);
    return InputFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $179db65871bc5893$export$2e2bcd8739ae039 = $179db65871bc5893$var$InputFormField;










function $37f74405e557560a$var$_defineProperty(e, r, t) {
    return (r = $37f74405e557560a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $37f74405e557560a$var$_toPropertyKey(t) {
    var i = $37f74405e557560a$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $37f74405e557560a$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $37f74405e557560a$var$SelectFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SelectFormField, AbstractFormField);
    function SelectFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SelectFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SelectFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'select'
            })
        ]);
        $37f74405e557560a$var$_defineProperty(_this, "select", null);
        _this.select = element.querySelectorAll('select')[0];
        _this.select.addEventListener('change', _this.handleChanges.bind(_this));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SelectFormField, [
        {
            key: "getValue",
            value: function getValue() {
                var selectValue = this.select.value;
                return this.select.value;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                return this.select.value.trim() !== '';
            }
        }
    ]);
    return SelectFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $37f74405e557560a$export$2e2bcd8739ae039 = $37f74405e557560a$var$SelectFormField;












var $8ee1d0e5da9427cf$exports = {};

/*************************
 * Croppie
 * Copyright 2019
 * Foliotek
 * Version: 2.6.5
 *************************/ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else if (typeof $8ee1d0e5da9427cf$exports.nodeName !== 'string') // CommonJS
    $8ee1d0e5da9427cf$exports = factory();
    else // Browser globals
    root.Croppie = factory();
})(typeof self !== 'undefined' ? self : undefined, function() {
    /* Polyfills */ if (typeof Promise !== 'function') /*! promise-polyfill 3.1.0 */ !function(a) {
        function b(a, b) {
            return function() {
                a.apply(b, arguments);
            };
        }
        function c(a) {
            if ("object" !== (0, $0cd339a6e98df7f5$export$71511d61b312f219)(this)) throw new TypeError("Promises must be constructed via new");
            if ("function" !== typeof a) throw new TypeError("not a function");
            this._state = null, this._value = null, this._deferreds = [], i(a, b(e, this), b(f, this));
        }
        function d(a) {
            var b = this;
            return null === this._state ? void this._deferreds.push(a) : void k(function() {
                var _$c = b._state ? a.onFulfilled : a.onRejected;
                if (null === _$c) return void (b._state ? a.resolve : a.reject)(b._value);
                var d;
                try {
                    d = _$c(b._value);
                } catch (e) {
                    return void a.reject(e);
                }
                a.resolve(d);
            });
        }
        function e(a) {
            try {
                if (a === this) throw new TypeError("A promise cannot be resolved with itself.");
                if (a && ("object" === (typeof a === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(a)) || "function" === typeof a)) {
                    var _$c = a.then;
                    if ("function" === typeof _$c) return void i(b(_$c, a), b(e, this), b(f, this));
                }
                this._state = !0, this._value = a, g.call(this);
            } catch (d) {
                f.call(this, d);
            }
        }
        function f(a) {
            this._state = !1, this._value = a, g.call(this);
        }
        function g() {
            for(var _$a = 0, b = this._deferreds.length; b > _$a; _$a++)d.call(this, this._deferreds[_$a]);
            this._deferreds = null;
        }
        function h(a, b, c, d) {
            this.onFulfilled = "function" === typeof a ? a : null, this.onRejected = "function" === typeof b ? b : null, this.resolve = c, this.reject = d;
        }
        function i(a, b, c) {
            var d = !1;
            try {
                a(function(a) {
                    d || (d = !0, b(a));
                }, function(a) {
                    d || (d = !0, c(a));
                });
            } catch (e) {
                if (d) return;
                d = !0, c(e);
            }
        }
        var j = setTimeout, k = "function" === typeof setImmediate && setImmediate || function(a) {
            j(a, 1);
        }, l = Array.isArray || function(a) {
            return "[object Array]" === Object.prototype.toString.call(a);
        };
        c.prototype["catch"] = function(a) {
            return this.then(null, a);
        }, c.prototype.then = function(a, b) {
            var e = this;
            return new c(function(c, f) {
                d.call(e, new h(a, b, c, f));
            });
        }, c.all = function() {
            var _$a = Array.prototype.slice.call(1 === arguments.length && l(arguments[0]) ? arguments[0] : arguments);
            return new c(function(b, c) {
                function d(f, g) {
                    try {
                        if (g && ("object" === (typeof g === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(g)) || "function" === typeof g)) {
                            var h = g.then;
                            if ("function" === typeof h) return void h.call(g, function(a) {
                                d(f, a);
                            }, c);
                        }
                        _$a[f] = g, 0 === --e && b(_$a);
                    } catch (i) {
                        c(i);
                    }
                }
                if (0 === _$a.length) return b([]);
                for(var e = _$a.length, f = 0; f < _$a.length; f++)d(f, _$a[f]);
            });
        }, c.resolve = function(a) {
            return a && "object" === (typeof a === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(a)) && a.constructor === c ? a : new c(function(b) {
                b(a);
            });
        }, c.reject = function(a) {
            return new c(function(b, c) {
                c(a);
            });
        }, c.race = function(a) {
            return new c(function(b, c) {
                for(var d = 0, e = a.length; e > d; d++)a[d].then(b, c);
            });
        }, c._setImmediateFn = function(a) {
            k = a;
        }, $8ee1d0e5da9427cf$exports ? $8ee1d0e5da9427cf$exports = c : a.Promise || (a.Promise = c);
    }(this);
    if (typeof window !== 'undefined' && typeof window.CustomEvent !== "function") (function() {
        function CustomEvent1(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        CustomEvent1.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent1;
    })();
    if (typeof HTMLCanvasElement !== 'undefined' && !HTMLCanvasElement.prototype.toBlob) Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function value(callback, type, quality) {
            var binStr = atob(this.toDataURL(type, quality).split(',')[1]), len = binStr.length, arr = new Uint8Array(len);
            for(var i = 0; i < len; i++)arr[i] = binStr.charCodeAt(i);
            callback(new Blob([
                arr
            ], {
                type: type || 'image/png'
            }));
        }
    });
    /* End Polyfills */ var cssPrefixes = [
        'Webkit',
        'Moz',
        'ms'
    ], emptyStyles = typeof document !== 'undefined' ? document.createElement('div').style : {}, EXIF_NORM = [
        1,
        8,
        3,
        6
    ], EXIF_FLIP = [
        2,
        7,
        4,
        5
    ], CSS_TRANS_ORG, CSS_TRANSFORM, CSS_USERSELECT;
    function vendorPrefix(prop) {
        if (prop in emptyStyles) return prop;
        var capProp = prop[0].toUpperCase() + prop.slice(1), i = cssPrefixes.length;
        while(i--){
            prop = cssPrefixes[i] + capProp;
            if (prop in emptyStyles) return prop;
        }
    }
    CSS_TRANSFORM = vendorPrefix('transform');
    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
    CSS_USERSELECT = vendorPrefix('userSelect');
    function getExifOffset(ornt, rotate) {
        var arr = EXIF_NORM.indexOf(ornt) > -1 ? EXIF_NORM : EXIF_FLIP, index = arr.indexOf(ornt), offset = rotate / 90 % arr.length; // 180 = 2%4 = 2 shift exif by 2 indexes
        return arr[(arr.length + index + offset % arr.length) % arr.length];
    }
    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
    function deepExtend(destination, source) {
        destination = destination || {};
        for(var property in source)if (source[property] && source[property].constructor && source[property].constructor === Object) {
            destination[property] = destination[property] || {};
            deepExtend(destination[property], source[property]);
        } else destination[property] = source[property];
        return destination;
    }
    function clone(object) {
        return deepExtend({}, object);
    }
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function later() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
    function dispatchChange(element) {
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            element.dispatchEvent(evt);
        } else element.fireEvent("onchange");
    }
    //http://jsperf.com/vanilla-css
    function css(el, styles, val) {
        if (typeof styles === 'string') {
            var tmp = styles;
            styles = {};
            styles[tmp] = val;
        }
        for(var prop in styles)el.style[prop] = styles[prop];
    }
    function addClass(el, c) {
        if (el.classList) el.classList.add(c);
        else el.className += ' ' + c;
    }
    function removeClass(el, c) {
        if (el.classList) el.classList.remove(c);
        else el.className = el.className.replace(c, '');
    }
    function setAttributes(el, attrs) {
        for(var key in attrs)el.setAttribute(key, attrs[key]);
    }
    function num(v) {
        return parseInt(v, 10);
    }
    /* Utilities */ function loadImage(src, doExif) {
        if (!src) throw 'Source image missing';
        var img = new Image();
        img.style.opacity = '0';
        return new Promise(function(resolve, reject) {
            function _resolve() {
                img.style.opacity = '1';
                setTimeout(function() {
                    resolve(img);
                }, 1);
            }
            img.removeAttribute('crossOrigin');
            if (src.match(/^https?:\/\/|^\/\//)) img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function() {
                if (doExif) EXIF.getData(img, function() {
                    _resolve();
                });
                else _resolve();
            };
            img.onerror = function(ev) {
                img.style.opacity = 1;
                setTimeout(function() {
                    reject(ev);
                }, 1);
            };
            img.src = src;
        });
    }
    function naturalImageDimensions(img, ornt) {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var orient = ornt || getExifOrientation(img);
        if (orient && orient >= 5) {
            var x = w;
            w = h;
            h = x;
        }
        return {
            width: w,
            height: h
        };
    }
    /* CSS Transform Prototype */ var TRANSLATE_OPTS = {
        translate3d: {
            suffix: ', 0px'
        },
        translate: {
            suffix: ''
        }
    };
    var Transform = function Transform(x, y, scale) {
        this.x = parseFloat(x);
        this.y = parseFloat(y);
        this.scale = parseFloat(scale);
    };
    Transform.parse = function(v) {
        if (v.style) return Transform.parse(v.style[CSS_TRANSFORM]);
        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) return Transform.fromMatrix(v);
        else return Transform.fromString(v);
    };
    Transform.fromMatrix = function(v) {
        var vals = v.substring(7).split(',');
        if (!vals.length || v === 'none') vals = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
    };
    Transform.fromString = function(v) {
        var values = v.split(') '), translate = values[0].substring(Croppie.globals.translate.length + 1).split(','), scale = values.length > 1 ? values[1].substring(6) : 1, x = translate.length > 1 ? translate[0] : 0, y = translate.length > 1 ? translate[1] : 0;
        return new Transform(x, y, scale);
    };
    Transform.prototype.toString = function() {
        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
    };
    var TransformOrigin = function TransformOrigin(el) {
        if (!el || !el.style[CSS_TRANS_ORG]) {
            this.x = 0;
            this.y = 0;
            return;
        }
        var css = el.style[CSS_TRANS_ORG].split(' ');
        this.x = parseFloat(css[0]);
        this.y = parseFloat(css[1]);
    };
    TransformOrigin.prototype.toString = function() {
        return this.x + 'px ' + this.y + 'px';
    };
    function getExifOrientation(img) {
        return img.exifdata && img.exifdata.Orientation ? num(img.exifdata.Orientation) : 1;
    }
    function drawCanvas(canvas, img, orientation) {
        var width = img.width, height = img.height, ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.save();
        switch(orientation){
            case 2:
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                ctx.translate(width, height);
                ctx.rotate(180 * Math.PI / 180);
                break;
            case 4:
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;
            case 5:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90 * Math.PI / 180);
                ctx.scale(1, -1);
                break;
            case 6:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90 * Math.PI / 180);
                ctx.translate(0, -height);
                break;
            case 7:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(-90 * Math.PI / 180);
                ctx.translate(-width, height);
                ctx.scale(1, -1);
                break;
            case 8:
                canvas.width = height;
                canvas.height = width;
                ctx.translate(0, width);
                ctx.rotate(-90 * Math.PI / 180);
                break;
        }
        ctx.drawImage(img, 0, 0, width, height);
        ctx.restore();
    }
    /* Private Methods */ function _create() {
        var _$self = this, contClass = 'croppie-container', customViewportClass = _$self.options.viewport.type ? 'cr-vp-' + _$self.options.viewport.type : null, boundary, img, viewport, overlay, bw, bh;
        _$self.options.useCanvas = _$self.options.enableOrientation || _hasExif.call(_$self);
        // Properties on class
        _$self.data = {};
        _$self.elements = {};
        boundary = _$self.elements.boundary = document.createElement('div');
        viewport = _$self.elements.viewport = document.createElement('div');
        img = _$self.elements.img = document.createElement('img');
        overlay = _$self.elements.overlay = document.createElement('div');
        if (_$self.options.useCanvas) {
            _$self.elements.canvas = document.createElement('canvas');
            _$self.elements.preview = _$self.elements.canvas;
        } else _$self.elements.preview = img;
        addClass(boundary, 'cr-boundary');
        boundary.setAttribute('aria-dropeffect', 'none');
        bw = _$self.options.boundary.width;
        bh = _$self.options.boundary.height;
        css(boundary, {
            width: bw + (isNaN(bw) ? '' : 'px'),
            height: bh + (isNaN(bh) ? '' : 'px')
        });
        addClass(viewport, 'cr-viewport');
        if (customViewportClass) addClass(viewport, customViewportClass);
        css(viewport, {
            width: _$self.options.viewport.width + 'px',
            height: _$self.options.viewport.height + 'px'
        });
        viewport.setAttribute('tabindex', 0);
        addClass(_$self.elements.preview, 'cr-image');
        setAttributes(_$self.elements.preview, {
            alt: 'preview',
            'aria-grabbed': 'false'
        });
        addClass(overlay, 'cr-overlay');
        _$self.element.appendChild(boundary);
        boundary.appendChild(_$self.elements.preview);
        boundary.appendChild(viewport);
        boundary.appendChild(overlay);
        addClass(_$self.element, contClass);
        if (_$self.options.customClass) addClass(_$self.element, _$self.options.customClass);
        _initDraggable.call(this);
        if (_$self.options.enableZoom) _initializeZoom.call(_$self);
        // if (self.options.enableOrientation) {
        //     _initRotationControls.call(self);
        // }
        if (_$self.options.enableResize) _initializeResize.call(_$self);
    }
    // function _initRotationControls () {
    //     var self = this,
    //         wrap, btnLeft, btnRight, iLeft, iRight;
    //     wrap = document.createElement('div');
    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');
    //     wrap.appendChild(btnLeft);
    //     wrap.appendChild(btnRight);
    //     iLeft = document.createElement('i');
    //     iRight = document.createElement('i');
    //     btnLeft.appendChild(iLeft);
    //     btnRight.appendChild(iRight);
    //     addClass(wrap, 'cr-rotate-controls');
    //     addClass(btnLeft, 'cr-rotate-l');
    //     addClass(btnRight, 'cr-rotate-r');
    //     self.elements.boundary.appendChild(wrap);
    //     btnLeft.addEventListener('click', function () {
    //         self.rotate(-90);
    //     });
    //     btnRight.addEventListener('click', function () {
    //         self.rotate(90);
    //     });
    // }
    function _hasExif() {
        return this.options.enableExif && window.EXIF;
    }
    function _initializeResize() {
        var _$self = this;
        var wrap = document.createElement('div');
        var isDragging = false;
        var direction;
        var originalX;
        var originalY;
        var minSize = 50;
        var maxWidth;
        var maxHeight;
        var vr;
        var hr;
        addClass(wrap, 'cr-resizer');
        css(wrap, {
            width: this.options.viewport.width + 'px',
            height: this.options.viewport.height + 'px'
        });
        if (this.options.resizeControls.height) {
            vr = document.createElement('div');
            addClass(vr, 'cr-resizer-vertical');
            wrap.appendChild(vr);
        }
        if (this.options.resizeControls.width) {
            hr = document.createElement('div');
            addClass(hr, 'cr-resizer-horisontal');
            wrap.appendChild(hr);
        }
        function mouseDown(ev) {
            if (ev.button !== undefined && ev.button !== 0) return;
            ev.preventDefault();
            if (isDragging) return;
            var overlayRect = _$self.elements.overlay.getBoundingClientRect();
            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;
            direction = ev.currentTarget.className.indexOf('vertical') !== -1 ? 'v' : 'h';
            maxWidth = overlayRect.width;
            maxHeight = overlayRect.height;
            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
        }
        function mouseMove(ev) {
            var pageX = ev.pageX;
            var pageY = ev.pageY;
            ev.preventDefault();
            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }
            var deltaX = pageX - originalX;
            var deltaY = pageY - originalY;
            var newHeight = _$self.options.viewport.height + deltaY;
            var newWidth = _$self.options.viewport.width + deltaX;
            if (direction === 'v' && newHeight >= minSize && newHeight <= maxHeight) {
                css(wrap, {
                    height: newHeight + 'px'
                });
                _$self.options.boundary.height += deltaY;
                css(_$self.elements.boundary, {
                    height: _$self.options.boundary.height + 'px'
                });
                _$self.options.viewport.height += deltaY;
                css(_$self.elements.viewport, {
                    height: _$self.options.viewport.height + 'px'
                });
            } else if (direction === 'h' && newWidth >= minSize && newWidth <= maxWidth) {
                css(wrap, {
                    width: newWidth + 'px'
                });
                _$self.options.boundary.width += deltaX;
                css(_$self.elements.boundary, {
                    width: _$self.options.boundary.width + 'px'
                });
                _$self.options.viewport.width += deltaX;
                css(_$self.elements.viewport, {
                    width: _$self.options.viewport.width + 'px'
                });
            }
            _updateOverlay.call(_$self);
            _updateZoomLimits.call(_$self);
            _updateCenterPoint.call(_$self);
            _triggerUpdate.call(_$self);
            originalY = pageY;
            originalX = pageX;
        }
        function mouseUp() {
            isDragging = false;
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
        }
        if (vr) {
            vr.addEventListener('mousedown', mouseDown);
            vr.addEventListener('touchstart', mouseDown);
        }
        if (hr) {
            hr.addEventListener('mousedown', mouseDown);
            hr.addEventListener('touchstart', mouseDown);
        }
        this.elements.boundary.appendChild(wrap);
    }
    function _setZoomerVal(v) {
        if (this.options.enableZoom) {
            var z = this.elements.zoomer, val = fix(v, 4);
            z.value = Math.max(parseFloat(z.min), Math.min(parseFloat(z.max), val)).toString();
        }
    }
    function _initializeZoom() {
        var _$self = this, wrap = _$self.elements.zoomerWrap = document.createElement('div'), zoomer = _$self.elements.zoomer = document.createElement('input');
        addClass(wrap, 'cr-slider-wrap');
        addClass(zoomer, 'cr-slider');
        zoomer.type = 'range';
        zoomer.step = '0.0001';
        zoomer.value = '1';
        zoomer.style.display = _$self.options.showZoomer ? '' : 'none';
        zoomer.setAttribute('aria-label', 'zoom');
        _$self.element.appendChild(wrap);
        wrap.appendChild(zoomer);
        _$self._currentZoom = 1;
        function change() {
            _onZoom.call(_$self, {
                value: parseFloat(zoomer.value),
                origin: new TransformOrigin(_$self.elements.preview),
                viewportRect: _$self.elements.viewport.getBoundingClientRect(),
                transform: Transform.parse(_$self.elements.preview)
            });
        }
        function scroll(ev) {
            var delta, targetZoom;
            if (_$self.options.mouseWheelZoom === 'ctrl' && ev.ctrlKey !== true) return 0;
            else if (ev.wheelDelta) delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
            else if (ev.deltaY) delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
            else if (ev.detail) delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
            else delta = 0;
            targetZoom = _$self._currentZoom + delta * _$self._currentZoom;
            ev.preventDefault();
            _setZoomerVal.call(_$self, targetZoom);
            change.call(_$self);
        }
        _$self.elements.zoomer.addEventListener('input', change); // this is being fired twice on keypress
        _$self.elements.zoomer.addEventListener('change', change);
        if (_$self.options.mouseWheelZoom) {
            _$self.elements.boundary.addEventListener('mousewheel', scroll);
            _$self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
        }
    }
    function _onZoom(ui) {
        var _$self = this, transform = ui ? ui.transform : Transform.parse(_$self.elements.preview), vpRect = ui ? ui.viewportRect : _$self.elements.viewport.getBoundingClientRect(), origin = ui ? ui.origin : new TransformOrigin(_$self.elements.preview);
        function applyCss() {
            var transCss = {};
            transCss[CSS_TRANSFORM] = transform.toString();
            transCss[CSS_TRANS_ORG] = origin.toString();
            css(_$self.elements.preview, transCss);
        }
        _$self._currentZoom = ui ? ui.value : _$self._currentZoom;
        transform.scale = _$self._currentZoom;
        _$self.elements.zoomer.setAttribute('aria-valuenow', _$self._currentZoom);
        applyCss();
        if (_$self.options.enforceBoundary) {
            var boundaries = _getVirtualBoundaries.call(_$self, vpRect), transBoundaries = boundaries.translate, oBoundaries = boundaries.origin;
            if (transform.x >= transBoundaries.maxX) {
                origin.x = oBoundaries.minX;
                transform.x = transBoundaries.maxX;
            }
            if (transform.x <= transBoundaries.minX) {
                origin.x = oBoundaries.maxX;
                transform.x = transBoundaries.minX;
            }
            if (transform.y >= transBoundaries.maxY) {
                origin.y = oBoundaries.minY;
                transform.y = transBoundaries.maxY;
            }
            if (transform.y <= transBoundaries.minY) {
                origin.y = oBoundaries.maxY;
                transform.y = transBoundaries.minY;
            }
        }
        applyCss();
        _debouncedOverlay.call(_$self);
        _triggerUpdate.call(_$self);
    }
    function _getVirtualBoundaries(viewport) {
        var _$self = this, scale = _$self._currentZoom, vpWidth = viewport.width, vpHeight = viewport.height, centerFromBoundaryX = _$self.elements.boundary.clientWidth / 2, centerFromBoundaryY = _$self.elements.boundary.clientHeight / 2, imgRect = _$self.elements.preview.getBoundingClientRect(), curImgWidth = imgRect.width, curImgHeight = imgRect.height, halfWidth = vpWidth / 2, halfHeight = vpHeight / 2;
        var maxX = (halfWidth / scale - centerFromBoundaryX) * -1;
        var minX = maxX - (curImgWidth * (1 / scale) - vpWidth * (1 / scale));
        var maxY = (halfHeight / scale - centerFromBoundaryY) * -1;
        var minY = maxY - (curImgHeight * (1 / scale) - vpHeight * (1 / scale));
        var originMinX = 1 / scale * halfWidth;
        var originMaxX = curImgWidth * (1 / scale) - originMinX;
        var originMinY = 1 / scale * halfHeight;
        var originMaxY = curImgHeight * (1 / scale) - originMinY;
        return {
            translate: {
                maxX: maxX,
                minX: minX,
                maxY: maxY,
                minY: minY
            },
            origin: {
                maxX: originMaxX,
                minX: originMinX,
                maxY: originMaxY,
                minY: originMinY
            }
        };
    }
    function _updateCenterPoint(rotate) {
        var _$self = this, scale = _$self._currentZoom, data = _$self.elements.preview.getBoundingClientRect(), vpData = _$self.elements.viewport.getBoundingClientRect(), transform = Transform.parse(_$self.elements.preview.style[CSS_TRANSFORM]), pc = new TransformOrigin(_$self.elements.preview), top = vpData.top - data.top + vpData.height / 2, left = vpData.left - data.left + vpData.width / 2, center = {}, adj = {};
        if (rotate) {
            var cx = pc.x;
            var cy = pc.y;
            var tx = transform.x;
            var ty = transform.y;
            center.y = cx;
            center.x = cy;
            transform.y = tx;
            transform.x = ty;
        } else {
            center.y = top / scale;
            center.x = left / scale;
            adj.y = (center.y - pc.y) * (1 - scale);
            adj.x = (center.x - pc.x) * (1 - scale);
            transform.x -= adj.x;
            transform.y -= adj.y;
        }
        var newCss = {};
        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
        newCss[CSS_TRANSFORM] = transform.toString();
        css(_$self.elements.preview, newCss);
    }
    function _initDraggable() {
        var _$self = this, isDragging = false, originalX, originalY, originalDistance, vpRect, transform;
        function assignTransformCoordinates(deltaX, deltaY) {
            var imgRect = _$self.elements.preview.getBoundingClientRect(), top = transform.y + deltaY, left = transform.x + deltaX;
            if (_$self.options.enforceBoundary) {
                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) transform.y = top;
                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) transform.x = left;
            } else {
                transform.y = top;
                transform.x = left;
            }
        }
        function toggleGrabState(isDragging) {
            _$self.elements.preview.setAttribute('aria-grabbed', isDragging);
            _$self.elements.boundary.setAttribute('aria-dropeffect', isDragging ? 'move' : 'none');
        }
        function keyDown(ev) {
            var LEFT_ARROW = 37, UP_ARROW = 38, RIGHT_ARROW = 39, DOWN_ARROW = 40;
            if (ev.shiftKey && (ev.keyCode === UP_ARROW || ev.keyCode === DOWN_ARROW)) {
                var zoom;
                if (ev.keyCode === UP_ARROW) zoom = parseFloat(_$self.elements.zoomer.value) + parseFloat(_$self.elements.zoomer.step);
                else zoom = parseFloat(_$self.elements.zoomer.value) - parseFloat(_$self.elements.zoomer.step);
                _$self.setZoom(zoom);
            } else if (_$self.options.enableKeyMovement && ev.keyCode >= 37 && ev.keyCode <= 40) {
                ev.preventDefault();
                var movement = parseKeyDown(ev.keyCode);
                transform = Transform.parse(_$self.elements.preview);
                document.body.style[CSS_USERSELECT] = 'none';
                vpRect = _$self.elements.viewport.getBoundingClientRect();
                keyMove(movement);
            }
            function parseKeyDown(key) {
                switch(key){
                    case LEFT_ARROW:
                        return [
                            1,
                            0
                        ];
                    case UP_ARROW:
                        return [
                            0,
                            1
                        ];
                    case RIGHT_ARROW:
                        return [
                            -1,
                            0
                        ];
                    case DOWN_ARROW:
                        return [
                            0,
                            -1
                        ];
                }
            }
        }
        function keyMove(movement) {
            var deltaX = movement[0], deltaY = movement[1], newCss = {};
            assignTransformCoordinates(deltaX, deltaY);
            newCss[CSS_TRANSFORM] = transform.toString();
            css(_$self.elements.preview, newCss);
            _updateOverlay.call(_$self);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(_$self);
            _triggerUpdate.call(_$self);
            originalDistance = 0;
        }
        function mouseDown(ev) {
            if (ev.button !== undefined && ev.button !== 0) return;
            ev.preventDefault();
            if (isDragging) return;
            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;
            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }
            toggleGrabState(isDragging);
            transform = Transform.parse(_$self.elements.preview);
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
            vpRect = _$self.elements.viewport.getBoundingClientRect();
        }
        function mouseMove(ev) {
            ev.preventDefault();
            var pageX = ev.pageX, pageY = ev.pageY;
            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }
            var deltaX = pageX - originalX, deltaY = pageY - originalY, newCss = {};
            if (ev.type === 'touchmove') {
                if (ev.touches.length > 1) {
                    var touch1 = ev.touches[0];
                    var touch2 = ev.touches[1];
                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));
                    if (!originalDistance) originalDistance = dist / _$self._currentZoom;
                    var scale = dist / originalDistance;
                    _setZoomerVal.call(_$self, scale);
                    dispatchChange(_$self.elements.zoomer);
                    return;
                }
            }
            assignTransformCoordinates(deltaX, deltaY);
            newCss[CSS_TRANSFORM] = transform.toString();
            css(_$self.elements.preview, newCss);
            _updateOverlay.call(_$self);
            originalY = pageY;
            originalX = pageX;
        }
        function mouseUp() {
            isDragging = false;
            toggleGrabState(isDragging);
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(_$self);
            _triggerUpdate.call(_$self);
            originalDistance = 0;
        }
        _$self.elements.overlay.addEventListener('mousedown', mouseDown);
        _$self.elements.viewport.addEventListener('keydown', keyDown);
        _$self.elements.overlay.addEventListener('touchstart', mouseDown);
    }
    function _updateOverlay() {
        if (!this.elements) return; // since this is debounced, it can be fired after destroy
        var _$self = this, boundRect = _$self.elements.boundary.getBoundingClientRect(), imgData = _$self.elements.preview.getBoundingClientRect();
        css(_$self.elements.overlay, {
            width: imgData.width + 'px',
            height: imgData.height + 'px',
            top: imgData.top - boundRect.top + 'px',
            left: imgData.left - boundRect.left + 'px'
        });
    }
    var _debouncedOverlay = debounce(_updateOverlay, 500);
    function _triggerUpdate() {
        var _$self = this, data = _$self.get();
        if (!_isVisible.call(_$self)) return;
        _$self.options.update.call(_$self, data);
        if (_$self.$ && typeof Prototype === 'undefined') _$self.$(_$self.element).trigger('update.croppie', data);
        else {
            var ev;
            if (window.CustomEvent) ev = new CustomEvent('update', {
                detail: data
            });
            else {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('update', true, true, data);
            }
            _$self.element.dispatchEvent(ev);
        }
    }
    function _isVisible() {
        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
    }
    function _updatePropertiesFromImage() {
        var _$self = this, initialZoom = 1, cssReset = {}, img = _$self.elements.preview, imgData, transformReset = new Transform(0, 0, initialZoom), originReset = new TransformOrigin(), isVisible = _isVisible.call(_$self);
        if (!isVisible || _$self.data.bound) return;
        _$self.data.bound = true;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        cssReset[CSS_TRANS_ORG] = originReset.toString();
        cssReset['opacity'] = 1;
        css(img, cssReset);
        imgData = _$self.elements.preview.getBoundingClientRect();
        _$self._originalImageWidth = imgData.width;
        _$self._originalImageHeight = imgData.height;
        _$self.data.orientation = _hasExif.call(_$self) ? getExifOrientation(_$self.elements.img) : _$self.data.orientation;
        if (_$self.options.enableZoom) _updateZoomLimits.call(_$self, true);
        else _$self._currentZoom = initialZoom;
        transformReset.scale = _$self._currentZoom;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        css(img, cssReset);
        if (_$self.data.points.length) _bindPoints.call(_$self, _$self.data.points);
        else _centerImage.call(_$self);
        _updateCenterPoint.call(_$self);
        _updateOverlay.call(_$self);
    }
    function _updateZoomLimits(initial) {
        var _$self = this, minZoom = Math.max(_$self.options.minZoom, 0) || 0, maxZoom = _$self.options.maxZoom || 1.5, initialZoom, defaultInitialZoom, zoomer = _$self.elements.zoomer, scale = parseFloat(zoomer.value), boundaryData = _$self.elements.boundary.getBoundingClientRect(), imgData = naturalImageDimensions(_$self.elements.img, _$self.data.orientation), vpData = _$self.elements.viewport.getBoundingClientRect(), minW, minH;
        if (_$self.options.enforceBoundary) {
            minW = vpData.width / imgData.width;
            minH = vpData.height / imgData.height;
            minZoom = Math.max(minW, minH);
        }
        if (minZoom >= maxZoom) maxZoom = minZoom + 1;
        zoomer.min = fix(minZoom, 4);
        zoomer.max = fix(maxZoom, 4);
        if (!initial && (scale < zoomer.min || scale > zoomer.max)) _setZoomerVal.call(_$self, scale < zoomer.min ? zoomer.min : zoomer.max);
        else if (initial) {
            defaultInitialZoom = Math.max(boundaryData.width / imgData.width, boundaryData.height / imgData.height);
            initialZoom = _$self.data.boundZoom !== null ? _$self.data.boundZoom : defaultInitialZoom;
            _setZoomerVal.call(_$self, initialZoom);
        }
        dispatchChange(zoomer);
    }
    function _bindPoints(points) {
        if (points.length !== 4) throw "Croppie - Invalid number of points supplied: " + points;
        var _$self = this, pointsWidth = points[2] - points[0], // pointsHeight = points[3] - points[1],
        vpData = _$self.elements.viewport.getBoundingClientRect(), boundRect = _$self.elements.boundary.getBoundingClientRect(), vpOffset = {
            left: vpData.left - boundRect.left,
            top: vpData.top - boundRect.top
        }, scale = vpData.width / pointsWidth, originTop = points[1], originLeft = points[0], transformTop = -1 * points[1] + vpOffset.top, transformLeft = -1 * points[0] + vpOffset.left, newCss = {};
        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
        css(_$self.elements.preview, newCss);
        _setZoomerVal.call(_$self, scale);
        _$self._currentZoom = scale;
    }
    function _centerImage() {
        var _$self = this, imgDim = _$self.elements.preview.getBoundingClientRect(), vpDim = _$self.elements.viewport.getBoundingClientRect(), boundDim = _$self.elements.boundary.getBoundingClientRect(), vpLeft = vpDim.left - boundDim.left, vpTop = vpDim.top - boundDim.top, w = vpLeft - (imgDim.width - vpDim.width) / 2, h = vpTop - (imgDim.height - vpDim.height) / 2, transform = new Transform(w, h, _$self._currentZoom);
        css(_$self.elements.preview, CSS_TRANSFORM, transform.toString());
    }
    function _transferImageToCanvas(customOrientation) {
        var _$self = this, canvas = _$self.elements.canvas, img = _$self.elements.img, ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = img.width;
        canvas.height = img.height;
        var orientation = _$self.options.enableOrientation && customOrientation || getExifOrientation(img);
        drawCanvas(canvas, img, orientation);
    }
    function _getCanvas(data) {
        var _$self = this, points = data.points, left = num(points[0]), top = num(points[1]), right = num(points[2]), bottom = num(points[3]), width = right - left, height = bottom - top, circle = data.circle, canvas = document.createElement('canvas'), ctx = canvas.getContext('2d'), startX = 0, startY = 0, canvasWidth = data.outputWidth || width, canvasHeight = data.outputHeight || height;
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        if (data.backgroundColor) {
            ctx.fillStyle = data.backgroundColor;
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        }
        // By default assume we're going to draw the entire
        // source image onto the destination canvas.
        var sx = left, sy = top, sWidth = width, sHeight = height, dx = 0, dy = 0, dWidth = canvasWidth, dHeight = canvasHeight;
        //
        // Do not go outside of the original image's bounds along the x-axis.
        // Handle translations when projecting onto the destination canvas.
        //
        // The smallest possible source x-position is 0.
        if (left < 0) {
            sx = 0;
            dx = Math.abs(left) / width * canvasWidth;
        }
        // The largest possible source width is the original image's width.
        if (sWidth + sx > _$self._originalImageWidth) {
            sWidth = _$self._originalImageWidth - sx;
            dWidth = sWidth / width * canvasWidth;
        }
        //
        // Do not go outside of the original image's bounds along the y-axis.
        //
        // The smallest possible source y-position is 0.
        if (top < 0) {
            sy = 0;
            dy = Math.abs(top) / height * canvasHeight;
        }
        // The largest possible source height is the original image's height.
        if (sHeight + sy > _$self._originalImageHeight) {
            sHeight = _$self._originalImageHeight - sy;
            dHeight = sHeight / height * canvasHeight;
        }
        // console.table({ left, right, top, bottom, canvasWidth, canvasHeight, width, height, startX, startY, circle, sx, sy, dx, dy, sWidth, sHeight, dWidth, dHeight });
        ctx.drawImage(this.elements.preview, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        if (circle) {
            ctx.fillStyle = '#fff';
            ctx.globalCompositeOperation = 'destination-in';
            ctx.beginPath();
            ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
        }
        return canvas;
    }
    function _getHtmlResult(data) {
        var points = data.points, div = document.createElement('div'), img = document.createElement('img'), width = points[2] - points[0], height = points[3] - points[1];
        addClass(div, 'croppie-result');
        div.appendChild(img);
        css(img, {
            left: -1 * points[0] + 'px',
            top: -1 * points[1] + 'px'
        });
        img.src = data.url;
        css(div, {
            width: width + 'px',
            height: height + 'px'
        });
        return div;
    }
    function _getBase64Result(data) {
        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
    }
    function _getBlobResult(data) {
        var _$self = this;
        return new Promise(function(resolve) {
            _getCanvas.call(_$self, data).toBlob(function(blob) {
                resolve(blob);
            }, data.format, data.quality);
        });
    }
    function _replaceImage(img) {
        if (this.elements.img.parentNode) {
            Array.prototype.forEach.call(this.elements.img.classList, function(c) {
                img.classList.add(c);
            });
            this.elements.img.parentNode.replaceChild(img, this.elements.img);
            this.elements.preview = img; // if the img is attached to the DOM, they're not using the canvas
        }
        this.elements.img = img;
    }
    function _bind(options, cb) {
        var _$self = this, url, points = [], zoom = null, hasExif = _hasExif.call(_$self);
        if (typeof options === 'string') {
            url = options;
            options = {};
        } else if (Array.isArray(options)) points = options.slice();
        else if (typeof options === 'undefined' && _$self.data.url) {
            _updatePropertiesFromImage.call(_$self);
            _triggerUpdate.call(_$self);
            return null;
        } else {
            url = options.url;
            points = options.points || [];
            zoom = typeof options.zoom === 'undefined' ? null : options.zoom;
        }
        _$self.data.bound = false;
        _$self.data.url = url || _$self.data.url;
        _$self.data.boundZoom = zoom;
        return loadImage(url, hasExif).then(function(img) {
            _replaceImage.call(_$self, img);
            if (!points.length) {
                var natDim = naturalImageDimensions(img);
                var rect = _$self.elements.viewport.getBoundingClientRect();
                var aspectRatio = rect.width / rect.height;
                var imgAspectRatio = natDim.width / natDim.height;
                var width, height;
                if (imgAspectRatio > aspectRatio) {
                    height = natDim.height;
                    width = height * aspectRatio;
                } else {
                    width = natDim.width;
                    height = natDim.height / aspectRatio;
                }
                var x0 = (natDim.width - width) / 2;
                var y0 = (natDim.height - height) / 2;
                var x1 = x0 + width;
                var y1 = y0 + height;
                _$self.data.points = [
                    x0,
                    y0,
                    x1,
                    y1
                ];
            } else if (_$self.options.relative) points = [
                points[0] * img.naturalWidth / 100,
                points[1] * img.naturalHeight / 100,
                points[2] * img.naturalWidth / 100,
                points[3] * img.naturalHeight / 100
            ];
            _$self.data.orientation = options.orientation || 1;
            _$self.data.points = points.map(function(p) {
                return parseFloat(p);
            });
            if (_$self.options.useCanvas) _transferImageToCanvas.call(_$self, _$self.data.orientation);
            _updatePropertiesFromImage.call(_$self);
            _triggerUpdate.call(_$self);
            cb && cb();
        });
    }
    function fix(v, decimalPoints) {
        return parseFloat(v).toFixed(decimalPoints || 0);
    }
    function _get() {
        var _$self = this, imgData = _$self.elements.preview.getBoundingClientRect(), vpData = _$self.elements.viewport.getBoundingClientRect(), x1 = vpData.left - imgData.left, y1 = vpData.top - imgData.top, widthDiff = (vpData.width - _$self.elements.viewport.offsetWidth) / 2, heightDiff = (vpData.height - _$self.elements.viewport.offsetHeight) / 2, x2 = x1 + _$self.elements.viewport.offsetWidth + widthDiff, y2 = y1 + _$self.elements.viewport.offsetHeight + heightDiff, scale = _$self._currentZoom;
        if (scale === Infinity || isNaN(scale)) scale = 1;
        var max = _$self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
        x1 = Math.max(max, x1 / scale);
        y1 = Math.max(max, y1 / scale);
        x2 = Math.max(max, x2 / scale);
        y2 = Math.max(max, y2 / scale);
        return {
            points: [
                fix(x1),
                fix(y1),
                fix(x2),
                fix(y2)
            ],
            zoom: scale,
            orientation: _$self.data.orientation
        };
    }
    var RESULT_DEFAULTS = {
        type: 'canvas',
        format: 'png',
        quality: 1
    }, RESULT_FORMATS = [
        'jpeg',
        'webp',
        'png'
    ];
    function _result(options) {
        var _$self = this, data = _get.call(_$self), opts = deepExtend(clone(RESULT_DEFAULTS), clone(options)), resultType = typeof options === 'string' ? options : opts.type || 'base64', size = opts.size || 'viewport', format = opts.format, quality = opts.quality, backgroundColor = opts.backgroundColor, circle = typeof opts.circle === 'boolean' ? opts.circle : _$self.options.viewport.type === 'circle', vpRect = _$self.elements.viewport.getBoundingClientRect(), ratio = vpRect.width / vpRect.height, prom;
        if (size === 'viewport') {
            data.outputWidth = vpRect.width;
            data.outputHeight = vpRect.height;
        } else if ((typeof size === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(size)) === 'object') {
            if (size.width && size.height) {
                data.outputWidth = size.width;
                data.outputHeight = size.height;
            } else if (size.width) {
                data.outputWidth = size.width;
                data.outputHeight = size.width / ratio;
            } else if (size.height) {
                data.outputWidth = size.height * ratio;
                data.outputHeight = size.height;
            }
        }
        if (RESULT_FORMATS.indexOf(format) > -1) {
            data.format = 'image/' + format;
            data.quality = quality;
        }
        data.circle = circle;
        data.url = _$self.data.url;
        data.backgroundColor = backgroundColor;
        prom = new Promise(function(resolve) {
            switch(resultType.toLowerCase()){
                case 'rawcanvas':
                    resolve(_getCanvas.call(_$self, data));
                    break;
                case 'canvas':
                case 'base64':
                    resolve(_getBase64Result.call(_$self, data));
                    break;
                case 'blob':
                    _getBlobResult.call(_$self, data).then(resolve);
                    break;
                default:
                    resolve(_getHtmlResult.call(_$self, data));
                    break;
            }
        });
        return prom;
    }
    function _refresh() {
        _updatePropertiesFromImage.call(this);
    }
    function _rotate(deg) {
        if (!this.options.useCanvas || !this.options.enableOrientation) throw 'Croppie: Cannot rotate without enableOrientation && EXIF.js included';
        var _$self = this, canvas = _$self.elements.canvas;
        _$self.data.orientation = getExifOffset(_$self.data.orientation, deg);
        drawCanvas(canvas, _$self.elements.img, _$self.data.orientation);
        _updateCenterPoint.call(_$self, true);
        _updateZoomLimits.call(_$self);
        // Reverses image dimensions if the degrees of rotation is not divisible by 180.
        if (Math.abs(deg) / 90 % 2 === 1) {
            var oldHeight = _$self._originalImageHeight;
            var oldWidth = _$self._originalImageWidth;
            _$self._originalImageWidth = oldHeight;
            _$self._originalImageHeight = oldWidth;
        }
    }
    function _destroy() {
        var _$self = this;
        _$self.element.removeChild(_$self.elements.boundary);
        removeClass(_$self.element, 'croppie-container');
        if (_$self.options.enableZoom) _$self.element.removeChild(_$self.elements.zoomerWrap);
        delete _$self.elements;
    }
    if (typeof window !== 'undefined' && window.jQuery) {
        var $ = window.jQuery;
        $.fn.croppie = function(opts) {
            var ot = typeof opts === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(opts);
            if (ot === 'string') {
                var args = Array.prototype.slice.call(arguments, 1);
                var singleInst = $(this).data('croppie');
                if (opts === 'get') return singleInst.get();
                else if (opts === 'result') return singleInst.result.apply(singleInst, args);
                else if (opts === 'bind') return singleInst.bind.apply(singleInst, args);
                return this.each(function() {
                    var i = $(this).data('croppie');
                    if (!i) return;
                    var method = i[opts];
                    if ($.isFunction(method)) {
                        method.apply(i, args);
                        if (opts === 'destroy') $(this).removeData('croppie');
                    } else throw 'Croppie ' + opts + ' method not found';
                });
            } else return this.each(function() {
                var i = new Croppie(this, opts);
                i.$ = $;
                $(this).data('croppie', i);
            });
        };
    }
    function Croppie(element, opts) {
        if (element.className.indexOf('croppie-container') > -1) throw new Error("Croppie: Can't initialize croppie more than once");
        this.element = element;
        this.options = deepExtend(clone(Croppie.defaults), opts);
        if (this.element.tagName.toLowerCase() === 'img') {
            var origImage = this.element;
            addClass(origImage, 'cr-original-image');
            setAttributes(origImage, {
                'aria-hidden': 'true',
                alt: ''
            });
            var replacementDiv = document.createElement('div');
            this.element.parentNode.appendChild(replacementDiv);
            replacementDiv.appendChild(origImage);
            this.element = replacementDiv;
            this.options.url = this.options.url || origImage.src;
        }
        _create.call(this);
        if (this.options.url) {
            var bindOpts = {
                url: this.options.url,
                points: this.options.points
            };
            delete this.options['url'];
            delete this.options['points'];
            _bind.call(this, bindOpts);
        }
    }
    Croppie.defaults = {
        viewport: {
            width: 100,
            height: 100,
            type: 'square'
        },
        boundary: {},
        orientationControls: {
            enabled: true,
            leftClass: '',
            rightClass: ''
        },
        resizeControls: {
            width: true,
            height: true
        },
        customClass: '',
        showZoomer: true,
        enableZoom: true,
        enableResize: false,
        mouseWheelZoom: true,
        enableExif: false,
        enforceBoundary: true,
        enableOrientation: false,
        enableKeyMovement: true,
        update: function update() {}
    };
    Croppie.globals = {
        translate: 'translate3d'
    };
    deepExtend(Croppie.prototype, {
        bind: function bind(options, cb) {
            return _bind.call(this, options, cb);
        },
        get: function get() {
            var data = _get.call(this);
            var points = data.points;
            if (this.options.relative) {
                points[0] /= this.elements.img.naturalWidth / 100;
                points[1] /= this.elements.img.naturalHeight / 100;
                points[2] /= this.elements.img.naturalWidth / 100;
                points[3] /= this.elements.img.naturalHeight / 100;
            }
            return data;
        },
        result: function result(type) {
            return _result.call(this, type);
        },
        refresh: function refresh() {
            return _refresh.call(this);
        },
        setZoom: function setZoom(v) {
            _setZoomerVal.call(this, v);
            dispatchChange(this.elements.zoomer);
        },
        rotate: function rotate(deg) {
            _rotate.call(this, deg);
        },
        destroy: function destroy() {
            return _destroy.call(this);
        }
    });
    return Croppie;
});


function $4b0d497bb10f4929$var$_defineProperty(e, r, t) {
    return (r = $4b0d497bb10f4929$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4b0d497bb10f4929$var$_toPropertyKey(t) {
    var i = $4b0d497bb10f4929$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $4b0d497bb10f4929$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4b0d497bb10f4929$var$ProfilePhotoFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(ProfilePhotoFormField, AbstractFormField);
    function ProfilePhotoFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ProfilePhotoFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, ProfilePhotoFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'profile_photo'
            })
        ]);
        $4b0d497bb10f4929$var$_defineProperty(_this, "acceptedTypes", new Set([
            'image/jpeg',
            'image/png',
            'image/webp'
        ]));
        $4b0d497bb10f4929$var$_defineProperty(_this, "maxFileSize", 8388608);
        $4b0d497bb10f4929$var$_defineProperty(_this, "maxWidth", 1024);
        $4b0d497bb10f4929$var$_defineProperty(_this, "minResolution", 512);
        $4b0d497bb10f4929$var$_defineProperty(_this, "cropTarget", null);
        $4b0d497bb10f4929$var$_defineProperty(_this, "error", null);
        $4b0d497bb10f4929$var$_defineProperty(_this, "hasImage", false);
        _this.input = element.querySelectorAll('input')[0];
        _this.cropTarget = element.querySelectorAll('.cropper')[0];
        _this.errorTarget = element.querySelectorAll('.photo-error')[0];
        _this.requiredError = _this.errorTarget.textContent.trim();
        _this.existingValue = element.dataset.value;
        if (_this.existingValue) {
            _this.croppie = new (0, (/*@__PURE__*/$parcel$interopDefault($8ee1d0e5da9427cf$exports)))(_this.cropTarget, {
                enableResize: true,
                enableExif: true,
                viewport: {
                    width: 200,
                    height: 270
                },
                boundary: {
                    width: 300,
                    height: 300
                }
            });
            _this.croppie.bind({
                url: _this.existingValue
            });
            _this.hasImage = true;
            _this.cropTarget.classList.add('active');
        } else _this.croppie = new (0, (/*@__PURE__*/$parcel$interopDefault($8ee1d0e5da9427cf$exports)))(_this.cropTarget, {
            enableResize: true,
            enableExif: true,
            viewport: {
                width: 200,
                height: 270
            },
            boundary: {
                width: 300,
                height: 300
            }
        });
        var readFile = function() {
            var input = _this.input;
            _this.element.classList.remove('has-error');
            var that = _this;
            if (input.files && input.files[0]) {
                var file = input.files[0];
                if (!_this.acceptedTypes.has(file.type)) {
                    _this.showError('Choose a JPG, PNG, or WebP image.');
                    input.value = '';
                    return;
                }
                if (file.size > _this.maxFileSize) {
                    _this.showError('Choose an image no larger than 8 MB.');
                    input.value = '';
                    return;
                }
                var reader = new FileReader();
                reader.onload = function readFile(e) {
                    that.cropTarget.classList.add('active');
                    that.croppie.bind({
                        url: e.target.result
                    }).then(function() {
                        that.hasImage = true;
                        that.resetError();
                    })["catch"](function() {
                        that.hasImage = false;
                        that.showError('We could not read this image. Please try another image.');
                    });
                };
                reader.readAsDataURL(file);
            }
        };
        _this.input.addEventListener('change', readFile.bind(_this));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ProfilePhotoFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var points, width, height, scale, blob, scale1;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.hasImage) return [
                                    2,
                                    null
                                ];
                                points = this.croppie.get().points;
                                width = Math.max(1, Math.floor(points[2] - points[0]));
                                height = Math.max(1, Math.floor(points[3] - points[1]));
                                scale = Math.min(1, this.maxWidth / width);
                                width = Math.max(1, Math.floor(width * scale));
                                height = Math.max(1, Math.floor(height * scale));
                                return [
                                    4,
                                    this.croppie.result({
                                        type: 'blob',
                                        size: {
                                            width: width,
                                            height: height
                                        },
                                        format: 'jpeg',
                                        quality: 0.9
                                    })
                                ];
                            case 1:
                                blob = _state.sent();
                                if (blob.size <= this.maxFileSize) return [
                                    2,
                                    blob
                                ];
                                _state.label = 2;
                            case 2:
                                if (!(blob.size > this.maxFileSize && width > 1 && height > 1)) return [
                                    3,
                                    4
                                ];
                                scale1 = Math.min(0.9, Math.sqrt(this.maxFileSize / blob.size) * 0.95);
                                width = Math.max(1, Math.floor(width * scale1));
                                height = Math.max(1, Math.floor(height * scale1));
                                return [
                                    4,
                                    this.croppie.result({
                                        type: 'blob',
                                        size: {
                                            width: width,
                                            height: height
                                        },
                                        format: 'jpeg',
                                        quality: 0.9
                                    })
                                ];
                            case 3:
                                blob = _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 4:
                                return [
                                    2,
                                    blob
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.hasImage) {
                    if (this.isRequired) this.showError(this.requiredError);
                    return !this.isRequired;
                }
                var points = this.croppie.get().points;
                var width = Math.max(1, Math.floor(points[2] - points[0]));
                var height = Math.max(1, Math.floor(points[3] - points[1]));
                var scale = Math.min(1, this.maxWidth / width);
                if (Math.floor(width * scale) < this.minResolution || Math.floor(height * scale) < this.minResolution) {
                    this.showError("The cropped photo must be at least 512 \xd7 512 pixels. Zoom out or choose a larger image.");
                    return false;
                }
                this.resetError();
                return true;
            }
        },
        {
            key: "showError",
            value: function showError(message) {
                this.element.classList.add('has-error');
                this.errorTarget.textContent = message;
                this.errorTarget.classList.remove('hidden');
            }
        },
        {
            key: "resetError",
            value: function resetError() {
                this.element.classList.remove('has-error');
                this.errorTarget.classList.add('hidden');
            }
        }
    ]);
    return ProfilePhotoFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $4b0d497bb10f4929$export$2e2bcd8739ae039 = $4b0d497bb10f4929$var$ProfilePhotoFormField;















function $f397827bc6340d08$var$_defineProperty(e, r, t) {
    return (r = $f397827bc6340d08$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f397827bc6340d08$var$_toPropertyKey(t) {
    var i = $f397827bc6340d08$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $f397827bc6340d08$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f397827bc6340d08$var$AbstractSurveyFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(AbstractSurveyFormField, AbstractFormField);
    function AbstractSurveyFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AbstractSurveyFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, AbstractSurveyFormField, [
            element,
            options
        ]);
        $f397827bc6340d08$var$_defineProperty(_this, "number", null);
        _this.number = element.querySelectorAll(".question-number")[0];
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AbstractSurveyFormField, [
        {
            key: "setNumber",
            value: function setNumber(number) {
                this.number.innerHTML = number;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                this.element.classList.remove("active");
            }
        },
        {
            key: "activate",
            value: function activate() {
                this.element.classList.remove("active");
                this.element.classList.add("active");
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.element.classList.contains("active");
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired || !this.isActive()) return true;
                return this.getValue().trim() !== "";
            }
        }
    ]);
    return AbstractSurveyFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $f397827bc6340d08$export$2e2bcd8739ae039 = $f397827bc6340d08$var$AbstractSurveyFormField;


function $eab7bf3dd07de7a6$var$_defineProperty(e, r, t) {
    return (r = $eab7bf3dd07de7a6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $eab7bf3dd07de7a6$var$_toPropertyKey(t) {
    var i = $eab7bf3dd07de7a6$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $eab7bf3dd07de7a6$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $eab7bf3dd07de7a6$var$SurveyCheckboxFormField = /*#__PURE__*/ function(AbstractSurveyFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SurveyCheckboxFormField, AbstractSurveyFormField);
    function SurveyCheckboxFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SurveyCheckboxFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SurveyCheckboxFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: "survey_checkbox"
            })
        ]);
        $eab7bf3dd07de7a6$var$_defineProperty(_this, "options", []);
        $eab7bf3dd07de7a6$var$_defineProperty(_this, "other", null);
        var items = _this.element.getElementsByClassName("form-check-input");
        for(var i = 0; i < items.length; i++){
            _this.options.push(items[i]);
            items[i].addEventListener("click", _this.handleChanges.bind(_this));
        }
        var other = _this.element.getElementsByClassName("checkbox-other");
        if (other.length) {
            _this.other = other[0];
            _this.other.addEventListener("keyup", _this.handleChanges.bind(_this));
        }
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SurveyCheckboxFormField, [
        {
            key: "getValue",
            value: function getValue() {
                var values = [];
                this.options.forEach(function(item) {
                    if (item.checked) values.push(item.value);
                });
                if (this.other && this.other.value.length) values.push(this.other.value);
                return values.join(", ");
            }
        }
    ]);
    return SurveyCheckboxFormField;
}((0, $f397827bc6340d08$export$2e2bcd8739ae039));
var $eab7bf3dd07de7a6$export$2e2bcd8739ae039 = $eab7bf3dd07de7a6$var$SurveyCheckboxFormField;










function $122883f94a549514$var$_defineProperty(e, r, t) {
    return (r = $122883f94a549514$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $122883f94a549514$var$_toPropertyKey(t) {
    var i = $122883f94a549514$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $122883f94a549514$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $122883f94a549514$var$SurveyRadioBoxesFormField = /*#__PURE__*/ function(AbstractSurveyFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SurveyRadioBoxesFormField, AbstractSurveyFormField);
    function SurveyRadioBoxesFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SurveyRadioBoxesFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SurveyRadioBoxesFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'survey_radio_boxes'
            })
        ]);
        $122883f94a549514$var$_defineProperty(_this, "options", []);
        $122883f94a549514$var$_defineProperty(_this, "other", null);
        $122883f94a549514$var$_defineProperty(_this, "otherInput", null);
        var items = _this.element.getElementsByClassName('question-option');
        for(var i = 0; i < items.length; i++)_this.options.push(items[i]);
        var other = _this.element.getElementsByClassName('survey-radio-boxes-other');
        if (other.length) {
            _this.other = other[0];
            var _this_other_getElementsByClassName_;
            _this.otherInput = (_this_other_getElementsByClassName_ = _this.other.getElementsByClassName('survey-radio-boxes-other-input')[0]) !== null && _this_other_getElementsByClassName_ !== void 0 ? _this_other_getElementsByClassName_ : null;
        }
        _this.options.forEach(function(option) {
            option.addEventListener('click', function() {
                _this.options.forEach(function(sibling) {
                    return sibling.classList.remove('active');
                });
                option.classList.add('active');
                _this.syncOtherState();
                _this.handleChanges(_this);
            });
        });
        if (_this.otherInput) _this.otherInput.addEventListener('input', _this.handleChanges.bind(_this));
        _this.syncOtherState();
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SurveyRadioBoxesFormField, [
        {
            key: "syncOtherState",
            value: function syncOtherState() {
                if (!this.other) return;
                var otherOption = this.options.find(function(option) {
                    return option.dataset.isOther === '1';
                });
                if (otherOption && otherOption.classList.contains('active')) this.other.classList.add('active');
                else this.other.classList.remove('active');
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                var _this = this;
                var value = '';
                this.options.forEach(function(option) {
                    if (!option.classList.contains('active')) return;
                    if (option.dataset.isOther === '1') {
                        var otherValue = _this.otherInput ? _this.otherInput.value.trim() : '';
                        value = otherValue.length ? "Other: ".concat(otherValue) : 'Other';
                        return;
                    }
                    value = option.dataset.value;
                });
                return value;
            }
        }
    ]);
    return SurveyRadioBoxesFormField;
}((0, $f397827bc6340d08$export$2e2bcd8739ae039));
var $122883f94a549514$export$2e2bcd8739ae039 = $122883f94a549514$var$SurveyRadioBoxesFormField;










function $66b50713caa2e364$var$_defineProperty(e, r, t) {
    return (r = $66b50713caa2e364$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $66b50713caa2e364$var$_toPropertyKey(t) {
    var i = $66b50713caa2e364$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $66b50713caa2e364$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $66b50713caa2e364$var$SurveySelectFormField = /*#__PURE__*/ function(AbstractSurveyFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SurveySelectFormField, AbstractSurveyFormField);
    function SurveySelectFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SurveySelectFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SurveySelectFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: "survey_select"
            })
        ]);
        $66b50713caa2e364$var$_defineProperty(_this, "select", null);
        $66b50713caa2e364$var$_defineProperty(_this, "other", null);
        _this.select = element.querySelectorAll("select")[0];
        var other = _this.element.getElementsByClassName("survey-other");
        if (other.length) {
            _this.other = other[0];
            _this.other.addEventListener("keyup", _this.handleChanges.bind(_this));
        }
        _this.select.addEventListener("change", function() {
            if (_this.other && _this.select.value === "Other") _this.other.classList.add("active");
            else if (_this.other) _this.other.classList.remove("active");
            _this.handleChanges(_this);
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SurveySelectFormField, [
        {
            key: "getValue",
            value: function getValue() {
                var selectValue = this.select.value;
                if (this.other && selectValue === "Other") return "Other: " + this.other.value;
                return this.select.value;
            }
        }
    ]);
    return SurveySelectFormField;
}((0, $f397827bc6340d08$export$2e2bcd8739ae039));
var $66b50713caa2e364$export$2e2bcd8739ae039 = $66b50713caa2e364$var$SurveySelectFormField;









var $1350e248d2af07ac$var$SurveyTextFormField = /*#__PURE__*/ function(AbstractSurveyFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SurveyTextFormField, AbstractSurveyFormField);
    function SurveyTextFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SurveyTextFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SurveyTextFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'survey_text'
            })
        ]);
        _this.input = element.querySelectorAll('textarea')[0];
        _this.input.addEventListener('keyup', _this.handleChanges.bind(_this));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SurveyTextFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return this.input ? this.input.value : '';
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                this.input.value = value;
            }
        }
    ]);
    return SurveyTextFormField;
}((0, $f397827bc6340d08$export$2e2bcd8739ae039));
var $1350e248d2af07ac$export$2e2bcd8739ae039 = $1350e248d2af07ac$var$SurveyTextFormField;










function $542c956b61b64821$var$_defineProperty(e, r, t) {
    return (r = $542c956b61b64821$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $542c956b61b64821$var$_toPropertyKey(t) {
    var i = $542c956b61b64821$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $542c956b61b64821$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $542c956b61b64821$var$SurveyCheckboxButtonsFormField = /*#__PURE__*/ function(AbstractSurveyFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SurveyCheckboxButtonsFormField, AbstractSurveyFormField);
    function SurveyCheckboxButtonsFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SurveyCheckboxButtonsFormField);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SurveyCheckboxButtonsFormField, [
            element,
            (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
                type: 'survey_checkbox_buttons'
            })
        ]);
        $542c956b61b64821$var$_defineProperty(_this, "options", []);
        $542c956b61b64821$var$_defineProperty(_this, "other", null);
        $542c956b61b64821$var$_defineProperty(_this, "otherInput", null);
        var items = _this.element.getElementsByClassName('question-option');
        for(var i = 0; i < items.length; i++)_this.options.push(items[i]);
        _this.options.forEach(function(option) {
            option.addEventListener('click', function() {
                option.classList.toggle('active');
                _this.syncOtherState();
                _this.handleChanges(_this);
            });
        });
        var other = _this.element.getElementsByClassName('survey-checkbox-buttons-other');
        if (other.length) {
            _this.other = other[0];
            var _this_other_getElementsByClassName_;
            _this.otherInput = (_this_other_getElementsByClassName_ = _this.other.getElementsByClassName('survey-checkbox-buttons-other-input')[0]) !== null && _this_other_getElementsByClassName_ !== void 0 ? _this_other_getElementsByClassName_ : null;
        }
        if (_this.otherInput) _this.otherInput.addEventListener('keyup', _this.handleChanges.bind(_this));
        _this.syncOtherState();
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SurveyCheckboxButtonsFormField, [
        {
            key: "syncOtherState",
            value: function syncOtherState() {
                if (!this.other) return;
                var otherOption = this.options.find(function(option) {
                    return option.dataset.isOther === '1';
                });
                if (otherOption && otherOption.classList.contains('active')) this.other.classList.add('active');
                else this.other.classList.remove('active');
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                var _this = this;
                var values = [];
                this.options.forEach(function(option) {
                    if (!option.classList.contains('active')) return;
                    if (option.dataset.isOther === '1') {
                        var otherValue = _this.otherInput ? _this.otherInput.value.trim() : '';
                        values.push(otherValue.length ? "Other: ".concat(otherValue) : 'Other');
                        return;
                    }
                    values.push(option.dataset.value);
                });
                return values.join(', ');
            }
        }
    ]);
    return SurveyCheckboxButtonsFormField;
}((0, $f397827bc6340d08$export$2e2bcd8739ae039));
var $542c956b61b64821$export$2e2bcd8739ae039 = $542c956b61b64821$var$SurveyCheckboxButtonsFormField;


function $16da752e42cc99d4$var$_defineProperty(e, r, t) {
    return (r = $16da752e42cc99d4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $16da752e42cc99d4$var$_toPropertyKey(t) {
    var i = $16da752e42cc99d4$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $16da752e42cc99d4$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $16da752e42cc99d4$var$FormFields = /*#__PURE__*/ function() {
    "use strict";
    function FormFields(parent) {
        var onValidate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, selector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'data-field-name';
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, FormFields);
        $16da752e42cc99d4$var$_defineProperty(this, "firstValidated", false);
        $16da752e42cc99d4$var$_defineProperty(this, "onValidate", null);
        $16da752e42cc99d4$var$_defineProperty(this, "name", null);
        $16da752e42cc99d4$var$_defineProperty(this, "fields", []);
        $16da752e42cc99d4$var$_defineProperty(this, "map", {
            radios: (0, $0e971c5a04e686db$export$2e2bcd8739ae039),
            checkbox: (0, $bc7011be64c26b4e$export$2e2bcd8739ae039),
            checkbox_other: (0, $8279f1a00c51d7f9$export$2e2bcd8739ae039),
            input: (0, $179db65871bc5893$export$2e2bcd8739ae039),
            date: (0, $e338b6351d28b1c9$export$2e2bcd8739ae039),
            select: (0, $37f74405e557560a$export$2e2bcd8739ae039),
            profile_photo: (0, $4b0d497bb10f4929$export$2e2bcd8739ae039),
            survey_checkboxes: (0, $eab7bf3dd07de7a6$export$2e2bcd8739ae039),
            survey_radio_boxes: (0, $122883f94a549514$export$2e2bcd8739ae039),
            survey_select: (0, $66b50713caa2e364$export$2e2bcd8739ae039),
            survey_text: (0, $1350e248d2af07ac$export$2e2bcd8739ae039),
            survey_checkbox_buttons: (0, $542c956b61b64821$export$2e2bcd8739ae039)
        });
        this.onValidate = onValidate;
        var fields = parent.querySelectorAll("[".concat(selector, "]"));
        this.name = parent.getAttribute('name');
        for(var i = 0; i < fields.length; i++){
            var el = fields[i];
            var name = el.dataset.fieldName || el.dataset.surveyFieldName;
            var type = el.dataset.fieldType;
            var isRequired = el.dataset.fieldRequired === '1';
            var FieldClass = typeof this.map[type] !== 'undefined' ? this.map[type] : null;
            if (FieldClass) this.fields.push(new FieldClass(el, {
                name: name,
                isRequired: isRequired
            }));
        }
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(FormFields, [
        {
            key: "validate",
            value: function validate() {
                var isValid = true;
                this.fields.forEach(function(field) {
                    field.validate();
                    isValid = isValid && field.isValid();
                });
                if (!this.firstValidated && !isValid) {
                    this.firstValidated = true;
                    this.validateOnChange();
                }
                if (this.onValidate) this.onValidate(isValid);
                return isValid;
            }
        },
        {
            key: "validateOnChange",
            value: function validateOnChange() {
                var _this = this;
                this.fields.forEach(function(field) {
                    return field.onChange(_this.validate.bind(_this));
                });
            }
        },
        {
            key: "setValue",
            value: function setValue(name, value) {
                this.fields.forEach(function(field) {
                    if (field.getName() === name) field.setValue(value);
                });
            }
        },
        {
            key: "getFields",
            value: function getFields() {
                return this.fields;
            }
        },
        {
            key: "getRequiredFields",
            value: function getRequiredFields() {
                var items = [];
                this.fields.forEach(function(field) {
                    if (field.isRequired) items.push(field);
                });
                return items;
            }
        },
        {
            key: "getDataObject",
            value: function getDataObject() {
                var data = {};
                this.fields.forEach(function(field) {
                    if (field.getValue()) data[field.getName()] = field.getValue();
                });
                return data;
            }
        },
        {
            key: "getDataObjectAsync",
            value: function getDataObjectAsync() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var data, entries;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = this.getDataObject();
                                return [
                                    4,
                                    Promise.all(Object.entries(data).map(function(param) {
                                        var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                                            var _tmp;
                                            return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = [
                                                            name
                                                        ];
                                                        return [
                                                            4,
                                                            value
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _tmp.concat([
                                                                _state.sent()
                                                            ])
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 1:
                                entries = _state.sent();
                                return [
                                    2,
                                    Object.fromEntries(entries)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var data = new FormData();
                var object = this.getDataObject();
                Object.keys(object).forEach(function(key) {
                    data.append(key, object[key]);
                });
                return data;
            }
        }
    ]);
    return FormFields;
}();
var $16da752e42cc99d4$export$2e2bcd8739ae039 = $16da752e42cc99d4$var$FormFields;








function $280589c83433d17c$var$_defineProperty(e, r, t) {
    return (r = $280589c83433d17c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $280589c83433d17c$var$_toPropertyKey(t) {
    var i = $280589c83433d17c$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $280589c83433d17c$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $280589c83433d17c$var$SurveyFormFields = /*#__PURE__*/ function(FormFields) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(SurveyFormFields, FormFields);
    function SurveyFormFields(parent, onValidate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SurveyFormFields);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, SurveyFormFields, [
            parent,
            onValidate,
            'data-survey-field-name'
        ]);
        $280589c83433d17c$var$_defineProperty(_this, "logic", {
            rules: []
        });
        _this.logic = _this.parseLogic(parent.dataset.logic);
        _this.showSurveyQuestions();
        _this.fields.forEach(function(field) {
            return field.onChange(_this.showSurveyQuestions.bind(_this));
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SurveyFormFields, [
        {
            key: "parseLogic",
            value: function parseLogic(encodedLogic) {
                if (!encodedLogic) return {
                    rules: [],
                    numbering: {
                        mode: 'automatic'
                    }
                };
                try {
                    var logic = JSON.parse(atob(encodedLogic));
                    return {
                        rules: Array.isArray(logic.rules) ? logic.rules : [],
                        conditional: Array.isArray(logic.conditional) ? logic.conditional : null,
                        numbering: logic.numbering && (0, $0cd339a6e98df7f5$export$71511d61b312f219)(logic.numbering) === 'object' ? logic.numbering : {
                            mode: 'automatic'
                        }
                    };
                } catch (error) {
                    return {
                        rules: [],
                        numbering: {
                            mode: 'automatic'
                        }
                    };
                }
            }
        },
        {
            key: "showSurveyQuestions",
            value: function showSurveyQuestions() {
                var _this, _loop = function(i) {
                    var changed = false;
                    _this.logic.rules.forEach(function(rule) {
                        if (!_this1.ruleMatches(rule)) return;
                        (rule.then || []).forEach(function(fieldName) {
                            var field = fieldByName.get(fieldName);
                            if (field && !field.isActive()) {
                                field.activate();
                                changed = true;
                            }
                        });
                    });
                    if (!changed) return "break";
                };
                var _this1 = this;
                var conditionalQuestions = new Set();
                var fieldByName = new Map();
                this.fields.forEach(function(field) {
                    fieldByName.set(_this1.fieldName(field), field);
                });
                if (Array.isArray(this.logic.conditional)) this.logic.conditional.forEach(function(fieldName) {
                    conditionalQuestions.add(fieldName);
                });
                else this.logic.rules.forEach(function(rule) {
                    (rule.then || []).forEach(function(fieldName) {
                        conditionalQuestions.add(fieldName);
                    });
                });
                this.fields.forEach(function(field) {
                    if (conditionalQuestions.has(_this1.fieldName(field))) field.deactivate();
                    else field.activate();
                });
                for(var i = 0; i < this.fields.length; i++){
                    var _ret = (_this = this, _loop(i));
                    if (_ret === "break") break;
                }
                this.renumberActiveFields();
            }
        },
        {
            key: "renumberActiveFields",
            value: function renumberActiveFields() {
                var _this_logic_numbering;
                if (((_this_logic_numbering = this.logic.numbering) === null || _this_logic_numbering === void 0 ? void 0 : _this_logic_numbering.mode) === 'manual') return;
                var number = 1;
                this.fields.forEach(function(field) {
                    if (!field.isActive()) return;
                    field.setNumber(number);
                    number++;
                });
            }
        },
        {
            key: "ruleMatches",
            value: function ruleMatches(rule) {
                var _this = this;
                var question = rule.question || '';
                var answers = Array.isArray(rule.answers) ? rule.answers : [];
                if (!question) return false;
                var actualAnswer = this.answerFor(question);
                if (!actualAnswer) return false;
                if (!answers.length) return true;
                return answers.some(function(answer) {
                    return actualAnswer.includes(_this.normalizeAnswer(answer));
                });
            }
        },
        {
            key: "answerFor",
            value: function answerFor(fieldName) {
                var data = this.getDataObject();
                var _data_, _ref;
                var actualAnswer = (_ref = (_data_ = data[this.name + '__' + fieldName]) !== null && _data_ !== void 0 ? _data_ : data['survey__' + fieldName]) !== null && _ref !== void 0 ? _ref : '';
                return this.normalizeAnswer(actualAnswer);
            }
        },
        {
            key: "normalizeAnswer",
            value: function normalizeAnswer(answer) {
                return String(answer).toLowerCase().trim();
            }
        },
        {
            key: "fieldName",
            value: function fieldName(field) {
                return field.getName().replace(this.name + '__', '');
            }
        },
        {
            key: "getRequiredFields",
            value: function getRequiredFields() {
                var items = [];
                this.fields.forEach(function(field) {
                    if (field.isRequired && field.isActive()) items.push(field);
                });
                return items;
            }
        },
        {
            key: "getDataObject",
            value: function getDataObject() {
                var data = {};
                this.fields.forEach(function(field) {
                    if (field.isActive()) data[field.getName()] = field.getValue();
                });
                return data;
            }
        }
    ]);
    return SurveyFormFields;
}((0, $16da752e42cc99d4$export$2e2bcd8739ae039));
var $280589c83433d17c$export$2e2bcd8739ae039 = $280589c83433d17c$var$SurveyFormFields;














var $9af8e4f3bf48e764$exports = {};

$9af8e4f3bf48e764$exports = (parcelRequire("eiilo"));


function $c2c1ceb446234aea$var$_defineProperty(e, r, t) {
    return (r = $c2c1ceb446234aea$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c2c1ceb446234aea$var$_toPropertyKey(t) {
    var i = $c2c1ceb446234aea$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $c2c1ceb446234aea$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// The public key the site gives the payment step when PAYMENT_MODE=fake.
var $c2c1ceb446234aea$var$FAKE_KEY = 'pk_fake';
var $c2c1ceb446234aea$var$StripePayment = /*#__PURE__*/ function() {
    "use strict";
    function StripePayment(param) {
        var stripeKey = param.stripeKey, intentSecret = param.intentSecret, intentId = param.intentId, element = param.element;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, StripePayment);
        $c2c1ceb446234aea$var$_defineProperty(this, "stripe", null);
        $c2c1ceb446234aea$var$_defineProperty(this, "intentSecret", null);
        $c2c1ceb446234aea$var$_defineProperty(this, "intentId", null);
        $c2c1ceb446234aea$var$_defineProperty(this, "isValid", false);
        $c2c1ceb446234aea$var$_defineProperty(this, "error", null);
        $c2c1ceb446234aea$var$_defineProperty(this, "card", null);
        $c2c1ceb446234aea$var$_defineProperty(this, "changeListeners", []);
        this.stripeKey = stripeKey;
        this.intentSecret = intentSecret;
        this.intentId = intentId;
        this.element = element;
        this.setup();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(StripePayment, [
        {
            key: "setup",
            value: function setup() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var body, computed, fontSize, _, elements, style, card;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.stripeKey === $c2c1ceb446234aea$var$FAKE_KEY) {
                                    this.isValid = true;
                                    document.getElementById('card-element').textContent = 'Test payment: no card is needed and nothing is sent to Stripe.';
                                    return [
                                        2
                                    ];
                                }
                                body = document.getElementsByTagName('body')[0];
                                computed = window.getComputedStyle(body);
                                fontSize = computed.getPropertyValue('font-size');
                                _ = this;
                                return [
                                    4,
                                    (0, $9af8e4f3bf48e764$exports.loadStripe)(this.stripeKey)
                                ];
                            case 1:
                                _.stripe = _state.sent();
                                elements = this.stripe.elements({
                                    fonts: [
                                        {
                                            cssSrc: 'https://cfc-stmoritz.com/assets/stripe/font.css'
                                        }
                                    ],
                                    locale: 'en'
                                });
                                style = {
                                    base: {
                                        iconColor: '#000000',
                                        color: '#000000',
                                        fontFamily: "'Brown', sans-serif",
                                        fontSmoothing: 'antialiased',
                                        paddingTop: '9px',
                                        paddingBottom: '14px',
                                        fontSize: '18px',
                                        '::selection': {
                                            backgroundColor: 'rgb(239, 239, 239)'
                                        },
                                        '::placeholder': {
                                            color: '#6b7280'
                                        },
                                        ':-webkit-autofill': {
                                            color: '#000000'
                                        }
                                    },
                                    invalid: {
                                        color: '#000000',
                                        iconColor: '#000000'
                                    }
                                };
                                card = elements.create('card', {
                                    style: style
                                });
                                card.addEventListener('change', this.handleChange.bind(this));
                                card.mount('#card-element');
                                this.card = card;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "onChange",
            value: function onChange(callback) {
                this.changeListeners.push(callback);
            }
        },
        {
            key: "handleChanges",
            value: function handleChanges() {
                var _this = this;
                this.changeListeners.forEach(function(fn) {
                    return fn(_this);
                });
            }
        },
        {
            key: "validate",
            value: function validate() {
                this.element.classList.remove('has-error');
                if (!this.isValid) {
                    this.element.classList.add('has-error');
                    return false;
                }
                return true;
            }
        },
        {
            key: "handleChange",
            value: function handleChange(e) {
                if (e.error) {
                    this.error = e.error.message;
                    this.isValid = false;
                } else {
                    this.isValid = true;
                    this.error = null;
                }
                this.validate();
                this.handleChanges();
            }
        },
        {
            key: "submit",
            value: function submit(param, onDone) {
                var firstName = param.firstName, lastName = param.lastName, email = param.email;
                if (this.stripeKey === $c2c1ceb446234aea$var$FAKE_KEY) {
                    onDone({
                        paymentIntent: {
                            id: this.intentId,
                            status: 'requires_capture'
                        }
                    });
                    return;
                }
                var data = {
                    receipt_email: email,
                    payment_method_data: {
                        billing_details: {
                            name: "".concat(firstName, " ").concat(lastName)
                        }
                    }
                };
                this.stripe.handleCardPayment(this.intentSecret, this.card, data).then(onDone);
            }
        }
    ]);
    return StripePayment;
}();
var $c2c1ceb446234aea$export$2e2bcd8739ae039 = $c2c1ceb446234aea$var$StripePayment;


var $1d3ac66408e2383f$var$PaymentFormFields = /*#__PURE__*/ function(FormFields) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(PaymentFormFields, FormFields);
    function PaymentFormFields(parent, onValidate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, PaymentFormFields);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, PaymentFormFields, [
            parent,
            onValidate
        ]);
        var _parent_dataset = parent.dataset, stripeKey = _parent_dataset.stripeKey, intentId = _parent_dataset.intentId, intentSecret = _parent_dataset.intentSecret;
        _this.stripe = new (0, $c2c1ceb446234aea$export$2e2bcd8739ae039)({
            stripeKey: stripeKey,
            intentId: intentId,
            intentSecret: intentSecret,
            element: document.getElementById('card-element-container')
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(PaymentFormFields, [
        {
            key: "validate",
            value: function validate() {
                var isValid = (0, $b12a51be9d81d1bc$export$71511d61b312f219)((0, $9c9f503bd82065f0$export$71511d61b312f219)(PaymentFormFields.prototype), "validate", this).call(this);
                var isStripeValid = this.stripe.validate();
                return isValid && isStripeValid;
            }
        },
        {
            key: "submit",
            value: function submit(callback) {
                var data = this.getDataObject();
                var config = {
                    firstName: data.billing__first_name,
                    lastName: data.billing__last_name,
                    email: data.billing__email
                };
                this.stripe.submit(config, callback);
            }
        }
    ]);
    return PaymentFormFields;
}((0, $16da752e42cc99d4$export$2e2bcd8739ae039));
var $1d3ac66408e2383f$export$2e2bcd8739ae039 = $1d3ac66408e2383f$var$PaymentFormFields;


function $20d1e052e99ae8eb$var$_defineProperty(e, r, t) {
    return (r = $20d1e052e99ae8eb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $20d1e052e99ae8eb$var$_toPropertyKey(t) {
    var i = $20d1e052e99ae8eb$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $20d1e052e99ae8eb$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $20d1e052e99ae8eb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $20d1e052e99ae8eb$var$_defineProperty(_this, "forms", []);
        $20d1e052e99ae8eb$var$_defineProperty(_this, "formNames", []);
        $20d1e052e99ae8eb$var$_defineProperty(_this, "paymentHandler", null);
        $20d1e052e99ae8eb$var$_defineProperty(_this, "submitting", false);
        $20d1e052e99ae8eb$var$_defineProperty(_this, "handlers", {
            'form-fields': (0, $16da752e42cc99d4$export$2e2bcd8739ae039),
            'survey-form-fields': (0, $280589c83433d17c$export$2e2bcd8739ae039),
            'payment-form-fields': (0, $1d3ac66408e2383f$export$2e2bcd8739ae039)
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                this.action = this.element.dataset.action;
                this.step = this.element.dataset.step;
                this.t = this.element.dataset.t;
                this.s = this.element.dataset.s;
                var forms = (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(this.element.getElementsByTagName('form'));
                this.messages = JSON.parse(atob(this.element.dataset.messages));
                forms.forEach(function(form) {
                    form.addEventListener('submit', function(e) {
                        return e.preventDefault();
                    });
                    var name = form.getAttribute('name');
                    var _form_dataset_handler;
                    var handlerName = (_form_dataset_handler = form.dataset.handler) !== null && _form_dataset_handler !== void 0 ? _form_dataset_handler : 'form-fields';
                    var _this_handlers_handlerName;
                    var Handler = (_this_handlers_handlerName = _this.handlers[handlerName]) !== null && _this_handlers_handlerName !== void 0 ? _this_handlers_handlerName : (0, $16da752e42cc99d4$export$2e2bcd8739ae039);
                    var handlerInstance = new Handler(form);
                    if (handlerName === 'payment-form-fields') _this.paymentHandler = handlerInstance;
                    _this.formNames.push(name);
                    _this.forms.push({
                        name: name,
                        element: form,
                        handler: handlerInstance
                    });
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.forms.forEach(function(form) {
                    form.removeEventListener('submit', function(e) {
                        return e.preventDefault();
                    });
                });
            }
        },
        {
            key: "next",
            value: function next(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var _this, isValid, body, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this1, _loop, _iterator, _step, _ret, err;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.submitting) return [
                                    2
                                ];
                                e.preventDefault();
                                this.submitting = true;
                                isValid = true;
                                body = new FormData();
                                body.append('step', this.step);
                                if (this.s.length) body.append('s', this.s);
                                if (this.t.length) body.append('t', this.t);
                                if (this.formNames.length) body.append('forms', this.formNames);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var form, currentFormValid, formData, error;
                                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                form = _step.value;
                                                currentFormValid = form.handler.validate();
                                                isValid = isValid && currentFormValid;
                                                if (!currentFormValid) return [
                                                    3,
                                                    5
                                                ];
                                                formData = void 0;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    form.handler.getDataObjectAsync()
                                                ];
                                            case 2:
                                                formData = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                error = _state.sent();
                                                _this1.submitting = false;
                                                _this1.showError(_this1.messages.unknown);
                                                return [
                                                    2,
                                                    {
                                                        v: void void 0
                                                    }
                                                ];
                                            case 4:
                                                Object.keys(formData).forEach(function(key) {
                                                    body.append(key, formData[key]);
                                                });
                                                _state.label = 5;
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = this.forms[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                _this1 = this;
                                return [
                                    5,
                                    (0, $248fc3c53839d9ba$export$19a8beecd37a4c45)(_loop())
                                ];
                            case 3:
                                _ret = _state.sent();
                                if ((0, $0cd339a6e98df7f5$export$71511d61b312f219)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                if (!isValid) {
                                    this.submitting = false;
                                    this.showError(this.messages.required);
                                    return [
                                        2
                                    ];
                                }
                                this.resetError();
                                if (this.paymentHandler) this.paymentHandler.submit(function(e) {
                                    if (e.error) {
                                        _this.submitting = false;
                                        _this.showError(e.error.message);
                                    } else _this._doNext(body);
                                });
                                else this._doNext(body);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "showError",
            value: function showError(message) {
                this.errorTarget.innerHTML = message;
            }
        },
        {
            key: "resetError",
            value: function resetError() {
                this.errorTarget.innerHTML = '';
            }
        },
        {
            key: "_doNext",
            value: function _doNext(body) {
                var _this = this;
                var config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };
                var onSuccess = function(r) {
                    _this.submitting = false;
                    if (r.data && r.data.redirect) window.location.href = r.data.redirect;
                };
                var onError = function(r) {
                    _this.submitting = false;
                    if (r.response && r.response.data && r.response.data.error) _this.showError(r.response.data.error);
                    else _this.showError(_this.messages.unknown);
                };
                (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).post(this.action, body, config).then(onSuccess)["catch"](onError);
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$20d1e052e99ae8eb$var$_defineProperty($20d1e052e99ae8eb$export$2e2bcd8739ae039, "targets", [
    'error'
]);










function $844310940cad0620$var$_defineProperty(e, r, t) {
    return (r = $844310940cad0620$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $844310940cad0620$var$_toPropertyKey(t) {
    var i = $844310940cad0620$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $844310940cad0620$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $844310940cad0620$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $844310940cad0620$var$_defineProperty(_this, "landscape", {
            2560: '2560x1440'
        });
        $844310940cad0620$var$_defineProperty(_this, "portrait", {
            1080: '720x1280-v2'
        });
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.videoName = null;
                this.fileName = null;
                window.addEventListener('resize', (0, $2be48b05c8019145$export$61fc7d43ac8f84b0)(this.init.bind(this)));
                this.init();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                window.removeEventListener('resize', (0, $2be48b05c8019145$export$61fc7d43ac8f84b0)(this.init.bind(this)));
            }
        },
        {
            key: "init",
            value: function init() {
                if (!window) return;
                var _getViewport = (0, $2be48b05c8019145$export$d7eeb7266a7f734a)(window), w = _getViewport.w, h = _getViewport.h;
                var videoName = this.element.dataset.videoName;
                videoName = w > h ? videoName : videoName + '_portrait';
                var config = w > h ? this.landscape : this.portrait;
                var fileName = false;
                Object.keys(config).forEach(function(key, i) {
                    if (!fileName && (key > w || i === Object.keys(config).length - 1)) fileName = config[key];
                });
                if (this.videoName !== videoName || this.fileName !== fileName) {
                    this.videoTarget.poster = this.getVideoPoster(videoName, fileName);
                    this.videoTarget.src = this.getCroppedSource(videoName, fileName);
                }
            }
        },
        {
            key: "getVideoPoster",
            value: function getVideoPoster(videoName, fileName) {
                return "/assets/video/".concat(videoName, "/segmented/").concat(fileName, "/poster.jpg");
            }
        },
        {
            key: "getCroppedSource",
            value: function getCroppedSource(videoName, fileName) {
                return "/assets/video/".concat(videoName, "/cropped/").concat(fileName, ".mp4?v=1");
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$844310940cad0620$var$_defineProperty($844310940cad0620$export$2e2bcd8739ae039, "targets", [
    'video'
]);








function $06236f6204554d92$var$_defineProperty(e, r, t) {
    return (r = $06236f6204554d92$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $06236f6204554d92$var$_toPropertyKey(t) {
    var i = $06236f6204554d92$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $06236f6204554d92$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $06236f6204554d92$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                var config = JSON.parse(atob(this.element.dataset.infiniteScrollConfig));
                this.loading = false;
                this.id = config.id;
                this.page = config.page;
                this.total = config.total;
                var intersectionObserver = new IntersectionObserver(function(entries) {
                    if (entries[0].intersectionRatio <= 0) return;
                    _this.load();
                });
                intersectionObserver.observe(this.moreTarget);
            }
        },
        {
            key: "load",
            value: function load() {
                var _this = this;
                if (this.loading) return;
                this.loading = true;
                var url = "?infinite-scroll=1&".concat(this.id, "_page=").concat(this.page + 1);
                var containerId = "scroll_".concat(this.id);
                fetch(url).then(function(r) {
                    return r.text();
                }).then(function(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var element = doc.getElementById(containerId);
                    _this.containerTarget.insertAdjacentHTML('beforeend', element.innerHTML);
                    _this.page = _this.page + 1;
                    if (_this.page >= _this.total) {
                        _this.moreTarget.classList.add('hidden');
                        _this.interactionObserver.unobserve(_this.moreTarget);
                    }
                    _this.loading = false;
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.interactionObserver) this.interactionObserver.unobserve(this.moreTarget);
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$06236f6204554d92$var$_defineProperty($06236f6204554d92$export$2e2bcd8739ae039, "targets", [
    'container',
    'more'
]);








var $ab6a033130a60e5b$exports = {};
!function(e) {
    $ab6a033130a60e5b$exports = e();
}(function() {
    return (function e(n, t, o) {
        function r(c, u) {
            if (!t[c]) {
                if (!n[c]) {
                    var s = undefined;
                    if (!u && s) return s(c, !0);
                    if (i) return i(c, !0);
                    var a = new Error("Cannot find module '" + c + "'");
                    throw a.code = "MODULE_NOT_FOUND", a;
                }
                var l = t[c] = {
                    exports: {}
                };
                n[c][0].call(l.exports, function(e) {
                    return r(n[c][1][e] || e);
                }, l, l.exports, e, n, t, o);
            }
            return t[c].exports;
        }
        for(var i = undefined, c = 0; c < o.length; c++)r(o[c]);
        return r;
    })({
        1: [
            function(e, n, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.create = t.visible = void 0;
                var o = function o(e) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], _$t = document.createElement("div");
                    return _$t.innerHTML = e.trim(), !0 === n ? _$t.children : _$t.firstChild;
                }, r = function r(e, n) {
                    var _$t = e.children;
                    return 1 === _$t.length && _$t[0].tagName === n;
                }, i = function i(e) {
                    return null != (e = e || document.querySelector(".basicLightbox")) && !0 === e.ownerDocument.body.contains(e);
                };
                t.visible = i;
                t.create = function(e, n) {
                    var _$t = function(e, n) {
                        var _$t = o('\n\t\t<div class="basicLightbox '.concat(n.className, '">\n\t\t\t<div class="basicLightbox__placeholder" role="dialog"></div>\n\t\t</div>\n\t')), i = _$t.querySelector(".basicLightbox__placeholder");
                        e.forEach(function(e) {
                            return i.appendChild(e);
                        });
                        var c = r(i, "IMG"), u = r(i, "VIDEO"), s = r(i, "IFRAME");
                        return !0 === c && _$t.classList.add("basicLightbox--img"), !0 === u && _$t.classList.add("basicLightbox--video"), !0 === s && _$t.classList.add("basicLightbox--iframe"), _$t;
                    }(e = function(e) {
                        var _$n = "string" == typeof e, _$t = e instanceof HTMLElement == 1;
                        if (!1 === _$n && !1 === _$t) throw new Error("Content must be a DOM element/node or string");
                        return !0 === _$n ? Array.from(o(e, !0)) : "TEMPLATE" === e.tagName ? [
                            e.content.cloneNode(!0)
                        ] : Array.from(e.children);
                    }(e), n = function() {
                        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        if (null == (_$e = Object.assign({}, _$e)).closable && (_$e.closable = !0), null == _$e.className && (_$e.className = ""), null == _$e.onShow && (_$e.onShow = function() {}), null == _$e.onClose && (_$e.onClose = function() {}), "boolean" != typeof _$e.closable) throw new Error("Property `closable` must be a boolean");
                        if ("string" != typeof _$e.className) throw new Error("Property `className` must be a string");
                        if ("function" != typeof _$e.onShow) throw new Error("Property `onShow` must be a function");
                        if ("function" != typeof _$e.onClose) throw new Error("Property `onClose` must be a function");
                        return _$e;
                    }(n)), c = function c(e) {
                        return !1 !== n.onClose(u) && function(e, n) {
                            return e.classList.remove("basicLightbox--visible"), setTimeout(function() {
                                return !1 === i(e) || e.parentElement.removeChild(e), n();
                            }, 410), !0;
                        }(_$t, function() {
                            if ("function" == typeof e) return e(u);
                        });
                    };
                    !0 === n.closable && _$t.addEventListener("click", function(e) {
                        e.target === _$t && c();
                    });
                    var u = {
                        element: function element() {
                            return _$t;
                        },
                        visible: function visible() {
                            return i(_$t);
                        },
                        show: function show(e) {
                            return !1 !== n.onShow(u) && function(e, n) {
                                return document.body.appendChild(e), setTimeout(function() {
                                    requestAnimationFrame(function() {
                                        return e.classList.add("basicLightbox--visible"), n();
                                    });
                                }, 10), !0;
                            }(_$t, function() {
                                if ("function" == typeof e) return e(u);
                            });
                        },
                        close: c
                    };
                    return u;
                };
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});


function $deef8d4baee5fcab$var$_defineProperty(e, r, t) {
    return (r = $deef8d4baee5fcab$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $deef8d4baee5fcab$var$_toPropertyKey(t) {
    var i = $deef8d4baee5fcab$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $deef8d4baee5fcab$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $deef8d4baee5fcab$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                var img = this.imageTarget;
                var src = this.element.dataset.lightboxUrl;
                this.lightbox = $ab6a033130a60e5b$exports.create('<img src="'.concat(src, '"  alt="').concat(img.alt, '" sizes="100vw">'));
            }
        },
        {
            key: "open",
            value: function open() {
                this.lightbox.show();
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$deef8d4baee5fcab$var$_defineProperty($deef8d4baee5fcab$export$2e2bcd8739ae039, "targets", [
    'image'
]);









function $c0eac8e91a3605b9$var$_defineProperty(e, r, t) {
    return (r = $c0eac8e91a3605b9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c0eac8e91a3605b9$var$_toPropertyKey(t) {
    var i = $c0eac8e91a3605b9$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $c0eac8e91a3605b9$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c0eac8e91a3605b9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        return (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.lastScrollTop = 0;
                if (this.element.dataset.template === 'home') {
                    window.addEventListener('scroll', (0, $2be48b05c8019145$export$61fc7d43ac8f84b0)(this.init.bind(this)), {
                        passive: true
                    });
                    this.init();
                }
            }
        },
        {
            key: "handleScroll",
            value: function handleScroll() {
                var scrollTop = (0, $2be48b05c8019145$export$c4a223a8ba9e4ea5)(window);
                this.element.classList.remove('has-scrolled');
                if (scrollTop > 20) {
                    if (!this.element.classList.contains('has-scrolled')) this.element.classList.add('has-scrolled');
                    var navHeight = this.navElementTarget.offsetHeight;
                    var heroHeight = this.heroTarget.offsetHeight;
                    var totalDistance = heroHeight - navHeight;
                    var opacity = scrollTop > totalDistance ? 1 : (scrollTop / totalDistance).toFixed(2);
                    this.underlayTarget.style.opacity = opacity;
                }
            }
        },
        {
            key: "init",
            value: function init() {
                if (getComputedStyle(this.element.parentElement).display === 'none') return;
                var viewport = (0, $2be48b05c8019145$export$d7eeb7266a7f734a)(window);
                var scrollTop = (0, $2be48b05c8019145$export$c4a223a8ba9e4ea5)(window);
                if (scrollTop > 0 && getComputedStyle(this.logoTarget).display === 'none') this.logoTarget.style.display = '';
                var backgroundThreshold = 0.05;
                var backgroundTrigger = scrollTop / (viewport.h * backgroundThreshold);
                if (backgroundTrigger >= 1) {
                    this.underlayTarget.style.opacity = 1;
                    this.logoTarget.style.opacity = 1;
                } else {
                    this.underlayTarget.style.opacity = backgroundTrigger;
                    this.logoTarget.style.opacity = backgroundTrigger;
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                window.removeEventListener('scroll', (0, $2be48b05c8019145$export$61fc7d43ac8f84b0)(this.init.bind(this)));
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$c0eac8e91a3605b9$var$_defineProperty($c0eac8e91a3605b9$export$2e2bcd8739ae039, "targets", [
    'navElement',
    'hero',
    'underlay',
    'logo'
]);














function $22955ac9f4cd8b20$var$_defineProperty(e, r, t) {
    return (r = $22955ac9f4cd8b20$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $22955ac9f4cd8b20$var$_toPropertyKey(t) {
    var i = $22955ac9f4cd8b20$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $22955ac9f4cd8b20$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $22955ac9f4cd8b20$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $22955ac9f4cd8b20$var$_defineProperty(_this, "messages", {});
        $22955ac9f4cd8b20$var$_defineProperty(_this, "action", null);
        $22955ac9f4cd8b20$var$_defineProperty(_this, "steps", []);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.form = new (0, $16da752e42cc99d4$export$2e2bcd8739ae039)(this.formTarget);
                this.messages = JSON.parse(atob(this.element.dataset.messages));
                this.action = this.element.dataset.action;
                var items = this.element.getElementsByClassName('newsletter-step');
                for(var i = 0; i < items.length; i++)this.steps.push(items[i]);
            }
        },
        {
            key: "next",
            value: function next(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var _this, isValid, onSuccess, onError, body;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        _this = this;
                        e.preventDefault();
                        isValid = this.form.validate();
                        if (!isValid) {
                            this.showError(this.messages.required);
                            return [
                                2
                            ];
                        }
                        onSuccess = function(r) {
                            _this.resetError();
                            _this.steps[0].classList.remove('active');
                            _this.steps[1].classList.add('active');
                            var status = r.data && r.data.mailchimp_status;
                            if (status) console.info("[Newsletter] Mailchimp status: ".concat(status));
                        };
                        onError = function(r) {
                            if (r.response && r.response.data && r.response.data.error) _this.showError(r.response.data.error);
                            else _this.showError(_this.messages.unknown);
                        };
                        body = this.form.getData();
                        (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).post(this.action, body).then(onSuccess)["catch"](onError);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "showError",
            value: function showError(message) {
                this.errorTarget.innerHTML = message;
            }
        },
        {
            key: "resetError",
            value: function resetError() {
                this.errorTarget.innerHTML = '';
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$22955ac9f4cd8b20$var$_defineProperty($22955ac9f4cd8b20$export$2e2bcd8739ae039, "targets", [
    'error',
    'form'
]);









function $9b1e43eed6e1568a$var$_defineProperty(e, r, t) {
    return (r = $9b1e43eed6e1568a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9b1e43eed6e1568a$var$_toPropertyKey(t) {
    var i = $9b1e43eed6e1568a$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $9b1e43eed6e1568a$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9b1e43eed6e1568a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $9b1e43eed6e1568a$var$_defineProperty(_this, "input", null);
        $9b1e43eed6e1568a$var$_defineProperty(_this, "error", null);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                var items = this.element.getElementsByClassName('reduction-input');
                for(var i = 0; i < items.length; i++){
                    this.input = items[i];
                    break;
                }
                this.input.addEventListener('input', this.resetError.bind(this));
                var errors = this.element.getElementsByClassName('reduction-error');
                for(var i1 = 0; i1 < errors.length; i1++){
                    this.error = errors[i1];
                    break;
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.input.removeEventListener('input', this.resetError.bind(this));
            }
        },
        {
            key: "resetError",
            value: function resetError() {
                this.error.innerHTML = '';
            }
        },
        {
            key: "showError",
            value: function showError(message) {
                this.error.innerHTML = message;
            }
        },
        {
            key: "apply",
            value: function apply(e) {
                var _this = this;
                e.preventDefault();
                if (!this.input) return;
                if (!this.input.value.length) return;
                var url = this.element.getAttribute('data-end-point') + this.input.value;
                var onSuccess = function(data) {
                    if (data.error) _this.showError(data.message);
                    if (data.html) _this.summaryTarget.innerHTML = data.html;
                    _this.input.value = '';
                };
                var onError = function(error) {
                    _this.showError('An unknown error ocurred');
                };
                fetch(url).then(function(r) {
                    return r.json();
                }).then(onSuccess)["catch"](onError);
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$9b1e43eed6e1568a$var$_defineProperty($9b1e43eed6e1568a$export$2e2bcd8739ae039, "targets", [
    'summary'
]);









function $43867dd0ab098f39$var$_defineProperty(e, r, t) {
    return (r = $43867dd0ab098f39$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $43867dd0ab098f39$var$_toPropertyKey(t) {
    var i = $43867dd0ab098f39$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $43867dd0ab098f39$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $43867dd0ab098f39$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = (0, $244694db38c6e8cb$export$71511d61b312f219)(this, _Class, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        $43867dd0ab098f39$var$_defineProperty(_this, "toggles", []);
        $43867dd0ab098f39$var$_defineProperty(_this, "items", []);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                var toggles = this.element.children[0].children;
                for(var i = 0; i < toggles.length; i++)if (toggles[i].classList.contains('tab-toggle')) this.toggles.push(toggles[i]);
                var items = this.element.children;
                for(var i1 = 0; i1 < items.length; i1++)if (items[i1].classList.contains('tab-item')) this.items.push(items[i1]);
                this._depth = this._getDepth();
                this._activateFromUrl();
                this._popstateHandler = function() {
                    return _this._activateFromUrl();
                };
                window.addEventListener('popstate', this._popstateHandler);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                window.removeEventListener('popstate', this._popstateHandler);
            }
        },
        {
            key: "reset",
            value: function reset(e) {
                this.toggles.forEach(function(toggle) {
                    toggle.classList.remove('active');
                });
                this.items.forEach(function(item) {
                    item.classList.remove('active');
                });
            }
        },
        {
            key: "toggle",
            value: function toggle(e) {
                var el = e.currentTarget;
                var itemId = el.dataset.tabToggleId;
                var tabUrl = el.dataset.tabUrl;
                var activeItem = null;
                this.items.forEach(function(item) {
                    if (item.dataset.tabItemId === itemId) activeItem = item;
                });
                if (activeItem) {
                    this.reset();
                    activeItem.classList.add('active');
                    el.classList.add('active');
                }
                if (tabUrl) history.pushState({
                    tabId: itemId
                }, '', tabUrl);
                else {
                    var slug = this._slugify(el.textContent);
                    if (slug) this._updateUrl(slug);
                }
            }
        },
        {
            key: "_getDepth",
            value: function _getDepth() {
                var depth = 0;
                var el = this.element.parentElement;
                while(el){
                    if (el.dataset && el.controller === 'tabs' || el.getAttribute && el.getAttribute('data-controller') === 'tabs') depth++;
                    el = el.parentElement;
                }
                return depth;
            }
        },
        {
            key: "_getTabSegments",
            value: function _getTabSegments() {
                var url = new URL(window.location);
                var tab = url.searchParams.get('tab');
                return tab ? tab.split('/') : [];
            }
        },
        {
            key: "_updateUrl",
            value: function _updateUrl(slug) {
                var segments = this._getTabSegments();
                segments[this._depth] = slug;
                // Truncate deeper segments when a parent tab changes
                segments.length = this._depth + 1;
                var url = new URL(window.location);
                url.searchParams.set('tab', segments.join('/'));
                history.pushState({
                    tab: segments.join('/')
                }, '', url);
            }
        },
        {
            key: "_activateFromUrl",
            value: function _activateFromUrl() {
                var _this = this;
                var segments = this._getTabSegments();
                var slug = segments[this._depth];
                if (!slug) return;
                var toggle = this.toggles.find(function(t) {
                    return _this._slugify(t.textContent) === slug;
                });
                var toggleIdx = this.toggles.indexOf(toggle);
                if (toggle && toggleIdx < this.items.length) {
                    this.reset();
                    toggle.classList.add('active');
                    this.items[toggleIdx].classList.add('active');
                }
            }
        },
        {
            key: "_slugify",
            value: function _slugify(text) {
                return text.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$43867dd0ab098f39$var$_defineProperty($43867dd0ab098f39$export$2e2bcd8739ae039, "targets", [
    'toggles'
]);


var $e7f24e80db9536d7$var$application = (0, $9761593eb1d92c30$export$16975c34e60e1e61).start();
$e7f24e80db9536d7$var$application.register('accordion', (0, $6c5afe00ef2f00bb$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('burger', (0, $ce37487ff92820e5$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('carousel', (0, $b6691ef87a57683b$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('cookie-consent', (0, $052589c5dcbd5464$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('countdown', (0, $a153307ea713bd69$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('form-step', (0, $20d1e052e99ae8eb$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('header-video', (0, $844310940cad0620$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('infinite-scroll', (0, $06236f6204554d92$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('lightbox', (0, $deef8d4baee5fcab$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('reduction-code', (0, $9b1e43eed6e1568a$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('nav', (0, $c0eac8e91a3605b9$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('newsletter', (0, $22955ac9f4cd8b20$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('tabs', (0, $43867dd0ab098f39$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register('tag-filter', (0, $4f2160f59d07c6b0$export$2e2bcd8739ae039));



})();
//# sourceMappingURL=main.js.map
